/*! lineupjs - v3.2.2 - 2019
* https://lineup.js.org
* Copyright (c) 2019 Samuel Gratzl; Licensed BSD-3-Clause*/
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.LineUpJS = e() : t.LineUpJS = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 101);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return i;
    }), n.d(e, "a", function () {
      return _o;
    }), n.d(e, "b", function () {
      return a;
    }), n.d(e, "d", function () {
      return u;
    });
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _r = function r(t, e) {
      return (_r = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var n in e) {
          e.hasOwnProperty(n) && (t[n] = e[n]);
        }
      })(t, e);
    };

    function i(t, e) {
      function n() {
        this.constructor = t;
      }

      _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
    }

    var _o = function o() {
      return (_o = Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var i in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    function a(t, e, n, r) {
      var i,
          o = arguments.length,
          a = o < 3 ? e : null === r ? r = Object.getOwnPropertyDescriptor(e, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, e, n, r);else for (var u = t.length - 1; u >= 0; u--) {
        (i = t[u]) && (a = (o < 3 ? i(a) : o > 3 ? i(e, n, a) : i(e, n)) || a);
      }
      return o > 3 && a && Object.defineProperty(e, n, a), a;
    }

    function u() {
      for (var t = 0, e = 0, n = arguments.length; e < n; e++) {
        t += arguments[e].length;
      }

      var r = Array(t),
          i = 0;

      for (e = 0; e < n; e++) {
        for (var o = arguments[e], a = 0, u = o.length; a < u; a++, i++) {
          r[i] = o[a];
        }
      }

      return r;
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(13),
        o = n(16),
        a = n(42),
        u = n(38),
        c = n(7),
        s = n(2),
        l = function (t) {
      function e(e, n) {
        var r = t.call(this) || this;
        return r.desc = n, r.width = 100, r.parent = null, r.uid = Object(a.d)(e), r.renderer = r.desc.renderer || r.desc.type, r.groupRenderer = r.desc.groupRenderer || r.desc.type, r.summaryRenderer = r.desc.summaryRenderer || r.desc.type, r.width = null != r.desc.width && r.desc.width > 0 ? r.desc.width : 100, r.visible = !1 !== r.desc.visible, r.metadata = {
          label: n.label || r.id,
          description: n.description || ""
        }, r;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "fixed", {
        get: function get() {
          return Boolean(this.desc.fixed);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "frozen", {
        get: function get() {
          return Boolean(this.desc.frozen);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "id", {
        get: function get() {
          return this.uid;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.assignNewId = function (t) {
        this.uid = Object(a.d)(t());
      }, Object.defineProperty(e.prototype, "label", {
        get: function get() {
          return this.metadata.label;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "description", {
        get: function get() {
          return this.metadata.description;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "fqid", {
        get: function get() {
          return this.parent ? this.parent.fqid + "_" + this.id : this.id;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "fqpath", {
        get: function get() {
          return this.parent ? this.parent.fqpath + "@" + this.parent.indexOf(this) : "";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_WIDTH_CHANGED, e.EVENT_LABEL_CHANGED, e.EVENT_METADATA_CHANGED, e.EVENT_VISIBILITY_CHANGED, e.EVENT_SUMMARY_RENDERER_TYPE_CHANGED, e.EVENT_RENDERER_TYPE_CHANGED, e.EVENT_GROUP_RENDERER_TYPE_CHANGED, e.EVENT_DIRTY, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getWidth = function () {
        return this.width;
      }, e.prototype.hide = function () {
        this.setVisible(!1);
      }, e.prototype.show = function () {
        this.setVisible(!0);
      }, e.prototype.isVisible = function () {
        return this.visible;
      }, e.prototype.getVisible = function () {
        return this.isVisible();
      }, e.prototype.setVisible = function (t) {
        this.visible !== t && this.fire([e.EVENT_VISIBILITY_CHANGED, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], this.visible, this.visible = t);
      }, e.prototype.flatten = function (t, e, n, r) {
        void 0 === n && (n = 0), void 0 === r && (r = 0);
        var i = this.getWidth();
        return t.push({
          col: this,
          offset: e,
          width: i
        }), i;
      }, e.prototype.setWidth = function (t) {
        Object(o.l)(this.width, t, .5) || this.fire([e.EVENT_WIDTH_CHANGED, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], this.width, this.width = t);
      }, e.prototype.setWidthImpl = function (t) {
        this.width = t;
      }, e.prototype.setMetaData = function (t) {
        if (t.label !== this.label || this.description !== t.description) {
          var n = this.getMetaData();
          this.metadata = {
            label: t.label,
            description: t.description
          }, this.fire([e.EVENT_LABEL_CHANGED, e.EVENT_METADATA_CHANGED, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY], n, this.getMetaData());
        }
      }, e.prototype.getMetaData = function () {
        return Object.assign({}, this.metadata);
      }, e.prototype.sortByMe = function (t, e) {
        void 0 === t && (t = Object(s.k)(this)), void 0 === e && (e = 0);
        var n = this.findMyRanker();
        return !!n && n.sortBy(this, t, e);
      }, e.prototype.groupByMe = function () {
        var t = this.findMyRanker();
        return !!t && t.toggleGrouping(this);
      }, e.prototype.isGroupedBy = function () {
        var t = this.findMyRanker();
        return t ? t.getGroupCriteria().indexOf(this) : -1;
      }, e.prototype.toggleMySorting = function () {
        var t = this.findMyRanker();
        return !!t && t.toggleSorting(this);
      }, e.prototype.isSortedByMeImpl = function (t) {
        var e = this,
            n = this.findMyRanker();
        if (!n) return {
          asc: void 0,
          priority: void 0
        };
        var r = t(n),
            i = r.findIndex(function (t) {
          return t.col === e;
        });
        return i < 0 ? {
          asc: void 0,
          priority: void 0
        } : {
          asc: r[i].asc ? "asc" : "desc",
          priority: i
        };
      }, e.prototype.isSortedByMe = function () {
        return this.isSortedByMeImpl(function (t) {
          return t.getSortCriteria();
        });
      }, e.prototype.groupSortByMe = function (t, e) {
        void 0 === t && (t = Object(s.k)(this)), void 0 === e && (e = 0);
        var n = this.findMyRanker();
        return !!n && n.groupSortBy(this, t, e);
      }, e.prototype.toggleMyGroupSorting = function () {
        var t = this.findMyRanker();
        return !!t && t.toggleGroupSorting(this);
      }, e.prototype.isGroupSortedByMe = function () {
        return this.isSortedByMeImpl(function (t) {
          return t.getGroupSortCriteria();
        });
      }, e.prototype.removeMe = function () {
        return !this.fixed && !!this.parent && this.parent.remove(this);
      }, e.prototype.attach = function (t) {
        this.parent = t;
      }, e.prototype.detach = function () {
        this.parent = null;
      }, e.prototype.insertAfterMe = function (t) {
        return !!this.parent && null != this.parent.insertAfter(t, this);
      }, e.prototype.findMyRanker = function () {
        return this.parent ? this.parent.findMyRanker() : null;
      }, e.prototype.dump = function (t) {
        var e = {
          id: this.id,
          desc: t(this.desc),
          width: this.width
        };
        return this.label !== (this.desc.label || this.id) && (e.label = this.label), this.getRenderer() !== this.desc.type && (e.renderer = this.getRenderer()), this.getGroupRenderer() !== this.desc.type && (e.groupRenderer = this.getGroupRenderer()), this.getSummaryRenderer() !== this.desc.type && (e.summaryRenderer = this.getSummaryRenderer()), e;
      }, e.prototype.restore = function (t, e) {
        this.width = t.width || this.width, this.metadata = {
          label: t.label || this.label,
          description: this.description
        }, (t.renderer || t.rendererType) && (this.renderer = t.renderer || t.rendererType), t.groupRenderer && (this.groupRenderer = t.groupRenderer), t.summaryRenderer && (this.summaryRenderer = t.summaryRenderer);
      }, e.prototype.getLabel = function (t) {
        return String(this.getValue(t));
      }, e.prototype.getValue = function (t) {
        return "";
      }, e.prototype.getExportValue = function (t, e) {
        return "text" === e ? this.getLabel(t) : this.getValue(t);
      }, e.prototype.getColor = function (t) {
        return e.DEFAULT_COLOR;
      }, e.prototype.isMissing = function (t) {
        return Object(c.c)(this.getValue(t));
      }, e.prototype.compare = function (t, e) {
        return 0;
      }, e.prototype.group = function (t) {
        return u.a;
      }, e.prototype.groupCompare = function (t, e) {
        return t.name.toLowerCase().localeCompare(e.name.toLowerCase());
      }, e.prototype.isFiltered = function () {
        return !1;
      }, e.prototype.filter = function (t) {
        return null != t;
      }, e.prototype.getRenderer = function () {
        return this.renderer;
      }, e.prototype.getGroupRenderer = function () {
        return this.groupRenderer;
      }, e.prototype.getSummaryRenderer = function () {
        return this.summaryRenderer;
      }, e.prototype.setRenderer = function (t) {
        t !== this.renderer && this.fire([e.EVENT_RENDERER_TYPE_CHANGED, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], this.renderer, this.renderer = t);
      }, e.prototype.setDefaultRenderer = function (t) {
        if (this.renderer === this.desc.type && !this.desc.renderer) return this.setRenderer(t);
      }, e.prototype.setGroupRenderer = function (t) {
        t !== this.groupRenderer && this.fire([e.EVENT_GROUP_RENDERER_TYPE_CHANGED, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], this.groupRenderer, this.groupRenderer = t);
      }, e.prototype.setDefaultGroupRenderer = function (t) {
        if (this.groupRenderer === this.desc.type && !this.desc.groupRenderer) return this.setGroupRenderer(t);
      }, e.prototype.setSummaryRenderer = function (t) {
        t !== this.summaryRenderer && this.fire([e.EVENT_SUMMARY_RENDERER_TYPE_CHANGED, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY], this.summaryRenderer, this.summaryRenderer = t);
      }, e.prototype.setDefaultSummaryRenderer = function (t) {
        if (this.summaryRenderer === this.desc.type && !this.desc.summaryRenderer) return this.setSummaryRenderer(t);
      }, e.prototype.setDefaultWidth = function (t) {
        if (100 === this.width && !this.desc.width) return this.setWidthImpl(t);
      }, e.prototype.markDirty = function (t) {
        switch (void 0 === t && (t = "all"), t) {
          case "header":
            return this.fire([e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY]);

          case "values":
            return this.fire([e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY]);

          default:
            return this.fire([e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY]);
        }
      }, e.DEFAULT_COLOR = "#C1C1C1", e.FLAT_ALL_COLUMNS = -1, e.EVENT_WIDTH_CHANGED = "widthChanged", e.EVENT_LABEL_CHANGED = "labelChanged", e.EVENT_METADATA_CHANGED = "metaDataChanged", e.EVENT_DIRTY = "dirty", e.EVENT_DIRTY_HEADER = "dirtyHeader", e.EVENT_DIRTY_VALUES = "dirtyValues", e.EVENT_RENDERER_TYPE_CHANGED = "rendererTypeChanged", e.EVENT_GROUP_RENDERER_TYPE_CHANGED = "groupRendererChanged", e.EVENT_SUMMARY_RENDERER_TYPE_CHANGED = "summaryRendererChanged", e.EVENT_VISIBILITY_CHANGED = "visibilityChanged", e;
    }(i.a);

    e.d = l;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "e", function () {
      return a;
    }), n.d(e, "d", function () {
      return u;
    }), n.d(e, "k", function () {
      return c;
    }), n.d(e, "a", function () {
      return s;
    }), n.d(e, "b", function () {
      return p;
    }), n.d(e, "m", function () {
      return f;
    }), n.d(e, "h", function () {
      return d;
    }), n.d(e, "l", function () {
      return g;
    }), n.d(e, "f", function () {
      return b;
    }), n.d(e, "g", function () {
      return m;
    }), n.d(e, "i", function () {
      return y;
    }), n.d(e, "j", function () {
      return v;
    });
    n(103);
    var r = n(1),
        i = Symbol.for("SupportType"),
        o = Symbol.for("Category");

    function a() {
      return Reflect.metadata(i, !0);
    }

    function u(t) {
      return void 0 === t && (t = "ascending"), "descending" === t ? Reflect.metadata(Symbol.for("sortDescendingByDefault"), !0) : function (t) {
        return t;
      };
    }

    function c(t) {
      var e = t.constructor;
      return !Reflect.hasMetadata(Symbol.for("sortDescendingByDefault"), e);
    }

    var s = function s() {
      this.string = {
        label: "label",
        order: 1,
        name: "string",
        featureLevel: "basic"
      }, this.categorical = {
        label: "categorical",
        order: 2,
        name: "categorical",
        featureLevel: "basic"
      }, this.number = {
        label: "numerical",
        order: 3,
        name: "number",
        featureLevel: "basic"
      }, this.date = {
        label: "date",
        order: 4,
        name: "date",
        featureLevel: "basic"
      }, this.array = {
        label: "matrix",
        order: 5,
        name: "array",
        featureLevel: "advanced"
      }, this.map = {
        label: "map",
        order: 6,
        name: "map",
        featureLevel: "advanced"
      }, this.composite = {
        label: "combined",
        order: 7,
        name: "composite",
        featureLevel: "advanced"
      }, this.support = {
        label: "support",
        order: 8,
        name: "support",
        featureLevel: "advanced"
      }, this.other = {
        label: "others",
        order: 9,
        name: "other",
        featureLevel: "advanced"
      };
    },
        l = new s();

    function p(t) {
      return Reflect.metadata(o, t);
    }

    function f() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }

      return Reflect.metadata(Symbol.for("toolbarIcon"), t);
    }

    function d(t) {
      for (var e = [], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }

      return Reflect.metadata(Symbol.for("toolbarDialogAddon" + t), e);
    }

    var h = new Map();

    function g(t) {
      var e = t.constructor;
      return Reflect.hasMetadata(i, e);
    }

    function b(t) {
      var e = Reflect.getMetadata(o, t instanceof r.d ? Object.getPrototypeOf(t).constructor : t) || "other";
      return l[e] || l.other;
    }

    function m(t, e) {
      var n = e["string" == typeof t ? t : t.type];
      return n ? b(n) : l.other;
    }

    function y(t) {
      if (h.has(t.desc.type)) return h.get(t.desc.type);
      var e = [],
          n = t,
          r = Symbol.for("toolbarIcon");

      do {
        var i = Reflect.getOwnMetadata(r, n.constructor);
        i && e.push.apply(e, i), n = Object.getPrototypeOf(n);
      } while (n);

      return h.set(t.desc.type, e), e;
    }

    function v(t, e) {
      var n = t.desc.type + "@" + e;
      if (h.has(n)) return h.get(n);
      var r = [],
          i = t,
          o = Symbol.for("toolbarDialogAddon" + e);

      do {
        var a = Reflect.getOwnMetadata(o, i.constructor);
        a && r.push.apply(r, a), i = Object.getPrototypeOf(i);
      } while (i);

      return h.set(n, r), r;
    }
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return s;
    }), n.d(e, "k", function () {
      return l;
    }), n.d(e, "e", function () {
      return p;
    }), n.d(e, "g", function () {
      return f;
    }), n.d(e, "c", function () {
      return r;
    }), n.d(e, "h", function () {
      return d;
    }), n.d(e, "b", function () {
      return i;
    }), n.d(e, "m", function () {
      return h;
    }), n.d(e, "o", function () {
      return g;
    }), n.d(e, "n", function () {
      return b;
    }), n.d(e, "j", function () {
      return m;
    }), n.d(e, "l", function () {
      return y;
    }), n.d(e, "i", function () {
      return v;
    }), n.d(e, "p", function () {
      return E;
    });
    var r,
        i,
        o = n(33),
        a = n(16),
        u = n(1),
        c = n(7),
        s = Object(o.a)(".3n");

    function l(t) {
      return t instanceof u.d && "function" == typeof t.getNumber || !(t instanceof u.d) && null != t.type.match(/(number|stack|ordinal)/);
    }

    function p(t, e, n) {
      var r = t.getBoxPlotData(e),
          i = t.getBoxPlotData(n);
      if (null == r) return null == i ? 0 : c.b;
      if (null == i) return -1 * c.b;
      var o = t.getSortMethod();
      return g(r[o], i[o]);
    }

    function f(t, e, n) {
      var r = "normalized" === n ? t.getBoxPlotData(e) : t.getRawBoxPlotData(e);
      return null == r ? NaN : r[t.getSortMethod()];
    }

    function d(t) {
      return "function" == typeof t.getBoxPlotData;
    }

    function h(t) {
      return d(t) && "function" == typeof t.getNumbers;
    }

    function g(t, e, n, r) {
      return void 0 === n && (n = !1), void 0 === r && (r = !1), n = n || null == t || isNaN(t), r = r || null == e || isNaN(e), n ? r ? 0 : c.b : r ? -1 * c.b : t - e;
    }

    function b() {
      return {
        min: -1 / 0,
        max: 1 / 0,
        filterMissing: !1
      };
    }

    function m(t, e) {
      return Object(a.l)(t.min, e.min, .001) && Object(a.l)(t.max, e.max, .001) && t.filterMissing === e.filterMissing;
    }

    function y(t, e) {
      return !t || (isNaN(e) ? !t.filterMissing : !(isFinite(t.min) && e < t.min || isFinite(t.max) && e > t.max));
    }

    function v(t) {
      return !t.filterMissing && !isFinite(t.min) && !isFinite(t.max);
    }

    function E(t) {
      return {
        min: null != t.min && isFinite(t.min) ? t.min : -1 / 0,
        max: null != t.max && isFinite(t.max) ? t.max : 1 / 0,
        filterMissing: t.filterMissing
      };
    }

    !function (t) {
      t.min = "min", t.max = "max", t.median = "median", t.q1 = "q1", t.q3 = "q3";
    }(r || (r = {})), function (t) {
      t.min = "min", t.max = "max", t.median = "median", t.q1 = "q1", t.q3 = "q3", t.mean = "mean";
    }(i || (i = {}));
  }, function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return o;
    }), n.d(e, "i", function () {
      return a;
    }), n.d(e, "h", function () {
      return u;
    }), n.d(e, "j", function () {
      return c;
    }), n.d(e, "e", function () {
      return s;
    }), n.d(e, "f", function () {
      return l;
    }), n.d(e, "g", function () {
      return p;
    }), n.d(e, "l", function () {
      return f;
    }), n.d(e, "b", function () {
      return d;
    }), n.d(e, "a", function () {
      return h;
    }), n.d(e, "k", function () {
      return b;
    }), n.d(e, "d", function () {
      return y;
    });
    var r = n(51),
        i = n(25);

    function o(t, e, n, r) {
      return void 0 === e && (e = {}), void 0 === n && (n = {}), Object.keys(e).forEach(function (n) {
        var r = String(e[n]);
        t.getAttribute(n) !== r && t.setAttribute(n, r);
      }), Object.keys(n).forEach(function (e) {
        var r = n[e];
        t.style.getPropertyValue(e) !== r && t.style.setProperty(e, r);
      }), c(t, r);
    }

    function a() {}

    var u = {
      template: "<div></div>",
      update: a,
      render: a
    };

    function c(t, e) {
      return void 0 === e ? t : (t.textContent !== e && (t.textContent = e), t);
    }

    function s(t, e, n) {
      Array.from(t.querySelectorAll(e)).forEach(n);
    }

    function l(t, e) {
      Array.from(t.children).forEach(e);
    }

    function p(t, e) {
      if (0 !== t.childElementCount) {
        if (!e.every(function (e, n) {
          var r = t.children[n];
          return null != r && r.dataset.columnId === e.column.id && r.dataset.renderer === e.rendererId;
        })) {
          var n = new Set(e.map(function (t) {
            return t.column.id + "@" + t.rendererId;
          }));
          l(t, function (e) {
            var r = e.dataset.columnId + "@" + e.dataset.renderer;
            n.has(r) || t.removeChild(e);
          }), e.forEach(function (e) {
            var n = t.querySelector('[data-column-id="' + e.column.id + '"]');
            n || (t.insertAdjacentHTML("beforeend", e.template), (n = t.lastElementChild).dataset.columnId = e.column.id, n.dataset.renderer = e.rendererId), t.appendChild(n);
          });
        }
      } else {
        t.innerHTML = e.map(function (t) {
          return t.template;
        }).join("");
        var r = Array.from(t.children);
        e.forEach(function (t, e) {
          var n = r[e];
          n.dataset.columnId = t.column.id, n.dataset.renderer = t.rendererId;
        });
      }
    }

    function f(t, e) {
      return void 0 === e && (e = t.labels.length), t.getWidth() / e > r.e;
    }

    function d(t) {
      return Object(i.d)(t).l > .5 ? "black" : "white";
    }

    function h(t, e, n, r) {
      var i = d(e);
      if (r <= .05 || "black" === i || r > .9) t.style.color = "black" === i || r <= .05 ? null : i;else {
        t.style.color = null, t.innerText = n, console.assert(null != t.ownerDocument);
        var o = t.ownerDocument.createElement("span");
        o.classList.add("lu-gradient-text"), o.style.color = i, o.innerText = n, t.appendChild(o);
      }
    }

    var g,
        b = (g = 0, function (t) {
      return "" + t + (g++).toString(36);
    }),
        m = 5;

    function y(t, e) {
      for (var n = [], r = 0, i = e; r < i.length; r++) {
        var o = i[r];

        if (!t.isMissing(o)) {
          var a = t.getLabel(o);
          if (n.push(a), n.length >= m) break;
        }
      }

      return n.join(", ") + (n.length < e.length ? ", ..." : "");
    }
  }, function (t, e, n) {
    "use strict";

    e.a = function (t) {
      for (var e = t.length / 6 | 0, n = new Array(e), r = 0; r < e;) {
        n[r] = "#" + t.slice(6 * r, 6 * ++r);
      }

      return n;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(33),
        o = n(42),
        a = n(2),
        u = n(1),
        c = n(27),
        s = n(3),
        l = n(17),
        p = n(7),
        f = n(22),
        d = n(28),
        h = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.currentFilter = Object(s.n)(), r.numberFormat = Object(i.a)(".2f"), r.currentGroupThresholds = [], r.groupSortMethod = s.b.median, r.mapping = Object(l.e)(n), r.original = r.mapping.clone(), r.colorMapping = Object(d.h)(n), n.numberFormat && (r.numberFormat = Object(i.a)(n.numberFormat)), r.missingValue = null != n.missingValue ? n.missingValue : NaN, r.setGroupRenderer("boxplot"), r.setDefaultSummaryRenderer("histogram"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.map = this.mapping.dump(), n.colorMapping = this.colorMapping.dump(), n.filter = Object(s.i)(this.currentFilter) ? null : this.currentFilter, n.groupSortMethod = this.groupSortMethod, this.currentGroupThresholds && (n.stratifyThreshholds = this.currentGroupThresholds), n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.map ? this.mapping = Object(l.c)(e.map) : e.domain && (this.mapping = new l.a(e.domain, "linear", e.range || [0, 1])), e.colorMapping && (this.colorMapping = Object(d.e)(e.colorMapping)), e.groupSortMethod && (this.groupSortMethod = e.groupSortMethod), e.filter && (this.currentFilter = Object(s.p)(e.filter)), e.stratifyThreshholds && (this.currentGroupThresholds = e.stratifyThresholds), e.numberFormat && (this.numberFormat = Object(i.a)(e.numberFormat));
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_MAPPING_CHANGED, n.EVENT_COLOR_MAPPING_CHANGED, n.EVENT_FILTER_CHANGED, n.EVENT_SORTMETHOD_CHANGED, n.EVENT_GROUPING_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getLabel = function (e) {
        if (this.desc.numberFormat) {
          var n = this.getRawValue(e);
          return isNaN(n) ? "NaN" : isFinite(n) ? this.numberFormat(n) : n.toString();
        }

        var r = t.prototype.getValue.call(this, e);
        return "number" == typeof r ? this.numberFormat(+r) : String(r);
      }, e.prototype.getRange = function () {
        return this.mapping.getRange(this.numberFormat);
      }, e.prototype.getRawValue = function (e, n) {
        void 0 === n && (n = this.missingValue);
        var r = t.prototype.getValue.call(this, e);
        return Object(p.c)(r) ? n : +r;
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.getRawValue(e) : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.isMissing = function (e) {
        return Object(p.c)(t.prototype.getValue.call(this, e));
      }, e.prototype.getValue = function (t) {
        var e = this.getRawValue(t);
        return isNaN(e) ? e : this.mapping.apply(e);
      }, e.prototype.getNumber = function (t) {
        return this.getValue(t);
      }, e.prototype.getRawNumber = function (t, e) {
        return void 0 === e && (e = this.missingValue), this.getRawValue(t, e);
      }, e.prototype.compare = function (t, e) {
        return Object(s.o)(this.getNumber(t), this.getNumber(e), this.isMissing(t), this.isMissing(e));
      }, e.prototype.groupCompare = function (t, e) {
        return Object(c.b)(t.rows, e.rows, this, this.groupSortMethod);
      }, e.prototype.getOriginalMapping = function () {
        return this.original.clone();
      }, e.prototype.getMapping = function () {
        return this.mapping.clone();
      }, e.prototype.setMapping = function (t) {
        this.mapping.eq(t) || this.fire([n.EVENT_MAPPING_CHANGED, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY], this.mapping.clone(), this.mapping = t);
      }, e.prototype.getColor = function (t) {
        var e = this.getNumber(t);
        return isNaN(e) ? u.d.DEFAULT_COLOR : this.colorMapping.apply(e);
      }, e.prototype.getColorMapping = function () {
        return this.colorMapping.clone();
      }, e.prototype.setColorMapping = function (t) {
        this.colorMapping.eq(t) || this.fire([n.EVENT_COLOR_MAPPING_CHANGED, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY], this.colorMapping.clone(), this.colorMapping = t);
      }, e.prototype.isFiltered = function () {
        return !Object(s.i)(this.currentFilter);
      }, e.prototype.getFilter = function () {
        return Object.assign({}, this.currentFilter);
      }, e.prototype.setFilter = function (t) {
        if (void 0 === t && (t = {
          min: -1 / 0,
          max: 1 / 0,
          filterMissing: !1
        }), !Object(s.j)(t, this.currentFilter)) {
          var e = this.getFilter();
          this.currentFilter.min = Object(p.d)(t.min) ? -1 / 0 : t.min, this.currentFilter.max = Object(p.d)(t.max) ? 1 / 0 : t.max, this.currentFilter.filterMissing = t.filterMissing, this.fire([n.EVENT_FILTER_CHANGED, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY], e, this.getFilter());
        }
      }, e.prototype.filter = function (t) {
        return Object(s.l)(this.currentFilter, this.getRawNumber(t, NaN));
      }, e.prototype.getGroupThresholds = function () {
        return this.currentGroupThresholds.slice();
      }, e.prototype.setGroupThresholds = function (t) {
        if (!Object(o.b)(this.currentGroupThresholds, t)) {
          var e = this.getGroupThresholds();
          this.currentGroupThresholds = t.slice(), this.fire([n.EVENT_GROUPING_CHANGED, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY], e, t);
        }
      }, e.prototype.group = function (t) {
        if (this.isMissing(t)) return p.e;
        var e = this.currentGroupThresholds;

        if (0 === e.length) {
          var n = this.mapping.domain;
          e = [(n[1] - n[0]) / 2];
        }

        var r = this.getRawNumber(t),
            i = e.findIndex(function (t) {
          return r <= t;
        });

        switch (i) {
          case -1:
            return {
              name: this.label + " > " + e[e.length - 1],
              color: this.colorMapping.apply(1)
            };

          case 0:
            return {
              name: this.label + " <= " + e[0],
              color: this.colorMapping.apply(0)
            };

          default:
            return {
              name: e[i - 1] + " <= " + this.label + " <= " + e[i],
              color: this.colorMapping.apply(this.mapping.apply((e[i - 1] + e[i]) / 2))
            };
        }
      }, e.prototype.getSortMethod = function () {
        return this.groupSortMethod;
      }, e.prototype.setSortMethod = function (t) {
        this.groupSortMethod !== t && (this.fire([n.EVENT_SORTMETHOD_CHANGED], this.groupSortMethod, this.groupSortMethod = t), this.isGroupSortedByMe().asc || this.toggleMyGroupSorting());
      }, e.EVENT_MAPPING_CHANGED = "mappingChanged", e.EVENT_COLOR_MAPPING_CHANGED = "colorMappingChanged", e.EVENT_FILTER_CHANGED = "filterChanged", e.EVENT_SORTMETHOD_CHANGED = "sortMethodChanged", e.EVENT_GROUPING_CHANGED = "groupingChanged", e = n = Object(r.b)([Object(a.m)("groupBy", "sortGroupBy", "filterNumber", "colorMapped", "editMapping"), Object(a.h)("sortGroup", "sortNumber"), Object(a.h)("group", "groupNumber"), Object(a.b)("number"), Object(a.d)("descending")], e);
    }(f.b);

    e.b = h;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return void 0 === t || null == t || "number" == typeof t && isNaN(t) || "" === t || "NA" === t || "NaN" === t || "string" == typeof t && "na" === t.toLowerCase() || Array.isArray(t) && t.every(function (t) {
        return r(t);
      });
    }

    function i(t) {
      return null == t || void 0 === t || isNaN(t);
    }

    n.d(e, "c", function () {
      return r;
    }), n.d(e, "d", function () {
      return i;
    }), n.d(e, "b", function () {
      return o;
    }), n.d(e, "a", function () {
      return a;
    }), n.d(e, "e", function () {
      return u;
    });
    var o = -1,
        a = 1,
        u = {
      name: "Missing values",
      color: "gray"
    };
  }, function (t, e, n) {
    "use strict";

    n.d(e, "d", function () {
      return s;
    }), n.d(e, "e", function () {
      return l;
    }), n.d(e, "h", function () {
      return p;
    }), n.d(e, "f", function () {
      return f;
    }), n.d(e, "b", function () {
      return d;
    }), n.d(e, "a", function () {
      return h;
    }), n.d(e, "g", function () {
      return g;
    }), n.d(e, "c", function () {
      return b;
    });

    for (var r = n(121), i = new Map(), o = /^[$]([\w]+): ([\w #.()'\/,-]+)( !default)?;/gim, a = String(r), u = a.match(o); null != u;) {
      i.set(u[1], u[2]), u = a.match(o);
    }

    function c(t, e) {
      return void 0 === e && (e = ""), "$" === t[0] && (t = t.slice(1)), i.has(t) ? i.get(t) : e;
    }

    var s = parseInt(c("lu_engine_grip_gap", "5px"), 10),
        l = {
      width: parseInt(c("lu_missing_dash_width", "3px"), 10),
      height: parseInt(c("lu_missing_dash_height", "10px"), 10),
      color: c("lu_missing_dash_color", "gray")
    },
        p = {
      circle: c("lu_renderer_upset_circle_color"),
      inactive: parseFloat(c("lu_renderer_upset_inactive_opacity", "0.1")),
      stroke: c("lu_renderer_upset_stroke")
    },
        f = {
      color: c("lu_renderer_dot_color", "gray"),
      size: parseInt(c("lu_renderer_dot_size", "5px"), 10),
      opacity: parseFloat(c("lu_renderer_dot_opacity", "0.7"))
    },
        d = {
      box: c("lu_renderer_boxplot_box", "#e0e0e0"),
      stroke: c("lu_renderer_boxplot_stroke", "black"),
      sort: c("lu_renderer_boxplot_sort_indicator", "#ffa500"),
      outlier: c("lu_renderer_boxplot_outlier", "#e0e0e0")
    },
        h = {
      width: parseInt(c("lu_aggregate_square_bracket_width", "4px"), 10),
      strokeWidth: parseInt(c("lu_aggregate_square_bracket_stroke_width", "1px"), 10),
      color: c("lu_aggregate_square_bracket_stroke_color", "#000")
    },
        g = parseInt(c("lu_slopw_width", "200px"), 10),
        b = 4;
  }, function (t, e, n) {
    "use strict";

    var r;
    n.d(e, "a", function () {
      return r;
    }), function (t) {
      t[t.CELL = 0] = "CELL", t[t.GROUP = 1] = "GROUP", t[t.SUMMARY = 2] = "SUMMARY";
    }(r || (r = {}));
  }, function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return i;
    }), n.d(e, "b", function () {
      return o;
    }), n.d(e, "a", function () {
      return a;
    });
    var r = n(8);

    function i(t, e, n, i, o) {
      void 0 === i && (i = 0), void 0 === o && (o = 0);
      var a = Math.max(0, i + (e - r.e.width) / 2),
          u = Math.max(0, o + (n - r.e.height) / 2);
      t.fillStyle = r.e.color, t.fillRect(a, u, Math.min(e, r.e.width), Math.min(n, r.e.height));
    }

    function o(t, e, n) {
      var r = e.isMissing(n);
      return t.classList.toggle("lu-missing", r), r;
    }

    function a(t, e, n, o, a, u) {
      void 0 === a && (a = 0), void 0 === u && (u = 0);
      var c = e.isMissing(n);
      return c && i(t, o, r.c, a, u), c;
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(42),
        o = n(13),
        a = n(2),
        u = n(1),
        c = n(38),
        s = n(27),
        l = n(6),
        p = n(26),
        f = function (t) {
      function e(n, r, o) {
        void 0 === r && (r = 2), void 0 === o && (o = 1);
        var a = t.call(this) || this;
        return a.id = n, a.maxSortCriteria = r, a.maxGroupColumns = o, a.sortCriteria = [], a.groupSortCriteria = [], a.groupColumns = [], a.columns = [], a.comparator = function (t, e) {
          if (0 === a.sortCriteria.length) return t.i - e.i;

          for (var n = 0, r = a.sortCriteria; n < r.length; n++) {
            var i = r[n],
                o = i.col.compare(t, e);
            if (0 !== o) return i.asc ? o : -o;
          }

          return t.i - e.i;
        }, a.groupComparator = function (t, e) {
          if (0 === a.groupSortCriteria.length) return t.name.toLowerCase().localeCompare(e.name.toLowerCase());

          for (var n = 0, r = a.groupSortCriteria; n < r.length; n++) {
            var i = r[n],
                o = i.col.groupCompare(t, e);
            if (0 !== o) return i.asc ? o : -o;
          }

          return t.name.localeCompare(e.name);
        }, a.grouper = function (t) {
          var e = a.groupColumns;

          switch (e.length) {
            case 0:
              return c.a;

            case 1:
              return e[0].group(t);

            default:
              var n = e.map(function (e) {
                return e.group(t);
              });
              return Object(s.c)(n);
          }
        }, a.dirtyOrder = function () {
          a.fire([e.EVENT_DIRTY_ORDER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], a.getSortCriteria(), a.getGroupSortCriteria(), a.getGroupCriteria());
        }, a.groups = [Object.assign({
          order: []
        }, c.a)], a.id = Object(i.d)(n), a.label = "Ranking " + (n.startsWith("rank") ? n.slice(4) : n), a;
      }

      return Object(r.c)(e, t), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_WIDTH_CHANGED, e.EVENT_FILTER_CHANGED, e.EVENT_LABEL_CHANGED, e.EVENT_GROUPS_CHANGED, e.EVENT_ADD_COLUMN, e.EVENT_REMOVE_COLUMN, e.EVENT_GROUP_CRITERIA_CHANGED, e.EVENT_MOVE_COLUMN, e.EVENT_DIRTY, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_GROUP_SORT_CRITERIA_CHANGED, e.EVENT_COLUMN_VISIBILITY_CHANGED, e.EVENT_SORT_CRITERIA_CHANGED, e.EVENT_DIRTY_ORDER, e.EVENT_ORDER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.assignNewId = function (t) {
        this.id = Object(i.d)(t()), this.columns.forEach(function (e) {
          return e.assignNewId(t);
        });
      }, e.prototype.getLabel = function () {
        return this.label;
      }, e.prototype.setLabel = function (t) {
        t !== this.label && this.fire(e.EVENT_LABEL_CHANGED, this.label, this.label = t);
      }, e.prototype.setOrder = function (t) {
        this.setGroups([Object.assign({
          order: t
        }, c.a)]);
      }, e.prototype.setGroups = function (t) {
        var n = this.getOrder(),
            r = this.groups;
        this.groups = t, this.fire([e.EVENT_ORDER_CHANGED, e.EVENT_GROUPS_CHANGED, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], n, this.getOrder(), r, t);
      }, e.prototype.getOrder = function () {
        var t;

        switch (this.groups.length) {
          case 0:
            return [];

          case 1:
            return this.groups[0].order;

          default:
            return (t = []).concat.apply(t, this.groups.map(function (t) {
              return t.order;
            }));
        }
      }, e.prototype.getGroups = function () {
        return this.groups.slice();
      }, e.prototype.dump = function (t) {
        var e = {};
        return e.columns = this.columns.map(function (e) {
          return e.dump(t);
        }), e.sortCriteria = this.sortCriteria.map(function (t) {
          return {
            asc: t.asc,
            sortBy: t.col.id
          };
        }), e.groupSortCriteria = this.groupSortCriteria.map(function (t) {
          return {
            asc: t.asc,
            sortBy: t.col.id
          };
        }), e.groupColumns = this.groupColumns.map(function (t) {
          return t.id;
        }), e;
      }, e.prototype.restore = function (t, e) {
        var n = this;

        if (this.clear(), t.columns.map(function (t) {
          var r = e(t);
          r && n.push(r);
        }), t.sortColumn && t.sortColumn.sortBy) {
          var r = this.columns.find(function (e) {
            return e.id === t.sortColumn.sortBy;
          });
          r && this.sortBy(r, t.sortColumn.asc);
        }

        if (t.groupColumns) {
          var i = t.groupColumns.map(function (t) {
            return n.columns.find(function (e) {
              return e.id === t;
            });
          });
          this.groupBy(i);
        }

        var o = function o(t) {
          return t.map(function (t) {
            return {
              asc: t.asc,
              col: n.columns.find(function (e) {
                return e.id === t.sortBy;
              }) || null
            };
          }).filter(function (t) {
            return t.col;
          });
        };

        t.sortCriteria && this.setSortCriteria(o(t.sortCriteria)), t.groupSortCriteria && this.setGroupSortCriteria(o(t.groupSortCriteria));
      }, e.prototype.flatten = function (t, e, n, r) {
        void 0 === n && (n = 0), void 0 === r && (r = 0);
        var i = e;
        return (n > 0 || n <= u.d.FLAT_ALL_COLUMNS) && this.columns.forEach(function (e) {
          e.getVisible() && n <= u.d.FLAT_ALL_COLUMNS && (i += e.flatten(t, i, n - 1, r) + r);
        }), i - e;
      }, e.prototype.getPrimarySortCriteria = function () {
        return 0 === this.sortCriteria.length ? null : this.sortCriteria[0];
      }, e.prototype.getSortCriteria = function () {
        return this.sortCriteria.map(function (t) {
          return Object.assign({}, t);
        });
      }, e.prototype.getGroupSortCriteria = function () {
        return this.groupSortCriteria.map(function (t) {
          return Object.assign({}, t);
        });
      }, e.prototype.toggleSorting = function (t) {
        return this.setSortCriteria(this.toggleSortingLogic(t, this.sortCriteria));
      }, e.prototype.toggleSortingLogic = function (t, e) {
        var n = e.slice(),
            r = n.findIndex(function (e) {
          return e.col === t;
        }),
            i = Object(a.k)(t);
        return r < 0 ? n.splice(0, n.length, {
          col: t,
          asc: i
        }) : n[r].asc === i ? n.splice(r, 1, {
          col: t,
          asc: !i
        }) : n.splice(r, 1), n;
      }, e.prototype.toggleGrouping = function (t) {
        var e = this.groupColumns.indexOf(t);

        if (e >= 0) {
          var n = this.groupColumns.slice();
          return n.splice(e, 1), this.setGroupCriteria(n);
        }

        return this.setGroupCriteria([t]);
      }, e.prototype.getGroupCriteria = function () {
        return this.groupColumns.slice();
      }, e.prototype.sortBy = function (t, e, n) {
        return void 0 === e && (e = !1), void 0 === n && (n = 0), t.findMyRanker() === this && this.setSortCriteria(this.hierarchyLogic(this.sortCriteria, this.sortCriteria.findIndex(function (e) {
          return e.col === t;
        }), {
          col: t,
          asc: e
        }, n));
      }, e.prototype.groupSortBy = function (t, e, n) {
        return void 0 === e && (e = !1), void 0 === n && (n = 0), t.findMyRanker() === this && this.setGroupSortCriteria(this.hierarchyLogic(this.groupSortCriteria, this.groupSortCriteria.findIndex(function (e) {
          return e.col === t;
        }), {
          col: t,
          asc: e
        }, n));
      }, e.prototype.hierarchyLogic = function (t, e, n, r) {
        return t = t.slice(), e >= 0 ? (t.splice(e, 1), r >= 0 && t.splice(Math.min(r, t.length), 0, n)) : r >= 0 && (t[Math.min(r, t.length)] = n), t;
      }, e.prototype.groupBy = function (t, e) {
        return void 0 === e && (e = 0), t.findMyRanker() === this && this.setGroupCriteria(this.hierarchyLogic(this.groupColumns, this.groupColumns.indexOf(t), t, e));
      }, e.prototype.setSortCriteria = function (t) {
        var e,
            n = this,
            i = Array.isArray(t) ? t.slice() : [t];
        i.length > this.maxSortCriteria && i.splice(this.maxSortCriteria, i.length - this.maxSortCriteria);
        var o = this.sortCriteria.slice();
        return !d(i, o) && (o.forEach(function (t) {
          t.col.on(u.d.EVENT_DIRTY_VALUES + ".order", null), t.col.on(l.b.EVENT_SORTMETHOD_CHANGED + ".order", null);
        }), i.forEach(function (t) {
          t.col.on(u.d.EVENT_DIRTY_VALUES + ".order", n.dirtyOrder), t.col.on(l.b.EVENT_SORTMETHOD_CHANGED + ".order", n.dirtyOrder);
        }), (e = this.sortCriteria).splice.apply(e, Object(r.d)([0, this.sortCriteria.length], i.slice())), this.triggerResort(o), !0);
      }, e.prototype.setGroupCriteria = function (t) {
        var n,
            a = this,
            c = Array.isArray(t) ? t : [t];
        if (c.length > this.maxGroupColumns && (c = c.slice(0, this.maxGroupColumns)), Object(i.b)(this.groupColumns, c)) return !0;
        this.groupColumns.forEach(function (t) {
          t.on(Object(o.b)(".group", u.d.EVENT_DIRTY_VALUES, l.b.EVENT_SORTMETHOD_CHANGED, l.b.EVENT_GROUPING_CHANGED), null);
        });
        var s = this.groupColumns.slice();
        return (n = this.groupColumns).splice.apply(n, Object(r.d)([0, this.groupColumns.length], c)), this.groupColumns.forEach(function (t) {
          t.on(Object(o.b)(".group", u.d.EVENT_DIRTY_VALUES, l.b.EVENT_SORTMETHOD_CHANGED, l.b.EVENT_GROUPING_CHANGED), a.dirtyOrder);
        }), this.fire([e.EVENT_GROUP_CRITERIA_CHANGED, e.EVENT_DIRTY_ORDER, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], s, this.getGroupCriteria()), !0;
      }, e.prototype.toggleGroupSorting = function (t) {
        return this.setGroupSortCriteria(this.toggleSortingLogic(t, this.groupSortCriteria));
      }, e.prototype.setMaxSortCriteria = function (t) {
        var e = this.maxSortCriteria;
        e !== t && (this.maxSortCriteria = t, e < t || this.sortCriteria.length < t || this.setSortCriteria(this.sortCriteria.slice(0, t)));
      }, e.prototype.getMaxSortCriteria = function () {
        return this.maxSortCriteria;
      }, e.prototype.setMaxGroupColumns = function (t) {
        var e = this.maxGroupColumns;
        e !== t && (this.maxGroupColumns = t, e < t || this.groupColumns.length < t || this.setGroupCriteria(this.groupColumns.slice(0, t)));
      }, e.prototype.getMaxGroupColumns = function () {
        return this.maxGroupColumns;
      }, e.prototype.setGroupSortCriteria = function (t) {
        var e,
            n = this,
            i = Array.isArray(t) ? t.slice() : [t];
        i.length > this.maxSortCriteria && i.splice(this.maxSortCriteria, i.length - this.maxSortCriteria);
        var o = this.groupSortCriteria.slice();
        return !d(i, o) && (o.forEach(function (t) {
          t.col.on(u.d.EVENT_DIRTY_VALUES + ".groupOrder", null), t.col.on(l.b.EVENT_SORTMETHOD_CHANGED + ".groupOrder", null);
        }), i.forEach(function (t) {
          t.col.on(u.d.EVENT_DIRTY_VALUES + ".groupOrder", n.dirtyOrder), t.col.on(l.b.EVENT_SORTMETHOD_CHANGED + ".groupOrder", n.dirtyOrder);
        }), (e = this.groupSortCriteria).splice.apply(e, Object(r.d)([0, this.groupSortCriteria.length], i.slice())), this.triggerGroupResort(o), !0);
      }, e.prototype.triggerGroupResort = function (t) {
        var n = this.getGroupSortCriteria(),
            r = Array.isArray(t) ? t : n;
        this.fire([e.EVENT_GROUP_SORT_CRITERIA_CHANGED, e.EVENT_DIRTY_ORDER, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], r, n);
      }, e.prototype.triggerResort = function (t) {
        var n = this.getSortCriteria(),
            r = Array.isArray(t) ? t : n;
        this.fire([e.EVENT_SORT_CRITERIA_CHANGED, e.EVENT_DIRTY_ORDER, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], r, n);
      }, Object.defineProperty(e.prototype, "children", {
        get: function get() {
          return this.columns.slice();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "length", {
        get: function get() {
          return this.columns.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.insert = function (t, n) {
        var i = this;
        return void 0 === n && (n = this.columns.length), this.columns.splice(n, 0, t), t.attach(this), this.forward.apply(this, Object(r.d)([t], Object(o.b)(".ranking", u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY, l.b.EVENT_FILTER_CHANGED))), t.on(e.EVENT_FILTER_CHANGED + ".order", this.dirtyOrder), t.on(u.d.EVENT_VISIBILITY_CHANGED + ".ranking", function (n, r) {
          return i.fire([e.EVENT_COLUMN_VISIBILITY_CHANGED, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, n, r);
        }), this.fire([e.EVENT_ADD_COLUMN, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, n), t;
      }, e.prototype.move = function (t, n) {
        if (void 0 === n && (n = this.columns.length), t.parent !== this) return console.error("invalid move operation: ", t), null;
        var r = this.columns.indexOf(t);
        return n === r ? t : (this.columns.splice(r, 1), this.columns.splice(r < n ? n - 1 : n, 0, t), this.fire([e.EVENT_MOVE_COLUMN, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, n, r), t);
      }, e.prototype.moveAfter = function (t, e) {
        var n = this.columns.indexOf(e);
        return n < 0 ? null : this.move(t, n + 1);
      }, Object.defineProperty(e.prototype, "fqpath", {
        get: function get() {
          return "";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.findByPath = function (t) {
        for (var e = this, n = t.split("@").map(Number).slice(1); n.length > 0;) {
          var r = n.shift();
          e = e.at(r);
        }

        return e;
      }, e.prototype.indexOf = function (t) {
        return this.columns.indexOf(t);
      }, e.prototype.at = function (t) {
        return this.columns[t];
      }, e.prototype.insertAfter = function (t, e) {
        var n = this.columns.indexOf(e);
        return n < 0 ? null : this.insert(t, n + 1);
      }, e.prototype.push = function (t) {
        return this.insert(t);
      }, e.prototype.remove = function (t) {
        var n = this.columns.indexOf(t);
        if (n < 0) return !1;
        this.unforward.apply(this, Object(r.d)([t], Object(o.b)(".ranking", u.d.EVENT_VISIBILITY_CHANGED, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY, l.b.EVENT_FILTER_CHANGED)));
        var i = this.sortCriteria.findIndex(function (e) {
          return e.col === t;
        }),
            a = i >= 0;
        a && this.sortCriteria.splice(i, 1);
        var c = this.groupSortCriteria.findIndex(function (e) {
          return e.col === t;
        }),
            s = c >= 0;
        s && this.groupSortCriteria.splice(c, 1);
        var p = null,
            f = this.groupColumns.indexOf(t);
        return f >= 0 && (p = this.groupColumns.slice()).splice(f, 1), t.detach(), this.columns.splice(n, 1), this.fire([e.EVENT_REMOVE_COLUMN, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, n), p ? this.setGroupCriteria(p) : a ? this.triggerResort(null) : s && this.triggerGroupResort(null), !0;
      }, e.prototype.clear = function () {
        var t = this;

        if (0 !== this.columns.length) {
          this.sortCriteria.splice(0, this.sortCriteria.length), this.groupSortCriteria.splice(0, this.groupSortCriteria.length), this.groupColumns.forEach(function (t) {
            t.on(u.d.EVENT_DIRTY_VALUES + ".group", null), t.on(l.b.EVENT_SORTMETHOD_CHANGED + ".group", null);
          }), this.groupColumns.splice(0, this.groupColumns.length), this.columns.forEach(function (e) {
            t.unforward.apply(t, Object(r.d)([e], Object(o.b)(".ranking", u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY, l.b.EVENT_FILTER_CHANGED))), e.detach();
          });
          var n = this.columns.splice(0, this.columns.length);
          this.fire([e.EVENT_REMOVE_COLUMN, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], n);
        }
      }, Object.defineProperty(e.prototype, "flatColumns", {
        get: function get() {
          var t = [];
          return this.flatten(t, 0, u.d.FLAT_ALL_COLUMNS), t.map(function (t) {
            return t.col;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.find = function (t) {
        for (var e = "string" == typeof t ? function (e) {
          return e.id === t;
        } : t, n = 0, r = this.flatColumns; n < r.length; n++) {
          var i = r[n];
          if (e(i)) return i;
        }

        return null;
      }, e.prototype.isFiltered = function () {
        return this.columns.some(function (t) {
          return t.isFiltered();
        });
      }, e.prototype.filter = function (t) {
        return this.columns.every(function (e) {
          return e.filter(t);
        });
      }, e.prototype.findMyRanker = function () {
        return this;
      }, Object.defineProperty(e.prototype, "fqid", {
        get: function get() {
          return this.id;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.markDirty = function (t) {
        switch (void 0 === t && (t = "all"), t) {
          case "header":
            return this.fire([u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY]);

          case "values":
            return this.fire([u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY]);

          default:
            return this.fire([u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY]);
        }
      }, e.EVENT_WIDTH_CHANGED = u.d.EVENT_WIDTH_CHANGED, e.EVENT_FILTER_CHANGED = l.b.EVENT_FILTER_CHANGED, e.EVENT_LABEL_CHANGED = u.d.EVENT_LABEL_CHANGED, e.EVENT_ADD_COLUMN = p.b.EVENT_ADD_COLUMN, e.EVENT_MOVE_COLUMN = p.b.EVENT_MOVE_COLUMN, e.EVENT_REMOVE_COLUMN = p.b.EVENT_REMOVE_COLUMN, e.EVENT_DIRTY = u.d.EVENT_DIRTY, e.EVENT_DIRTY_HEADER = u.d.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES = u.d.EVENT_DIRTY_VALUES, e.EVENT_COLUMN_VISIBILITY_CHANGED = u.d.EVENT_VISIBILITY_CHANGED, e.EVENT_SORT_CRITERIA_CHANGED = "sortCriteriaChanged", e.EVENT_GROUP_CRITERIA_CHANGED = "groupCriteriaChanged", e.EVENT_GROUP_SORT_CRITERIA_CHANGED = "groupSortCriteriaChanged", e.EVENT_DIRTY_ORDER = "dirtyOrder", e.EVENT_ORDER_CHANGED = "orderChanged", e.EVENT_GROUPS_CHANGED = "groupsChanged", e;
    }(o.a);

    function d(t, e) {
      return t.length === e.length && t.every(function (t, n) {
        var r = e[n];
        return t.col === r.col && t.asc === r.asc;
      });
    }

    e.b = f;
  }, function (t, e, n) {
    "use strict";

    var r = function r(t, e) {
      return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
    },
        i = function i(t) {
      var e;
      return 1 === t.length && (e = t, t = function t(_t2, n) {
        return r(e(_t2), n);
      }), {
        left: function left(e, n, r, i) {
          for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
            var o = r + i >>> 1;
            t(e[o], n) < 0 ? r = o + 1 : i = o;
          }

          return r;
        },
        right: function right(e, n, r, i) {
          for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
            var o = r + i >>> 1;
            t(e[o], n) > 0 ? i = o : r = o + 1;
          }

          return r;
        }
      };
    };

    var o = i(r),
        a = o.right,
        u = (o.left, a);

    var c = function c(t) {
      return null === t ? NaN : +t;
    },
        s = function s(t, e) {
      var n,
          r,
          i,
          o = t.length,
          a = -1;

      if (null == e) {
        for (; ++a < o;) {
          if (null != (n = t[a]) && n >= n) for (r = i = n; ++a < o;) {
            null != (n = t[a]) && (r > n && (r = n), i < n && (i = n));
          }
        }
      } else for (; ++a < o;) {
        if (null != (n = e(t[a], a, t)) && n >= n) for (r = i = n; ++a < o;) {
          null != (n = e(t[a], a, t)) && (r > n && (r = n), i < n && (i = n));
        }
      }

      return [r, i];
    },
        l = Array.prototype,
        p = l.slice,
        f = (l.map, function (t) {
      return function () {
        return t;
      };
    }),
        d = function d(t) {
      return t;
    },
        h = function h(t, e, n) {
      t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;

      for (var r = -1, i = 0 | Math.max(0, Math.ceil((e - t) / n)), o = new Array(i); ++r < i;) {
        o[r] = t + r * n;
      }

      return o;
    },
        g = Math.sqrt(50),
        b = Math.sqrt(10),
        m = Math.sqrt(2),
        y = function y(t, e, n) {
      var r,
          i,
          o,
          a,
          u = -1;
      if (n = +n, (t = +t) === (e = +e) && n > 0) return [t];
      if ((r = e < t) && (i = t, t = e, e = i), 0 === (a = v(t, e, n)) || !isFinite(a)) return [];
      if (a > 0) for (t = Math.ceil(t / a), e = Math.floor(e / a), o = new Array(i = Math.ceil(e - t + 1)); ++u < i;) {
        o[u] = (t + u) * a;
      } else for (t = Math.floor(t * a), e = Math.ceil(e * a), o = new Array(i = Math.ceil(t - e + 1)); ++u < i;) {
        o[u] = (t - u) / a;
      }
      return r && o.reverse(), o;
    };

    function v(t, e, n) {
      var r = (e - t) / Math.max(0, n),
          i = Math.floor(Math.log(r) / Math.LN10),
          o = r / Math.pow(10, i);
      return i >= 0 ? (o >= g ? 10 : o >= b ? 5 : o >= m ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (o >= g ? 10 : o >= b ? 5 : o >= m ? 2 : 1);
    }

    function E(t, e, n) {
      var r = Math.abs(e - t) / Math.max(0, n),
          i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
          o = r / i;
      return o >= g ? i *= 10 : o >= b ? i *= 5 : o >= m && (i *= 2), e < t ? -i : i;
    }

    var O = function O(t) {
      return Math.ceil(Math.log(t.length) / Math.LN2) + 1;
    },
        C = function C() {
      var t = d,
          e = s,
          n = O;

      function r(r) {
        var i,
            o,
            a = r.length,
            c = new Array(a);

        for (i = 0; i < a; ++i) {
          c[i] = t(r[i], i, r);
        }

        var s = e(c),
            l = s[0],
            p = s[1],
            f = n(c, l, p);
        Array.isArray(f) || (f = E(l, p, f), f = h(Math.ceil(l / f) * f, p, f));

        for (var d = f.length; f[0] <= l;) {
          f.shift(), --d;
        }

        for (; f[d - 1] > p;) {
          f.pop(), --d;
        }

        var g,
            b = new Array(d + 1);

        for (i = 0; i <= d; ++i) {
          (g = b[i] = []).x0 = i > 0 ? f[i - 1] : l, g.x1 = i < d ? f[i] : p;
        }

        for (i = 0; i < a; ++i) {
          l <= (o = c[i]) && o <= p && b[u(f, o, 0, d)].push(r[i]);
        }

        return b;
      }

      return r.value = function (e) {
        return arguments.length ? (t = "function" == typeof e ? e : f(e), r) : t;
      }, r.domain = function (t) {
        return arguments.length ? (e = "function" == typeof t ? t : f([t[0], t[1]]), r) : e;
      }, r.thresholds = function (t) {
        return arguments.length ? (n = "function" == typeof t ? t : Array.isArray(t) ? f(p.call(t)) : f(t), r) : n;
      }, r;
    },
        _ = function _(t, e, n) {
      if (null == n && (n = c), r = t.length) {
        if ((e = +e) <= 0 || r < 2) return +n(t[0], 0, t);
        if (e >= 1) return +n(t[r - 1], r - 1, t);
        var r,
            i = (r - 1) * e,
            o = Math.floor(i),
            a = +n(t[o], o, t);
        return a + (+n(t[o + 1], o + 1, t) - a) * (i - o);
      }
    },
        T = function T(t, e) {
      var n,
          r,
          i = t.length,
          o = -1;

      if (null == e) {
        for (; ++o < i;) {
          if (null != (n = t[o]) && n >= n) for (r = n; ++o < i;) {
            null != (n = t[o]) && n > r && (r = n);
          }
        }
      } else for (; ++o < i;) {
        if (null != (n = e(t[o], o, t)) && n >= n) for (r = n; ++o < i;) {
          null != (n = e(t[o], o, t)) && n > r && (r = n);
        }
      }

      return r;
    },
        N = function N(t, e) {
      var n,
          r = t.length,
          i = r,
          o = -1,
          a = 0;
      if (null == e) for (; ++o < r;) {
        isNaN(n = c(t[o])) ? --i : a += n;
      } else for (; ++o < r;) {
        isNaN(n = c(e(t[o], o, t))) ? --i : a += n;
      }
      if (i) return a / i;
    },
        D = function D(t, e) {
      var n,
          i = t.length,
          o = -1,
          a = [];
      if (null == e) for (; ++o < i;) {
        isNaN(n = c(t[o])) || a.push(n);
      } else for (; ++o < i;) {
        isNaN(n = c(e(t[o], o, t))) || a.push(n);
      }
      return _(a.sort(r), .5);
    },
        R = function R(t, e) {
      var n,
          r,
          i = t.length,
          o = -1;

      if (null == e) {
        for (; ++o < i;) {
          if (null != (n = t[o]) && n >= n) for (r = n; ++o < i;) {
            null != (n = t[o]) && r > n && (r = n);
          }
        }
      } else for (; ++o < i;) {
        if (null != (n = e(t[o], o, t)) && n >= n) for (r = n; ++o < i;) {
          null != (n = e(t[o], o, t)) && r > n && (r = n);
        }
      }

      return r;
    };

    n.d(e, "b", function () {
      return u;
    }), n.d(e, "a", function () {
      return r;
    }), n.d(e, "c", function () {
      return i;
    }), n.d(e, "d", function () {
      return s;
    }), n.d(e, "e", function () {
      return C;
    }), n.d(e, "f", function () {
      return T;
    }), n.d(e, "g", function () {
      return N;
    }), n.d(e, "h", function () {
      return D;
    }), n.d(e, "i", function () {
      return R;
    }), n.d(e, "j", function () {
      return _;
    }), n.d(e, "k", function () {
      return h;
    }), n.d(e, "n", function () {
      return y;
    }), n.d(e, "l", function () {
      return v;
    }), n.d(e, "m", function () {
      return E;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = {
      value: function value() {}
    };

    function o() {
      for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
        if (!(t = arguments[e] + "") || t in r) throw new Error("illegal type: " + t);
        r[t] = [];
      }

      return new a(r);
    }

    function a(t) {
      this._ = t;
    }

    function u(t, e) {
      return t.trim().split(/^|\s+/).map(function (t) {
        var n = "",
            r = t.indexOf(".");
        if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
          type: t,
          name: n
        };
      });
    }

    function c(t, e) {
      for (var n, r = 0, i = t.length; r < i; ++r) {
        if ((n = t[r]).name === e) return n.value;
      }
    }

    function s(t, e, n) {
      for (var r = 0, o = t.length; r < o; ++r) {
        if (t[r].name === e) {
          t[r] = i, t = t.slice(0, r).concat(t.slice(r + 1));
          break;
        }
      }

      return null != n && t.push({
        name: e,
        value: n
      }), t;
    }

    a.prototype = o.prototype = {
      constructor: a,
      on: function on(t, e) {
        var n,
            r = this._,
            i = u(t + "", r),
            o = -1,
            a = i.length;

        if (!(arguments.length < 2)) {
          if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

          for (; ++o < a;) {
            if (n = (t = i[o]).type) r[n] = s(r[n], t.name, e);else if (null == e) for (n in r) {
              r[n] = s(r[n], t.name, null);
            }
          }

          return this;
        }

        for (; ++o < a;) {
          if ((n = (t = i[o]).type) && (n = c(r[n], t.name))) return n;
        }
      },
      copy: function copy() {
        var t = {},
            e = this._;

        for (var n in e) {
          t[n] = e[n].slice();
        }

        return new a(t);
      },
      call: function call(t, e) {
        if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), o = 0; o < n; ++o) {
          i[o] = arguments[o + 2];
        }
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (o = 0, n = (r = this._[t]).length; o < n; ++o) {
          r[o].value.apply(e, i);
        }
      },
      apply: function apply(t, e, n) {
        if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

        for (var r = this._[t], i = 0, o = r.length; i < o; ++i) {
          r[i].value.apply(e, n);
        }
      }
    };
    var l = o;

    function p(t) {
      for (var e = [], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }

      return e.map(function (e) {
        return "" + e + t;
      });
    }

    n.d(e, "b", function () {
      return p;
    });

    var f = function () {
      function t() {
        var t = this.createEventList();
        this.listenerEvents = new Set(t), this.listeners = l.apply(void 0, t);
        var e = this;

        this.forwarder = function () {
          for (var t = [], n = 0; n < arguments.length; n++) {
            t[n] = arguments[n];
          }

          e.fireImpl.apply(e, Object(r.d)([this.type, this.primaryType, this.origin], t));
        };
      }

      return t.prototype.on = function (t, e) {
        var n = this;
        return Array.isArray(t) ? t.forEach(function (t) {
          n.listenerEvents.has(t.split(".")[0]) && (n.listenersChanged(t, Boolean(e)), n.listeners.on(t, e));
        }) : this.listenerEvents.has(t.split(".")[0]) && (this.listenersChanged(t, Boolean(e)), this.listeners.on(t, e)), this;
      }, t.prototype.listenersChanged = function (t, e) {}, t.prototype.createEventList = function () {
        return [];
      }, t.prototype.fire = function (t) {
        for (var e = [], n = 1; n < arguments.length; n++) {
          e[n - 1] = arguments[n];
        }

        var i = Array.isArray(t) ? t[0] : t;
        this.fireImpl.apply(this, Object(r.d)([t, i, this], e));
      }, t.prototype.fireImpl = function (t, e, n) {
        for (var r = this, i = [], o = 3; o < arguments.length; o++) {
          i[o - 3] = arguments[o];
        }

        var a = function a(t) {
          if (r.listenerEvents.has(t)) {
            var o = {
              source: r,
              origin: n,
              type: t,
              primaryType: e,
              args: i
            };
            r.listeners.apply(t, o, i);
          }
        };

        Array.isArray(t) ? t.forEach(a.bind(this)) : a(t);
      }, t.prototype.forward = function (t) {
        for (var e = [], n = 1; n < arguments.length; n++) {
          e[n - 1] = arguments[n];
        }

        t.on(e, this.forwarder);
      }, t.prototype.unforward = function (t) {
        for (var e = [], n = 1; n < arguments.length; n++) {
          e[n - 1] = arguments[n];
        }

        t.on(e, null);
      }, t;
    }();

    e.a = f;
  }, function (t, e, n) {
    "use strict";
    /**!
     * @fileOverview Kickass library to create and place poppers near their reference elements.
     * @version 1.15.0
     * @license
     * Copyright (c) 2016 Federico Zivolo and contributors
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all
     * copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */

    for (var r = "undefined" != typeof window && "undefined" != typeof document, i = ["Edge", "Trident", "Firefox"], o = 0, a = 0; a < i.length; a += 1) {
      if (r && navigator.userAgent.indexOf(i[a]) >= 0) {
        o = 1;
        break;
      }
    }

    var u = r && window.Promise ? function (t) {
      var e = !1;
      return function () {
        e || (e = !0, window.Promise.resolve().then(function () {
          e = !1, t();
        }));
      };
    } : function (t) {
      var e = !1;
      return function () {
        e || (e = !0, setTimeout(function () {
          e = !1, t();
        }, o));
      };
    };

    function c(t) {
      return t && "[object Function]" === {}.toString.call(t);
    }

    function s(t, e) {
      if (1 !== t.nodeType) return [];
      var n = t.ownerDocument.defaultView.getComputedStyle(t, null);
      return e ? n[e] : n;
    }

    function l(t) {
      return "HTML" === t.nodeName ? t : t.parentNode || t.host;
    }

    function p(t) {
      if (!t) return document.body;

      switch (t.nodeName) {
        case "HTML":
        case "BODY":
          return t.ownerDocument.body;

        case "#document":
          return t.body;
      }

      var e = s(t),
          n = e.overflow,
          r = e.overflowX,
          i = e.overflowY;
      return /(auto|scroll|overlay)/.test(n + i + r) ? t : p(l(t));
    }

    var f = r && !(!window.MSInputMethodContext || !document.documentMode),
        d = r && /MSIE 10/.test(navigator.userAgent);

    function h(t) {
      return 11 === t ? f : 10 === t ? d : f || d;
    }

    function g(t) {
      if (!t) return document.documentElement;

      for (var e = h(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling;) {
        n = (t = t.nextElementSibling).offsetParent;
      }

      var r = n && n.nodeName;
      return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === s(n, "position") ? g(n) : n : t ? t.ownerDocument.documentElement : document.documentElement;
    }

    function b(t) {
      return null !== t.parentNode ? b(t.parentNode) : t;
    }

    function m(t, e) {
      if (!(t && t.nodeType && e && e.nodeType)) return document.documentElement;
      var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
          r = n ? t : e,
          i = n ? e : t,
          o = document.createRange();
      o.setStart(r, 0), o.setEnd(i, 0);
      var a,
          u,
          c = o.commonAncestorContainer;
      if (t !== c && e !== c || r.contains(i)) return "BODY" === (u = (a = c).nodeName) || "HTML" !== u && g(a.firstElementChild) !== a ? g(c) : c;
      var s = b(t);
      return s.host ? m(s.host, e) : m(t, b(e).host);
    }

    function y(t) {
      var e = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft",
          n = t.nodeName;

      if ("BODY" === n || "HTML" === n) {
        var r = t.ownerDocument.documentElement;
        return (t.ownerDocument.scrollingElement || r)[e];
      }

      return t[e];
    }

    function v(t, e) {
      var n = "x" === e ? "Left" : "Top",
          r = "Left" === n ? "Right" : "Bottom";
      return parseFloat(t["border" + n + "Width"], 10) + parseFloat(t["border" + r + "Width"], 10);
    }

    function E(t, e, n, r) {
      return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], h(10) ? parseInt(n["offset" + t]) + parseInt(r["margin" + ("Height" === t ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === t ? "Bottom" : "Right")]) : 0);
    }

    function O(t) {
      var e = t.body,
          n = t.documentElement,
          r = h(10) && getComputedStyle(n);
      return {
        height: E("Height", e, n, r),
        width: E("Width", e, n, r)
      };
    }

    var C = function C(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    },
        _ = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        T = function T(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    },
        N = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    };

    function D(t) {
      return N({}, t, {
        right: t.left + t.width,
        bottom: t.top + t.height
      });
    }

    function R(t) {
      var e = {};

      try {
        if (h(10)) {
          e = t.getBoundingClientRect();
          var n = y(t, "top"),
              r = y(t, "left");
          e.top += n, e.left += r, e.bottom += n, e.right += r;
        } else e = t.getBoundingClientRect();
      } catch (t) {}

      var i = {
        left: e.left,
        top: e.top,
        width: e.right - e.left,
        height: e.bottom - e.top
      },
          o = "HTML" === t.nodeName ? O(t.ownerDocument) : {},
          a = o.width || t.clientWidth || i.right - i.left,
          u = o.height || t.clientHeight || i.bottom - i.top,
          c = t.offsetWidth - a,
          l = t.offsetHeight - u;

      if (c || l) {
        var p = s(t);
        c -= v(p, "x"), l -= v(p, "y"), i.width -= c, i.height -= l;
      }

      return D(i);
    }

    function w(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = h(10),
          i = "HTML" === e.nodeName,
          o = R(t),
          a = R(e),
          u = p(t),
          c = s(e),
          l = parseFloat(c.borderTopWidth, 10),
          f = parseFloat(c.borderLeftWidth, 10);
      n && i && (a.top = Math.max(a.top, 0), a.left = Math.max(a.left, 0));
      var d = D({
        top: o.top - a.top - l,
        left: o.left - a.left - f,
        width: o.width,
        height: o.height
      });

      if (d.marginTop = 0, d.marginLeft = 0, !r && i) {
        var g = parseFloat(c.marginTop, 10),
            b = parseFloat(c.marginLeft, 10);
        d.top -= l - g, d.bottom -= l - g, d.left -= f - b, d.right -= f - b, d.marginTop = g, d.marginLeft = b;
      }

      return (r && !n ? e.contains(u) : e === u && "BODY" !== u.nodeName) && (d = function (t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = y(e, "top"),
            i = y(e, "left"),
            o = n ? -1 : 1;
        return t.top += r * o, t.bottom += r * o, t.left += i * o, t.right += i * o, t;
      }(d, e)), d;
    }

    function A(t) {
      if (!t || !t.parentElement || h()) return document.documentElement;

      for (var e = t.parentElement; e && "none" === s(e, "transform");) {
        e = e.parentElement;
      }

      return e || document.documentElement;
    }

    function M(t, e, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
          o = {
        top: 0,
        left: 0
      },
          a = i ? A(t) : m(t, e);
      if ("viewport" === r) o = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = t.ownerDocument.documentElement,
            r = w(t, n),
            i = Math.max(n.clientWidth, window.innerWidth || 0),
            o = Math.max(n.clientHeight, window.innerHeight || 0),
            a = e ? 0 : y(n),
            u = e ? 0 : y(n, "left");
        return D({
          top: a - r.top + r.marginTop,
          left: u - r.left + r.marginLeft,
          width: i,
          height: o
        });
      }(a, i);else {
        var u = void 0;
        "scrollParent" === r ? "BODY" === (u = p(l(e))).nodeName && (u = t.ownerDocument.documentElement) : u = "window" === r ? t.ownerDocument.documentElement : r;
        var c = w(u, a, i);
        if ("HTML" !== u.nodeName || function t(e) {
          var n = e.nodeName;
          if ("BODY" === n || "HTML" === n) return !1;
          if ("fixed" === s(e, "position")) return !0;
          var r = l(e);
          return !!r && t(r);
        }(a)) o = c;else {
          var f = O(t.ownerDocument),
              d = f.height,
              h = f.width;
          o.top += c.top - c.marginTop, o.bottom = d + c.top, o.left += c.left - c.marginLeft, o.right = h + c.left;
        }
      }
      var g = "number" == typeof (n = n || 0);
      return o.left += g ? n : n.left || 0, o.top += g ? n : n.top || 0, o.right -= g ? n : n.right || 0, o.bottom -= g ? n : n.bottom || 0, o;
    }

    function L(t, e, n, r, i) {
      var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
      if (-1 === t.indexOf("auto")) return t;
      var a = M(n, r, o, i),
          u = {
        top: {
          width: a.width,
          height: e.top - a.top
        },
        right: {
          width: a.right - e.right,
          height: a.height
        },
        bottom: {
          width: a.width,
          height: a.bottom - e.bottom
        },
        left: {
          width: e.left - a.left,
          height: a.height
        }
      },
          c = Object.keys(u).map(function (t) {
        return N({
          key: t
        }, u[t], {
          area: (e = u[t], e.width * e.height)
        });
        var e;
      }).sort(function (t, e) {
        return e.area - t.area;
      }),
          s = c.filter(function (t) {
        var e = t.width,
            r = t.height;
        return e >= n.clientWidth && r >= n.clientHeight;
      }),
          l = s.length > 0 ? s[0].key : c[0].key,
          p = t.split("-")[1];
      return l + (p ? "-" + p : "");
    }

    function j(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
      return w(n, r ? A(e) : m(e, n), r);
    }

    function x(t) {
      var e = t.ownerDocument.defaultView.getComputedStyle(t),
          n = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0),
          r = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);
      return {
        width: t.offsetWidth + r,
        height: t.offsetHeight + n
      };
    }

    function S(t) {
      var e = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
      };
      return t.replace(/left|right|bottom|top/g, function (t) {
        return e[t];
      });
    }

    function I(t, e, n) {
      n = n.split("-")[0];
      var r = x(t),
          i = {
        width: r.width,
        height: r.height
      },
          o = -1 !== ["right", "left"].indexOf(n),
          a = o ? "top" : "left",
          u = o ? "left" : "top",
          c = o ? "height" : "width",
          s = o ? "width" : "height";
      return i[a] = e[a] + e[c] / 2 - r[c] / 2, i[u] = n === u ? e[u] - r[s] : e[S(u)], i;
    }

    function V(t, e) {
      return Array.prototype.find ? t.find(e) : t.filter(e)[0];
    }

    function k(t, e, n) {
      return (void 0 === n ? t : t.slice(0, function (t, e, n) {
        if (Array.prototype.findIndex) return t.findIndex(function (t) {
          return t[e] === n;
        });
        var r = V(t, function (t) {
          return t[e] === n;
        });
        return t.indexOf(r);
      }(t, "name", n))).forEach(function (t) {
        t.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var n = t.function || t.fn;
        t.enabled && c(n) && (e.offsets.popper = D(e.offsets.popper), e.offsets.reference = D(e.offsets.reference), e = n(e, t));
      }), e;
    }

    function H() {
      if (!this.state.isDestroyed) {
        var t = {
          instance: this,
          styles: {},
          arrowStyles: {},
          attributes: {},
          flipped: !1,
          offsets: {}
        };
        t.offsets.reference = j(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = L(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = I(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = k(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
      }
    }

    function P(t, e) {
      return t.some(function (t) {
        var n = t.name;
        return t.enabled && n === e;
      });
    }

    function G(t) {
      for (var e = [!1, "ms", "Webkit", "Moz", "O"], n = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
        var i = e[r],
            o = i ? "" + i + n : t;
        if (void 0 !== document.body.style[o]) return o;
      }

      return null;
    }

    function F() {
      return this.state.isDestroyed = !0, P(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[G("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
    }

    function U(t) {
      var e = t.ownerDocument;
      return e ? e.defaultView : window;
    }

    function B(t, e, n, r) {
      n.updateBound = r, U(t).addEventListener("resize", n.updateBound, {
        passive: !0
      });
      var i = p(t);
      return function t(e, n, r, i) {
        var o = "BODY" === e.nodeName,
            a = o ? e.ownerDocument.defaultView : e;
        a.addEventListener(n, r, {
          passive: !0
        }), o || t(p(a.parentNode), n, r, i), i.push(a);
      }(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
    }

    function Y() {
      this.state.eventsEnabled || (this.state = B(this.reference, this.options, this.state, this.scheduleUpdate));
    }

    function W() {
      var t, e;
      this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (t = this.reference, e = this.state, U(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function (t) {
        t.removeEventListener("scroll", e.updateBound);
      }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e));
    }

    function q(t) {
      return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
    }

    function z(t, e) {
      Object.keys(e).forEach(function (n) {
        var r = "";
        -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && q(e[n]) && (r = "px"), t.style[n] = e[n] + r;
      });
    }

    var K = r && /Firefox/i.test(navigator.userAgent);

    function X(t, e, n) {
      var r = V(t, function (t) {
        return t.name === e;
      }),
          i = !!r && t.some(function (t) {
        return t.name === n && t.enabled && t.order < r.order;
      });

      if (!i) {
        var o = "`" + e + "`",
            a = "`" + n + "`";
        console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!");
      }

      return i;
    }

    var $ = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
        J = $.slice(3);

    function Z(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = J.indexOf(t),
          r = J.slice(n + 1).concat(J.slice(0, n));
      return e ? r.reverse() : r;
    }

    var Q = {
      FLIP: "flip",
      CLOCKWISE: "clockwise",
      COUNTERCLOCKWISE: "counterclockwise"
    };

    function tt(t, e, n, r) {
      var i = [0, 0],
          o = -1 !== ["right", "left"].indexOf(r),
          a = t.split(/(\+|\-)/).map(function (t) {
        return t.trim();
      }),
          u = a.indexOf(V(a, function (t) {
        return -1 !== t.search(/,|\s/);
      }));
      a[u] && -1 === a[u].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
      var c = /\s*,\s*|\s+/,
          s = -1 !== u ? [a.slice(0, u).concat([a[u].split(c)[0]]), [a[u].split(c)[1]].concat(a.slice(u + 1))] : [a];
      return (s = s.map(function (t, r) {
        var i = (1 === r ? !o : o) ? "height" : "width",
            a = !1;
        return t.reduce(function (t, e) {
          return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e) ? (t[t.length - 1] = e, a = !0, t) : a ? (t[t.length - 1] += e, a = !1, t) : t.concat(e);
        }, []).map(function (t) {
          return function (t, e, n, r) {
            var i = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                o = +i[1],
                a = i[2];
            if (!o) return t;

            if (0 === a.indexOf("%")) {
              var u = void 0;

              switch (a) {
                case "%p":
                  u = n;
                  break;

                case "%":
                case "%r":
                default:
                  u = r;
              }

              return D(u)[e] / 100 * o;
            }

            if ("vh" === a || "vw" === a) {
              return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
            }

            return o;
          }(t, i, e, n);
        });
      })).forEach(function (t, e) {
        t.forEach(function (n, r) {
          q(n) && (i[e] += n * ("-" === t[r - 1] ? -1 : 1));
        });
      }), i;
    }

    var et = {
      placement: "bottom",
      positionFixed: !1,
      eventsEnabled: !0,
      removeOnDestroy: !1,
      onCreate: function onCreate() {},
      onUpdate: function onUpdate() {},
      modifiers: {
        shift: {
          order: 100,
          enabled: !0,
          fn: function fn(t) {
            var e = t.placement,
                n = e.split("-")[0],
                r = e.split("-")[1];

            if (r) {
              var i = t.offsets,
                  o = i.reference,
                  a = i.popper,
                  u = -1 !== ["bottom", "top"].indexOf(n),
                  c = u ? "left" : "top",
                  s = u ? "width" : "height",
                  l = {
                start: T({}, c, o[c]),
                end: T({}, c, o[c] + o[s] - a[s])
              };
              t.offsets.popper = N({}, a, l[r]);
            }

            return t;
          }
        },
        offset: {
          order: 200,
          enabled: !0,
          fn: function fn(t, e) {
            var n = e.offset,
                r = t.placement,
                i = t.offsets,
                o = i.popper,
                a = i.reference,
                u = r.split("-")[0],
                c = void 0;
            return c = q(+n) ? [+n, 0] : tt(n, o, a, u), "left" === u ? (o.top += c[0], o.left -= c[1]) : "right" === u ? (o.top += c[0], o.left += c[1]) : "top" === u ? (o.left += c[0], o.top -= c[1]) : "bottom" === u && (o.left += c[0], o.top += c[1]), t.popper = o, t;
          },
          offset: 0
        },
        preventOverflow: {
          order: 300,
          enabled: !0,
          fn: function fn(t, e) {
            var n = e.boundariesElement || g(t.instance.popper);
            t.instance.reference === n && (n = g(n));
            var r = G("transform"),
                i = t.instance.popper.style,
                o = i.top,
                a = i.left,
                u = i[r];
            i.top = "", i.left = "", i[r] = "";
            var c = M(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);
            i.top = o, i.left = a, i[r] = u, e.boundaries = c;
            var s = e.priority,
                l = t.offsets.popper,
                p = {
              primary: function primary(t) {
                var n = l[t];
                return l[t] < c[t] && !e.escapeWithReference && (n = Math.max(l[t], c[t])), T({}, t, n);
              },
              secondary: function secondary(t) {
                var n = "right" === t ? "left" : "top",
                    r = l[n];
                return l[t] > c[t] && !e.escapeWithReference && (r = Math.min(l[n], c[t] - ("right" === t ? l.width : l.height))), T({}, n, r);
              }
            };
            return s.forEach(function (t) {
              var e = -1 !== ["left", "top"].indexOf(t) ? "primary" : "secondary";
              l = N({}, l, p[e](t));
            }), t.offsets.popper = l, t;
          },
          priority: ["left", "right", "top", "bottom"],
          padding: 5,
          boundariesElement: "scrollParent"
        },
        keepTogether: {
          order: 400,
          enabled: !0,
          fn: function fn(t) {
            var e = t.offsets,
                n = e.popper,
                r = e.reference,
                i = t.placement.split("-")[0],
                o = Math.floor,
                a = -1 !== ["top", "bottom"].indexOf(i),
                u = a ? "right" : "bottom",
                c = a ? "left" : "top",
                s = a ? "width" : "height";
            return n[u] < o(r[c]) && (t.offsets.popper[c] = o(r[c]) - n[s]), n[c] > o(r[u]) && (t.offsets.popper[c] = o(r[u])), t;
          }
        },
        arrow: {
          order: 500,
          enabled: !0,
          fn: function fn(t, e) {
            var n;
            if (!X(t.instance.modifiers, "arrow", "keepTogether")) return t;
            var r = e.element;

            if ("string" == typeof r) {
              if (!(r = t.instance.popper.querySelector(r))) return t;
            } else if (!t.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;

            var i = t.placement.split("-")[0],
                o = t.offsets,
                a = o.popper,
                u = o.reference,
                c = -1 !== ["left", "right"].indexOf(i),
                l = c ? "height" : "width",
                p = c ? "Top" : "Left",
                f = p.toLowerCase(),
                d = c ? "left" : "top",
                h = c ? "bottom" : "right",
                g = x(r)[l];
            u[h] - g < a[f] && (t.offsets.popper[f] -= a[f] - (u[h] - g)), u[f] + g > a[h] && (t.offsets.popper[f] += u[f] + g - a[h]), t.offsets.popper = D(t.offsets.popper);
            var b = u[f] + u[l] / 2 - g / 2,
                m = s(t.instance.popper),
                y = parseFloat(m["margin" + p], 10),
                v = parseFloat(m["border" + p + "Width"], 10),
                E = b - t.offsets.popper[f] - y - v;
            return E = Math.max(Math.min(a[l] - g, E), 0), t.arrowElement = r, t.offsets.arrow = (T(n = {}, f, Math.round(E)), T(n, d, ""), n), t;
          },
          element: "[x-arrow]"
        },
        flip: {
          order: 600,
          enabled: !0,
          fn: function fn(t, e) {
            if (P(t.instance.modifiers, "inner")) return t;
            if (t.flipped && t.placement === t.originalPlacement) return t;
            var n = M(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed),
                r = t.placement.split("-")[0],
                i = S(r),
                o = t.placement.split("-")[1] || "",
                a = [];

            switch (e.behavior) {
              case Q.FLIP:
                a = [r, i];
                break;

              case Q.CLOCKWISE:
                a = Z(r);
                break;

              case Q.COUNTERCLOCKWISE:
                a = Z(r, !0);
                break;

              default:
                a = e.behavior;
            }

            return a.forEach(function (u, c) {
              if (r !== u || a.length === c + 1) return t;
              r = t.placement.split("-")[0], i = S(r);
              var s = t.offsets.popper,
                  l = t.offsets.reference,
                  p = Math.floor,
                  f = "left" === r && p(s.right) > p(l.left) || "right" === r && p(s.left) < p(l.right) || "top" === r && p(s.bottom) > p(l.top) || "bottom" === r && p(s.top) < p(l.bottom),
                  d = p(s.left) < p(n.left),
                  h = p(s.right) > p(n.right),
                  g = p(s.top) < p(n.top),
                  b = p(s.bottom) > p(n.bottom),
                  m = "left" === r && d || "right" === r && h || "top" === r && g || "bottom" === r && b,
                  y = -1 !== ["top", "bottom"].indexOf(r),
                  v = !!e.flipVariations && (y && "start" === o && d || y && "end" === o && h || !y && "start" === o && g || !y && "end" === o && b),
                  E = !!e.flipVariationsByContent && (y && "start" === o && h || y && "end" === o && d || !y && "start" === o && b || !y && "end" === o && g),
                  O = v || E;
              (f || m || O) && (t.flipped = !0, (f || m) && (r = a[c + 1]), O && (o = function (t) {
                return "end" === t ? "start" : "start" === t ? "end" : t;
              }(o)), t.placement = r + (o ? "-" + o : ""), t.offsets.popper = N({}, t.offsets.popper, I(t.instance.popper, t.offsets.reference, t.placement)), t = k(t.instance.modifiers, t, "flip"));
            }), t;
          },
          behavior: "flip",
          padding: 5,
          boundariesElement: "viewport",
          flipVariations: !1,
          flipVariationsByContent: !1
        },
        inner: {
          order: 700,
          enabled: !1,
          fn: function fn(t) {
            var e = t.placement,
                n = e.split("-")[0],
                r = t.offsets,
                i = r.popper,
                o = r.reference,
                a = -1 !== ["left", "right"].indexOf(n),
                u = -1 === ["top", "left"].indexOf(n);
            return i[a ? "left" : "top"] = o[n] - (u ? i[a ? "width" : "height"] : 0), t.placement = S(e), t.offsets.popper = D(i), t;
          }
        },
        hide: {
          order: 800,
          enabled: !0,
          fn: function fn(t) {
            if (!X(t.instance.modifiers, "hide", "preventOverflow")) return t;
            var e = t.offsets.reference,
                n = V(t.instance.modifiers, function (t) {
              return "preventOverflow" === t.name;
            }).boundaries;

            if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
              if (!0 === t.hide) return t;
              t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
            } else {
              if (!1 === t.hide) return t;
              t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
            }

            return t;
          }
        },
        computeStyle: {
          order: 850,
          enabled: !0,
          fn: function fn(t, e) {
            var n = e.x,
                r = e.y,
                i = t.offsets.popper,
                o = V(t.instance.modifiers, function (t) {
              return "applyStyle" === t.name;
            }).gpuAcceleration;
            void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");

            var a = void 0 !== o ? o : e.gpuAcceleration,
                u = g(t.instance.popper),
                c = R(u),
                s = {
              position: i.position
            },
                l = function (t, e) {
              var n = t.offsets,
                  r = n.popper,
                  i = n.reference,
                  o = Math.round,
                  a = Math.floor,
                  u = function u(t) {
                return t;
              },
                  c = o(i.width),
                  s = o(r.width),
                  l = -1 !== ["left", "right"].indexOf(t.placement),
                  p = -1 !== t.placement.indexOf("-"),
                  f = e ? l || p || c % 2 == s % 2 ? o : a : u,
                  d = e ? o : u;

              return {
                left: f(c % 2 == 1 && s % 2 == 1 && !p && e ? r.left - 1 : r.left),
                top: d(r.top),
                bottom: d(r.bottom),
                right: f(r.right)
              };
            }(t, window.devicePixelRatio < 2 || !K),
                p = "bottom" === n ? "top" : "bottom",
                f = "right" === r ? "left" : "right",
                d = G("transform"),
                h = void 0,
                b = void 0;

            if (b = "bottom" === p ? "HTML" === u.nodeName ? -u.clientHeight + l.bottom : -c.height + l.bottom : l.top, h = "right" === f ? "HTML" === u.nodeName ? -u.clientWidth + l.right : -c.width + l.right : l.left, a && d) s[d] = "translate3d(" + h + "px, " + b + "px, 0)", s[p] = 0, s[f] = 0, s.willChange = "transform";else {
              var m = "bottom" === p ? -1 : 1,
                  y = "right" === f ? -1 : 1;
              s[p] = b * m, s[f] = h * y, s.willChange = p + ", " + f;
            }
            var v = {
              "x-placement": t.placement
            };
            return t.attributes = N({}, v, t.attributes), t.styles = N({}, s, t.styles), t.arrowStyles = N({}, t.offsets.arrow, t.arrowStyles), t;
          },
          gpuAcceleration: !0,
          x: "bottom",
          y: "right"
        },
        applyStyle: {
          order: 900,
          enabled: !0,
          fn: function fn(t) {
            var e, n;
            return z(t.instance.popper, t.styles), e = t.instance.popper, n = t.attributes, Object.keys(n).forEach(function (t) {
              !1 !== n[t] ? e.setAttribute(t, n[t]) : e.removeAttribute(t);
            }), t.arrowElement && Object.keys(t.arrowStyles).length && z(t.arrowElement, t.arrowStyles), t;
          },
          onLoad: function onLoad(t, e, n, r, i) {
            var o = j(i, e, t, n.positionFixed),
                a = L(n.placement, o, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
            return e.setAttribute("x-placement", a), z(e, {
              position: n.positionFixed ? "fixed" : "absolute"
            }), n;
          },
          gpuAcceleration: void 0
        }
      }
    },
        nt = function () {
      function t(e, n) {
        var r = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        C(this, t), this.scheduleUpdate = function () {
          return requestAnimationFrame(r.update);
        }, this.update = u(this.update.bind(this)), this.options = N({}, t.Defaults, i), this.state = {
          isDestroyed: !1,
          isCreated: !1,
          scrollParents: []
        }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(N({}, t.Defaults.modifiers, i.modifiers)).forEach(function (e) {
          r.options.modifiers[e] = N({}, t.Defaults.modifiers[e] || {}, i.modifiers ? i.modifiers[e] : {});
        }), this.modifiers = Object.keys(this.options.modifiers).map(function (t) {
          return N({
            name: t
          }, r.options.modifiers[t]);
        }).sort(function (t, e) {
          return t.order - e.order;
        }), this.modifiers.forEach(function (t) {
          t.enabled && c(t.onLoad) && t.onLoad(r.reference, r.popper, r.options, t, r.state);
        }), this.update();
        var o = this.options.eventsEnabled;
        o && this.enableEventListeners(), this.state.eventsEnabled = o;
      }

      return _(t, [{
        key: "update",
        value: function value() {
          return H.call(this);
        }
      }, {
        key: "destroy",
        value: function value() {
          return F.call(this);
        }
      }, {
        key: "enableEventListeners",
        value: function value() {
          return Y.call(this);
        }
      }, {
        key: "disableEventListeners",
        value: function value() {
          return W.call(this);
        }
      }]), t;
    }();

    nt.Utils = ("undefined" != typeof window ? window : global).PopperUtils, nt.placements = $, nt.Defaults = et;

    var rt = nt,
        it = n(82),
        ot = function () {
      function t(t, e) {
        void 0 === e && (e = {}), this.dialog = t, this.options = {
          title: "",
          fullDialog: !1,
          resetPossible: !0,
          placement: "bottom-start",
          toggleDialog: !0,
          modifiers: {}
        }, this.popper = null, Object.assign(this.options, e), console.assert(null != t.attachment.ownerDocument), this.node = t.attachment.ownerDocument.createElement("form"), this.node.classList.add("lu-dialog");
      }

      return Object.defineProperty(t.prototype, "attachment", {
        get: function get() {
          return this.dialog.attachment;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "level", {
        get: function get() {
          return this.dialog.level;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.equals = function (t) {
        return this.dialog.level === t.dialog.level && this.dialog.attachment === t.dialog.attachment;
      }, t.prototype.open = function () {
        var t = this;

        if (!(this.options.toggleDialog && this.dialog.manager.removeLike(this) || !1 === this.build(this.node))) {
          var e = this.attachment.closest(".lu");
          this.options.title && this.node.insertAdjacentHTML("afterbegin", "<strong>" + this.options.title + "</strong>"), this.options.fullDialog && this.node.insertAdjacentHTML("beforeend", '<div>\n        <button type="submit" title="Apply"></button>\n        <button type="button" title="Cancel"></button>\n        <button type="reset" title="Reset to default values" ' + (this.options.resetPossible ? "" : 'style="visibility: hidden"') + "></button>\n      </div>"), e.appendChild(this.node), this.popper = new rt(this.attachment, this.node, Object(it.a)({
            modifiers: {
              preventOverflow: {
                boundariesElement: e
              }
            }
          }, this.options));
          var n = this.find("input[autofocus]");
          n && self.setTimeout(function () {
            return n.focus();
          });
          var r = this.find("button[type=reset]");
          r && (r.onclick = function (e) {
            e.stopPropagation(), e.preventDefault(), t.reset();
          }), this.node.onsubmit = function (e) {
            return e.stopPropagation(), e.preventDefault(), !!t.node.checkValidity() && (t.submit() && t.destroy(), !1);
          };
          var i = this.find("button[title=Cancel]");
          i && (i.onclick = function (e) {
            e.stopPropagation(), e.preventDefault(), t.destroy();
          }), this.dialog.manager.push(this);
        }
      }, t.prototype.find = function (t) {
        return this.node.querySelector(t);
      }, t.prototype.findInput = function (t) {
        return this.find(t);
      }, t.prototype.forEach = function (t, e) {
        return Array.from(this.node.querySelectorAll(t)).map(e);
      }, t.prototype.reset = function () {}, t.prototype.submit = function () {
        return !0;
      }, t.prototype.destroy = function () {
        this.dialog.manager.remove(this), this.popper && this.popper.destroy(), this.node.remove();
      }, t;
    }();

    e.c = ot;
  }, function (t, e, n) {
    "use strict";

    var r = new Date(),
        i = new Date();

    function o(t, e, n, a) {
      function u(e) {
        return t(e = new Date(+e)), e;
      }

      return u.floor = u, u.ceil = function (n) {
        return t(n = new Date(n - 1)), e(n, 1), t(n), n;
      }, u.round = function (t) {
        var e = u(t),
            n = u.ceil(t);
        return t - e < n - t ? e : n;
      }, u.offset = function (t, n) {
        return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
      }, u.range = function (n, r, i) {
        var o,
            a = [];
        if (n = u.ceil(n), i = null == i ? 1 : Math.floor(i), !(n < r && i > 0)) return a;

        do {
          a.push(o = new Date(+n)), e(n, i), t(n);
        } while (o < n && n < r);

        return a;
      }, u.filter = function (n) {
        return o(function (e) {
          if (e >= e) for (; t(e), !n(e);) {
            e.setTime(e - 1);
          }
        }, function (t, r) {
          if (t >= t) if (r < 0) for (; ++r <= 0;) {
            for (; e(t, -1), !n(t);) {
              ;
            }
          } else for (; --r >= 0;) {
            for (; e(t, 1), !n(t);) {
              ;
            }
          }
        });
      }, n && (u.count = function (e, o) {
        return r.setTime(+e), i.setTime(+o), t(r), t(i), Math.floor(n(r, i));
      }, u.every = function (t) {
        return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? u.filter(a ? function (e) {
          return a(e) % t == 0;
        } : function (e) {
          return u.count(0, e) % t == 0;
        }) : u : null;
      }), u;
    }

    var a = o(function () {}, function (t, e) {
      t.setTime(+t + e);
    }, function (t, e) {
      return e - t;
    });

    a.every = function (t) {
      return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? o(function (e) {
        e.setTime(Math.floor(e / t) * t);
      }, function (e, n) {
        e.setTime(+e + n * t);
      }, function (e, n) {
        return (n - e) / t;
      }) : a : null;
    };

    var u = a,
        c = (a.range, 6e4),
        s = 6048e5,
        l = o(function (t) {
      t.setTime(t - t.getMilliseconds());
    }, function (t, e) {
      t.setTime(+t + 1e3 * e);
    }, function (t, e) {
      return (e - t) / 1e3;
    }, function (t) {
      return t.getUTCSeconds();
    }),
        p = l,
        f = (l.range, o(function (t) {
      t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds());
    }, function (t, e) {
      t.setTime(+t + e * c);
    }, function (t, e) {
      return (e - t) / c;
    }, function (t) {
      return t.getMinutes();
    })),
        d = f,
        h = (f.range, o(function (t) {
      t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds() - t.getMinutes() * c);
    }, function (t, e) {
      t.setTime(+t + 36e5 * e);
    }, function (t, e) {
      return (e - t) / 36e5;
    }, function (t) {
      return t.getHours();
    })),
        g = h,
        b = (h.range, o(function (t) {
      t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setDate(t.getDate() + e);
    }, function (t, e) {
      return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * c) / 864e5;
    }, function (t) {
      return t.getDate() - 1;
    })),
        m = b;
    b.range;

    function y(t) {
      return o(function (e) {
        e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setDate(t.getDate() + 7 * e);
      }, function (t, e) {
        return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * c) / s;
      });
    }

    var v = y(0),
        E = y(1),
        O = y(2),
        C = y(3),
        _ = y(4),
        T = y(5),
        N = y(6),
        D = (v.range, E.range, O.range, C.range, _.range, T.range, N.range, o(function (t) {
      t.setDate(1), t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setMonth(t.getMonth() + e);
    }, function (t, e) {
      return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
    }, function (t) {
      return t.getMonth();
    })),
        R = D,
        w = (D.range, o(function (t) {
      t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setFullYear(t.getFullYear() + e);
    }, function (t, e) {
      return e.getFullYear() - t.getFullYear();
    }, function (t) {
      return t.getFullYear();
    }));

    w.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? o(function (e) {
        e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setFullYear(e.getFullYear() + n * t);
      }) : null;
    };

    var A = w,
        M = (w.range, o(function (t) {
      t.setUTCSeconds(0, 0);
    }, function (t, e) {
      t.setTime(+t + e * c);
    }, function (t, e) {
      return (e - t) / c;
    }, function (t) {
      return t.getUTCMinutes();
    })),
        L = M,
        j = (M.range, o(function (t) {
      t.setUTCMinutes(0, 0, 0);
    }, function (t, e) {
      t.setTime(+t + 36e5 * e);
    }, function (t, e) {
      return (e - t) / 36e5;
    }, function (t) {
      return t.getUTCHours();
    })),
        x = j,
        S = (j.range, o(function (t) {
      t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCDate(t.getUTCDate() + e);
    }, function (t, e) {
      return (e - t) / 864e5;
    }, function (t) {
      return t.getUTCDate() - 1;
    })),
        I = S;
    S.range;

    function V(t) {
      return o(function (e) {
        e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
      }, function (t, e) {
        t.setUTCDate(t.getUTCDate() + 7 * e);
      }, function (t, e) {
        return (e - t) / s;
      });
    }

    var k = V(0),
        H = V(1),
        P = V(2),
        G = V(3),
        F = V(4),
        U = V(5),
        B = V(6),
        Y = (k.range, H.range, P.range, G.range, F.range, U.range, B.range, o(function (t) {
      t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCMonth(t.getUTCMonth() + e);
    }, function (t, e) {
      return e.getUTCMonth() - t.getUTCMonth() + 12 * (e.getUTCFullYear() - t.getUTCFullYear());
    }, function (t) {
      return t.getUTCMonth();
    })),
        W = Y,
        q = (Y.range, o(function (t) {
      t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCFullYear(t.getUTCFullYear() + e);
    }, function (t, e) {
      return e.getUTCFullYear() - t.getUTCFullYear();
    }, function (t) {
      return t.getUTCFullYear();
    }));

    q.every = function (t) {
      return isFinite(t = Math.floor(t)) && t > 0 ? o(function (e) {
        e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
      }, function (e, n) {
        e.setUTCFullYear(e.getUTCFullYear() + n * t);
      }) : null;
    };

    var z = q;
    q.range;
    n.d(e, "c", function () {
      return u;
    }), n.d(e, "n", function () {
      return u;
    }), n.d(e, "g", function () {
      return p;
    }), n.d(e, "r", function () {
      return p;
    }), n.d(e, "d", function () {
      return d;
    }), n.d(e, "b", function () {
      return g;
    }), n.d(e, "a", function () {
      return m;
    }), n.d(e, "j", function () {
      return v;
    }), n.d(e, "h", function () {
      return v;
    }), n.d(e, "e", function () {
      return E;
    }), n.d(e, "i", function () {
      return _;
    }), n.d(e, "f", function () {
      return R;
    }), n.d(e, "k", function () {
      return A;
    }), n.d(e, "o", function () {
      return L;
    }), n.d(e, "m", function () {
      return x;
    }), n.d(e, "l", function () {
      return I;
    }), n.d(e, "u", function () {
      return k;
    }), n.d(e, "s", function () {
      return k;
    }), n.d(e, "p", function () {
      return H;
    }), n.d(e, "t", function () {
      return F;
    }), n.d(e, "q", function () {
      return W;
    }), n.d(e, "v", function () {
      return z;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "j", function () {
      return a;
    }), n.d(e, "g", function () {
      return u;
    }), n.d(e, "i", function () {
      return c;
    }), n.d(e, "h", function () {
      return s;
    }), n.d(e, "k", function () {
      return l;
    }), n.d(e, "l", function () {
      return p;
    });
    var r = n(0),
        i = n(12),
        o = n(7);

    function a(t) {
      return Math.ceil(Math.log(t) / Math.LN2) + 1;
    }

    var u = function () {
      function t(t, e, n) {
        this.scale = e, this.histGen = n, this.values = t.filter(function (t) {
          return !Object(o.c)(t);
        }), this.missing = t.length - this.values.length;
      }

      return Object.defineProperty(t.prototype, "count", {
        get: function get() {
          return this.values.length + this.missing;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "sorted", {
        get: function get() {
          return this.values.slice().sort(i.a);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "sortedMapped", {
        get: function get() {
          var t = this;
          return this.scale ? this.sorted.map(function (e) {
            return t.scale.apply(e);
          }) : this.sorted;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.map = function (t) {
        return this.scale && null != t ? this.scale.apply(t) : t;
      }, Object.defineProperty(t.prototype, "hist", {
        get: function get() {
          return this.histGen ? this.histGen(this.values) : [];
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "maxBin", {
        get: function get() {
          return Math.max.apply(Math, this.hist.map(function (t) {
            return t.length;
          }));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "min", {
        get: function get() {
          return this.map(Math.min.apply(Math, this.values));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "max", {
        get: function get() {
          return this.map(Math.max.apply(Math, this.values));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "median", {
        get: function get() {
          return this.map(Object(i.h)(this.sorted));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "q1", {
        get: function get() {
          return this.map(Object(i.j)(this.sorted, .25));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "q3", {
        get: function get() {
          return this.map(Object(i.j)(this.sorted, .75));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "mean", {
        get: function get() {
          return this.map(Object(i.g)(this.values));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "whiskerLow", {
        get: function get() {
          for (var t = this.q1, e = t - 1.5 * (this.q3 - t), n = e, r = 0, i = this.sortedMapped; r < i.length; r++) {
            var o = i[r];

            if (e < o) {
              n = o;
              break;
            }
          }

          return n;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "whiskerHigh", {
        get: function get() {
          for (var t = this.q1, e = this.q3, n = e + 1.5 * (e - t), r = n, i = 0, o = this.sortedMapped.slice().reverse(); i < o.length; i++) {
            var a = o[i];

            if (a < n) {
              r = a;
              break;
            }
          }

          return r;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "outlier", {
        get: function get() {
          var t = this.whiskerLow,
              e = this.whiskerHigh;
          return this.sortedMapped.filter(function (n) {
            return (n < t || n > e) && !Object(o.c)(n);
          });
        },
        enumerable: !0,
        configurable: !0
      }), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "sorted", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "sortedMapped", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "hist", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "maxBin", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "min", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "max", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "median", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "q1", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "q3", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "mean", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "whiskerLow", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "whiskerHigh", null), Object(r.b)([function (t, e, n) {
        var r = n.get,
            i = "__" + e;
        return n.get = function () {
          if (this.hasOwnProperty(i)) return this[i];
          var t = r.call(this);
          return this[i] = t, t;
        }, n;
      }], t.prototype, "outlier", null), t;
    }();

    function c(t, e, n, r, o) {
      if (0 === t.length) return {
        min: NaN,
        max: NaN,
        mean: NaN,
        q1: NaN,
        q3: NaN,
        outlier: [],
        median: NaN,
        count: 0,
        maxBin: 0,
        hist: [],
        missing: 0
      };
      var c = Object(i.e)();
      r && c.domain(r), o ? c.thresholds(o) : c.thresholds(a(t.length));
      var s = t.map(function (t) {
        return n(t) ? NaN : e(t);
      });
      return new u(s, void 0, c);
    }

    function s(t, e, n) {
      var r = new Map(),
          i = 0;
      n.forEach(function (t) {
        return r.set(t.name, 0);
      }), t.forEach(function (t) {
        var n = e(t);
        null != n ? r.set(n.name, (r.get(n.name) || 0) + 1) : i += 1;
      });
      var o = [];
      return r.forEach(function (t, e) {
        return o.push({
          cat: e,
          y: t
        });
      }), {
        maxBin: Math.max.apply(Math, o.map(function (t) {
          return t.y;
        })),
        hist: o,
        missing: i
      };
    }

    function l(t, e) {
      if (void 0 === e && (e = 0), 0 === e) return Math.round(t);
      var n = Math.pow(10, e);
      return Math.round(t * n) / n;
    }

    function p(t, e, n) {
      return void 0 === n && (n = .5), t === e || Math.abs(t - e) < n;
    }
  }, function (t, e, n) {
    "use strict";

    n.d(e, "d", function () {
      return a;
    }), n.d(e, "a", function () {
      return s;
    }), n.d(e, "b", function () {
      return l;
    }), n.d(e, "c", function () {
      return p;
    }), n.d(e, "e", function () {
      return f;
    });
    var r = n(65),
        i = n(16);

    function o(t) {
      switch (void 0 === t && (t = "linear"), t) {
        case "log":
          return Object(r.b)().clamp(!0);

        case "sqrt":
          return Object(r.d)().clamp(!0);

        case "pow1.1":
          return Object(r.c)().exponent(1.1).clamp(!0);

        case "pow2":
          return Object(r.c)().exponent(2).clamp(!0);

        case "pow3":
          return Object(r.c)().exponent(3).clamp(!0);

        default:
          return Object(r.a)().clamp(!0);
      }
    }

    function a(t) {
      return "function" == typeof t.getMapping;
    }

    function u(t, e) {
      return t.length === e.length && t.every(function (t, n) {
        return Object(i.l)(t, e[n], 1e-4);
      });
    }

    function c(t, e) {
      return "log" === e && 0 === t[0] && (t[0] = 1e-7), t;
    }

    var s = function () {
      function t(t, e, n) {
        void 0 === t && (t = [0, 1]), void 0 === e && (e = "linear"), void 0 === n && (n = [0, 1]), this.type = e, this.s = o(e).domain(c(t, this.type)).range(n);
      }

      return Object.defineProperty(t.prototype, "domain", {
        get: function get() {
          return this.s.domain();
        },
        set: function set(t) {
          this.s.domain(c(t, this.type));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "range", {
        get: function get() {
          return this.s.range();
        },
        set: function set(t) {
          this.s.range(t);
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.getRange = function (t) {
        return [t(this.invert(0)), t(this.invert(1))];
      }, t.prototype.apply = function (t) {
        return this.s(t);
      }, t.prototype.invert = function (t) {
        return this.s.invert(t);
      }, Object.defineProperty(t.prototype, "scaleType", {
        get: function get() {
          return this.type;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.dump = function () {
        return {
          type: this.type,
          domain: this.domain,
          range: this.range
        };
      }, t.prototype.eq = function (e) {
        if (!(e instanceof t)) return !1;
        var n = e;
        return n.type === this.type && u(this.domain, n.domain) && u(this.range, n.range);
      }, t.prototype.restore = function (t) {
        this.type = t.type, this.s = o(t.type).domain(t.domain).range(t.range);
      }, t.prototype.clone = function () {
        return new t(this.domain, this.type, this.range);
      }, t;
    }(),
        l = function () {
      function t(t, e) {
        void 0 === t && (t = [0, 1]), void 0 === e && (e = "return this.linear(value,this.value_min,this.value_max);"), this.domain = t, this._code = e, this.f = new Function("value", e);
      }

      return Object.defineProperty(t.prototype, "code", {
        get: function get() {
          return this._code;
        },
        set: function set(t) {
          this._code !== t && (this._code = t, this.f = new Function("value", t));
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.getRange = function () {
        return ["?", "?"];
      }, t.prototype.apply = function (t) {
        var e = this.domain[0],
            n = this.domain[this.domain.length - 1],
            r = this.f.call({
          value_min: e,
          value_max: n,
          value_range: n - e,
          value_domain: this.domain.slice(),
          linear: function linear(t, e, n) {
            return (t - e) / (n - e);
          }
        }, t);
        return "number" == typeof r ? Math.max(Math.min(r, 1), 0) : NaN;
      }, t.prototype.dump = function () {
        return {
          type: "script",
          code: this.code,
          domain: this.domain
        };
      }, t.prototype.eq = function (e) {
        return e instanceof t && e.code === this.code;
      }, t.prototype.restore = function (t) {
        this.code = t.code, this.domain = t.domain;
      }, t.prototype.clone = function () {
        return new t(this.domain, this.code);
      }, t;
    }();

    function p(t) {
      if ("script" === t.type) {
        var e = new l();
        return e.restore(t), e;
      }

      var n = new s();
      return n.restore(t), n;
    }

    function f(t) {
      return t.map ? p(t.map) : t.domain ? new s(t.domain, "linear", t.range || [0, 1]) : new s([0, 1], "linear", [0, 1]);
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(13),
        o = n(55),
        a = n(87),
        u = n(21),
        c = n(40),
        s = n(58),
        l = n(62),
        p = n(50),
        f = n(61),
        d = n(43),
        h = n(27),
        g = n(11),
        b = n(71),
        m = n(2),
        y = function (t) {
      function e(e) {
        void 0 === e && (e = {});
        var n = t.call(this) || this;
        return n.rankings = [], n.selection = new a.a(), n.aggregations = new Set(), n.uid = 0, n.createHelper = function (t) {
          var e = n.fromDescRef(t.desc),
              r = null;
          e && e.type && (n.fixDesc(t.desc), (r = new (0, n.columnTypes[e.type])(t.id, e)).restore(t, n.createHelper));
          return r;
        }, n.columnTypes = Object.assign(Object(u.Vc)(), e.columnTypes || {}), n.multiSelections = !1 !== e.multiSelection, n;
      }

      return Object(r.c)(e, t), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_ADD_COLUMN, e.EVENT_REMOVE_COLUMN, e.EVENT_ADD_RANKING, e.EVENT_REMOVE_RANKING, e.EVENT_DIRTY, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_ORDER_CHANGED, e.EVENT_SELECTION_CHANGED, e.EVENT_ADD_DESC, e.EVENT_CLEAR_DESC, e.EVENT_JUMP_TO_NEAREST, e.EVENT_GROUP_AGGREGATION_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.pushRanking = function (t) {
        var e = this.cloneRanking(t);
        return this.insertRanking(e), e;
      }, e.prototype.takeSnapshot = function (t) {
        var e = this,
            n = this.cloneRanking(),
            r = t.findMyRanker(),
            i = "string" === t.desc.type,
            o = !1,
            a = r ? r.children.filter(function (e) {
          return e === t ? (o = !1, !0) : i || "string" !== e.desc.type ? Object(m.l)(e) : (i = !0, !0);
        }) : [t];
        return o || a.push(t), a.forEach(function (r) {
          var i = e.clone(r);
          n.push(i), r === t && i.sortByMe();
        }), this.insertRanking(n), n;
      }, e.prototype.insertRanking = function (t, n) {
        void 0 === n && (n = this.rankings.length), this.rankings.splice(n, 0, t), this.forward.apply(this, Object(r.d)([t], Object(i.b)(".provider", g.b.EVENT_ADD_COLUMN, g.b.EVENT_REMOVE_COLUMN, g.b.EVENT_DIRTY, g.b.EVENT_DIRTY_HEADER, g.b.EVENT_ORDER_CHANGED, g.b.EVENT_DIRTY_VALUES)));
        var a = this;
        t.on(g.b.EVENT_DIRTY_ORDER + ".provider", Object(o.a)(function () {
          a.triggerReorder(this.source);
        }, 100)), this.fire([e.EVENT_ADD_RANKING, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, n), this.triggerReorder(t);
      }, e.prototype.triggerReorder = function (t) {
        Promise.resolve(this.sort(t)).then(function (e) {
          Object(h.g)(e), t.setGroups(e);
        });
      }, e.prototype.removeRanking = function (t) {
        var n = this.rankings.indexOf(t);
        return !(n < 0) && (this.unforward.apply(this, Object(r.d)([t], Object(i.b)(".provider", g.b.EVENT_ADD_COLUMN, g.b.EVENT_REMOVE_COLUMN, g.b.EVENT_DIRTY, g.b.EVENT_DIRTY_HEADER, g.b.EVENT_ORDER_CHANGED, g.b.EVENT_DIRTY_VALUES))), this.rankings.splice(n, 1), t.on(g.b.EVENT_DIRTY_ORDER + ".provider", null), this.cleanUpRanking(t), this.fire([e.EVENT_REMOVE_RANKING, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, n), !0);
      }, e.prototype.clearRankings = function () {
        var t = this;
        this.rankings.forEach(function (e) {
          t.unforward.apply(t, Object(r.d)([e], Object(i.b)(".provider", g.b.EVENT_ADD_COLUMN, g.b.EVENT_REMOVE_COLUMN, g.b.EVENT_DIRTY, g.b.EVENT_DIRTY_HEADER, g.b.EVENT_ORDER_CHANGED, g.b.EVENT_DIRTY_VALUES))), e.on(g.b.EVENT_DIRTY_ORDER + ".provider", null), t.cleanUpRanking(e);
        }), this.rankings = [], this.fire([e.EVENT_REMOVE_RANKING, e.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], null, -1);
      }, e.prototype.getRankings = function () {
        return this.rankings.slice();
      }, e.prototype.getFirstRanking = function () {
        return this.rankings[0] || null;
      }, e.prototype.getLastRanking = function () {
        return this.rankings[this.rankings.length - 1];
      }, e.prototype.ensureOneRanking = function () {
        if (0 === this.rankings.length) {
          var t = this.pushRanking();
          this.push(t, Object(c.a)());
        }
      }, e.prototype.cleanUpRanking = function (t) {}, e.prototype.push = function (t, e) {
        var n = this.create(e);
        return n ? (t.push(n), n) : null;
      }, e.prototype.insert = function (t, e, n) {
        var r = this.create(n);
        return r ? (t.insert(r, e), r) : null;
      }, e.prototype.nextId = function () {
        return "col" + this.uid++;
      }, e.prototype.fixDesc = function (t) {
        var e = this;
        "rank" === t.type ? t.accessor = this.rankAccessor.bind(this) : "selection" === t.type ? (t.accessor = function (t) {
          return e.isSelected(t.i);
        }, t.setter = function (t, n) {
          return n ? e.select(t.i) : e.deselect(t.i);
        }, t.setterAll = function (t, n) {
          return n ? e.selectAll(t.map(function (t) {
            return t.i;
          })) : e.deselectAll(t.map(function (t) {
            return t.i;
          }));
        }) : "aggregate" === t.type && (t.isAggregated = function (t, n) {
          return e.isAggregated(t, n);
        }, t.setAggregated = function (t, n, r) {
          return e.setAggregated(t, n, r);
        });
      }, e.prototype.create = function (t) {
        this.fixDesc(t);
        var e = this.columnTypes[t.type];
        return e ? new e(this.nextId(), t) : null;
      }, e.prototype.clone = function (t) {
        var e = this.dumpColumn(t);
        return this.restoreColumn(e);
      }, e.prototype.restoreColumn = function (t) {
        var e = this,
            n = function n(t) {
          var r = e.fromDescRef(t.desc),
              i = e.columnTypes[r.type];
          e.fixDesc(r);
          var o = new i("", r);
          return o.restore(t, n), o.assignNewId(e.nextId.bind(e)), o;
        };

        return n(t);
      }, e.prototype.find = function (t) {
        for (var e = "string" == typeof t ? function (e) {
          return e.id === t;
        } : t, n = 0, r = this.rankings; n < r.length; n++) {
          var i = r[n].find(e);
          if (i) return i;
        }

        return null;
      }, e.prototype.dump = function () {
        var t = this;
        return {
          uid: this.uid,
          selection: this.getSelection(),
          aggregations: Array.from(this.aggregations),
          rankings: this.rankings.map(function (e) {
            return e.dump(t.toDescRef);
          })
        };
      }, e.prototype.dumpColumn = function (t) {
        return t.dump(this.toDescRef);
      }, e.prototype.toDescRef = function (t) {
        return t;
      }, e.prototype.fromDescRef = function (t) {
        return t;
      }, e.prototype.restoreRanking = function (t) {
        var e = this.cloneRanking();
        e.restore(t, this.createHelper), e.children.some(function (t) {
          return t instanceof c.b;
        }) || e.insert(this.create(Object(c.a)()), 0);
        var n = this.nextId.bind(this);
        return e.children.forEach(function (t) {
          return t.assignNewId(n);
        }), e;
      }, e.prototype.restore = function (t) {
        var e = this;
        this.clearRankings(), this.uid = t.uid || 0, t.selection && t.selection.forEach(function (t) {
          return e.selection.add(t);
        }), t.aggregations && (this.aggregations.clear(), t.aggregations.forEach(function (t) {
          return e.aggregations.add(t);
        })), t.rankings && t.rankings.forEach(function (t) {
          var n = e.cloneRanking();
          n.restore(t, e.createHelper), n.children.some(function (t) {
            return t instanceof c.b;
          }) || n.insert(e.create(Object(c.a)()), 0), e.insertRanking(n);
        }), t.layout && Object.keys(t.layout).forEach(function (n) {
          e.deriveRanking(t.layout[n]);
        });
        var n = this.nextId.bind(this);
        this.rankings.forEach(function (t) {
          t.children.forEach(function (t) {
            return t.assignNewId(n);
          });
        });
      }, e.prototype.deriveRanking = function (t) {
        var e = this,
            n = this.cloneRanking();
        n.clear();

        var r = function r(t) {
          switch (t.type) {
            case "rank":
              return e.create(Object(c.a)());

            case "selection":
              return e.create(Object(s.b)());

            case "group":
              return e.create(Object(l.b)());

            case "aggregate":
              return e.create(Object(p.b)());

            case "actions":
              var n = e.create(Object(f.a)(t.label || "actions"));
              return n.restore(t, e.createHelper), n;

            case "stacked":
              var i = e.create(Object(d.a)(t.label || "Combined"));
              return (t.children || []).forEach(function (t) {
                var e = r(t);
                e && i.push(e);
              }), i;

            default:
              var o = e.findDesc(t.column);

              if (o) {
                var a = e.create(o);
                return t.label = t.label || o.label || o.column, a && a.restore(t, e.createHelper), a;
              }

              return null;
          }
        };

        return t.forEach(function (t) {
          var e = r(t);
          e && n.push(e);
        }), n.children.some(function (t) {
          return t instanceof c.b;
        }) || n.insert(this.create(Object(c.a)()), 0), this.insertRanking(n), n;
      }, e.prototype.isAggregated = function (t, e) {
        for (var n = e; n;) {
          var r = t.id + "@" + Object(h.f)(n);
          if (this.aggregations.has(r)) return this.aggregations.add(t.id + "@" + Object(h.f)(e)), !0;
          n = n.parent;
        }

        return !1;
      }, e.prototype.unaggregateParents = function (t, e) {
        for (var n = e.parent; n;) {
          this.aggregations.delete(t.id + "@" + Object(h.f)(n)), n = n.parent;
        }
      }, e.prototype.setAggregated = function (t, n, r) {
        this.unaggregateParents(t, n);
        var i = t.id + "@" + Object(h.f)(n);
        this.isAggregated(t, n) !== r && (r ? this.aggregations.add(i) : this.aggregations.delete(i), this.fire([e.EVENT_GROUP_AGGREGATION_CHANGED, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, n, r));
      }, e.prototype.aggregateAllOf = function (t, n) {
        var r = this,
            i = t.getGroups();
        i.forEach(function (e) {
          if (r.unaggregateParents(t, e), r.isAggregated(t, e) !== n) {
            var i = t.id + "@" + Object(h.f)(e);
            n ? r.aggregations.add(i) : r.aggregations.delete(i);
          }
        }), this.fire([e.EVENT_GROUP_AGGREGATION_CHANGED, e.EVENT_DIRTY_VALUES, e.EVENT_DIRTY], t, i, n);
      }, e.prototype.isSelected = function (t) {
        return this.selection.has(t);
      }, e.prototype.select = function (t) {
        this.selection.has(t) || (!this.multiSelections && this.selection.size > 0 && this.selection.clear(), this.selection.add(t), this.fire(e.EVENT_SELECTION_CHANGED, this.getSelection()));
      }, e.prototype.jumpToNearest = function (t) {
        0 !== t.length && this.fire(e.EVENT_JUMP_TO_NEAREST, t);
      }, e.prototype.selectAll = function (t) {
        var n = this;
        t.every(function (t) {
          return n.selection.has(t);
        }) || (this.multiSelections || (this.selection.clear(), t = t.slice(0, 1)), t.forEach(function (t) {
          n.selection.add(t);
        }), this.fire(e.EVENT_SELECTION_CHANGED, this.getSelection()));
      }, e.prototype.selectAllOf = function (t) {
        this.setSelection(t.getOrder());
      }, e.prototype.setSelection = function (t) {
        var e = this;
        if (0 === t.length) return this.clearSelection();
        this.selection.size === t.length && t.every(function (t) {
          return e.selection.has(t);
        }) || (this.selection.clear(), this.selectAll(t));
      }, e.prototype.toggleSelection = function (t, e) {
        return void 0 === e && (e = !1), this.isSelected(t) ? (e ? this.deselect(t) : this.clearSelection(), !1) : (e ? this.select(t) : this.setSelection([t]), !0);
      }, e.prototype.deselect = function (t) {
        this.selection.has(t) && (this.selection.delete(t), this.fire(e.EVENT_SELECTION_CHANGED, this.getSelection()));
      }, e.prototype.deselectAll = function (t) {
        var n = this;
        t.every(function (t) {
          return !n.selection.has(t);
        }) || (t.forEach(function (t) {
          n.selection.delete(t);
        }), this.fire(e.EVENT_SELECTION_CHANGED, this.getSelection()));
      }, e.prototype.selectedRows = function () {
        return 0 === this.selection.size ? [] : this.view(this.getSelection());
      }, e.prototype.getSelection = function () {
        return Array.from(this.selection);
      }, e.prototype.clearSelection = function () {
        0 !== this.selection.size && (this.selection.clear(), this.fire(e.EVENT_SELECTION_CHANGED, [], !1));
      }, e.prototype.exportTable = function (t, e) {
        return void 0 === e && (e = {}), Promise.resolve(this.view(t.getOrder())).then(function (n) {
          return Object(b.e)(t, n, e);
        });
      }, e.EVENT_SELECTION_CHANGED = "selectionChanged", e.EVENT_ADD_COLUMN = g.b.EVENT_ADD_COLUMN, e.EVENT_REMOVE_COLUMN = g.b.EVENT_REMOVE_COLUMN, e.EVENT_ADD_RANKING = "addRanking", e.EVENT_REMOVE_RANKING = "removeRanking", e.EVENT_DIRTY = g.b.EVENT_DIRTY, e.EVENT_DIRTY_HEADER = g.b.EVENT_DIRTY_HEADER, e.EVENT_DIRTY_VALUES = g.b.EVENT_DIRTY_VALUES, e.EVENT_ORDER_CHANGED = g.b.EVENT_ORDER_CHANGED, e.EVENT_ADD_DESC = "addDesc", e.EVENT_CLEAR_DESC = "clearDesc", e.EVENT_JUMP_TO_NEAREST = "jumpToNearest", e.EVENT_GROUP_AGGREGATION_CHANGED = p.c.EVENT_AGGREGATE, e;
    }(i.a);

    e.d = y;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(2),
        o = n(1),
        a = n(22),
        u = n(24),
        c = n(7),
        s = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.lookup = new Map(), r.currentFilter = null, r.categories = Object(u.g)(n), r.missingCategory = n.missingCategory ? Object(u.h)(n.missingCategory, NaN) : null, r.categories.forEach(function (t) {
          return r.lookup.set(t.name, t);
        }), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (t) {
        var e = this.getCategory(t);
        return e ? e.name : null;
      }, e.prototype.getCategory = function (e) {
        var n = t.prototype.getValue.call(this, e);
        if (!n) return this.missingCategory;
        var r = String(n);
        return this.lookup.has(r) ? this.lookup.get(r) : this.missingCategory;
      }, Object.defineProperty(e.prototype, "dataLength", {
        get: function get() {
          return this.categories.length;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "labels", {
        get: function get() {
          return this.categories.map(function (t) {
            return t.label;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getLabel = function (t) {
        var e = this.getCategory(t);
        return e ? e.label : "";
      }, e.prototype.getColor = function (t) {
        var e = this.getCategory(t);
        return e ? e.color : o.d.DEFAULT_COLOR;
      }, e.prototype.getValues = function (t) {
        var e = this.getCategory(t);
        return this.categories.map(function (t) {
          return t === e;
        });
      }, e.prototype.getLabels = function (t) {
        return this.getValues(t).map(String);
      }, e.prototype.getMap = function (t) {
        var e = this.categories;
        return this.getValues(t).map(function (t, n) {
          return {
            key: e[n].label,
            value: t
          };
        });
      }, e.prototype.getMapLabel = function (t) {
        var e = this.categories;
        return this.getLabels(t).map(function (t, n) {
          return {
            key: e[n].label,
            value: t
          };
        });
      }, e.prototype.getSet = function (t) {
        var e = this.getCategory(t),
            n = new Set();
        return e && e !== this.missingCategory && n.add(e), n;
      }, e.prototype.isMissing = function (t) {
        return this.getCategory(t) === this.missingCategory;
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.filter = this.currentFilter, n;
      }, e.prototype.restore = function (e, n) {
        if (t.prototype.restore.call(this, e, n), "filter" in e) {
          var r = e.filter;
          "string" == typeof r || Array.isArray(r) ? this.currentFilter = {
            filter: r,
            filterMissing: !1
          } : this.currentFilter = r;
        } else this.currentFilter = null;
      }, e.prototype.isFiltered = function () {
        return null != this.currentFilter;
      }, e.prototype.filter = function (t) {
        return Object(u.d)(this.currentFilter, this.getCategory(t));
      }, e.prototype.getFilter = function () {
        return null == this.currentFilter ? null : Object.assign({}, this.currentFilter);
      }, e.prototype.setFilter = function (t) {
        Object(u.e)(this.currentFilter, t) || this.fire([n.EVENT_FILTER_CHANGED, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY], this.currentFilter, this.currentFilter = t);
      }, e.prototype.compare = function (t, e) {
        return Object(u.a)(this.getCategory(t), this.getCategory(e));
      }, e.prototype.group = function (t) {
        var e = this.getCategory(t);
        return e ? {
          name: e.label,
          color: e.color
        } : c.e;
      }, e.prototype.groupCompare = function (t, e) {
        return Object(u.b)(t.rows, e.rows, this);
      }, e.prototype.getGroupRenderer = function () {
        var e = t.prototype.getGroupRenderer.call(this);
        return e === this.desc.type && this.isGroupedBy() >= 0 ? "catdistributionbar" : e;
      }, e.EVENT_FILTER_CHANGED = "filterChanged", e = n = Object(r.b)([Object(i.m)("group", "groupBy", "sortGroupBy", "filterCategorical"), Object(i.b)("categorical")], e);
    }(a.b);

    e.a = s;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    });
    var r,
        i = n(0),
        o = n(2),
        a = n(1),
        u = n(7),
        c = n(22),
        s = n(42),
        l = n(38);
    !function (t) {
      t.left = "left", t.center = "center", t.right = "right";
    }(r || (r = {}));

    var p = function (t) {
      function e(e, n) {
        var i = t.call(this, e, n) || this;
        return i.currentFilter = null, i.currentGroupCriteria = [], i.setDefaultWidth(200), i.alignment = n.alignment || r.left, i.escape = !1 !== n.escape, i;
      }

      var n;
      return Object(i.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_GROUPING_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (e) {
        var n = t.prototype.getValue.call(this, e);
        return null == n ? "" : String(n);
      }, e.prototype.getLabel = function (t) {
        return this.getValue(t) || "";
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return this.currentFilter instanceof RegExp ? n.filter = "REGEX:" + this.currentFilter.source : n.filter = this.currentFilter, this.currentGroupCriteria && (n.groupCriteria = this.currentGroupCriteria.map(function (t) {
          return "string" == typeof t ? t : "REGEX:" + t.source;
        })), n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.filter && e.filter.startsWith("REGEX:") ? this.currentFilter = new RegExp(e.filter.slice(6), "gm") : this.currentFilter = e.filter || null, e.groupCriteria && (this.currentGroupCriteria = e.groupCriteria.map(function (t) {
          return t.startsWith("REGEX:") ? new RegExp(t.slice(6), "gm") : t;
        }));
      }, e.prototype.isFiltered = function () {
        return null != this.currentFilter;
      }, e.prototype.filter = function (t) {
        if (!this.isFiltered()) return !0;
        var e = this.getLabel(t),
            r = this.currentFilter;
        return r === n.FILTER_MISSING ? null != e && "" !== e.trim() : "string" == typeof r && r.length > 0 ? "" !== e && e.toLowerCase().indexOf(r.toLowerCase()) >= 0 : !(r instanceof RegExp) || "" !== e && r.test(e);
      }, e.prototype.getFilter = function () {
        return this.currentFilter;
      }, e.prototype.setFilter = function (t) {
        "" === t && (t = null), this.currentFilter !== t && this.fire([n.EVENT_FILTER_CHANGED, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], this.currentFilter, this.currentFilter = t);
      }, e.prototype.getGroupCriteria = function () {
        return this.currentGroupCriteria.slice();
      }, e.prototype.setGroupCriteria = function (t) {
        if (!Object(s.a)(this.currentGroupCriteria, t)) {
          var e = this.getGroupCriteria();
          this.currentGroupCriteria = t.slice(), this.fire([n.EVENT_GROUPING_CHANGED, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], e, t);
        }
      }, e.prototype.compare = function (t, e) {
        var n = this.getLabel(t),
            r = this.getLabel(e);
        return "" === n ? "" === r ? 0 : u.a : "" === r ? -u.a : n.toLowerCase().localeCompare(r.toLowerCase());
      }, e.prototype.group = function (t) {
        if (this.isMissing(t)) return u.e;
        if (0 === this.currentGroupCriteria.length) return l.a;
        var e = this.getLabel(t);
        if (!e) return l.a;

        for (var n = 0, r = this.currentGroupCriteria; n < r.length; n++) {
          var i = r[n];
          if (i instanceof RegExp && i.test(e) || "string" == typeof i && e.startsWith(i)) return {
            name: "string" == typeof i ? i : i.source,
            color: l.a.color
          };
        }

        return l.a;
      }, e.EVENT_FILTER_CHANGED = "filterChanged", e.EVENT_GROUPING_CHANGED = "groupingChanged", e.FILTER_MISSING = "__FILTER_MISSING", e = n = Object(i.b)([Object(o.m)("search", "groupBy", "filterString"), Object(o.h)("group", "groupString"), Object(o.b)("string")], e);
    }(c.b);

    e.d = p;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(61),
        o = n(50),
        a = n(81),
        u = n(66),
        c = n(41),
        s = n(24),
        l = n(7),
        p = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultRenderer("upset"), r;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "categories", {
        get: function get() {
          return this.labels.map(function (t, e) {
            return Object(s.h)(t, e);
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getSet = function (t) {
        var e = this.getValues(t);
        return new Set(this.categories.filter(function (t, n) {
          return e[n];
        }));
      }, e.prototype.compare = function (t, e) {
        var n = this.getValue(t),
            r = this.getValue(e);
        return null == n ? null == r ? 0 : l.a : null == r ? -l.a : n.filter(function (t) {
          return t;
        }).length - r.filter(function (t) {
          return t;
        }).length;
      }, e;
    }(c.d),
        f = n(39),
        d = n(19),
        h = n(46),
        g = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.lookup = new Map(), r.categories = Object(s.g)(n), r.missingCategory = n.missingCategory ? Object(s.h)(n.missingCategory, NaN) : null, r.categories.forEach(function (t) {
          return r.lookup.set(t.name, t);
        }), r;
      }

      return Object(r.c)(e, t), e.prototype.parseValue = function (t) {
        if (!t) return this.missingCategory;
        var e = String(t);
        return this.lookup.has(e) ? this.lookup.get(e) : this.missingCategory;
      }, e.prototype.getCategories = function (e) {
        var n = this;
        return t.prototype.getValue.call(this, e).map(function (t) {
          var e = t.key,
              r = t.value;
          return {
            key: e,
            value: n.parseValue(r)
          };
        });
      }, e.prototype.getValue = function (t) {
        return this.getCategories(t).map(function (t) {
          var e = t.key,
              n = t.value;
          return {
            key: e,
            value: n ? n.name : null
          };
        });
      }, e.prototype.getLabels = function (t) {
        return this.getCategories(t).map(function (t) {
          var e = t.key,
              n = t.value;
          return {
            key: e,
            value: n ? n.label : ""
          };
        });
      }, e;
    }(h.a),
        b = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.lookup = new Map(), r.categories = Object(s.g)(n), r.missingCategory = n.missingCategory ? Object(s.h)(n.missingCategory, NaN) : null, r.categories.forEach(function (t) {
          return r.lookup.set(t.name, t);
        }), r;
      }

      return Object(r.c)(e, t), e.prototype.getCategories = function (e) {
        var n = this;
        return t.prototype.getValues.call(this, e).map(function (t) {
          if (!t) return n.missingCategory;
          var e = String(t);
          return n.lookup.has(e) ? n.lookup.get(e) : n.missingCategory;
        });
      }, e.prototype.getSet = function (t) {
        var e = new Set(this.getCategories(t));
        return e.delete(this.missingCategory), e;
      }, e.prototype.getValues = function (t) {
        return this.getCategories(t).map(function (t) {
          return t ? t.name : null;
        });
      }, e.prototype.getLabels = function (t) {
        return this.getCategories(t).map(function (t) {
          return t ? t.label : "";
        });
      }, e;
    }(c.d),
        m = n(35),
        y = n(47),
        v = n(23),
        E = n(3),
        O = n(2),
        C = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.currentFilter = Object(E.n)(), r.format = Object(v.a)(n.dateFormat || "%x"), r.parse = n.dateParse ? Object(v.b)(n.dateParse) : Object(v.b)(n.dateFormat || "%x"), r.sort = n.sort || y.a.median, r.setDefaultRenderer("default"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_SORTMETHOD_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.parseValue = function (t) {
        return Object(l.c)(t) ? null : t instanceof Date ? t : this.parse(String(t));
      }, e.prototype.getValue = function (e) {
        var n = this;
        return t.prototype.getValue.call(this, e).map(function (t) {
          var e = t.key,
              r = t.value;
          return {
            key: e,
            value: n.parseValue(r)
          };
        });
      }, e.prototype.getLabels = function (t) {
        var e = this;
        return this.getValue(t).map(function (t) {
          var n = t.key,
              r = t.value;
          return {
            key: n,
            value: r instanceof Date ? e.format(r) : ""
          };
        });
      }, e.prototype.getDates = function (t) {
        return this.getValue(t).map(function (t) {
          return t.value;
        });
      }, e.prototype.getDate = function (t) {
        return y.d.prototype.getDate.call(this, t);
      }, e.prototype.getSortMethod = function () {
        return this.sort;
      }, e.prototype.setSortMethod = function (t) {
        return y.d.prototype.setSortMethod.call(this, t);
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.sortMethod = this.getSortMethod(), n.filter = Object(E.i)(this.currentFilter) ? null : this.currentFilter, n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.sortMethod && (this.sort = e.sortMethod), e.filter && (this.currentFilter = Object(E.p)(e.filter));
      }, e.prototype.isFiltered = function () {
        return m.c.prototype.isFiltered.call(this);
      }, e.prototype.getFilter = function () {
        return m.c.prototype.getFilter.call(this);
      }, e.prototype.setFilter = function (t) {
        void 0 === t && (t = {
          min: -1 / 0,
          max: 1 / 0,
          filterMissing: !1
        }), m.c.prototype.setFilter.call(this, t);
      }, e.prototype.filter = function (t) {
        return m.c.prototype.filter.call(this, t);
      }, e.EVENT_SORTMETHOD_CHANGED = y.d.EVENT_SORTMETHOD_CHANGED, e.EVENT_FILTER_CHANGED = m.c.EVENT_FILTER_CHANGED, e = n = Object(r.b)([Object(O.m)("filterDate"), Object(O.h)("sort", "sortDates")], e);
    }(h.a),
        _ = n(62),
        T = n(45),
        N = n(68),
        D = n(69),
        R = n(80),
        w = n(6),
        A = n(16),
        M = n(1),
        L = n(17),
        j = n(28),
        x = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.currentFilter = Object(E.n)(), r.mapping = Object(L.e)(n), r.original = r.mapping.clone(), r.colorMapping = Object(j.h)(n), r.sort = n.sort || E.b.median, r.setDefaultRenderer("mapbars"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.compare = function (t, e) {
        return Object(E.e)(this, t, e);
      }, e.prototype.getBoxPlotData = function (t) {
        var e = this.getRawValue(t);
        return null == e ? null : new A.g(e.map(function (t) {
          return t.value;
        }), this.mapping);
      }, e.prototype.getRange = function () {
        return this.mapping.getRange(E.a);
      }, e.prototype.getRawBoxPlotData = function (t) {
        var e = this.getRawValue(t);
        return null == e ? null : new A.g(e.map(function (t) {
          return t.value;
        }));
      }, e.prototype.getNumber = function (t) {
        return Object(E.g)(this, t, "normalized");
      }, e.prototype.getRawNumber = function (t) {
        return Object(E.g)(this, t, "raw");
      }, e.prototype.getValue = function (t) {
        var e = this;
        return this.getRawValue(t).map(function (t) {
          var n = t.key,
              r = t.value;
          return {
            key: n,
            value: Object(l.c)(r) ? NaN : e.mapping.apply(r)
          };
        });
      }, e.prototype.getRawValue = function (e) {
        var n = t.prototype.getValue.call(this, e);
        return null == n ? [] : n;
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.getRawValue(e) : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.getLabels = function (t) {
        return this.getValue(t).map(function (t) {
          var e = t.key,
              n = t.value;
          return {
            key: e,
            value: Object(E.a)(n)
          };
        });
      }, e.prototype.getSortMethod = function () {
        return this.sort;
      }, e.prototype.setSortMethod = function (t) {
        this.sort !== t && (this.fire([n.EVENT_SORTMETHOD_CHANGED], this.sort, this.sort = t), this.isSortedByMe().asc || this.sortByMe());
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.sortMethod = this.getSortMethod(), n.filter = Object(E.i)(this.currentFilter) ? null : this.currentFilter, n.map = this.mapping.dump(), n.colorMapping = this.colorMapping.dump(), n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.sortMethod && (this.sort = e.sortMethod), e.filter && (this.currentFilter = Object(E.p)(e.filter)), e.map ? this.mapping = Object(L.c)(e.map) : e.domain && (this.mapping = new L.a(e.domain, "linear", e.range || [0, 1])), e.colorMapping && (this.colorMapping = Object(j.e)(e.colorMapping));
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_COLOR_MAPPING_CHANGED, n.EVENT_MAPPING_CHANGED, n.EVENT_SORTMETHOD_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getOriginalMapping = function () {
        return this.original.clone();
      }, e.prototype.getMapping = function () {
        return this.mapping.clone();
      }, e.prototype.setMapping = function (t) {
        this.mapping.eq(t) || this.fire([n.EVENT_MAPPING_CHANGED, M.d.EVENT_DIRTY_VALUES, M.d.EVENT_DIRTY], this.mapping.clone(), this.mapping = t);
      }, e.prototype.getColor = function (t) {
        return w.b.prototype.getColor.call(this, t);
      }, e.prototype.getColorMapping = function () {
        return this.colorMapping.clone();
      }, e.prototype.setColorMapping = function (t) {
        this.colorMapping.eq(t) || this.fire([n.EVENT_COLOR_MAPPING_CHANGED, M.d.EVENT_DIRTY_VALUES, M.d.EVENT_DIRTY], this.colorMapping.clone(), this.colorMapping = t);
      }, e.prototype.isFiltered = function () {
        return w.b.prototype.isFiltered.call(this);
      }, e.prototype.getFilter = function () {
        return w.b.prototype.getFilter.call(this);
      }, e.prototype.setFilter = function (t) {
        void 0 === t && (t = {
          min: -1 / 0,
          max: 1 / 0,
          filterMissing: !1
        }), w.b.prototype.setFilter.call(this, t);
      }, e.prototype.filter = function (t) {
        return w.b.prototype.filter.call(this, t);
      }, e.EVENT_MAPPING_CHANGED = w.b.EVENT_MAPPING_CHANGED, e.EVENT_COLOR_MAPPING_CHANGED = w.b.EVENT_COLOR_MAPPING_CHANGED, e.EVENT_SORTMETHOD_CHANGED = w.b.EVENT_SORTMETHOD_CHANGED, e.EVENT_FILTER_CHANGED = w.b.EVENT_FILTER_CHANGED, e = n = Object(r.b)([Object(O.m)("filterNumber", "colorMapped", "editMapping"), Object(O.h)("sort", "sortNumbers"), Object(O.d)("descending")], e);
    }(h.a),
        S = n(29),
        I = n(63),
        V = n(40),
        k = n(75),
        H = n(76),
        P = n(58),
        G = n(22),
        F = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.lookup = new Map(), r.currentFilter = null, r.separator = new RegExp(n.separator || ";"), r.categories = Object(s.g)(n), r.categories.forEach(function (t) {
          return r.lookup.set(t.name, t);
        }), r.setDefaultRenderer("upset"), r.setDefaultGroupRenderer("upset"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, Object.defineProperty(e.prototype, "labels", {
        get: function get() {
          return this.categories.map(function (t) {
            return t.label;
          });
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dataLength", {
        get: function get() {
          return this.categories.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getValue = function (t) {
        return this.getCategories(t).map(function (t) {
          return t.name;
        });
      }, e.prototype.getLabel = function (t) {
        return "(" + this.getCategories(t).map(function (t) {
          return t.label;
        }).join(",") + ")";
      }, e.prototype.normalize = function (t) {
        return "string" == typeof t ? t.split(this.separator).map(function (t) {
          return t.trim();
        }) : Array.isArray(t) ? t.map(function (t) {
          return String(t).trim();
        }) : t instanceof Set ? Array.from(t).map(String) : [];
      }, e.prototype.getSet = function (e) {
        var n = this,
            r = this.normalize(t.prototype.getValue.call(this, e)),
            i = new Set();
        return r.forEach(function (t) {
          var e = n.lookup.get(t);
          e && i.add(e);
        }), i;
      }, e.prototype.getCategories = function (t) {
        return Array.from(this.getSet(t)).sort(function (t, e) {
          return t.value === e.value ? t.label.localeCompare(e.label) : t.value - e.value;
        });
      }, e.prototype.isMissing = function (t) {
        return 0 === this.getSet(t).size;
      }, e.prototype.getValues = function (t) {
        var e = new Set(this.getSet(t));
        return this.categories.map(function (t) {
          return e.has(t);
        });
      }, e.prototype.getLabels = function (t) {
        return this.getValues(t).map(String);
      }, e.prototype.getMap = function (t) {
        return this.getCategories(t).map(function (t) {
          return {
            key: t.label,
            value: !0
          };
        });
      }, e.prototype.getMapLabel = function (t) {
        return this.getCategories(t).map(function (t) {
          return {
            key: t.label,
            value: "true"
          };
        });
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.filter = this.currentFilter, n;
      }, e.prototype.restore = function (e, n) {
        if (t.prototype.restore.call(this, e, n), "filter" in e) {
          var r = e.filter;
          "string" == typeof r || Array.isArray(r) ? this.currentFilter = {
            filter: r,
            filterMissing: !1
          } : this.currentFilter = r;
        } else this.currentFilter = null;
      }, e.prototype.isFiltered = function () {
        return null != this.currentFilter;
      }, e.prototype.filter = function (t) {
        var e = this;
        return !this.currentFilter || Array.from(this.getSet(t)).some(function (t) {
          return Object(s.d)(e.currentFilter, t);
        });
      }, e.prototype.getFilter = function () {
        return d.a.prototype.getFilter.call(this);
      }, e.prototype.setFilter = function (t) {
        return d.a.prototype.setFilter.call(this, t);
      }, e.prototype.compare = function (t, e) {
        var n = this.getSet(t),
            r = this.getSet(e);
        if (0 === n.size) return 0 === r.size ? 0 : l.a;
        if (0 === r.size) return -l.a;
        if (n.size !== r.size) return n.size - r.size;

        for (var i = 0, o = this.categories; i < o.length; i++) {
          var a = o[i];
          if (n.has(a)) return -1;
          if (r.has(a)) return 1;
        }

        return 0;
      }, e.EVENT_FILTER_CHANGED = d.a.EVENT_FILTER_CHANGED, e = n = Object(r.b)([Object(O.m)("filterCategorical"), Object(O.b)("categorical")], e);
    }(G.b),
        U = n(43),
        B = n(20),
        Y = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultWidth(200), r.alignment = n.alignment || B.a.left, r.escape = !1 !== n.escape, r.setDefaultRenderer("map"), r;
      }

      return Object(r.c)(e, t), e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (e) {
        return t.prototype.getValue.call(this, e).map(function (t) {
          var e = t.key,
              n = t.value;
          return {
            key: e,
            value: null == n ? "" : String(n)
          };
        });
      }, e = Object(r.b)([Object(O.m)("search")], e);
    }(h.a),
        W = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultWidth(200), r.alignment = n.alignment || B.a.left, r.escape = !1 !== n.escape, r;
      }

      return Object(r.c)(e, t), e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValues = function (e) {
        return t.prototype.getValues.call(this, e).map(function (t) {
          return null == t ? "" : String(t);
        });
      }, e = Object(r.b)([Object(O.m)("search")], e);
    }(c.d),
        q = n(67),
        z = n(37),
        K = n(70),
        X = n(27),
        $ = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.patternFunction = null, r.setDefaultWidth(200), r.alignment = n.alignment || B.a.left, r.escape = !1 !== n.escape, r.pattern = n.pattern || "", r.patternTemplates = n.patternTemplates || [], r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.setPattern = function (t) {
        return z.d.prototype.setPattern.call(this, t);
      }, e.prototype.getPattern = function () {
        return this.pattern;
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_PATTERN_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValues = function (t) {
        return this.getLinks(t).map(function (t) {
          return t ? t.href : "";
        });
      }, e.prototype.getLabels = function (t) {
        return this.getLinks(t).map(function (t) {
          return t ? t.alt : "";
        });
      }, e.prototype.transformValue = function (t, e, n) {
        return null == t || "" === t ? null : "string" == typeof t ? this.pattern ? (this.patternFunction || (this.patternFunction = Object(X.e)(this.pattern, "item", "index")), {
          alt: t,
          href: this.patternFunction.call(this, t, e.v, n)
        }) : {
          alt: t,
          href: t
        } : t;
      }, e.prototype.getLinks = function (e) {
        var n = this;
        return t.prototype.getValues.call(this, e).map(function (t, r) {
          return n.transformValue(t, e, r);
        });
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return this.pattern !== this.desc.pattern && (n.pattern = this.pattern), n;
      }, e.prototype.restore = function (e, n) {
        e.pattern && (this.pattern = e.pattern), t.prototype.restore.call(this, e, n);
      }, e.EVENT_PATTERN_CHANGED = z.d.EVENT_PATTERN_CHANGED, e = n = Object(r.b)([Object(O.m)("search", "editPattern")], e);
    }(c.d),
        J = n(38),
        Z = n(60),
        Q = n(53),
        tt = n(59),
        et = n(26),
        nt = n(49),
        rt = function (t) {
      function e(e, n) {
        return t.call(this, e, n) || this;
      }

      return Object(r.c)(e, t), e.prototype.getLabel = function () {
        return "";
      }, e.prototype.getValue = function () {
        return "";
      }, e.prototype.compare = function () {
        return 0;
      }, e;
    }(M.d),
        it = n(86),
        ot = n(11);

    function at(t, e) {
      void 0 === e && (e = {});

      var n = function (t) {
        function e(e, n) {
          var r = t.call(this, e, n) || this;
          return "function" == typeof r.init && r.init.apply(r, [].slice.apply(arguments)), r;
        }

        return Object(r.c)(e, t), e.prototype.init = function () {}, e;
      }(G.b);

      return n.prototype.toString = function () {
        return t;
      }, n.prototype = Object.assign(n.prototype, e), n;
    }

    function ut() {
      return {
        actions: i.b,
        aggregate: o.c,
        annotate: a.a,
        boolean: u.c,
        booleans: p,
        boxplot: f.c,
        categorical: d.a,
        categoricalMap: g,
        categoricals: b,
        date: m.c,
        dateMap: C,
        dates: y.d,
        group: _.c,
        hierarchy: T.g,
        imposition: N.b,
        impositionBoxPlot: q.b,
        impositions: D.b,
        reduce: k.d,
        nested: R.b,
        number: w.b,
        numbers: S.c,
        numberMap: x,
        ordinal: I.b,
        rank: V.b,
        script: H.d,
        selection: P.c,
        set: F,
        stack: U.b,
        string: B.d,
        stringMap: Y,
        strings: W,
        link: z.d,
        linkMap: K.a,
        links: $
      };
    }

    n.d(e, "rc", function () {
      return at;
    }), n.d(e, "Vc", function () {
      return ut;
    }), n.d(e, "Sc", function () {
      return O.l;
    }), n.d(e, "l", function () {
      return O.b;
    }), n.d(e, "Wb", function () {
      return O.e;
    }), n.d(e, "Rb", function () {
      return O.d;
    }), n.d(e, "k", function () {
      return O.a;
    }), n.d(e, "gd", function () {
      return O.m;
    }), n.d(e, "tc", function () {
      return O.h;
    }), n.d(e, "Zb", function () {
      return O.g;
    }), n.d(e, "Yb", function () {
      return O.f;
    }), n.d(e, "M", function () {
      return O.IColumnCategory;
    }), n.d(e, "Mc", function () {
      return l.c;
    }), n.d(e, "Tc", function () {
      return l.d;
    }), n.d(e, "z", function () {
      return l.b;
    }), n.d(e, "y", function () {
      return l.a;
    }), n.d(e, "Uc", function () {
      return l.e;
    }), n.d(e, "qc", function () {
      return J.a;
    }), n.d(e, "Ic", function () {
      return Z.b;
    }), n.d(e, "Rc", function () {
      return s.f;
    }), n.d(e, "ed", function () {
      return s.h;
    }), n.d(e, "bc", function () {
      return s.a;
    }), n.d(e, "vc", function () {
      return s.b;
    }), n.d(e, "dd", function () {
      return s.g;
    }), n.d(e, "yc", function () {
      return s.c;
    }), n.d(e, "Fc", function () {
      return s.e;
    }), n.d(e, "zc", function () {
      return s.d;
    }), n.d(e, "p", function () {
      return E.a;
    }), n.d(e, "ac", function () {
      return E.e;
    }), n.d(e, "uc", function () {
      return E.g;
    }), n.d(e, "x", function () {
      return E.c;
    }), n.d(e, "xc", function () {
      return E.h;
    }), n.d(e, "u", function () {
      return E.b;
    }), n.d(e, "Qc", function () {
      return E.m;
    }), n.d(e, "Yc", function () {
      return E.o;
    }), n.d(e, "Xc", function () {
      return E.n;
    }), n.d(e, "Hc", function () {
      return E.j;
    }), n.d(e, "Pc", function () {
      return E.l;
    }), n.d(e, "Ec", function () {
      return E.i;
    }), n.d(e, "cd", function () {
      return E.p;
    }), n.d(e, "S", function () {
      return Q.a;
    }), n.d(e, "ad", function () {
      return Q.i;
    }), n.d(e, "Wc", function () {
      return Q.h;
    }), n.d(e, "Gc", function () {
      return Q.g;
    }), n.d(e, "Dc", function () {
      return Q.f;
    }), n.d(e, "Ac", function () {
      return Q.c;
    }), n.d(e, "Bc", function () {
      return Q.d;
    }), n.d(e, "pc", function () {
      return Q.b;
    }), n.d(e, "Cc", function () {
      return Q.e;
    }), n.d(e, "fd", function () {
      return Q.j;
    }), n.d(e, "Lc", function () {
      return tt.b;
    }), n.d(e, "wc", function () {
      return tt.a;
    }), n.d(e, "Kc", function () {
      return L.d;
    }), n.d(e, "Mb", function () {
      return L.a;
    }), n.d(e, "Ob", function () {
      return L.b;
    }), n.d(e, "ic", function () {
      return L.c;
    }), n.d(e, "bd", function () {
      return L.e;
    }), n.d(e, "a", function () {
      return i.b;
    }), n.d(e, "cc", function () {
      return i.a;
    }), n.d(e, "b", function () {
      return o.c;
    }), n.d(e, "dc", function () {
      return o.b;
    }), n.d(e, "C", function () {
      return o.IAggregateGroupColumnDesc;
    }), n.d(e, "c", function () {
      return a.a;
    }), n.d(e, "d", function () {
      return c.d;
    }), n.d(e, "D", function () {
      return c.IArrayColumnDesc;
    }), n.d(e, "E", function () {
      return c.IArrayDesc;
    }), n.d(e, "sb", function () {
      return c.ISplicer;
    }), n.d(e, "e", function () {
      return u.c;
    }), n.d(e, "F", function () {
      return u.IBooleanColumnDesc;
    }), n.d(e, "G", function () {
      return u.IBooleanDesc;
    }), n.d(e, "f", function () {
      return p;
    }), n.d(e, "g", function () {
      return f.c;
    }), n.d(e, "H", function () {
      return f.IBoxPlotColumnDesc;
    }), n.d(e, "I", function () {
      return f.IBoxPlotDesc;
    }), n.d(e, "h", function () {
      return d.a;
    }), n.d(e, "i", function () {
      return g;
    }), n.d(e, "j", function () {
      return b;
    }), n.d(e, "m", function () {
      return M.d;
    }), n.d(e, "W", function () {
      return M.IFlatColumn;
    }), n.d(e, "P", function () {
      return M.IColumnParent;
    }), n.d(e, "O", function () {
      return M.IColumnMetaData;
    }), n.d(e, "N", function () {
      return Z.IColumnDesc;
    }), n.d(e, "n", function () {
      return et.b;
    }), n.d(e, "Nc", function () {
      return et.c;
    }), n.d(e, "cb", function () {
      return et.IMultiLevelColumn;
    }), n.d(e, "o", function () {
      return nt.a;
    }), n.d(e, "q", function () {
      return m.c;
    }), n.d(e, "R", function () {
      return m.IDateColumnDesc;
    }), n.d(e, "s", function () {
      return C;
    }), n.d(e, "T", function () {}), n.d(e, "r", function () {
      return y.d;
    }), n.d(e, "V", function () {
      return y.IDatesDesc;
    }), n.d(e, "U", function () {
      return y.IDatesColumnDesc;
    }), n.d(e, "t", function () {
      return rt;
    }), n.d(e, "A", function () {
      return _.c;
    }), n.d(e, "ec", function () {
      return _.b;
    }), n.d(e, "w", function () {
      return _.a;
    }), n.d(e, "B", function () {
      return T.g;
    }), n.d(e, "L", function () {
      return T.ICategoryNode;
    }), n.d(e, "jb", function () {
      return T.IPartialCategoryNode;
    }), n.d(e, "X", function () {
      return T.IHierarchyColumnDesc;
    }), n.d(e, "Y", function () {
      return T.IHierarchyDesc;
    }), n.d(e, "K", function () {
      return T.ICategoryInternalNode;
    }), n.d(e, "Q", function () {
      return T.ICutOffNode;
    }), n.d(e, "Zc", function () {
      return T.j;
    }), n.d(e, "Jc", function () {
      return T.i;
    }), n.d(e, "sc", function () {
      return T.h;
    }), n.d(e, "fc", function () {
      return q.a;
    }), n.d(e, "wb", function () {
      return q.b;
    }), n.d(e, "gc", function () {
      return N.a;
    }), n.d(e, "xb", function () {
      return N.b;
    }), n.d(e, "hc", function () {
      return D.a;
    }), n.d(e, "yb", function () {
      return D.b;
    }), n.d(e, "Cb", function () {
      return h.a;
    }), n.d(e, "Db", function () {
      return it.a;
    }), n.d(e, "jc", function () {
      return R.a;
    }), n.d(e, "Eb", function () {
      return R.b;
    }), n.d(e, "Fb", function () {
      return w.b;
    }), n.d(e, "eb", function () {
      return w.INumberColumnDesc;
    }), n.d(e, "db", function () {
      return E.default;
    }), n.d(e, "Oc", function () {
      return E.k;
    }), n.d(e, "Gb", function () {
      return x;
    }), n.d(e, "gb", function () {}), n.d(e, "fb", function () {}), n.d(e, "Hb", function () {
      return S.c;
    }), n.d(e, "ib", function () {
      return S.INumbersDesc;
    }), n.d(e, "hb", function () {
      return S.INumbersColumnDesc;
    }), n.d(e, "Ib", function () {
      return I.b;
    }), n.d(e, "J", function () {
      return I.ICategoricalNumberColumnDesc;
    }), n.d(e, "kc", function () {
      return V.a;
    }), n.d(e, "Jb", function () {
      return V.b;
    }), n.d(e, "Kb", function () {
      return ot.b;
    }), n.d(e, "rb", function () {
      return ot.ISortCriteria;
    }), n.d(e, "Lb", function () {
      return k.d;
    }), n.d(e, "lc", function () {
      return k.c;
    }), n.d(e, "lb", function () {
      return k.IReduceDesc;
    }), n.d(e, "kb", function () {
      return k.IReduceColumnDesc;
    }), n.d(e, "Nb", function () {
      return H.d;
    }), n.d(e, "mc", function () {
      return H.c;
    }), n.d(e, "nb", function () {
      return H.IScriptDesc;
    }), n.d(e, "mb", function () {
      return H.IScriptColumnDesc;
    }), n.d(e, "Pb", function () {
      return P.c;
    }), n.d(e, "nc", function () {
      return P.b;
    }), n.d(e, "ob", function () {
      return P.ISelectionColumnDesc;
    }), n.d(e, "Qb", function () {
      return F;
    }), n.d(e, "pb", function () {}), n.d(e, "qb", function () {}), n.d(e, "Sb", function () {
      return U.b;
    }), n.d(e, "oc", function () {
      return U.a;
    }), n.d(e, "Tb", function () {
      return B.d;
    }), n.d(e, "v", function () {
      return B.a;
    }), n.d(e, "ub", function () {
      return B.IStringDesc;
    }), n.d(e, "tb", function () {
      return B.IStringColumnDesc;
    }), n.d(e, "Ub", function () {
      return Y;
    }), n.d(e, "Vb", function () {
      return W;
    }), n.d(e, "Xb", function () {
      return G.b;
    }), n.d(e, "vb", function () {
      return G.IValueColumnDesc;
    }), n.d(e, "zb", function () {
      return z.d;
    }), n.d(e, "bb", function () {
      return z.ILinkDesc;
    }), n.d(e, "ab", function () {
      return z.ILinkColumnDesc;
    }), n.d(e, "Z", function () {
      return z.ILink;
    }), n.d(e, "Ab", function () {
      return K.a;
    }), n.d(e, "Bb", function () {
      return $;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(1),
        o = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.accessor = n.accessor || function () {
          return null;
        }, r.loaded = !0 !== n.lazyLoaded, r;
      }

      return Object(r.c)(e, t), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_DATA_LOADED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getLabel = function (t) {
        return this.isLoaded() ? String(this.getValue(t)) : "";
      }, e.prototype.getRaw = function (t) {
        return this.isLoaded() ? this.accessor(t, this.id, this.desc, this.findMyRanker()) : null;
      }, e.prototype.getValue = function (t) {
        return this.getRaw(t);
      }, e.prototype.isLoaded = function () {
        return this.loaded;
      }, e.prototype.setLoaded = function (t) {
        this.loaded !== t && this.fire([e.EVENT_DATA_LOADED, i.d.EVENT_DIRTY_HEADER, i.d.EVENT_DIRTY_VALUES, i.d.EVENT_DIRTY], this.loaded, this.loaded = t);
      }, e.prototype.getRenderer = function () {
        return this.isLoaded() ? t.prototype.getRenderer.call(this) : e.RENDERER_LOADING;
      }, e.prototype.dump = function (n) {
        var r = t.prototype.dump.call(this, n);
        return r.loaded = this.loaded, this.loaded || r.rendererType !== e.RENDERER_LOADING || delete r.rendererType, r;
      }, e.prototype.restore = function (e, n) {
        void 0 !== e.loaded && (this.loaded = e.loaded), t.prototype.restore.call(this, e, n);
      }, e.EVENT_DATA_LOADED = "dataLoaded", e.RENDERER_LOADING = "loading", e;
    }(i.d);

    e.b = o;
  }, function (t, e, n) {
    "use strict";

    var r = n(15);

    function i(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
        return e.setFullYear(t.y), e;
      }

      return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
    }

    function o(t) {
      if (0 <= t.y && t.y < 100) {
        var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
        return e.setUTCFullYear(t.y), e;
      }

      return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
    }

    function a(t) {
      return {
        y: t,
        m: 0,
        d: 1,
        H: 0,
        M: 0,
        S: 0,
        L: 0
      };
    }

    var u,
        c,
        s,
        l,
        p,
        f = {
      "-": "",
      _: " ",
      0: "0"
    },
        d = /^\s*\d+/,
        h = /^%/,
        g = /[\\^$*+?|[\]().{}]/g;

    function b(t, e, n) {
      var r = t < 0 ? "-" : "",
          i = (r ? -t : t) + "",
          o = i.length;
      return r + (o < n ? new Array(n - o + 1).join(e) + i : i);
    }

    function m(t) {
      return t.replace(g, "\\$&");
    }

    function y(t) {
      return new RegExp("^(?:" + t.map(m).join("|") + ")", "i");
    }

    function v(t) {
      for (var e = {}, n = -1, r = t.length; ++n < r;) {
        e[t[n].toLowerCase()] = n;
      }

      return e;
    }

    function E(t, e, n) {
      var r = d.exec(e.slice(n, n + 1));
      return r ? (t.w = +r[0], n + r[0].length) : -1;
    }

    function O(t, e, n) {
      var r = d.exec(e.slice(n, n + 1));
      return r ? (t.u = +r[0], n + r[0].length) : -1;
    }

    function C(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.U = +r[0], n + r[0].length) : -1;
    }

    function _(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.V = +r[0], n + r[0].length) : -1;
    }

    function T(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.W = +r[0], n + r[0].length) : -1;
    }

    function N(t, e, n) {
      var r = d.exec(e.slice(n, n + 4));
      return r ? (t.y = +r[0], n + r[0].length) : -1;
    }

    function D(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
    }

    function R(t, e, n) {
      var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
      return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
    }

    function w(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
    }

    function A(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.d = +r[0], n + r[0].length) : -1;
    }

    function M(t, e, n) {
      var r = d.exec(e.slice(n, n + 3));
      return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
    }

    function L(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.H = +r[0], n + r[0].length) : -1;
    }

    function j(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.M = +r[0], n + r[0].length) : -1;
    }

    function x(t, e, n) {
      var r = d.exec(e.slice(n, n + 2));
      return r ? (t.S = +r[0], n + r[0].length) : -1;
    }

    function S(t, e, n) {
      var r = d.exec(e.slice(n, n + 3));
      return r ? (t.L = +r[0], n + r[0].length) : -1;
    }

    function I(t, e, n) {
      var r = d.exec(e.slice(n, n + 6));
      return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
    }

    function V(t, e, n) {
      var r = h.exec(e.slice(n, n + 1));
      return r ? n + r[0].length : -1;
    }

    function k(t, e, n) {
      var r = d.exec(e.slice(n));
      return r ? (t.Q = +r[0], n + r[0].length) : -1;
    }

    function H(t, e, n) {
      var r = d.exec(e.slice(n));
      return r ? (t.Q = 1e3 * +r[0], n + r[0].length) : -1;
    }

    function P(t, e) {
      return b(t.getDate(), e, 2);
    }

    function G(t, e) {
      return b(t.getHours(), e, 2);
    }

    function F(t, e) {
      return b(t.getHours() % 12 || 12, e, 2);
    }

    function U(t, e) {
      return b(1 + r.a.count(Object(r.k)(t), t), e, 3);
    }

    function B(t, e) {
      return b(t.getMilliseconds(), e, 3);
    }

    function Y(t, e) {
      return B(t, e) + "000";
    }

    function W(t, e) {
      return b(t.getMonth() + 1, e, 2);
    }

    function q(t, e) {
      return b(t.getMinutes(), e, 2);
    }

    function z(t, e) {
      return b(t.getSeconds(), e, 2);
    }

    function K(t) {
      var e = t.getDay();
      return 0 === e ? 7 : e;
    }

    function X(t, e) {
      return b(r.h.count(Object(r.k)(t), t), e, 2);
    }

    function $(t, e) {
      var n = t.getDay();
      return t = n >= 4 || 0 === n ? Object(r.i)(t) : r.i.ceil(t), b(r.i.count(Object(r.k)(t), t) + (4 === Object(r.k)(t).getDay()), e, 2);
    }

    function J(t) {
      return t.getDay();
    }

    function Z(t, e) {
      return b(r.e.count(Object(r.k)(t), t), e, 2);
    }

    function Q(t, e) {
      return b(t.getFullYear() % 100, e, 2);
    }

    function tt(t, e) {
      return b(t.getFullYear() % 1e4, e, 4);
    }

    function et(t) {
      var e = t.getTimezoneOffset();
      return (e > 0 ? "-" : (e *= -1, "+")) + b(e / 60 | 0, "0", 2) + b(e % 60, "0", 2);
    }

    function nt(t, e) {
      return b(t.getUTCDate(), e, 2);
    }

    function rt(t, e) {
      return b(t.getUTCHours(), e, 2);
    }

    function it(t, e) {
      return b(t.getUTCHours() % 12 || 12, e, 2);
    }

    function ot(t, e) {
      return b(1 + r.l.count(Object(r.v)(t), t), e, 3);
    }

    function at(t, e) {
      return b(t.getUTCMilliseconds(), e, 3);
    }

    function ut(t, e) {
      return at(t, e) + "000";
    }

    function ct(t, e) {
      return b(t.getUTCMonth() + 1, e, 2);
    }

    function st(t, e) {
      return b(t.getUTCMinutes(), e, 2);
    }

    function lt(t, e) {
      return b(t.getUTCSeconds(), e, 2);
    }

    function pt(t) {
      var e = t.getUTCDay();
      return 0 === e ? 7 : e;
    }

    function ft(t, e) {
      return b(r.s.count(Object(r.v)(t), t), e, 2);
    }

    function dt(t, e) {
      var n = t.getUTCDay();
      return t = n >= 4 || 0 === n ? Object(r.t)(t) : r.t.ceil(t), b(r.t.count(Object(r.v)(t), t) + (4 === Object(r.v)(t).getUTCDay()), e, 2);
    }

    function ht(t) {
      return t.getUTCDay();
    }

    function gt(t, e) {
      return b(r.p.count(Object(r.v)(t), t), e, 2);
    }

    function bt(t, e) {
      return b(t.getUTCFullYear() % 100, e, 2);
    }

    function mt(t, e) {
      return b(t.getUTCFullYear() % 1e4, e, 4);
    }

    function yt() {
      return "+0000";
    }

    function vt() {
      return "%";
    }

    function Et(t) {
      return +t;
    }

    function Ot(t) {
      return Math.floor(+t / 1e3);
    }

    u = function (t) {
      var e = t.dateTime,
          n = t.date,
          u = t.time,
          c = t.periods,
          s = t.days,
          l = t.shortDays,
          p = t.months,
          d = t.shortMonths,
          h = y(c),
          g = v(c),
          b = y(s),
          m = v(s),
          Ct = y(l),
          _t = v(l),
          Tt = y(p),
          Nt = v(p),
          Dt = y(d),
          Rt = v(d),
          wt = {
        a: function a(t) {
          return l[t.getDay()];
        },
        A: function A(t) {
          return s[t.getDay()];
        },
        b: function b(t) {
          return d[t.getMonth()];
        },
        B: function B(t) {
          return p[t.getMonth()];
        },
        c: null,
        d: P,
        e: P,
        f: Y,
        H: G,
        I: F,
        j: U,
        L: B,
        m: W,
        M: q,
        p: function p(t) {
          return c[+(t.getHours() >= 12)];
        },
        Q: Et,
        s: Ot,
        S: z,
        u: K,
        U: X,
        V: $,
        w: J,
        W: Z,
        x: null,
        X: null,
        y: Q,
        Y: tt,
        Z: et,
        "%": vt
      },
          At = {
        a: function a(t) {
          return l[t.getUTCDay()];
        },
        A: function A(t) {
          return s[t.getUTCDay()];
        },
        b: function b(t) {
          return d[t.getUTCMonth()];
        },
        B: function B(t) {
          return p[t.getUTCMonth()];
        },
        c: null,
        d: nt,
        e: nt,
        f: ut,
        H: rt,
        I: it,
        j: ot,
        L: at,
        m: ct,
        M: st,
        p: function p(t) {
          return c[+(t.getUTCHours() >= 12)];
        },
        Q: Et,
        s: Ot,
        S: lt,
        u: pt,
        U: ft,
        V: dt,
        w: ht,
        W: gt,
        x: null,
        X: null,
        y: bt,
        Y: mt,
        Z: yt,
        "%": vt
      },
          Mt = {
        a: function a(t, e, n) {
          var r = Ct.exec(e.slice(n));
          return r ? (t.w = _t[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        A: function A(t, e, n) {
          var r = b.exec(e.slice(n));
          return r ? (t.w = m[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        b: function b(t, e, n) {
          var r = Dt.exec(e.slice(n));
          return r ? (t.m = Rt[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        B: function B(t, e, n) {
          var r = Tt.exec(e.slice(n));
          return r ? (t.m = Nt[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        c: function c(t, n, r) {
          return xt(t, e, n, r);
        },
        d: A,
        e: A,
        f: I,
        H: L,
        I: L,
        j: M,
        L: S,
        m: w,
        M: j,
        p: function p(t, e, n) {
          var r = h.exec(e.slice(n));
          return r ? (t.p = g[r[0].toLowerCase()], n + r[0].length) : -1;
        },
        Q: k,
        s: H,
        S: x,
        u: O,
        U: C,
        V: _,
        w: E,
        W: T,
        x: function x(t, e, r) {
          return xt(t, n, e, r);
        },
        X: function X(t, e, n) {
          return xt(t, u, e, n);
        },
        y: D,
        Y: N,
        Z: R,
        "%": V
      };

      function Lt(t, e) {
        return function (n) {
          var r,
              i,
              o,
              a = [],
              u = -1,
              c = 0,
              s = t.length;

          for (n instanceof Date || (n = new Date(+n)); ++u < s;) {
            37 === t.charCodeAt(u) && (a.push(t.slice(c, u)), null != (i = f[r = t.charAt(++u)]) ? r = t.charAt(++u) : i = "e" === r ? " " : "0", (o = e[r]) && (r = o(n, i)), a.push(r), c = u + 1);
          }

          return a.push(t.slice(c, u)), a.join("");
        };
      }

      function jt(t, e) {
        return function (n) {
          var i,
              u,
              c = a(1900);
          if (xt(c, t, n += "", 0) != n.length) return null;
          if ("Q" in c) return new Date(c.Q);

          if ("p" in c && (c.H = c.H % 12 + 12 * c.p), "V" in c) {
            if (c.V < 1 || c.V > 53) return null;
            "w" in c || (c.w = 1), "Z" in c ? (u = (i = o(a(c.y))).getUTCDay(), i = u > 4 || 0 === u ? r.p.ceil(i) : Object(r.p)(i), i = r.l.offset(i, 7 * (c.V - 1)), c.y = i.getUTCFullYear(), c.m = i.getUTCMonth(), c.d = i.getUTCDate() + (c.w + 6) % 7) : (u = (i = e(a(c.y))).getDay(), i = u > 4 || 0 === u ? r.e.ceil(i) : Object(r.e)(i), i = r.a.offset(i, 7 * (c.V - 1)), c.y = i.getFullYear(), c.m = i.getMonth(), c.d = i.getDate() + (c.w + 6) % 7);
          } else ("W" in c || "U" in c) && ("w" in c || (c.w = "u" in c ? c.u % 7 : "W" in c ? 1 : 0), u = "Z" in c ? o(a(c.y)).getUTCDay() : e(a(c.y)).getDay(), c.m = 0, c.d = "W" in c ? (c.w + 6) % 7 + 7 * c.W - (u + 5) % 7 : c.w + 7 * c.U - (u + 6) % 7);

          return "Z" in c ? (c.H += c.Z / 100 | 0, c.M += c.Z % 100, o(c)) : e(c);
        };
      }

      function xt(t, e, n, r) {
        for (var i, o, a = 0, u = e.length, c = n.length; a < u;) {
          if (r >= c) return -1;

          if (37 === (i = e.charCodeAt(a++))) {
            if (i = e.charAt(a++), !(o = Mt[i in f ? e.charAt(a++) : i]) || (r = o(t, n, r)) < 0) return -1;
          } else if (i != n.charCodeAt(r++)) return -1;
        }

        return r;
      }

      return wt.x = Lt(n, wt), wt.X = Lt(u, wt), wt.c = Lt(e, wt), At.x = Lt(n, At), At.X = Lt(u, At), At.c = Lt(e, At), {
        format: function format(t) {
          var e = Lt(t += "", wt);
          return e.toString = function () {
            return t;
          }, e;
        },
        parse: function parse(t) {
          var e = jt(t += "", i);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcFormat: function utcFormat(t) {
          var e = Lt(t += "", At);
          return e.toString = function () {
            return t;
          }, e;
        },
        utcParse: function utcParse(t) {
          var e = jt(t, o);
          return e.toString = function () {
            return t;
          }, e;
        }
      };
    }({
      dateTime: "%x, %X",
      date: "%-m/%-d/%Y",
      time: "%-I:%M:%S %p",
      periods: ["AM", "PM"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }), c = u.format, s = u.parse, l = u.utcFormat, p = u.utcParse;
    Date.prototype.toISOString || l("%Y-%m-%dT%H:%M:%S.%LZ");
    +new Date("2000-01-01T00:00:00.000Z") || p("%Y-%m-%dT%H:%M:%S.%LZ");
    n.d(e, "a", function () {
      return c;
    }), n.d(e, "b", function () {
      return s;
    }), n.d(e, "c", function () {
      return l;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "f", function () {
      return u;
    }), n.d(e, "h", function () {
      return c;
    }), n.d(e, "a", function () {
      return s;
    }), n.d(e, "b", function () {
      return p;
    }), n.d(e, "g", function () {
      return f;
    }), n.d(e, "c", function () {
      return d;
    }), n.d(e, "e", function () {
      return g;
    }), n.d(e, "d", function () {
      return b;
    });
    var r = n(1),
        i = n(59),
        o = n(27),
        a = n(7);

    function u(t) {
      return Object(i.a)(t) && Array.isArray(t.categories);
    }

    function c(t, e, n) {
      if (void 0 === n && (n = function n() {
        return r.d.DEFAULT_COLOR;
      }), "string" == typeof t) return {
        name: t,
        label: t,
        color: n(),
        value: e
      };
      var i = null == t.name ? String(t.value) : t.name;
      return {
        name: i,
        label: t.label || i,
        color: t.color || n(),
        value: null != t.value ? t.value : e
      };
    }

    function s(t, e) {
      var n = null == t || isNaN(t.value),
          r = null == e || isNaN(e.value);
      return n || null == t ? r ? 0 : a.a : r || null == e ? -a.a : t.value === e.value ? t.label.toLowerCase().localeCompare(e.label.toLowerCase()) : t.value - e.value;
    }

    function l(t, e) {
      for (var n = new Map(), r = 0, i = t; r < i.length; r++) {
        var o = i[r],
            a = e.getCategory(o);
        n.set(a, (n.get(a) || 0) + 1);
      }

      if (0 === n.size) return {
        cat: null,
        count: 0
      };
      var u = null,
          c = 0;
      return n.forEach(function (t, e) {
        t > c && (u = e, c = t);
      }), {
        cat: u,
        count: c
      };
    }

    function p(t, e, n) {
      if (0 === t.length) return 0 === e.length ? 0 : a.a;
      if (0 === e.length) return -a.a;
      var r = l(t, n),
          i = l(e, n);
      return null === r.cat ? null === i.cat ? 0 : a.a : null === i.cat ? -a.a : r.cat === i.cat ? i.count - r.count : r.cat.value - i.cat.value;
    }

    function f(t) {
      if (!t.categories) return [];
      var e = Object(o.a)(),
          n = t.categories.length - 1;
      return t.categories.map(function (t, r) {
        return c(t, r / n, e);
      }).sort(s);
    }

    function d(t) {
      return t instanceof r.d && "function" == typeof t.getCategory || !(t instanceof r.d) && null != t.type.match(/(categorical|ordinal|hierarchy)/);
    }

    function h(t) {
      return null == t || !t.filterMissing && (null == t.filter || "" === t.filter);
    }

    function g(t, e) {
      return t === e || (null == t || null == e ? h(t) === h(e) : t.filterMissing === e.filterMissing && typeof t.filter == typeof e.filter && (Array.isArray(t.filter) ? function (t, e) {
        var n = null != t ? t.length : 0,
            r = null != e ? e.length : 0;
        if (n !== r) return !1;
        if (0 === n) return !0;
        return t.every(function (t, n) {
          return t === e[n];
        });
      }(t.filter, e.filter) : String(t.filter) === String(e.filter)));
    }

    function b(t, e) {
      if (null == t) return !0;
      if (null == e || isNaN(e.value)) return !t.filterMissing;
      var n = t.filter;
      return Array.isArray(n) ? n.includes(e.name) : "string" == typeof n && n.length > 0 ? e.name.toLowerCase().includes(n.toLowerCase()) : !(n instanceof RegExp) || n.test(e.name);
    }
  }, function (t, e, n) {
    "use strict";

    var r = function r(t, e, n) {
      t.prototype = e.prototype = n, n.constructor = t;
    };

    function i(t, e) {
      var n = Object.create(t.prototype);

      for (var r in e) {
        n[r] = e[r];
      }

      return n;
    }

    function o() {}

    var a = "\\s*([+-]?\\d+)\\s*",
        u = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        c = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        s = /^#([0-9a-f]{3})$/,
        l = /^#([0-9a-f]{6})$/,
        p = new RegExp("^rgb\\(" + [a, a, a] + "\\)$"),
        f = new RegExp("^rgb\\(" + [c, c, c] + "\\)$"),
        d = new RegExp("^rgba\\(" + [a, a, a, u] + "\\)$"),
        h = new RegExp("^rgba\\(" + [c, c, c, u] + "\\)$"),
        g = new RegExp("^hsl\\(" + [u, c, c] + "\\)$"),
        b = new RegExp("^hsla\\(" + [u, c, c, u] + "\\)$"),
        m = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };

    function y() {
      return this.rgb().formatHex();
    }

    function v() {
      return this.rgb().formatRgb();
    }

    function E(t) {
      var e;
      return t = (t + "").trim().toLowerCase(), (e = s.exec(t)) ? new N((e = parseInt(e[1], 16)) >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : (e = l.exec(t)) ? O(parseInt(e[1], 16)) : (e = p.exec(t)) ? new N(e[1], e[2], e[3], 1) : (e = f.exec(t)) ? new N(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = d.exec(t)) ? C(e[1], e[2], e[3], e[4]) : (e = h.exec(t)) ? C(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = g.exec(t)) ? A(e[1], e[2] / 100, e[3] / 100, 1) : (e = b.exec(t)) ? A(e[1], e[2] / 100, e[3] / 100, e[4]) : m.hasOwnProperty(t) ? O(m[t]) : "transparent" === t ? new N(NaN, NaN, NaN, 0) : null;
    }

    function O(t) {
      return new N(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
    }

    function C(t, e, n, r) {
      return r <= 0 && (t = e = n = NaN), new N(t, e, n, r);
    }

    function _(t) {
      return t instanceof o || (t = E(t)), t ? new N((t = t.rgb()).r, t.g, t.b, t.opacity) : new N();
    }

    function T(t, e, n, r) {
      return 1 === arguments.length ? _(t) : new N(t, e, n, null == r ? 1 : r);
    }

    function N(t, e, n, r) {
      this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
    }

    function D() {
      return "#" + w(this.r) + w(this.g) + w(this.b);
    }

    function R() {
      var t = this.opacity;
      return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
    }

    function w(t) {
      return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
    }

    function A(t, e, n, r) {
      return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new j(t, e, n, r);
    }

    function M(t) {
      if (t instanceof j) return new j(t.h, t.s, t.l, t.opacity);
      if (t instanceof o || (t = E(t)), !t) return new j();
      if (t instanceof j) return t;
      var e = (t = t.rgb()).r / 255,
          n = t.g / 255,
          r = t.b / 255,
          i = Math.min(e, n, r),
          a = Math.max(e, n, r),
          u = NaN,
          c = a - i,
          s = (a + i) / 2;
      return c ? (u = e === a ? (n - r) / c + 6 * (n < r) : n === a ? (r - e) / c + 2 : (e - n) / c + 4, c /= s < .5 ? a + i : 2 - a - i, u *= 60) : c = s > 0 && s < 1 ? 0 : u, new j(u, c, s, t.opacity);
    }

    function L(t, e, n, r) {
      return 1 === arguments.length ? M(t) : new j(t, e, n, null == r ? 1 : r);
    }

    function j(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    function x(t, e, n) {
      return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
    }

    r(o, E, {
      copy: function copy(t) {
        return Object.assign(new this.constructor(), this, t);
      },
      displayable: function displayable() {
        return this.rgb().displayable();
      },
      hex: y,
      formatHex: y,
      formatHsl: function formatHsl() {
        return M(this).formatHsl();
      },
      formatRgb: v,
      toString: v
    }), r(N, T, i(o, {
      brighter: function brighter(t) {
        return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new N(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? .7 : Math.pow(.7, t), new N(this.r * t, this.g * t, this.b * t, this.opacity);
      },
      rgb: function rgb() {
        return this;
      },
      displayable: function displayable() {
        return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
      },
      hex: D,
      formatHex: D,
      formatRgb: R,
      toString: R
    })), r(j, L, i(o, {
      brighter: function brighter(t) {
        return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new j(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? .7 : Math.pow(.7, t), new j(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = this.h % 360 + 360 * (this.h < 0),
            e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
            n = this.l,
            r = n + (n < .5 ? n : 1 - n) * e,
            i = 2 * n - r;
        return new N(x(t >= 240 ? t - 240 : t + 120, i, r), x(t, i, r), x(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
      },
      displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
      },
      formatHsl: function formatHsl() {
        var t = this.opacity;
        return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
      }
    }));
    var S = Math.PI / 180,
        I = 180 / Math.PI,
        V = .96422,
        k = 1,
        H = .82521,
        P = 4 / 29,
        G = 6 / 29,
        F = 3 * G * G,
        U = G * G * G;

    function B(t) {
      if (t instanceof W) return new W(t.l, t.a, t.b, t.opacity);
      if (t instanceof Z) return Q(t);
      t instanceof N || (t = _(t));
      var e,
          n,
          r = X(t.r),
          i = X(t.g),
          o = X(t.b),
          a = q((.2225045 * r + .7168786 * i + .0606169 * o) / k);
      return r === i && i === o ? e = n = a : (e = q((.4360747 * r + .3850649 * i + .1430804 * o) / V), n = q((.0139322 * r + .0971045 * i + .7141733 * o) / H)), new W(116 * a - 16, 500 * (e - a), 200 * (a - n), t.opacity);
    }

    function Y(t, e, n, r) {
      return 1 === arguments.length ? B(t) : new W(t, e, n, null == r ? 1 : r);
    }

    function W(t, e, n, r) {
      this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
    }

    function q(t) {
      return t > U ? Math.pow(t, 1 / 3) : t / F + P;
    }

    function z(t) {
      return t > G ? t * t * t : F * (t - P);
    }

    function K(t) {
      return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
    }

    function X(t) {
      return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
    }

    function $(t) {
      if (t instanceof Z) return new Z(t.h, t.c, t.l, t.opacity);
      if (t instanceof W || (t = B(t)), 0 === t.a && 0 === t.b) return new Z(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
      var e = Math.atan2(t.b, t.a) * I;
      return new Z(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
    }

    function J(t, e, n, r) {
      return 1 === arguments.length ? $(t) : new Z(t, e, n, null == r ? 1 : r);
    }

    function Z(t, e, n, r) {
      this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
    }

    function Q(t) {
      if (isNaN(t.h)) return new W(t.l, 0, 0, t.opacity);
      var e = t.h * S;
      return new W(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
    }

    r(W, Y, i(o, {
      brighter: function brighter(t) {
        return new W(this.l + 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
      },
      darker: function darker(t) {
        return new W(this.l - 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
      },
      rgb: function rgb() {
        var t = (this.l + 16) / 116,
            e = isNaN(this.a) ? t : t + this.a / 500,
            n = isNaN(this.b) ? t : t - this.b / 200;
        return new N(K(3.1338561 * (e = V * z(e)) - 1.6168667 * (t = k * z(t)) - .4906146 * (n = H * z(n))), K(-.9787684 * e + 1.9161415 * t + .033454 * n), K(.0719453 * e - .2289914 * t + 1.4052427 * n), this.opacity);
      }
    })), r(Z, J, i(o, {
      brighter: function brighter(t) {
        return new Z(this.h, this.c, this.l + 18 * (null == t ? 1 : t), this.opacity);
      },
      darker: function darker(t) {
        return new Z(this.h, this.c, this.l - 18 * (null == t ? 1 : t), this.opacity);
      },
      rgb: function rgb() {
        return Q(this).rgb();
      }
    }));
    var tt = -.14861,
        et = 1.78277,
        nt = -.29227,
        rt = -.90649,
        it = 1.97294,
        ot = it * rt,
        at = it * et,
        ut = et * nt - rt * tt;

    function ct(t, e, n, r) {
      return 1 === arguments.length ? function (t) {
        if (t instanceof st) return new st(t.h, t.s, t.l, t.opacity);
        t instanceof N || (t = _(t));
        var e = t.r / 255,
            n = t.g / 255,
            r = t.b / 255,
            i = (ut * r + ot * e - at * n) / (ut + ot - at),
            o = r - i,
            a = (it * (n - i) - nt * o) / rt,
            u = Math.sqrt(a * a + o * o) / (it * i * (1 - i)),
            c = u ? Math.atan2(a, o) * I - 120 : NaN;
        return new st(c < 0 ? c + 360 : c, u, i, t.opacity);
      }(t) : new st(t, e, n, null == r ? 1 : r);
    }

    function st(t, e, n, r) {
      this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
    }

    r(st, ct, i(o, {
      brighter: function brighter(t) {
        return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new st(this.h, this.s, this.l * t, this.opacity);
      },
      darker: function darker(t) {
        return t = null == t ? .7 : Math.pow(.7, t), new st(this.h, this.s, this.l * t, this.opacity);
      },
      rgb: function rgb() {
        var t = isNaN(this.h) ? 0 : (this.h + 120) * S,
            e = +this.l,
            n = isNaN(this.s) ? 0 : this.s * e * (1 - e),
            r = Math.cos(t),
            i = Math.sin(t);
        return new N(255 * (e + n * (tt * r + et * i)), 255 * (e + n * (nt * r + rt * i)), 255 * (e + n * (it * r)), this.opacity);
      }
    })), n.d(e, "a", function () {
      return E;
    }), n.d(e, "f", function () {
      return T;
    }), n.d(e, "d", function () {
      return L;
    }), n.d(e, "e", function () {
      return Y;
    }), n.d(e, "c", function () {
      return J;
    }), n.d(e, "b", function () {
      return ct;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return s;
    });
    var r = n(0),
        i = n(13),
        o = n(1),
        a = n(2),
        u = n(3),
        c = n(22);

    function s(t) {
      return "function" == typeof t.getCollapsed;
    }

    var l = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e._children = [], e;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_FILTER_CHANGED, n.EVENT_ADD_COLUMN, n.EVENT_MOVE_COLUMN, n.EVENT_REMOVE_COLUMN]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.assignNewId = function (e) {
        t.prototype.assignNewId.call(this, e), this._children.forEach(function (t) {
          return t.assignNewId(e);
        });
      }, Object.defineProperty(e.prototype, "children", {
        get: function get() {
          return this._children.slice();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "length", {
        get: function get() {
          return this._children.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.flatten = function (t, e, n, r) {
        void 0 === n && (n = 0), void 0 === r && (r = 0);
        var i = 0;
        return (0 === n || n <= o.d.FLAT_ALL_COLUMNS) && (i = this.getWidth(), t.push({
          col: this,
          offset: e,
          width: i
        }), 0 === n) ? i : (this._children.forEach(function (i) {
          i.isVisible() && n <= o.d.FLAT_ALL_COLUMNS && i.flatten(t, e, n - 1, r);
        }), i);
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.children = this._children.map(function (t) {
          return t.dump(e);
        }), n;
      }, e.prototype.restore = function (e, n) {
        var r = this;
        e.children.map(function (t) {
          var e = n(t);
          e && r.push(e);
        }), t.prototype.restore.call(this, e, n);
      }, e.prototype.insert = function (t, e) {
        return !Object(u.k)(t) && this.canJustAddNumbers ? null : (this._children.splice(e, 0, t), this.insertImpl(t, e));
      }, e.prototype.move = function (t, e) {
        if (t.parent !== this) return null;

        var n = this._children.indexOf(t);

        return e === n ? t : (this._children.splice(n, 1), this._children.splice(n < e ? e - 1 : e, 0, t), this.moveImpl(t, e, n));
      }, e.prototype.insertImpl = function (t, e) {
        return t.attach(this), this.forward.apply(this, Object(r.d)([t], Object(i.b)(".combine", o.d.EVENT_DIRTY_HEADER, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY, n.EVENT_FILTER_CHANGED, o.d.EVENT_RENDERER_TYPE_CHANGED, o.d.EVENT_GROUP_RENDERER_TYPE_CHANGED))), this.fire([n.EVENT_ADD_COLUMN, o.d.EVENT_DIRTY_HEADER, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY], t, e), t;
      }, e.prototype.moveImpl = function (t, e, r) {
        return this.fire([n.EVENT_MOVE_COLUMN, o.d.EVENT_DIRTY_HEADER, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY, o.d.EVENT_RENDERER_TYPE_CHANGED, o.d.EVENT_GROUP_RENDERER_TYPE_CHANGED], t, e, r), t;
      }, e.prototype.push = function (t) {
        return this.insert(t, this._children.length);
      }, e.prototype.at = function (t) {
        return this._children[t];
      }, e.prototype.indexOf = function (t) {
        return this._children.indexOf(t);
      }, e.prototype.insertAfter = function (t, e) {
        var n = this.indexOf(e);
        return n < 0 ? null : this.insert(t, n + 1);
      }, e.prototype.moveAfter = function (t, e) {
        var n = this.indexOf(e);
        return n < 0 ? null : this.move(t, n + 1);
      }, e.prototype.remove = function (t) {
        var e = this._children.indexOf(t);

        return !(e < 0) && (this._children.splice(e, 1), this.removeImpl(t, e));
      }, e.prototype.removeImpl = function (t, e) {
        return t.detach(), this.unforward.apply(this, Object(r.d)([t], Object(i.b)(".combine", o.d.EVENT_DIRTY_HEADER, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY, n.EVENT_FILTER_CHANGED))), this.fire([n.EVENT_REMOVE_COLUMN, o.d.EVENT_DIRTY_HEADER, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY], t, e), !0;
      }, e.prototype.isFiltered = function () {
        return this._children.some(function (t) {
          return t.isFiltered();
        });
      }, e.prototype.filter = function (t) {
        return this._children.every(function (e) {
          return e.filter(t);
        });
      }, e.prototype.isLoaded = function () {
        return this._children.every(function (t) {
          return !(t instanceof c.b || t instanceof n) || t.isLoaded();
        });
      }, Object.defineProperty(e.prototype, "canJustAddNumbers", {
        get: function get() {
          return !1;
        },
        enumerable: !0,
        configurable: !0
      }), e.EVENT_FILTER_CHANGED = "filterChanged", e.EVENT_ADD_COLUMN = "addColumn", e.EVENT_MOVE_COLUMN = "moveColumn", e.EVENT_REMOVE_COLUMN = "removeColumn", e = n = Object(r.b)([Object(a.m)("compositeContained", "splitCombined"), Object(a.b)("composite")], e);
    }(o.d);

    e.b = l;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "e", function () {
      return a;
    }), n.d(e, "c", function () {
      return u;
    }), n.d(e, "f", function () {
      return c;
    }), n.d(e, "g", function () {
      return s;
    }), n.d(e, "a", function () {
      return p;
    }), n.d(e, "d", function () {
      return f;
    }), n.d(e, "b", function () {
      return d;
    });
    var r = n(0),
        i = n(16),
        o = n(3);

    function a(t) {
      for (var e = [], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }

      return new (Function.bind.apply(Function, Object(r.d)([void 0, "value"], e, ["\n  const escapedValue = encodeURIComponent(String(value));\n  return `" + t + "`;\n "])))();
    }

    function u(t) {
      if (console.assert(t.length > 0), 1 === t.length) return t[0];
      var e = t.map(function (t) {
        return Object.assign({
          subGroups: []
        }, t);
      });
      e.slice(1).forEach(function (t, n) {
        t.parent = e[n], e[n].subGroups.push(t);
      });
      var n = {
        name: e.map(function (t) {
          return t.name;
        }).join(" ∩ "),
        color: e[0].color,
        parent: e[e.length - 1]
      };
      return n.parent.subGroups.push(n), n;
    }

    function c(t) {
      return t.name;
    }

    function s(t) {
      if (!(t.length <= 1)) {
        var e = new Map(),
            n = function n(t) {
          var r = t.name;

          if (t.parent) {
            var i = n(t.parent);
            t.parent = i.g, r = i.id + ".$[id}";
          }

          return e.has(r) ? {
            g: e.get(r),
            id: r
          } : (t.parent && t.parent.subGroups.push(t), t.subGroups = [], e.set(r, t), {
            g: t,
            id: r
          });
        };

        t.forEach(function (t) {
          t.parent && (t.parent = n(t.parent).g, t.parent.subGroups.push(t));
        });
      }
    }

    var l = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"].concat(["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"]);

    function p() {
      var t = 0;
      return function () {
        return l[t++ % l.length];
      };
    }

    function f(t, e) {
      var n = t.map(function (t, n) {
        return {
          i: n,
          v: e.getNumber(t),
          m: e.isMissing(t)
        };
      }).filter(function (t) {
        return !t.m;
      }).sort(function (t, e) {
        return Object(o.o)(t.v, e.v);
      }),
          r = n[Math.floor(n.length / 2)];
      return void 0 === r ? 0 : r.i;
    }

    function d(t, e, n, r) {
      var a = new i.g(t.map(function (t) {
        return n.getNumber(t);
      })),
          u = new i.g(e.map(function (t) {
        return n.getNumber(t);
      }));
      return Object(o.o)(a[r], u[r]);
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(5),
        i = n(57),
        o = function o(t) {
      return Object(i.d)(t[t.length - 1]);
    },
        a = o(new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(r.a)),
        u = o(new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(r.a)),
        c = o(new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(r.a)),
        s = o(new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(r.a)),
        l = o(new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(r.a)),
        p = o(new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(r.a)),
        f = n(25),
        d = Object(i.b)(Object(f.b)(-100, .75, .35), Object(f.b)(80, 1.5, .8)),
        h = Object(i.b)(Object(f.b)(260, .75, .35), Object(f.b)(80, 1.5, .8)),
        g = Object(f.b)(),
        b = Object(i.b)(Object(f.b)(300, .5, 0), Object(f.b)(-240, .5, 1));

    function m(t) {
      var e = t.length;
      return function (n) {
        return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
      };
    }

    var y = m(Object(r.a)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")),
        v = m(Object(r.a)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),
        E = m(Object(r.a)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),
        O = m(Object(r.a)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921")),
        C = o(new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(r.a)),
        _ = o(new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(r.a)),
        T = o(new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(r.a)),
        N = o(new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(r.a)),
        D = o(new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(r.a)),
        R = o(new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(r.a)),
        w = o(new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(r.a)),
        A = o(new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(r.a)),
        M = o(new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(r.a)),
        L = o(new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(r.a)),
        j = o(new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(r.a)),
        x = o(new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(r.a)),
        S = o(new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(r.a)),
        I = o(new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(r.a)),
        V = o(new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(r.a)),
        k = o(new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(r.a)),
        H = o(new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(r.a)),
        P = o(new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(r.a)),
        G = o(new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(r.a)),
        F = o(new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(r.a)),
        U = o(new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(r.a)),
        B = n(1),
        Y = n(42),
        W = n(65);

    n.d(e, "c", function () {
      return K;
    }), n.d(e, "a", function () {
      return X;
    }), n.d(e, "d", function () {
      return J;
    }), n.d(e, "b", function () {
      return Z;
    }), n.d(e, "i", function () {
      return Q;
    }), n.d(e, "f", function () {
      return tt;
    }), n.d(e, "g", function () {
      return et;
    }), n.d(e, "e", function () {
      return ht;
    }), n.d(e, "h", function () {
      return gt;
    });

    var q = function () {
      function t(t, e, n) {
        this.name = t, this.type = e, this.apply = n;
      }

      return t.prototype.dump = function () {
        return this.name;
      }, t.prototype.clone = function () {
        return this;
      }, t.prototype.eq = function (t) {
        return t === this;
      }, t;
    }(),
        z = function () {
      function t(t) {
        this.color = t;
      }

      return Object.defineProperty(t.prototype, "type", {
        get: function get() {
          return "solid";
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.apply = function () {
        return this.color;
      }, t.prototype.dump = function () {
        return this.color;
      }, t.prototype.clone = function () {
        return this;
      }, t.prototype.eq = function (e) {
        return e instanceof t && e.color === this.color;
      }, t;
    }(),
        K = function () {
      function t(t, e) {
        this.base = t, this.steps = e;
      }

      return Object.defineProperty(t.prototype, "type", {
        get: function get() {
          return "quantized";
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.apply = function (t) {
        return this.base.apply(function (t, e) {
          var n = 1 / e;
          if (t <= n) return 0;
          if (t >= 1 - n) return 1;

          for (var r = 0; r < 1; r += n) {
            if (t < r) return r - n / 2;
          }

          return t;
        }(t, this.steps));
      }, t.prototype.dump = function () {
        return {
          base: this.base.dump(),
          steps: this.steps
        };
      }, t.prototype.clone = function () {
        return this;
      }, t.prototype.eq = function (e) {
        return e instanceof t && e.base.eq(this.base) && e.steps === this.steps;
      }, t;
    }(),
        X = function () {
      function t(t) {
        this.entries = t, this.scale = Object(W.a)(), this.scale.domain(t.map(function (t) {
          return t.value;
        })).range(t.map(function (t) {
          return t.color;
        })).clamp(!0);
      }

      return Object.defineProperty(t.prototype, "type", {
        get: function get() {
          return "custom";
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.apply = function (t) {
        return this.scale(t);
      }, t.prototype.dump = function () {
        return this.entries;
      }, t.prototype.clone = function () {
        return new t(this.entries);
      }, t.prototype.eq = function (e) {
        return e instanceof t && Object(Y.a)(this.entries, e.entries);
      }, t;
    }();

    var $ = new Map();

    function J(t) {
      if ($.has(t)) return $.get(t);
      var e = new z(t);
      return $.set(t, e), e;
    }

    for (var Z = J(B.d.DEFAULT_COLOR), Q = [], tt = [], et = new Map(), nt = {
      interpolateBlues: a,
      interpolateGreens: u,
      interpolateGreys: c,
      interpolateOranges: s,
      interpolatePurples: l,
      interpolateReds: p,
      interpolateCool: h,
      interpolateCubehelixDefault: b,
      interpolateWarm: d,
      interpolatePlasma: O,
      interpolateMagma: v,
      interpolateViridis: y,
      interpolateInferno: E,
      interpolateYlOrRd: C,
      interpolateYlOrBr: _,
      interpolateBuGn: T,
      interpolateBuPu: N,
      interpolateGnBu: D,
      interpolateOrRd: R,
      interpolatePuBuGn: w,
      interpolatePuBu: A,
      interpolatePuRd: M,
      interpolateRdPu: L,
      interpolateYlGnBu: j,
      interpolateYlGn: x,
      interpolateRainbow: function interpolateRainbow(t) {
        (t < 0 || t > 1) && (t -= Math.floor(t));
        var e = Math.abs(t - .5);
        return g.h = 360 * t - 100, g.s = 1.5 - 1.5 * e, g.l = .8 - .9 * e, g + "";
      }
    }, rt = {
      interpolateBrBG: S,
      interpolatePRGn: I,
      interpolatePiYG: V,
      interpolatePuOr: k,
      interpolateRdBu: H,
      interpolateRdGy: P,
      interpolateRdYlBu: G,
      interpolateRdYlGn: F,
      interpolateSpectral: U
    }, it = 0, ot = Object.keys(nt); it < ot.length; it++) {
      var at = ot[it];
      Q.push(new q(at, "sequential", nt[at]));
    }

    for (var ut = 0, ct = Object.keys(rt); ut < ct.length; ut++) {
      at = ct[ut];
      tt.push(new q(at, "divergent", rt[at]));
    }

    for (var st = 0, lt = Q; st < lt.length; st++) {
      var pt = lt[st];
      et.set(pt.name, pt);
    }

    for (var ft = 0, dt = tt; ft < dt.length; ft++) {
      pt = dt[ft];
      et.set(pt.name, pt);
    }

    function ht(t) {
      if (!t) return Z;

      if ("string" == typeof t) {
        var e = et.get(t);
        return e || J(t);
      }

      return "function" == typeof t ? new q("custom", "sequential", t) : t.base && t.steps ? new K(ht(t.base), t.steps) : Array.isArray(t) ? new X(t) : Z;
    }

    function gt(t) {
      return t.color ? (console.warn("The property `color` in the column description is deprecated and will not work in an upcoming LineUp release. Use the property `colorMapping` instead."), ht(t.color)) : t.colorMapping ? ht(t.colorMapping) : Z;
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(16),
        o = n(2),
        a = n(41),
        u = n(1),
        c = n(3),
        s = n(17),
        l = n(7),
        p = n(6),
        f = n(28),
        d = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.currentFilter = Object(c.n)(), r.mapping = Object(s.e)(n), r.original = r.mapping.clone(), r.colorMapping = Object(f.h)(n), r.sort = n.sort || c.b.median, r.dataLength && r.setDefaultWidth(Math.min(Math.max(100, 10 * r.dataLength), 500)), r.setDefaultRenderer("heatmap"), r.setDefaultGroupRenderer("heatmap"), r.setDefaultSummaryRenderer("histogram"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.compare = function (t, e) {
        return Object(c.e)(this, t, e);
      }, e.prototype.getRawNumbers = function (t) {
        return this.getRawValue(t);
      }, e.prototype.getBoxPlotData = function (t) {
        var e = this.getRawValue(t);
        return null == e ? null : new i.g(e, this.mapping);
      }, e.prototype.getRange = function () {
        return this.mapping.getRange(c.a);
      }, e.prototype.getRawBoxPlotData = function (t) {
        var e = this.getRawValue(t);
        return null == e ? null : new i.g(e);
      }, e.prototype.getNumbers = function (t) {
        return this.getValue(t);
      }, e.prototype.getNumber = function (t) {
        return Object(c.g)(this, t, "normalized");
      }, e.prototype.getRawNumber = function (t) {
        return Object(c.g)(this, t, "raw");
      }, e.prototype.getValue = function (t) {
        var e = this;
        return this.getRawValue(t).map(function (t) {
          return Object(l.c)(t) ? NaN : e.mapping.apply(t);
        });
      }, e.prototype.getRawValue = function (e) {
        var n = t.prototype.getValue.call(this, e);
        return null == n ? [] : n;
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.getRawValue(e) : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.getLabels = function (t) {
        return this.getValue(t).map(c.a);
      }, e.prototype.getSortMethod = function () {
        return this.sort;
      }, e.prototype.setSortMethod = function (t) {
        this.sort !== t && (this.fire([n.EVENT_SORTMETHOD_CHANGED], this.sort, this.sort = t), this.isSortedByMe().asc || this.sortByMe());
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.sortMethod = this.getSortMethod(), n.filter = Object(c.i)(this.currentFilter) ? null : this.currentFilter, n.map = this.mapping.dump(), n.colorMapping = this.colorMapping.dump(), n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.sortMethod && (this.sort = e.sortMethod), e.filter && (this.currentFilter = Object(c.p)(e.filter)), e.map ? this.mapping = Object(s.c)(e.map) : e.domain && (this.mapping = new s.a(e.domain, "linear", e.range || [0, 1])), e.colorMapping && (this.colorMapping = Object(f.e)(e.colorMapping));
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_COLOR_MAPPING_CHANGED, n.EVENT_MAPPING_CHANGED, n.EVENT_SORTMETHOD_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getOriginalMapping = function () {
        return this.original.clone();
      }, e.prototype.getMapping = function () {
        return this.mapping.clone();
      }, e.prototype.setMapping = function (t) {
        this.mapping.eq(t) || this.fire([n.EVENT_MAPPING_CHANGED, u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY], this.mapping.clone(), this.mapping = t);
      }, e.prototype.getColor = function (t) {
        return p.b.prototype.getColor.call(this, t);
      }, e.prototype.getColorMapping = function () {
        return this.colorMapping.clone();
      }, e.prototype.setColorMapping = function (t) {
        this.colorMapping.eq(t) || this.fire([n.EVENT_COLOR_MAPPING_CHANGED, u.d.EVENT_DIRTY_HEADER, u.d.EVENT_DIRTY_VALUES, u.d.EVENT_DIRTY], this.colorMapping.clone(), this.colorMapping = t);
      }, e.prototype.isFiltered = function () {
        return p.b.prototype.isFiltered.call(this);
      }, e.prototype.getFilter = function () {
        return p.b.prototype.getFilter.call(this);
      }, e.prototype.setFilter = function (t) {
        void 0 === t && (t = {
          min: -1 / 0,
          max: 1 / 0,
          filterMissing: !1
        }), p.b.prototype.setFilter.call(this, t);
      }, e.prototype.filter = function (t) {
        return p.b.prototype.filter.call(this, t);
      }, e.EVENT_MAPPING_CHANGED = p.b.EVENT_MAPPING_CHANGED, e.EVENT_COLOR_MAPPING_CHANGED = p.b.EVENT_COLOR_MAPPING_CHANGED, e.EVENT_SORTMETHOD_CHANGED = p.b.EVENT_SORTMETHOD_CHANGED, e.EVENT_FILTER_CHANGED = p.b.EVENT_FILTER_CHANGED, e.CENTER = 0, e = n = Object(r.b)([Object(o.m)("filterNumber", "colorMapped", "editMapping"), Object(o.h)("sort", "sortNumbers"), Object(o.d)("descending")], e);
    }(a.d);

    e.c = d;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    }), n.d(e, "b", function () {
      return a;
    }), n.d(e, "c", function () {
      return u;
    }), n.d(e, "d", function () {
      return c;
    });
    var r = n(4),
        i = "Filter rows containing missing values";

    function o(t, e) {
      var n = Object(r.k)(e);
      return '<div class="lu-checkbox"><input type="checkbox" ' + (t ? 'checked="checked"' : "") + ' id="' + n + '"><label for="' + n + '" class="lu-filter-missing">' + i + "</label></div>";
    }

    function a(t, e, n) {
      var i = Object(r.k)(n);
      return '<div class="lu-checkbox"><input type="checkbox" ' + (t ? 'checked="checked"' : "") + " " + (0 === e ? "disabled" : "") + ' id="' + i + '"><label for="' + i + '" class="lu-filter-missing" ' + (0 === e ? 'class="lu-disabled"' : "") + ">Filter " + e + " missing value rows</label></div>";
    }

    function u(t) {
      return t.querySelector(".lu-filter-missing").previousElementSibling;
    }

    function c(t, e) {
      var n = t.querySelector("input");
      n.disabled = 0 === e && !n.checked, t.lastElementChild.classList.toggle("lu-disabled", n.disabled), t.lastElementChild.textContent = "Filter " + e + " missing value rows";
    }
  }, function (t, e, n) {
    /*! lineupengine - v1.1.2 - 2018
    * https://sgratzl.github.io/lineupengine/
    * Copyright (c) 2018 Samuel Gratzl; Licensed MIT*/
    window, t.exports = function (t) {
      var e = {};

      function n(r) {
        if (e[r]) return e[r].exports;
        var i = e[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }

      return n.m = t, n.c = e, n.d = function (t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, n.t = function (t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) {
          n.d(r, i, function (e) {
            return t[e];
          }.bind(null, i));
        }
        return r;
      }, n.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return n.d(e, "a", e), e;
      }, n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, n.p = "", n(n.s = 2);
    }([, function (t, e) {}, function (t, e, n) {
      "use strict";

      n.r(e);
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _r2 = function r(t, e) {
        return (_r2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }
        })(t, e);
      };

      function i(t, e) {
        function n() {
          this.constructor = t;
        }

        _r2(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
      }

      var o = Symbol("aborted");

      function a(t) {
        return {
          then: function then(e) {
            var n,
                r = null,
                i = function i() {
              return null === r;
            },
                a = new Promise(function (t) {
              return r = t;
            }),
                u = t.then(function (t) {
              return i() ? o : Promise.resolve(e(t)).then(function (t) {
                return i() ? o : t;
              });
            }),
                c = Promise.race([a, u]);

            return (n = {
              abort: function abort() {
                null !== r && (r(o), r = null);
              },
              then: c.then.bind(c),
              catch: c.catch.bind(c)
            })[Symbol.toStringTag] = c[Symbol.toStringTag], n;
          }
        };
      }

      function u(t) {
        return null != t && t && "function" == typeof t.then && "function" == typeof t.abort;
      }

      var c,
          s = function () {
        function t(t, e) {
          var n = this;
          this.context = t, this.key = e, this.cache = [], this.lastFilled = 0, this.key2index = new Map(), this.context.exceptions.forEach(function (t) {
            n.cache[t.index] = t.y, n.key2index.set(e(t.index), t.index);
          });
        }

        return t.prototype.findValidStart = function (t) {
          for (var e = t - 1; e >= 0; --e) {
            if (void 0 !== this.cache[e]) return e;
          }

          return -1;
        }, t.prototype.posByKey = function (t) {
          if (this.key2index.has(t)) {
            var e = this.key2index.get(t);
            return {
              index: e,
              pos: this.pos(e)
            };
          }

          return this.fillCacheTillKey(t);
        }, t.prototype.pos = function (t) {
          if (0 === this.context.exceptions.length) return t * this.context.defaultRowHeight;
          var e = this.cache[t];
          if (void 0 !== e) return e;
          var n = this.findValidStart(t);
          return n < 0 ? this.fillCache(0, t, 0) : this.fillCache(n + 1, t, this.cache[n] + this.heightOf(n)), this.cache[t];
        }, t.prototype.fillCache = function (t, e, n, r) {
          if (e <= this.lastFilled) {
            if (!r) return;

            for (var i = t; i <= e; ++i) {
              r(i, this.key(i), this.cache[i]);
            }
          } else {
            var o = n;

            for (i = t; i <= e; ++i) {
              this.cache[i] = o;
              var a = this.key(i);
              this.key2index.set(a, i), r && r(i, a, o), o += this.heightOf(i);
            }
          }
        }, t.prototype.heightOf = function (t) {
          var e = this.context.exceptionsLookup;
          return e.has(t) ? e.get(t) : this.context.defaultRowHeight;
        }, t.prototype.exceptionHeightOf = function (t, e) {
          void 0 === e && (e = !1);
          var n = this.context.padding(t),
              r = this.context.exceptionsLookup;
          return r.has(t) ? r.get(t) - n : e ? this.context.defaultRowHeight - n : null;
        }, t.prototype.padding = function (t) {
          return this.context.padding(t);
        }, t.prototype.fillCacheTillKey = function (t) {
          for (var e = 0, n = this.lastFilled; n < this.context.numberOfRows; ++n, ++this.lastFilled) {
            var r = this.cache[n];

            if (void 0 === r) {
              var i = this.key(n);
              if (this.cache[n] = e, this.key2index.set(i, n), i === t) return {
                index: n,
                pos: e
              };
              e += this.heightOf(n);
            } else e = r + this.heightOf(n);
          }

          return {
            index: -1,
            pos: -1
          };
        }, t.prototype.positions = function (t, e, n, r) {
          this.fillCache(t, e, n, r);
        }, t;
      }();

      !function (t) {
        t[t.UPDATE = 0] = "UPDATE", t[t.UPDATE_CREATE = 1] = "UPDATE_CREATE", t[t.UPDATE_REMOVE = 2] = "UPDATE_REMOVE", t[t.SHOW = 3] = "SHOW", t[t.HIDE = 4] = "HIDE";
      }(c || (c = {}));
      var l = 1;

      function p(t, e, n) {
        var r = t.previous,
            i = t.mode,
            o = t.nodeY,
            a = t.current,
            u = null == r.height ? e : r.height,
            s = null == a.height ? n : a.height;
        return i === c.UPDATE && Math.abs(r.y - o) <= l && Math.abs(u - s) <= l;
      }

      var f,
          d = [{
        delay: 0,
        apply: function apply(t) {
          var e = t.mode,
              n = t.previous,
              r = t.nodeY,
              i = t.current,
              o = t.node;
          o.dataset.animation = c[e].toLowerCase(), o.style.transform = "translate(0, " + (n.y - r) + "px)", e === c.SHOW ? o.style.height = null !== i.height ? i.height + "px" : null : o.style.height = n.height + "px", o.style.opacity = e === c.SHOW ? "0" : e === c.HIDE ? "1" : null;
        }
      }, {
        delay: 10,
        apply: function apply(t) {
          var e = t.mode,
              n = t.current,
              r = t.nodeY,
              i = t.node;
          i.style.transform = e === c.HIDE || e === c.UPDATE_REMOVE ? "translate(0, " + (n.y - r) + "px)" : null, e !== c.HIDE && (i.style.height = null !== n.height ? n.height + "px" : null), i.style.opacity = e === c.SHOW ? "1" : e === c.HIDE ? "0" : null;
        }
      }, {
        delay: 1100,
        apply: function apply(t) {
          var e = t.node;
          delete e.dataset.animation, e.style.opacity = null, e.style.transform = null;
        }
      }],
          h = function () {
        function t(t, e, n) {
          this.index = t, this.y = e, this.height = n;
        }

        return Object.defineProperty(t.prototype, "y2", {
          get: function get() {
            return this.y + this.height;
          },
          enumerable: !0,
          configurable: !0
        }), t;
      }();

      function g(t, e, n) {
        return void 0 === n && (n = 0), {
          exceptions: [],
          exceptionsLookup: {
            keys: function keys() {
              return [].values();
            },
            get: function get() {
              return e;
            },
            has: function has() {
              return !1;
            },
            size: 0
          },
          totalHeight: t * (e += n),
          numberOfRows: t,
          defaultRowHeight: e,
          padding: function padding() {
            return n;
          }
        };
      }

      function b(t, e, n) {
        void 0 === e && (e = NaN), void 0 === n && (n = 0);
        var r = new Map(),
            i = [],
            o = "function" == typeof n ? n : function () {
          return n;
        };
        isNaN(e) && (e = function (t) {
          var e = new Map();
          if (t.forEach(function (t) {
            e.set(t, (e.get(t) || 0) + 1);
          }), 0 === e.size) return 20;
          var n = Array.from(e).sort(function (t, e) {
            return t[1] !== e[1] ? e[1] - t[1] : t[0] - e[0];
          }),
              r = n[0][0];
          return 0 === r ? n.length > 1 ? n[1][0] : 20 : r;
        }(t)), e += o(-1);
        var a = -1,
            u = 0,
            c = 0,
            s = 0;
        return t.forEach(function (t, n) {
          if (t += o(n), c += t, s++, t !== e) {
            r.set(n, t);
            var l = (n - a - 1) * e;
            a = n;
            var p = u + l;
            u = p + t, i.push(new h(n, p, t));
          }
        }), {
          exceptionsLookup: r,
          exceptions: i,
          totalHeight: c,
          defaultRowHeight: e,
          numberOfRows: s,
          padding: o
        };
      }

      function m(t, e, n, r, i, o) {
        void 0 === n && (n = 2), void 0 === r && (r = 10 * e), void 0 === i && (i = .2), void 0 === o && (o = Date.now());

        var a = o,
            u = function u() {
          var t = 1e4 * Math.sin(a++);
          return t - Math.floor(t);
        };

        return b({
          forEach: function forEach(o) {
            for (var a = 0; a < t; ++a) {
              o(u() < i ? n + Math.round(u() * (r - n)) : e, a);
            }
          }
        }, e);
      }

      function y(t, e, n, r, i) {
        if (0 === i) return {
          first: 0,
          last: -1,
          firstRowPos: 0,
          endPos: 0
        };
        if (1 === i) return {
          first: 0,
          last: 0,
          firstRowPos: 0,
          endPos: 0 === r.length ? n : r[0].y2
        };
        var o = t,
            a = o + e;

        function u(t, e) {
          return Math.min(i - 1, e + Math.max(0, Math.floor(t / n)));
        }

        function c(t, e, r) {
          void 0 === r && (r = !1);
          var c = a - t,
              s = u(o - t, e),
              l = u(c, e),
              p = t + (s - e) * n,
              f = t + (l + 1 - e) * n;
          return console.assert(!r || !(p > o || f < a && l < i - 1), "error", r, p, f, o, a, e, t), {
            first: s,
            last: l,
            firstRowPos: p,
            endPos: f
          };
        }

        var s = c(0, 0, !0);
        if (0 === r.length) return s;
        if (s.last < r[0].index) return s;
        if (s.last === r[0].index && r[0].height > n) return Object.assign(s, {
          endPos: r[0].y2
        });
        var l = r[r.length - 1];

        if (o >= l.y) {
          var p = c(l.y2, l.index + 1);
          return o < l.y2 ? Object.assign(p, {
            first: l.index,
            firstRowPos: l.y
          }) : p;
        }

        for (var f = [], d = r[0], h = 0, g = r; h < g.length; h++) {
          var b = g[h],
              m = b.y,
              y = b.y2;
          if (m >= a) break;
          y <= o ? d = b : f.push(b);
        }

        if (0 === f.length) return c(d.y2, d.index + 1);
        var v = f[0],
            E = f[f.length - 1],
            O = Math.max(0, v.index - Math.max(0, Math.ceil((v.y - o) / n))),
            C = E.index;
        a >= E.y2 && (C = u(a - E.y2, E.index + 1));

        var _ = v.y - (v.index - O) * n,
            T = E.y2 + (C - E.index) * n;

        return console.assert(_ <= o && (T >= a || C === i - 1), "error", _, T, o, a, v, E), {
          first: O,
          last: C,
          firstRowPos: _,
          endPos: T
        };
      }

      function v(t, e) {
        var n = t.length,
            r = e.length;
        if (0 === n) return {
          added: e,
          removed: [],
          common: 0
        };
        if (0 === r) return {
          added: [],
          removed: t,
          common: 0
        };
        if (n === r) return {
          added: [],
          removed: [],
          common: n
        };
        var i = t.slice(Math.min(r, n));
        return {
          added: e.slice(Math.min(r, n)),
          removed: i,
          common: n - i.length
        };
      }

      function E(t, e, n) {
        for (var r = 0 === t.length ? 0 : t[t.length - 1] + 1, i = [], o = [], a = t.length - 1; a >= 0 && t[a] >= n; --a) {
          o.push(t.pop());
        }

        for (a = r; a < n; ++a) {
          e[a].frozen && (i.push(a), t.push(a));
        }

        return {
          target: t,
          added: i,
          removed: o
        };
      }

      !function (t) {
        t[t.NONE = 0] = "NONE", t[t.ALL = 1] = "ALL", t[t.SOME = 2] = "SOME", t[t.SOME_BOTTOM = 3] = "SOME_BOTTOM", t[t.SOME_TOP = 4] = "SOME_TOP";
      }(f || (f = {}));

      var O = "animation",
          C = function () {
        function t(t) {
          var e = this;
          this.node = t, this.handlers = new Map(), this.animationWaiting = !1, this.immediateTimeout = -1, this.timersWaiting = new Set(), this.prevs = new Map(), t.addEventListener("scroll", function () {
            e.handle("sync"), e.handleAnimation(), e.handleImmediate(), e.handleTimeouts();
          }, {
            passive: !0
          });
        }

        return t.prototype.has = function (t) {
          return this.handlers.has(t) && this.handlers.get(t).length > 0;
        }, t.prototype.handle = function (t) {
          var e = this.handlers.get(t) || [];

          if (e && !(e.length <= 0)) {
            var n = this.asInfo();

            if (this.prevs.has(t)) {
              var r = this.prevs.get(t);
              if (Math.abs(n.left - r.left) + Math.abs(n.top - r.top) < 4) return;
            }

            this.prevs.set(t, n);

            for (var i = 0, o = e; i < o.length; i++) {
              (0, o[i])(n);
            }
          }
        }, t.prototype.handleAnimation = function () {
          var t = this;
          !this.animationWaiting && this.has("animation") && (this.animationWaiting = !0, requestAnimationFrame(function () {
            t.animationWaiting && (t.animationWaiting = !1, t.handle("animation"));
          }));
        }, t.prototype.handleImmediate = function () {
          var t = this;
          this.immediateTimeout >= 0 || !this.has("immediate") || (this.immediateTimeout = self.setImmediate(function () {
            t.immediateTimeout < 0 || (t.immediateTimeout = -1, t.handle("immediate"));
          }));
        }, t.prototype.handleTimeouts = function () {
          var t = this,
              e = Array.from(this.handlers.keys()).filter(function (e) {
            return "number" == typeof e && !t.timersWaiting.has(e);
          });
          if (0 !== e.length) for (var n = function n(e) {
            r.timersWaiting.add(e), self.setTimeout(function () {
              t.timersWaiting.delete(e), t.handle(e);
            }, e);
          }, r = this, i = 0, o = e; i < o.length; i++) {
            n(o[i]);
          }
        }, t.prototype.asInfo = function () {
          return {
            left: this.node.scrollLeft,
            top: this.node.scrollTop,
            width: this.node.clientWidth,
            height: this.node.clientHeight
          };
        }, t.prototype.push = function (t, e) {
          "immediate" === t && "function" != typeof self.setImmediate && (t = 0), this.handlers.has(t) ? this.handlers.get(t).push(e) : this.handlers.set(t, [e]);
        }, t.prototype.remove = function (t) {
          return Array.from(this.handlers.values()).some(function (e) {
            var n = e.indexOf(t);
            return n >= 0 && e.splice(n, 1), n >= 0;
          });
        }, t;
      }();

      function _(t, e, n) {
        t.__le_scroller__ || (t.__le_scroller__ = new C(t));
        var r = t.__le_scroller__;
        return r.push(e, n), r.asInfo();
      }

      var T = function () {
        function t(t, e) {
          void 0 === e && (e = {});
          var n = this;
          this.body = t, this.pool = [], this.loadingPool = [], this.loading = new Map(), this.visible = {
            first: 0,
            forcedFirst: 0,
            last: -1,
            forcedLast: -1
          }, this.visibleFirstRowPos = 0, this.scrollListener = null, this.abortAnimation = function () {}, this.options = {
            async: O,
            minScrollDelta: 10,
            mixins: [],
            scrollingHint: !1,
            batchSize: 5
          }, this.adapter = this.createAdapter(), Object.assign(this.options, e), this.mixins = this.options.mixins.map(function (t) {
            return new t(n.adapter);
          }), this.fragment = t.ownerDocument.createDocumentFragment();
        }

        return t.prototype.addMixin = function (t, e) {
          this.mixins.push(new t(this.adapter, e));
        }, t.prototype.createAdapter = function () {
          var t = this,
              e = {
            visible: this.visible,
            addAtBeginning: this.addAtBeginning.bind(this),
            addAtBottom: this.addAtBottom.bind(this),
            removeFromBeginning: this.removeFromBeginning.bind(this),
            removeFromBottom: this.removeFromBottom.bind(this),
            updateOffset: this.updateOffset.bind(this),
            scroller: this.bodyScroller
          };
          return Object.defineProperties(e, {
            visibleFirstRowPos: {
              get: function get() {
                return t.visibleFirstRowPos;
              },
              enumerable: !0
            },
            context: {
              get: function get() {
                return t.context;
              },
              enumerable: !0
            }
          }), e;
        }, Object.defineProperty(t.prototype, "bodyScroller", {
          get: function get() {
            return this.body.parentElement;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "bodySizer", {
          get: function get() {
            var t = this.bodyScroller,
                e = Array.from(t.children).find(function (t) {
              return "footer" === t.tagName.toLowerCase();
            });
            if (e) return e;
            var n = t.ownerDocument.createElement("footer");
            return t.insertBefore(n, t.firstChild), n;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.init = function () {
          var t = this,
              e = this.bodyScroller,
              n = _(e, this.options.async, this.scrollListener = function (r) {
            if (!(Math.abs(n.top - r.top) < t.options.minScrollDelta && Math.abs(n.height - r.height) < t.options.minScrollDelta)) {
              var i = r.top > n.top;
              n = r, t.onScrolledVertically(r.top, r.height, i), t.options.scrollingHint && e.classList.remove("le-scrolling");
            }
          });

          this.options.scrollingHint && _(e, "animation", function () {
            return e.classList.add("le-scrolling");
          }), this.recreate();
        }, t.prototype.destroy = function () {
          !function (t, e) {
            t.__le_scroller__ && t.__le_scroller__.remove(e);
          }(this.bodyScroller, this.scrollListener), this.body.remove();
        }, t.cleanUp = function (t) {
          t.style.height && (t.style.height = null);
        }, t.prototype.select = function (t) {
          var e, n;
          return this.pool.length > 0 ? (e = this.pool.pop(), n = this.updateRow(e, t)) : this.loadingPool.length > 0 ? ((e = this.loadingPool.pop()).classList.remove("loading"), n = this.createRow(e, t)) : (e = this.body.ownerDocument.createElement("div"), n = this.createRow(e, t)), e.dataset.index = String(t), {
            item: e,
            result: n
          };
        }, t.prototype.selectProxy = function () {
          var t;
          return this.loadingPool.length > 0 ? t = this.loadingPool.pop() : (t = this.body.ownerDocument.createElement("div")).classList.add("loading"), t;
        }, t.prototype.recycle = function (e) {
          t.cleanUp(e), this.loading.has(e) ? this.loading.get(e).abort() : this.pool.push(e);
        }, t.prototype.proxy = function (e, n) {
          var r = this;
          if (!u(n)) return e;
          var i = n,
              a = e,
              c = this.selectProxy();
          return c.dataset.index = a.dataset.index, c.style.height = a.style.height, this.loading.set(c, i), i.then(function (e) {
            e === o ? (t.cleanUp(a), r.pool.push(a)) : r.body.replaceChild(a, c), r.loading.delete(c), t.cleanUp(c), r.loadingPool.push(c);
          }), c;
        }, t.prototype.create = function (t) {
          var e = this.select(t),
              n = e.item,
              r = e.result,
              i = this.context,
              o = i.exceptionsLookup,
              a = i.padding;
          return o.has(t) && (n.style.height = o.get(t) - a(t) + "px"), this.proxy(n, r);
        }, t.prototype.removeAll = function () {
          var t = this,
              e = Array.from(this.body.children);
          this.body.innerHTML = "", e.forEach(function (e) {
            t.recycle(e);
          });
        }, t.prototype.update = function () {
          var t = this,
              e = this.visible.first,
              n = this.fragment,
              r = Array.from(this.body.children);
          this.body.innerHTML = "", r.forEach(function (r, i) {
            if (!t.loading.has(r)) {
              var o = t.updateRow(r, i + e);
              n.appendChild(t.proxy(r, o));
            }
          }), this.body.appendChild(n);
        }, t.prototype.forEachRow = function (t, e) {
          var n = this;
          void 0 === e && (e = !1);
          var r = Array.from(this.body.children),
              i = this.fragment;
          e || (this.body.innerHTML = ""), r.forEach(function (r, o) {
            r.classList.contains("loading") || "update_remove" === r.dataset.animation || "hide" === r.dataset.animation || t(r, o + n.visible.first), e || i.appendChild(r);
          }), e || this.body.appendChild(i);
        }, t.prototype.removeFromBeginning = function (t, e) {
          return this.remove(t, e, !0);
        }, t.prototype.removeFromBottom = function (t, e) {
          return this.remove(t, e, !1);
        }, t.prototype.remove = function (t, e, n) {
          if (!(e < t)) for (var r = t; r <= e; ++r) {
            var i = n ? this.body.firstChild : this.body.lastChild;
            i.remove(), this.recycle(i);
          }
        }, t.prototype.addAtBeginning = function (t, e) {
          if (!(e < t)) if (t !== e) {
            for (var n = this.fragment, r = t; r <= e; ++r) {
              n.appendChild(this.create(r));
            }

            this.body.insertBefore(n, this.body.firstChild);
          } else this.body.insertBefore(this.create(t), this.body.firstChild);
        }, t.prototype.addAtBottom = function (t, e) {
          if (!(e < t)) if (t !== e) {
            for (var n = this.fragment, r = t; r <= e; ++r) {
              n.appendChild(this.create(r));
            }

            this.body.appendChild(n);
          } else this.body.appendChild(this.create(t));
        }, t.prototype.updateOffset = function (t) {
          this.visibleFirstRowPos = t, this.body.classList.toggle("odd", this.visible.first % 2 == 1), this.updateSizer(t);
        }, t.prototype.updateSizer = function (t) {
          var e = this.context.totalHeight;
          this.body.style.transform = "translate(0, " + t.toFixed(0) + "px)", this.bodySizer.style.transform = "translate(0, " + Math.max(0, e - 1).toFixed(0) + "px)";
        }, t.prototype.recreate = function (t) {
          return this.abortAnimation(), t ? this.recreateAnimated(t) : this.recreatePure();
        }, t.prototype.recreatePure = function () {
          var t = this.context,
              e = this.bodyScroller;
          this.updateOffset(0), this.removeAll(), this.clearPool();
          var n = y(e.scrollTop, e.clientHeight, t.defaultRowHeight, t.exceptions, t.numberOfRows),
              r = n.first,
              i = n.last,
              o = n.firstRowPos;
          this.visible.first = this.visible.forcedFirst = r, this.visible.last = this.visible.forcedLast = i, r < 0 ? this.updateOffset(0) : (this.addAtBottom(r, i), this.updateOffset(o));
        }, t.prototype.recreateAnimated = function (t) {
          var e = this,
              n = new Map(),
              r = new s(t.previous, t.previousKey),
              i = new s(this.context, t.currentKey),
              o = y(this.bodyScroller.scrollTop, this.bodyScroller.clientHeight, i.context.defaultRowHeight, i.context.exceptions, i.context.numberOfRows),
              a = Array.from(this.body.children),
              u = Object.assign({}, this.visible);
          this.body.innerHTML = "", r.positions(u.first, Math.min(u.last, u.first + a.length), this.visibleFirstRowPos, function (t, e, r) {
            var i = a[t];
            i && n.set(e, {
              n: i,
              pos: r,
              i: t
            });
          }), this.visible.first = this.visible.forcedFirst = o.first, this.visible.last = this.visible.forcedLast = o.last;
          var l = this.fragment,
              p = [],
              f = o.firstRowPos;
          i.positions(o.first, o.last, o.firstRowPos, function (t, o, a) {
            var u,
                s,
                d = c.UPDATE;

            if (n.has(o)) {
              var h = n.get(o);
              n.delete(o), h.n.dataset.index = String(t), u = e.proxy(h.n, e.updateRow(h.n, t)), s = {
                index: h.i,
                y: h.pos,
                height: r.exceptionHeightOf(h.i, !0)
              };
            } else {
              var g = r.posByKey(o);
              u = e.create(t), d = g.index < 0 ? c.SHOW : c.UPDATE_CREATE, s = {
                index: g.index,
                y: g.pos >= 0 ? g.pos : a,
                height: g.index < 0 ? i.exceptionHeightOf(t, !0) : r.exceptionHeightOf(g.index, !0)
              };
            }

            p.push({
              node: u,
              key: o,
              mode: d,
              previous: s,
              nodeY: f,
              nodeYCurrentHeight: a,
              current: {
                index: t,
                y: a,
                height: i.exceptionHeightOf(t)
              }
            }), u.style.transform = "translate(0, " + (f - a) + "px)", f += s.height + (s.index < 0 ? i.padding(t) : r.padding(s.index)), l.appendChild(u);
          });
          var h = o.endPos;
          n.forEach(function (t, e) {
            var n = i.posByKey(e),
                o = n.pos >= 0 ? n.pos : t.pos,
                a = t.n;
            a.style.transform = "translate(0, " + (t.pos - f) + "px)", l.appendChild(a);
            var u = r.exceptionHeightOf(t.i, !0);
            p.push({
              node: t.n,
              key: e,
              mode: n.index < 0 ? c.HIDE : c.UPDATE_REMOVE,
              previous: {
                index: t.i,
                y: t.pos,
                height: u
              },
              nodeY: f,
              nodeYCurrentHeight: h,
              current: {
                index: n.index,
                y: o,
                height: n.index < 0 ? null : i.exceptionHeightOf(n.index)
              }
            }), h += n.index < 0 ? i.context.defaultRowHeight : i.exceptionHeightOf(n.index, !0) + i.padding(n.index), f += u + r.padding(t.i);
          }), this.updateOffset(o.firstRowPos), this.animate(p, t.phases || d, r, i, l);
        }, t.prototype.animate = function (t, e, n, r, i) {
          var o = this;
          if (t.length <= 0) this.body.appendChild(i);else {
            for (var a = -1, u = 0, s = function s(e, i) {
              void 0 === i && (i = t), i.forEach(function (t) {
                return e.apply(t, n, r);
              });
            }, l = function l() {
              if (console.assert(t[0].node.offsetTop >= 0, "dummy log for forcing dom update"), s(e[u++]), u < e.length) {
                var n = e[u];
                a = self.setTimeout(l, n.delay);
              } else {
                var r = o.body.classList;
                Array.from(r).forEach(function (t) {
                  t.startsWith("le-") && t.endsWith("-animation") && r.remove(t);
                }), t.forEach(function (t) {
                  var e = t.node,
                      n = t.mode;
                  n !== c.UPDATE_REMOVE && n !== c.HIDE || (e.remove(), e.style.transform = null, o.recycle(e));
                }), o.abortAnimation = function () {}, a = -1;
              }
            }; 0 === e[u].delay;) {
              s(e[u++]);
            }

            var f = this.body;
            this.body.appendChild(i);
            var d = [];
            t = t.filter(function (t) {
              return !p(t, n.context.defaultRowHeight, r.context.defaultRowHeight) || (d.push(t), !1);
            }), d.length > 0 && e.slice(u).forEach(function (t) {
              return s(t, d);
            }), 0 !== t.length && (f.classList.add("le-row-animation"), new Set(t.map(function (t) {
              return t.mode;
            })).forEach(function (t) {
              f.classList.add("le-" + c[t].toLowerCase().split("_")[0] + "-animation");
            }), this.abortAnimation = function () {
              a <= 0 || (clearTimeout(a), a = -1, u = e.length - 1, l());
            }, a = self.setTimeout(l, e[u].delay));
          }
        }, t.prototype.clearPool = function () {
          this.pool.splice(0, this.pool.length);
        }, t.prototype.revalidate = function () {
          var t = this.bodyScroller;
          this.onScrolledVertically(t.scrollTop, t.clientHeight, !0), this.updateOffset(this.visibleFirstRowPos);
        }, t.prototype.onScrolledVertically = function (t, e, n) {
          var r = this.onScrolledImpl(t, e);
          return this.mixins.forEach(function (t) {
            return t.onScrolled(n, r);
          }), r;
        }, t.prototype.shiftLast = function (t, e) {
          if (e >= this.options.batchSize) return t;
          var n = this.context.numberOfRows;
          return Math.min(n - 1, t + (this.options.batchSize - e));
        }, t.prototype.shiftFirst = function (t, e, n) {
          if (n >= this.options.batchSize || t <= 0) return {
            first: t,
            firstRowPos: e
          };

          for (var r = Math.max(0, t - (this.options.batchSize - n)), i = this.context, o = i.exceptionsLookup, a = i.defaultRowHeight, u = e, c = r; c < t; ++c) {
            o.has(c) ? u -= o.get(c) : u -= a;
          }

          return {
            first: r,
            firstRowPos: u
          };
        }, t.prototype.onScrolledImpl = function (t, e) {
          var n = this.context,
              r = y(t, e, n.defaultRowHeight, n.exceptions, n.numberOfRows),
              i = r.first,
              o = r.last,
              a = r.firstRowPos,
              u = this.visible;
          if (u.forcedFirst = i, u.forcedLast = o, i - u.first >= 0 && o - u.last <= 0) return f.NONE;
          var c = f.SOME;
          if (i > u.last || o < u.first) this.removeAll(), this.addAtBottom(i, o), c = f.ALL;else if (i < u.first) {
            u.last - (o + 1) >= this.options.batchSize ? this.removeFromBottom(o + 1, u.last) : o = u.last;
            var s = this.shiftFirst(i, a, u.first - 1 - i);
            i = s.first, a = s.firstRowPos, this.addAtBeginning(i, u.first - 1), c = f.SOME_TOP;
          } else i - 1 - u.first >= this.options.batchSize ? this.removeFromBeginning(u.first, i - 1) : (i = u.first, a = this.visibleFirstRowPos), o = this.shiftLast(o, o - u.last + 1), this.addAtBottom(u.last + 1, o), c = f.SOME_BOTTOM;
          return u.first = i, u.last = o, this.updateOffset(a), c;
        }, t;
      }(),
          N = T,
          D = function () {
        function t(t) {
          this.rules = new Map(), this.node = t.ownerDocument.createElement("style"), t.appendChild(this.node);
        }

        return t.prototype.destroy = function () {
          this.node.remove();
        }, t.prototype.updateRules = function () {
          this.node.innerHTML = Array.from(this.rules.values()).join("\n");
        }, t.prototype.addRule = function (t, e, n) {
          return void 0 === n && (n = !0), this.rules.set(t, e), n && this.updateRules(), t;
        }, t.prototype.updateRule = function (t, e, n) {
          return void 0 === n && (n = !0), this.rules.set(t, e), n && this.updateRules(), t;
        }, t.prototype.deleteRule = function (t, e) {
          void 0 === e && (e = !0), this.rules.get(t) && e && this.updateRules();
        }, Object.defineProperty(t.prototype, "ruleNames", {
          get: function get() {
            return Array.from(this.rules.keys());
          },
          enumerable: !0,
          configurable: !0
        }), t;
      }(),
          R = "\n  <header>\n    <article></article>\n  </header>\n  <main>\n    <footer>&nbsp;</footer>\n    <article></article>\n  </main>";

      function w(t) {
        return t.innerHTML = R, t;
      }

      function A(t, e) {
        t.dataset.id = e.id;
      }

      var M = function (t) {
        function e(e, n) {
          var r = t.call(this, e) || this;
          r.id = n;
          var i = e.querySelector("header"),
              o = e.querySelector("main");
          return self.setTimeout(function () {
            var t = function (t) {
              var e = t.ownerDocument.body;
              e.insertAdjacentHTML("beforeend", '\n    <div class="lineup-engine-scrollbar-tester"><div></div></div>\n  ');
              var n = e.lastElementChild,
                  r = n.offsetWidth - n.clientWidth,
                  i = n.offsetHeight - n.clientHeight;
              return n.remove(), {
                width: r,
                height: i
              };
            }(e).width;

            r.updateRule("__scollBarFix2", r.hashedId + " > header > article:last-of-type {\n        border-right: " + t + "px solid transparent;\n      }");
          }, 20), _(o, "animation", function (t) {
            var n = i.scrollLeft,
                r = t.left;
            n !== r && (i.scrollLeft = r), e.classList.toggle("le-shifted", t.left > 0);
          }), r;
        }

        return i(e, t), Object.defineProperty(e.prototype, "hashedId", {
          get: function get() {
            return this.id.startsWith("#") ? this.id : "#" + this.id;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.update = function (t, e, n, r, i) {
          void 0 === i && (i = "px");
          var o = void 0 !== r ? this.tableIds(r, !0) : {
            header: this.id + " > header > article",
            body: this.id + " > main > article"
          };
          this.updateRule("__heightsRule" + o.body, o.body + " > div {\n      height: " + t + "px;\n    }", !1), this.updateColumns(e, o, n, i), this.updateRules();
        }, e.prototype.remove = function (t) {
          var e = this.tableIds(t, !0);
          this.deleteRule("__heightsRule" + e.body, !1), this.deleteRule("__widthRule" + e.body, !1);

          for (var n = "__col" + e.body + "_", r = this.ruleNames.reduce(function (t, e) {
            return t + (e.startsWith(n) ? 1 : 0);
          }, 0), i = 0; i < r; ++i) {
            this.deleteRule("" + n + i, !1);
          }

          this.updateRules();
        }, e.prototype.tableIds = function (t, e) {
          void 0 === e && (e = !1);
          var n = this.id.startsWith("#") ? this.id.slice(1) : this.id;
          return {
            header: (e ? "#" : "") + n + "_H" + t,
            body: (e ? "#" : "") + n + "_B" + t
          };
        }, e.prototype.updateColumns = function (t, e, n, r) {
          var i = this;
          void 0 === r && (r = "px");
          var o = "__col" + e.body + "_",
              a = this.ruleNames.reduce(function (t, e) {
            return t + (e.startsWith(o) ? 1 : 0);
          }, 0),
              u = 0,
              c = 0;
          t.forEach(function (t) {
            var a = e.body + ' > div > [data-id="' + t.id + '"], ' + e.header + ' [data-id="' + t.id + '"] {\n        width: ' + t.width + r + ";\n        " + (t.frozen ? "left: " + u + "px;" : "") + "\n      }";

            if (0 !== n && t.frozen) {
              var s = e.body + ' > div > [data-id="' + t.id + '"] {\n          width: ' + t.width + r + ";\n          left: " + (u + n) + "px;\n        }";
              a = e.header + ' [data-id="' + t.id + '"] {\n          width: ' + t.width + r + ";\n          left: " + u + "px;\n        }", i.updateRule("" + o + c++, s, !1);
            }

            t.frozen && (u += t.width), i.updateRule("" + o + c++, a, !1);
          });

          for (var s = c - 1; s < a; ++s) {
            this.deleteRule("" + o + s, !1);
          }
        }, e;
      }(D),
          L = function () {
        function t(t, e, n) {
          for (var r = [], i = 3; i < arguments.length; i++) {
            r[i - 3] = arguments[i];
          }

          var o = this;
          this.header = t, this.style = e, this.tableId = n, this.cellPool = [], this.visibleColumns = {
            frozen: [],
            first: 0,
            forcedFirst: 0,
            last: -1,
            forcedLast: -1
          }, this.visibleFirstColumnPos = 0, this.columnAdapter = this.createColumnAdapter(), this.columnMixins = r.map(function (t) {
            return new t(o.columnAdapter);
          }), this.columnFragment = t.ownerDocument.createDocumentFragment();
        }

        return t.prototype.leftShift = function () {
          var t = this.context,
              e = this.visibleColumns.frozen.reduce(function (e, n) {
            return e + t.columns[n].width + t.column.padding(n);
          }, 0);
          return this.visibleFirstColumnPos - e;
        }, Object.defineProperty(t.prototype, "headerScroller", {
          get: function get() {
            return this.header.parentElement;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.addColumnMixin = function (t, e) {
          this.columnMixins.push(new t(this.columnAdapter, e));
        }, t.prototype.createColumnAdapter = function () {
          var t = this,
              e = {
            visible: this.visibleColumns,
            addAtBeginning: this.addColumnAtStart.bind(this),
            addAtBottom: this.addColumnAtEnd.bind(this),
            removeFromBeginning: this.removeColumnFromStart.bind(this),
            removeFromBottom: this.removeColumnFromEnd.bind(this),
            updateOffset: this.updateColumnOffset.bind(this),
            scroller: this.headerScroller,
            syncFrozen: this.syncFrozen.bind(this)
          };
          return Object.defineProperties(e, {
            visibleFirstRowPos: {
              get: function get() {
                return t.visibleFirstColumnPos;
              },
              enumerable: !0
            },
            context: {
              get: function get() {
                return t.context.column;
              },
              enumerable: !0
            }
          }), e;
        }, t.prototype.init = function () {
          var t = this,
              e = this.context;
          this.style.update(e.defaultRowHeight - e.padding(-1), e.columns, 0, this.tableId), e.columns.forEach(function () {
            t.cellPool.push([]);
          });
        }, t.prototype.onScrolledHorizontally = function (t, e, n) {
          var r = this.onScrolledHorizontallyImpl(t, e);
          return this.columnMixins.forEach(function (t) {
            return t.onScrolled(n, r);
          }), r;
        }, t.prototype.removeColumnFromStart = function (t, e, n) {
          var r = this;
          void 0 === n && (n = this.visibleColumns.frozen.length), this.forEachRow(function (i) {
            r.removeCellFromStart(i, t, e, n);
          });
        }, t.prototype.removeCellFromStart = function (t, e, n, r) {
          for (var i = e; i <= n; ++i) {
            var o = 0 === r ? t.firstElementChild : t.children[r];
            o.remove(), this.recycleCell(o, i);
          }
        }, t.prototype.removeColumnFromEnd = function (t, e) {
          var n = this;
          this.forEachRow(function (r) {
            n.removeCellFromEnd(r, t, e);
          });
        }, t.prototype.removeCellFromEnd = function (t, e, n) {
          for (var r = n; r >= e; --r) {
            var i = t.lastElementChild;
            i.remove(), this.recycleCell(i, r);
          }
        }, t.prototype.removeFrozenCells = function (t, e, n) {
          for (var r = 0, i = e; r < i.length; r++) {
            var o = i[r],
                a = t.children[n];
            a.remove(), this.recycleCell(a, o);
          }
        }, t.prototype.removeFrozenColumns = function (t, e) {
          var n = this;
          this.forEachRow(function (r) {
            n.removeFrozenCells(r, t, e);
          });
        }, t.prototype.removeAllColumns = function (t) {
          var e = this;
          this.forEachRow(function (n) {
            e.removeAllCells(n, t);
          });
        }, t.prototype.removeAllCells = function (t, e, n) {
          var r = this;
          void 0 === n && (n = this.visibleColumns.first);
          var i = Array.from(t.children),
              o = this.visibleColumns.frozen;
          if (t.innerHTML = "", e || 0 === o.length) for (var a = 0, u = o; a < u.length; a++) {
            var c = u[a];
            this.recycleCell(i.shift(), c);
          } else for (var s = 0, l = o; s < l.length; s++) {
            l[s], t.appendChild(i.shift());
          }
          i.forEach(function (t, e) {
            r.recycleCell(t, e + n);
          });
        }, t.prototype.selectCell = function (t, e, n) {
          var r = this.cellPool[e],
              i = n[e];

          if (r.length > 0) {
            var o = r.pop(),
                a = this.updateCell(o, t, i);
            return a && a !== o && A(a, i), a || o;
          }

          var u = this.createCell(this.header.ownerDocument, t, i);
          return A(u, i), u;
        }, t.prototype.recycleCell = function (t, e) {
          this.cellPool[e].push(t);
        }, t.prototype.addColumnAtStart = function (t, e, n) {
          var r = this;
          void 0 === n && (n = this.visibleColumns.frozen.length);
          var i = this.context.columns;
          this.forEachRow(function (o, a) {
            r.addCellAtStart(o, a, t, e, n, i);
          });
        }, t.prototype.addCellAtStart = function (t, e, n, r, i, o) {
          for (var a = r; a >= n; --a) {
            var u = this.selectCell(e, a, o);
            t.insertBefore(u, i > 0 ? t.children[i] : t.firstChild);
          }
        }, t.prototype.insertFrozenCells = function (t, e, n, r, i) {
          for (var o = t.children[r], a = 0, u = n; a < u.length; a++) {
            var c = u[a],
                s = this.selectCell(e, c, i);
            o ? t.insertBefore(s, o) : t.appendChild(s);
          }
        }, t.prototype.insertFrozenColumns = function (t, e) {
          var n = this,
              r = this.context.columns;
          this.forEachRow(function (i, o) {
            n.insertFrozenCells(i, o, t, e, r);
          });
        }, t.prototype.addColumnAtEnd = function (t, e) {
          var n = this,
              r = this.context.columns;
          this.forEachRow(function (i, o) {
            n.addCellAtEnd(i, o, t, e, r);
          });
        }, t.prototype.verifyRows = function () {
          var t = this.context.columns;
          this.forEachRow(function (e, n) {
            return function (t, e, n) {
              var r = Array.from(t.children);

              if (!(r.length <= 1)) {
                var i = r.map(function (t) {
                  return n.find(function (e) {
                    return e.id === t.dataset.id;
                  });
                });
                console.assert(i.every(function (t) {
                  return Boolean(t);
                }), "all columns must exist", e), console.assert(i.every(function (t, e) {
                  return 0 === e || t.index >= i[e - 1].index;
                }), "all columns in ascending order", e), console.assert(new Set(i).size === i.length, "unique columns", i);
              }
            }(e, n, t);
          });
        }, t.prototype.addCellAtEnd = function (t, e, n, r, i) {
          for (var o = n; o <= r; ++o) {
            var a = this.selectCell(e, o, i);
            t.appendChild(a);
          }
        }, t.prototype.updateHeaders = function () {
          var t = this,
              e = this.context.columns;
          Array.from(this.header.children).forEach(function (n, r) {
            t.updateHeader(n, e[r]);
          });
        }, t.prototype.recreate = function (t, e) {
          var n = this,
              r = this.context;
          this.style.update(r.defaultRowHeight - r.padding(-1), r.columns, -this.leftShift(), this.tableId), this.clearPool();

          for (var i = this.cellPool.length; i < r.columns.length; ++i) {
            this.cellPool.push([]);
          }

          var o = this.columnFragment,
              a = o.ownerDocument;
          this.header.innerHTML = "", r.columns.forEach(function (t) {
            var e = n.createHeader(a, t);
            A(e, t), o.appendChild(e);
          }), this.header.appendChild(o);
          var u = y(t, e, r.column.defaultRowHeight, r.column.exceptions, r.column.numberOfRows),
              c = u.first,
              s = u.last,
              l = u.firstRowPos;

          if (this.visibleColumns.first = this.visibleColumns.forcedFirst = c, this.visibleColumns.last = this.visibleColumns.forcedLast = s, r.columns.some(function (t) {
            return t.frozen;
          })) {
            var p = E([], r.columns, c).target;
            this.visibleColumns.frozen = p;
          } else this.visibleColumns.frozen = [];

          this.updateColumnOffset(l);
        }, t.prototype.clearPool = function () {
          this.cellPool.forEach(function (t) {
            return t.splice(0, t.length);
          });
        }, t.prototype.updateColumnOffset = function (t) {
          var e = t !== this.visibleFirstColumnPos;

          if (this.visibleFirstColumnPos = t, e) {
            var n = this.context;
            this.style.update(n.defaultRowHeight - n.padding(-1), n.columns, -this.leftShift(), this.tableId);
          }
        }, t.prototype.createRow = function (t, e) {
          var n = this.context.columns,
              r = this.visibleColumns;
          if (r.frozen.length > 0) for (var i = 0, o = r.frozen; i < o.length; i++) {
            var a = o[i],
                u = this.selectCell(e, a, n);
            t.appendChild(u);
          }

          for (a = r.first; a <= r.last; ++a) {
            u = this.selectCell(e, a, n), t.appendChild(u);
          }
        }, t.prototype.updateRow = function (t, e) {
          var n = this.context.columns,
              r = this.visibleColumns,
              i = Array.from(t.children);

          switch (i.length) {
            case 0:
              r.frozen.length > 0 && this.insertFrozenCells(t, e, r.frozen, 0, n), this.addCellAtEnd(t, e, r.first, r.last, n);
              break;

            case 1:
              var o = i[0],
                  a = o.dataset.id,
                  u = n.findIndex(function (t) {
                return t.id === a;
              });
              t.removeChild(o), u >= 0 && this.recycleCell(o, u), r.frozen.length > 0 && this.insertFrozenCells(t, e, r.frozen, 0, n), this.addCellAtEnd(t, e, r.first, r.last, n);
              break;

            default:
              this.mergeColumns(t, e, i);
          }
        }, t.prototype.mergeColumns = function (t, e, n) {
          var r = this,
              i = this.context.columns,
              o = this.visibleColumns;
          t.innerHTML = "";

          var a = new Map(n.map(function (t) {
            return [t.dataset.id, t];
          })),
              u = function u(n) {
            var o = i[n],
                u = a.get(o.id);

            if (u) {
              var c = r.updateCell(u, e, o);
              c && c !== u && A(c, o), t.appendChild(c || u);
            } else {
              var s = r.selectCell(e, n, i);
              t.appendChild(s);
            }
          };

          o.frozen.forEach(u);

          for (var c = o.first; c <= o.last; ++c) {
            u(c);
          }
        }, t.prototype.syncFrozen = function (t) {
          var e = this.context.columns,
              n = this.visibleColumns;
          if (!e.some(function (t) {
            return t.frozen;
          })) return 0;
          if (0 === t) return n.frozen.length > 0 && (this.removeFrozenColumns(n.frozen, 0), n.frozen = []), 0;
          var r = n.frozen.length,
              i = E(n.frozen, e, t),
              o = i.target,
              a = i.added,
              u = i.removed;
          return u.length > 0 && this.removeFrozenColumns(u, r - u.length), a.length > 0 && this.insertFrozenColumns(a, r - u.length), n.frozen = o, o.length;
        }, t.prototype.onScrolledHorizontallyImpl = function (t, e) {
          var n = this.context.column,
              r = y(t, e, n.defaultRowHeight, n.exceptions, n.numberOfRows),
              i = r.first,
              o = r.last,
              a = r.firstRowPos,
              u = this.visibleColumns;
          if (u.forcedFirst = i, u.forcedLast = o, i - u.first >= 0 && o - u.last <= 0) return f.NONE;
          var c = f.SOME,
              s = this.syncFrozen(i);
          return i > u.last || o < u.first ? (this.removeAllColumns(!1), this.addColumnAtEnd(i, o), c = f.ALL) : i < u.first ? (this.removeColumnFromEnd(o + 1, u.last), this.addColumnAtStart(i, u.first - 1, s), c = f.SOME_TOP) : (this.removeColumnFromStart(u.first, i - 1, s), this.addColumnAtEnd(u.last + 1, o), c = f.SOME_BOTTOM), u.first = i, u.last = o, this.updateColumnOffset(a), c;
        }, t;
      }(),
          j = function (t) {
        function e(e, n, r) {
          void 0 === r && (r = {});
          var o = t.call(this, w(e).querySelector("main > article"), r) || this;
          o.root = e, e.classList.add("lineup-engine"), o.style = new M(o.root, n);

          var a = o,
              u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }

            return i(e, t), Object.defineProperty(e.prototype, "context", {
              get: function get() {
                return a.context;
              },
              enumerable: !0,
              configurable: !0
            }), e.prototype.createHeader = function (t, e) {
              return a.createHeader(t, e);
            }, e.prototype.updateHeader = function (t, e) {
              return a.updateHeader(t, e);
            }, e.prototype.createCell = function (t, e, n) {
              return a.createCell(t, e, n);
            }, e.prototype.updateCell = function (t, e, n) {
              return a.updateCell(t, e, n);
            }, e.prototype.updateColumnOffset = function (e) {
              t.prototype.updateColumnOffset.call(this, e), a.updateOffset(a.visibleFirstRowPos);
            }, e.prototype.forEachRow = function (t) {
              return a.forEachRow(t);
            }, e;
          }(L);

          return o.cell = new (u.bind.apply(u, [void 0, o.header, o.style, void 0].concat(r.mixins || [])))(), o;
        }

        return i(e, t), Object.defineProperty(e.prototype, "header", {
          get: function get() {
            return this.root.querySelector("header > article");
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "headerScroller", {
          get: function get() {
            return this.root.querySelector("header");
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "visibleColumns", {
          get: function get() {
            return this.cell.visibleColumns;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "visibleFirstColumnPos", {
          get: function get() {
            return this.cell.visibleFirstColumnPos;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.addColumnMixin = function (t, e) {
          this.cell.addColumnMixin(t, e);
        }, e.prototype.init = function () {
          var e = this;
          this.cell.init();

          var n = _(this.body.parentElement, this.options.async, function (t) {
            if (!(Math.abs(n.left - t.left) < e.options.minScrollDelta && Math.abs(n.width - t.width) < e.options.minScrollDelta)) {
              var r = t.left > n.left;
              n = t, e.onScrolledHorizontally(t.left, t.width, r);
            }
          });

          t.prototype.init.call(this);
        }, e.prototype.destroy = function () {
          t.prototype.destroy.call(this), this.root.remove();
        }, e.prototype.onScrolledHorizontally = function (t, e, n) {
          return this.cell.onScrolledHorizontally(t, e, n);
        }, e.prototype.updateHeaders = function () {
          this.cell.updateHeaders();
        }, e.prototype.updateColumnWidths = function () {
          var t = this.context;
          this.style.update(t.defaultRowHeight - t.padding(-1), t.columns, -this.cell.leftShift());
        }, e.prototype.updateSizer = function (t) {
          var e = this.context,
              n = e.totalHeight,
              r = e.column.totalHeight;
          this.updateShifts(t, this.cell.leftShift()), this.bodySizer.style.transform = "translate(" + Math.max(0, r - 1).toFixed(0) + "px, " + Math.max(0, n - 1).toFixed(0) + "px)";
        }, e.prototype.updateShifts = function (t, e) {
          this.body.style.transform = "translate(" + e.toFixed(0) + "px, " + t.toFixed(0) + "px)";
        }, e.prototype.recreate = function (e) {
          var n = this.bodyScroller,
              r = n.scrollLeft;
          this.cell.recreate(r, n.clientWidth), t.prototype.recreate.call(this, e), n.scrollLeft = r;
        }, e.prototype.clearPool = function () {
          t.prototype.clearPool.call(this), this.cell.clearPool();
        }, e.prototype.createRow = function (t, e) {
          this.cell.createRow(t, e);
        }, e.prototype.updateRow = function (t, e) {
          this.cell.updateRow(t, e);
        }, e;
      }(T),
          x = n(1),
          S = function () {
        function t(t, e) {
          return this.adapter = t, this.prefetchTimeout = -1, this.cleanupTimeout = -1, this.options = {
            prefetchRows: 20,
            cleanUpRows: 3,
            delay: 50
          }, Object.assign(this.options, e), this;
        }

        return t.prototype.prefetchDown = function () {
          this.prefetchTimeout = -1;
          var t = this.adapter.context,
              e = Math.min(this.adapter.visible.forcedLast + this.options.prefetchRows, t.numberOfRows - 1);
          this.adapter.visible.last === e && this.adapter.visible.last >= this.adapter.visible.forcedLast + this.options.prefetchRows || (this.adapter.addAtBottom(this.adapter.visible.last + 1, e), this.adapter.visible.last = e);
        }, t.prototype.prefetchUp = function () {
          if (this.prefetchTimeout = -1, !(this.adapter.visible.first <= this.adapter.visible.forcedFirst - this.options.prefetchRows)) {
            var t = this.adapter.context,
                e = this.adapter.scroller,
                n = y(Math.max(e.scrollTop - this.options.prefetchRows * t.defaultRowHeight, 0), e.clientHeight, t.defaultRowHeight, t.exceptions, t.numberOfRows),
                r = n.first,
                i = n.firstRowPos;

            if (r !== this.adapter.visible.first) {
              var o = this.adapter.syncFrozen ? this.adapter.syncFrozen(r) : 0;
              this.adapter.addAtBeginning(r, this.adapter.visible.first - 1, o), this.adapter.visible.first = r, this.adapter.updateOffset(i);
            }
          }
        }, t.prototype.triggerPrefetch = function (t) {
          this.prefetchTimeout >= 0 && clearTimeout(this.prefetchTimeout);
          var e = this.adapter.visible.last < this.adapter.visible.forcedLast + this.options.prefetchRows,
              n = this.adapter.visible.first > this.adapter.visible.forcedFirst - this.options.prefetchRows,
              r = this.adapter.visible.last === this.adapter.context.numberOfRows,
              i = 0 === this.adapter.visible.first;

          if ((!t || e || r) && (t || n || i)) {
            var o = t || i ? this.prefetchDown.bind(this) : this.prefetchUp.bind(this);
            this.prefetchTimeout = self.setTimeout(o, this.options.delay);
          }
        }, t.prototype.cleanUpTop = function (t) {
          this.cleanupTimeout = -1;
          var e = Math.max(0, t - this.options.cleanUpRows);

          if (!(e <= this.adapter.visible.first)) {
            var n = this.adapter.syncFrozen ? this.adapter.syncFrozen(e) : 0;
            this.adapter.removeFromBeginning(this.adapter.visible.first, e - 1, n);
            var r = this.adapter.context,
                i = (e - this.adapter.visible.first) * r.defaultRowHeight;
            if (r.exceptions.length > 0) for (var o = this.adapter.visible.first; o < e; ++o) {
              r.exceptionsLookup.has(o) && (i += r.exceptionsLookup.get(o) - r.defaultRowHeight);
            }
            this.adapter.visible.first = e, this.adapter.updateOffset(this.adapter.visibleFirstRowPos + i), this.prefetchDown();
          }
        }, t.prototype.cleanUpBottom = function (t) {
          this.cleanupTimeout = -1;
          var e = t + this.options.cleanUpRows;
          this.adapter.visible.last <= e || (this.adapter.removeFromBottom(e + 1, this.adapter.visible.last), this.adapter.visible.last = e, this.prefetchUp());
        }, t.prototype.triggerCleanUp = function (t, e, n) {
          this.cleanupTimeout >= 0 && clearTimeout(this.cleanupTimeout), n && t - this.options.cleanUpRows <= this.adapter.visible.first || !n && this.adapter.visible.last <= e + this.options.cleanUpRows || (this.cleanupTimeout = self.setTimeout(n ? this.cleanUpTop.bind(this) : this.cleanUpBottom.bind(this), this.options.delay, n ? t : e));
        }, t.prototype.onScrolled = function (t, e) {
          e !== f.ALL && this.options.cleanUpRows > 0 && this.triggerCleanUp(this.adapter.visible.forcedFirst, this.adapter.visible.forcedLast, t), e !== f.NONE && this.options.prefetchRows > 0 && this.triggerPrefetch(t);
        }, t;
      }(),
          I = function (t) {
        function e(e, n, r, o, a) {
          void 0 === a && (a = {});
          var u = t.call(this, n, a) || this;
          u.header = e, u.body = n, u.tableId = r, u.style = o;

          var c = u,
              s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }

            return i(e, t), Object.defineProperty(e.prototype, "context", {
              get: function get() {
                return c.context;
              },
              enumerable: !0,
              configurable: !0
            }), e.prototype.createHeader = function (t, e) {
              return c.createHeader(t, e);
            }, e.prototype.updateHeader = function (t, e) {
              return c.updateHeader(t, e);
            }, e.prototype.createCell = function (t, e, n) {
              return c.createCell(t, e, n);
            }, e.prototype.updateColumnOffset = function (e) {
              t.prototype.updateColumnOffset.call(this, e), c.updateOffset(c.visibleFirstRowPos);
            }, e.prototype.updateCell = function (t, e, n) {
              return c.updateCell(t, e, n);
            }, e.prototype.forEachRow = function (t) {
              return c.forEachRow(t);
            }, e;
          }(L);

          return u.cell = new (s.bind.apply(s, [void 0, u.header, u.style, r].concat(a.mixins || [])))(), u;
        }

        return i(e, t), e.prototype.addColumnMixin = function (t, e) {
          this.cell.addColumnMixin(t, e);
        }, Object.defineProperty(e.prototype, "width", {
          get: function get() {
            return this.context.column.totalHeight;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "visibleColumns", {
          get: function get() {
            return this.cell.visibleColumns;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "visibleFirstColumnPos", {
          get: function get() {
            return this.cell.visibleFirstColumnPos;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "height", {
          get: function get() {
            return this.context.totalHeight;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "hidden", {
          get: function get() {
            return this.header.classList.contains("loading");
          },
          set: function set(t) {
            this.hidden !== t && (this.header.classList.toggle("loading", t), this.body.classList.toggle("loading", t), this.onVisibilityChanged(!t));
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.updateSizer = function (t) {
          this.updateShifts(t, this.cell.leftShift());
        }, e.prototype.updateShifts = function (t, e) {
          this.body.style.transform = "translate(" + e.toFixed(0) + "px, " + t.toFixed(0) + "px)";
        }, e.prototype.onVisibilityChanged = function (t) {}, e.prototype.hide = function () {
          this.hidden = !0;
        }, e.prototype.show = function (t, e, n) {
          var r = this.hidden;
          this.hidden = !1, r ? this.revalidate() : this.onScrolledHorizontally(t, e, n);
        }, e.prototype.init = function () {
          this.hide(), this.cell.init(), t.prototype.init.call(this);
        }, e.prototype.destroy = function () {
          t.prototype.destroy.call(this), this.header.remove(), this.style.remove(this.tableId);
        }, e.prototype.onScrolledVertically = function (e, n, r) {
          return this.hidden ? f.NONE : t.prototype.onScrolledVertically.call(this, e, n, r);
        }, e.prototype.onScrolledHorizontally = function (t, e, n) {
          var r = this.cell.onScrolledHorizontally(t, e, n);
          return this.updateSizer(this.visibleFirstRowPos), r;
        }, e.prototype.updateHeaders = function () {
          this.cell.updateHeaders();
        }, e.prototype.updateColumnWidths = function () {
          var t = this.context;
          this.style.update(t.defaultRowHeight - t.padding(-1), t.columns, -this.cell.leftShift(), this.tableId);
        }, e.prototype.recreate = function (e) {
          var n = this.bodyScroller,
              r = n.scrollLeft;
          this.cell.recreate(r, n.clientWidth), t.prototype.recreate.call(this, e), n.scrollLeft = r;
        }, e.prototype.clearPool = function () {
          t.prototype.clearPool.call(this), this.cell.clearPool();
        }, e.prototype.createRow = function (t, e) {
          this.cell.createRow(t, e);
        }, e.prototype.updateRow = function (t, e) {
          this.cell.updateRow(t, e);
        }, e;
      }(N),
          V = function () {
        function t(t, e, n) {
          void 0 === n && (n = {});
          var r = this;
          this.node = t, this.tableId = 0, this.sections = [], this.options = {
            columnPadding: 0,
            async: O,
            minScrollDelta: 30
          }, Object.assign(this.options, n), t.id = e.startsWith("#") ? e.slice(1) : e, t.innerHTML = "<header><footer>&nbsp;</footer></header><main><footer>&nbsp;</footer></main>", t.classList.add("lineup-engine", "lineup-multi-engine"), this.style = new M(this.node, e);

          var i = _(this.main, this.options.async, function (t) {
            if (!(Math.abs(i.left - t.left) < r.options.minScrollDelta && Math.abs(i.width - t.width) < r.options.minScrollDelta)) {
              var e = t.left > i.left;
              i = t, r.onScrolledHorizontally(t.left, t.width, e);
            }
          });
        }

        return t.prototype.update = function () {
          var t = this;
          this.onScrolledHorizontally(this.main.scrollLeft, this.main.clientWidth, !1);
          var e = 0;
          this.sections.forEach(function (n) {
            n.body.style.left = n.header.style.left = e + "px", e += n.width + t.options.columnPadding;
          });
        }, t.prototype.onScrolledHorizontally = function (t, e, n) {
          var r = this,
              i = 0,
              o = t + e;
          this.sections.forEach(function (e) {
            var a = i + e.width;
            a < t || i > o ? e.hide() : e.show(Math.max(0, t - i), Math.min(o - i, e.width), n), i = a + r.options.columnPadding;
          }), this.updateOffset();
        }, t.prototype.updateOffset = function () {
          var t = this,
              e = this.header.querySelector("footer"),
              n = this.main.querySelector("footer"),
              r = Math.max.apply(Math, [0].concat(this.sections.map(function (t) {
            return t.height;
          }))),
              i = this.sections.reduce(function (e, n) {
            return e + n.width + t.options.columnPadding;
          }, 0);
          e.style.transform = "translate(" + i + "px,0)", n.style.transform = "translate(" + i + "px, " + r + "px)";
        }, t.prototype.destroy = function () {
          this.sections.forEach(function (t) {
            return t.destroy();
          }), this.node.remove();
        }, Object.defineProperty(t.prototype, "doc", {
          get: function get() {
            return this.node.ownerDocument;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "header", {
          get: function get() {
            return this.node.querySelector("header");
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "main", {
          get: function get() {
            return this.node.querySelector("main");
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.pushTable = function (t) {
          for (var e = [], n = 1; n < arguments.length; n++) {
            e[n - 1] = arguments[n];
          }

          var r = this.doc.createElement("article"),
              i = this.doc.createElement("article"),
              o = "T" + this.tableId++,
              a = this.style.tableIds(o);
          r.id = a.header, i.id = a.body, this.header.insertBefore(r, this.header.lastElementChild), this.main.appendChild(i);
          var u = t.apply(void 0, [r, i, o, this.style].concat(e));
          return u.init(), this.sections.push(u), this.update(), u;
        }, t.prototype.pushSeparator = function (t) {
          for (var e = [], n = 1; n < arguments.length; n++) {
            e[n - 1] = arguments[n];
          }

          var r = this.doc.createElement("section"),
              i = this.doc.createElement("section");
          this.header.insertBefore(r, this.header.lastElementChild), this.main.appendChild(i);
          var o = t.apply(void 0, [r, i, this.style].concat(e));
          return o.init(), this.sections.push(o), this.update(), o;
        }, t.prototype.remove = function (t) {
          var e = this.sections.indexOf(t);
          return !(e < 0 || (this.sections.splice(e, 1), t.destroy(), this.update(), 0));
        }, t.prototype.clear = function () {
          this.sections.splice(0, this.sections.length).forEach(function (t) {
            return t.destroy();
          }), this.update();
        }, t.prototype.widthChanged = function () {
          this.update();
        }, t;
      }();

      n.d(e, "version", function () {
        return k;
      }), n.d(e, "ACellRenderer", function () {
        return j;
      }), n.d(e, "ARowRenderer", function () {
        return T;
      }), n.d(e, "uniformContext", function () {
        return g;
      }), n.d(e, "nonUniformContext", function () {
        return b;
      }), n.d(e, "randomContext", function () {
        return m;
      }), n.d(e, "range", function () {
        return y;
      }), n.d(e, "frozenDelta", function () {
        return v;
      }), n.d(e, "updateFrozen", function () {
        return E;
      }), n.d(e, "ABORTED", function () {
        return o;
      }), n.d(e, "isAbortAble", function () {
        return u;
      }), n.d(e, "abortAble", function () {
        return a;
      }), n.d(e, "IColumn", function () {
        return x.IColumn;
      }), n.d(e, "GridStyleManager", function () {
        return M;
      }), n.d(e, "setColumn", function () {
        return A;
      }), n.d(e, "TEMPLATE", function () {
        return R;
      }), n.d(e, "setTemplate", function () {
        return w;
      }), n.d(e, "StyleManager", function () {
        return D;
      }), n.d(e, "IMixin", function () {}), n.d(e, "IMixinAdapter", function () {}), n.d(e, "IMixinClass", function () {}), n.d(e, "EScrollResult", function () {
        return f;
      }), n.d(e, "PrefetchMixin", function () {
        return S;
      }), n.d(e, "ITableCellRenderContext", function () {}), n.d(e, "ACellTableSection", function () {
        return I;
      }), n.d(e, "IMultiTableRowRendererOptions", function () {}), n.d(e, "ISeparatorFactory", function () {}), n.d(e, "ITableFactory", function () {}), n.d(e, "ITableSection", function () {}), n.d(e, "MultiTableRowRenderer", function () {
        return V;
      }), n.d(e, "KeyFinder", function () {
        return s;
      }), n.d(e, "EAnimationMode", function () {
        return c;
      }), n.d(e, "noAnimationChange", function () {
        return p;
      }), n.d(e, "defaultPhases", function () {
        return d;
      });
      var k = "1.1.2";
    }]);
  }, function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return a;
    }), n.d(e, "b", function () {
      return u;
    }), n.d(e, "a", function () {
      return c;
    });
    var r = n(1),
        i = n(4),
        o = n(17);

    function a(t, e, n) {
      var r = function r(t) {
        var e = t;
        n ? e.dataset.active = "" : delete e.dataset.active;
      };

      r(t);
      var i = t.closest(".lu");
      i && Array.from(i.querySelectorAll('[data-col-id="' + e.id + '"] i[title^=Filter]')).forEach(r);
    }

    function u(t, e, n, r) {
      var o = Object(i.k)(r),
          a = e.getSortMethod();
      n.forEach(function (e) {
        return t.insertAdjacentHTML("beforeend", '<div class="checkbox"><input id="' + o + e + '" type="radio" name="multivaluesort" value="' + e + '"  ' + (a === e ? "checked" : "") + ' ><label for="' + o + e + '">' + (e.slice(0, 1).toUpperCase() + e.slice(1)) + "</label></div>");
      }), Object(i.e)(t, "input[name=multivaluesort]", function (t) {
        t.addEventListener("change", function () {
          return e.setSortMethod(t.value);
        }, {
          passive: !0
        });
      });
    }

    function c(t) {
      return Object(o.d)(t) ? t.getColorMapping().apply(0) : r.d.DEFAULT_COLOR;
    }
  }, function (t, e, n) {
    "use strict";

    var r = function r(t, e) {
      if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
      var n,
          r = t.slice(0, n);
      return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
    },
        i = function i(t) {
      return (t = r(Math.abs(t))) ? t[1] : NaN;
    },
        o = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

    function a(t) {
      if (!(e = o.exec(t))) throw new Error("invalid format: " + t);
      var e;
      return new u({
        fill: e[1],
        align: e[2],
        sign: e[3],
        symbol: e[4],
        zero: e[5],
        width: e[6],
        comma: e[7],
        precision: e[8] && e[8].slice(1),
        trim: e[9],
        type: e[10]
      });
    }

    function u(t) {
      this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
    }

    a.prototype = u.prototype, u.prototype.toString = function () {
      return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
    };

    var c,
        s,
        l,
        p,
        f = function f(t) {
      t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) {
        switch (t[r]) {
          case ".":
            i = e = r;
            break;

          case "0":
            0 === i && (i = r), e = r;
            break;

          default:
            if (i > 0) {
              if (!+t[r]) break t;
              i = 0;
            }

        }
      }

      return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
    },
        d = function d(t, e) {
      var n = r(t, e);
      if (!n) return t + "";
      var i = n[0],
          o = n[1];
      return o < 0 ? "0." + new Array(-o).join("0") + i : i.length > o + 1 ? i.slice(0, o + 1) + "." + i.slice(o + 1) : i + new Array(o - i.length + 2).join("0");
    },
        h = {
      "%": function _(t, e) {
        return (100 * t).toFixed(e);
      },
      b: function b(t) {
        return Math.round(t).toString(2);
      },
      c: function c(t) {
        return t + "";
      },
      d: function d(t) {
        return Math.round(t).toString(10);
      },
      e: function e(t, _e) {
        return t.toExponential(_e);
      },
      f: function f(t, e) {
        return t.toFixed(e);
      },
      g: function g(t, e) {
        return t.toPrecision(e);
      },
      o: function o(t) {
        return Math.round(t).toString(8);
      },
      p: function p(t, e) {
        return d(100 * t, e);
      },
      r: d,
      s: function s(t, e) {
        var n = r(t, e);
        if (!n) return t + "";
        var i = n[0],
            o = n[1],
            a = o - (c = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1,
            u = i.length;
        return a === u ? i : a > u ? i + new Array(a - u + 1).join("0") : a > 0 ? i.slice(0, a) + "." + i.slice(a) : "0." + new Array(1 - a).join("0") + r(t, Math.max(0, e + a - 1))[0];
      },
      X: function X(t) {
        return Math.round(t).toString(16).toUpperCase();
      },
      x: function x(t) {
        return Math.round(t).toString(16);
      }
    },
        g = function g(t) {
      return t;
    },
        b = Array.prototype.map,
        m = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

    s = function (t) {
      var e,
          n,
          r = void 0 === t.grouping || void 0 === t.thousands ? g : (e = b.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
        for (var i = t.length, o = [], a = 0, u = e[0], c = 0; i > 0 && u > 0 && (c + u + 1 > r && (u = Math.max(1, r - c)), o.push(t.substring(i -= u, i + u)), !((c += u + 1) > r));) {
          u = e[a = (a + 1) % e.length];
        }

        return o.reverse().join(n);
      }),
          o = void 0 === t.currency ? "" : t.currency[0] + "",
          u = void 0 === t.currency ? "" : t.currency[1] + "",
          s = void 0 === t.decimal ? "." : t.decimal + "",
          l = void 0 === t.numerals ? g : function (t) {
        return function (e) {
          return e.replace(/[0-9]/g, function (e) {
            return t[+e];
          });
        };
      }(b.call(t.numerals, String)),
          p = void 0 === t.percent ? "%" : t.percent + "",
          d = void 0 === t.minus ? "-" : t.minus + "",
          y = void 0 === t.nan ? "NaN" : t.nan + "";

      function v(t) {
        var e = (t = a(t)).fill,
            n = t.align,
            i = t.sign,
            g = t.symbol,
            b = t.zero,
            v = t.width,
            E = t.comma,
            O = t.precision,
            C = t.trim,
            _ = t.type;
        "n" === _ ? (E = !0, _ = "g") : h[_] || (void 0 === O && (O = 12), C = !0, _ = "g"), (b || "0" === e && "=" === n) && (b = !0, e = "0", n = "=");
        var T = "$" === g ? o : "#" === g && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "",
            N = "$" === g ? u : /[%p]/.test(_) ? p : "",
            D = h[_],
            R = /[defgprs%]/.test(_);

        function w(t) {
          var o,
              a,
              u,
              p = T,
              h = N;
          if ("c" === _) h = D(t) + h, t = "";else {
            var g = (t = +t) < 0;
            if (t = isNaN(t) ? y : D(Math.abs(t), O), C && (t = f(t)), g && 0 == +t && (g = !1), p = (g ? "(" === i ? i : d : "-" === i || "(" === i ? "" : i) + p, h = ("s" === _ ? m[8 + c / 3] : "") + h + (g && "(" === i ? ")" : ""), R) for (o = -1, a = t.length; ++o < a;) {
              if (48 > (u = t.charCodeAt(o)) || u > 57) {
                h = (46 === u ? s + t.slice(o + 1) : t.slice(o)) + h, t = t.slice(0, o);
                break;
              }
            }
          }
          E && !b && (t = r(t, 1 / 0));
          var w = p.length + t.length + h.length,
              A = w < v ? new Array(v - w + 1).join(e) : "";

          switch (E && b && (t = r(A + t, A.length ? v - h.length : 1 / 0), A = ""), n) {
            case "<":
              t = p + t + h + A;
              break;

            case "=":
              t = p + A + t + h;
              break;

            case "^":
              t = A.slice(0, w = A.length >> 1) + p + t + h + A.slice(w);
              break;

            default:
              t = A + p + t + h;
          }

          return l(t);
        }

        return O = void 0 === O ? 6 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, O)) : Math.max(0, Math.min(20, O)), w.toString = function () {
          return t + "";
        }, w;
      }

      return {
        format: v,
        formatPrefix: function formatPrefix(t, e) {
          var n = v(((t = a(t)).type = "f", t)),
              r = 3 * Math.max(-8, Math.min(8, Math.floor(i(e) / 3))),
              o = Math.pow(10, -r),
              u = m[8 + r / 3];
          return function (t) {
            return n(o * t) + u;
          };
        }
      };
    }({
      decimal: ".",
      thousands: ",",
      grouping: [3],
      currency: ["$", ""],
      minus: "-"
    }), l = s.format, p = s.formatPrefix;

    var y = function y(t) {
      return Math.max(0, -i(Math.abs(t)));
    },
        v = function v(t, e) {
      return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(i(e) / 3))) - i(Math.abs(t)));
    },
        E = function E(t, e) {
      return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, i(e) - i(t)) + 1;
    };

    n.d(e, "a", function () {
      return l;
    }), n.d(e, "b", function () {
      return p;
    }), n.d(e, "c", function () {
      return a;
    }), n.d(e, "d", function () {
      return y;
    }), n.d(e, "e", function () {
      return v;
    }), n.d(e, "f", function () {
      return E;
    });
  },, function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return g;
    });

    var r = n(0),
        i = n(23),
        o = n(2),
        a = n(7),
        u = n(22),
        c = n(1),
        s = n(3),
        l = n(53),
        p = n(12),
        f = n(38),
        d = n(42),
        h = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.currentFilter = Object(s.n)(), r.currentGrouper = Object(l.b)(), r.format = Object(i.a)(n.dateFormat || "%x"), r.parse = n.dateParse ? Object(i.b)(n.dateParse) : Object(i.b)(n.dateFormat || "%x"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.filter = Object(s.i)(this.currentFilter) ? null : this.currentFilter, this.currentGrouper && !Object(l.e)(this.currentGrouper) && (n.grouper = this.currentGrouper), n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.filter && (this.currentFilter = Object(s.p)(e.filter)), e.grouper && (this.currentGrouper = e.grouper);
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_FILTER_CHANGED, n.EVENT_GROUPING_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (t) {
        return this.getDate(t);
      }, e.prototype.getDate = function (e) {
        var n = t.prototype.getValue.call(this, e);
        return Object(a.c)(n) ? null : n instanceof Date ? n : this.parse(String(n));
      }, e.prototype.getLabel = function (t) {
        var e = this.getValue(t);
        return e instanceof Date ? this.format(e) : "";
      }, e.prototype.isFiltered = function () {
        return !Object(s.i)(this.currentFilter);
      }, e.prototype.getFilter = function () {
        return Object.assign({}, this.currentFilter);
      }, e.prototype.setFilter = function (t) {
        if (void 0 === t && (t = {
          min: -1 / 0,
          max: 1 / 0,
          filterMissing: !1
        }), !Object(s.j)(t, this.currentFilter)) {
          var e = this.getFilter();
          this.currentFilter.min = Object(a.d)(t.min) ? -1 / 0 : t.min, this.currentFilter.max = Object(a.d)(t.max) ? 1 / 0 : t.max, this.currentFilter.filterMissing = t.filterMissing, this.fire([n.EVENT_FILTER_CHANGED, c.d.EVENT_DIRTY_VALUES, c.d.EVENT_DIRTY], e, this.getFilter());
        }
      }, e.prototype.filter = function (t) {
        return Object(l.d)(this.currentFilter, this.getDate(t));
      }, e.prototype.compare = function (t, e) {
        var n = this.getDate(t),
            r = this.getDate(e);
        return n === r ? 0 : n instanceof Date ? r instanceof Date ? n.getTime() - r.getTime() : -1 * a.a : r instanceof Date ? a.a : 0;
      }, e.prototype.getDateGrouper = function () {
        return Object.assign({}, this.currentGrouper);
      }, e.prototype.setDateGrouper = function (t) {
        if (!Object(d.a)(this.currentGrouper, t)) {
          var e = this.getDateGrouper();
          this.currentGrouper = Object.assign({}, t), this.fire([n.EVENT_GROUPING_CHANGED, c.d.EVENT_DIRTY_VALUES, c.d.EVENT_DIRTY], e, t);
        }
      }, e.prototype.group = function (t) {
        var e = this.getDate(t);
        return e && e instanceof Date ? this.currentGrouper ? {
          name: Object(l.j)(this.currentGrouper, e).name,
          color: c.d.DEFAULT_COLOR
        } : f.a : a.e;
      }, e.prototype.groupCompare = function (t, e) {
        var n = g(t.rows, this.currentGrouper, this).value,
            r = g(e.rows, this.currentGrouper, this).value;
        return Object(s.o)(n, r, !1, !1);
      }, e.EVENT_FILTER_CHANGED = "filterChanged", e.EVENT_GROUPING_CHANGED = "groupingChanged", e = n = Object(r.b)([Object(o.m)("groupBy", "sortGroupBy", "filterDate"), Object(o.h)("group", "groupDate"), Object(o.b)("date")], e);
    }(u.b);

    function g(t, e, n) {
      var r = t.map(function (t) {
        return n.getDate(t);
      }).filter(function (t) {
        return t instanceof Date;
      });
      if (0 === r.length) return {
        value: null,
        name: ""
      };

      var i = function (t, e) {
        if (t.length % 2 == 1) return Object(p.h)(t, e);
        var n = t.slice().sort(function (t, e) {
          return t.getTime() - e.getTime();
        });
        return n[Math.floor(n.length / 2)].getTime();
      }(r, function (t) {
        return t.getTime();
      });

      return e ? Object(l.j)(e, new Date(i)) : {
        value: i,
        name: new Date(i).toString()
      };
    }

    e.c = h;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(2),
        o = n(14),
        a = n(4),
        u = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.column = e, i.ctx = r, i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = this,
            n = this.column.getRenderer(),
            r = this.column.getGroupRenderer(),
            i = this.column.getSummaryRenderer(),
            o = this.ctx.getPossibleRenderer(this.column),
            u = o.item,
            c = o.group,
            s = o.summary;
        console.assert(u.length > 1 || c.length > 1 || s.length > 1);
        var l = Object(a.k)(this.dialog.idPrefix);
        t.insertAdjacentHTML("beforeend", "\n      <strong>Item Visualization</strong>\n      " + u.sort(function (t, e) {
          return t.label.localeCompare(e.label);
        }).map(function (t) {
          return ' <div class="lu-checkbox"><input id="' + l + "0" + t.type + '" type="radio" name="renderer" value="' + t.type + '" ' + (n === t.type ? "checked" : "") + '><label for="' + l + "0" + t.type + '">' + t.label + "</label></div>";
        }).join("") + "\n      <strong>Group Visualization</strong>\n      " + c.sort(function (t, e) {
          return t.label.localeCompare(e.label);
        }).map(function (t) {
          return ' <div class="lu-checkbox"><input id="' + l + "1" + t.type + '" type="radio" name="group" value="' + t.type + '" ' + (r === t.type ? "checked" : "") + '><label for="' + l + "1" + t.type + '">' + t.label + "</label></div>";
        }).join("") + "\n      <strong>Summary Visualization</strong>\n      " + s.sort(function (t, e) {
          return t.label.localeCompare(e.label);
        }).map(function (t) {
          return ' <div class="lu-checkbox"><input id="' + l + "2" + t.type + '" type="radio" name="summary" value="' + t.type + '" ' + (i === t.type ? "checked" : "") + '><label for="' + l + "2" + t.type + '">' + t.label + "</label></div>";
        }).join("") + "\n    "), this.forEach('input[name="renderer"]', function (t) {
          t.addEventListener("change", function () {
            return e.column.setRenderer(t.value);
          }, {
            passive: !0
          });
        }), this.forEach('input[name="group"]', function (t) {
          t.addEventListener("change", function () {
            return e.column.setGroupRenderer(t.value);
          }, {
            passive: !0
          });
        }), this.forEach('input[name="summary"]', function (t) {
          t.addEventListener("change", function () {
            return e.column.setSummaryRenderer(t.value);
          }, {
            passive: !0
          });
        });
      }, e;
    }(o.c),
        c = n(1),
        s = n(5),
        l = Object(s.a)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"),
        p = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.column = e, r.before = e.getMetaData(), r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.classList.add("lu-rename-dialog");
        var e = Object(a.k)("col");
        t.insertAdjacentHTML("beforeend", '\n      <datalist id="' + e + 'L"><option value="' + c.d.DEFAULT_COLOR + '"></option>' + l.slice(1).map(function (t) {
          return "<option>" + t + "</option>";
        }).join("") + '</datalist>\n      <input type="text" value="' + this.column.label + '" required autofocus placeholder="name">\n      <textarea rows="5" placeholder="Description">' + this.column.description + "</textarea>");
      }, e.prototype.reset = function () {
        this.findInput('input[type="text"]').value = this.before.label, this.node.querySelector("textarea").value = this.before.description, this.column.setMetaData(this.before);
      }, e.prototype.submit = function () {
        var t = this.findInput('input[type="text"]').value,
            e = this.node.querySelector("textarea").value;
        return this.column.setMetaData({
          label: t,
          description: e
        }), !0;
      }, e;
    }(o.c),
        f = n(32),
        d = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.column = e, r.before = r.column.getFilter(), r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = Object(a.k)(this.dialog.idPrefix);
        t.insertAdjacentHTML("beforeend", '\n     <div class="lu-checkbox"><input id="' + e + '0" type="radio" name="boolean_check" value="null" ' + (null == this.before ? 'checked="checked"' : "") + '><label id="' + e + '0">No Filter</label></div>\n     <div class="lu-checkbox"><input id="' + e + '1" type="radio" name="boolean_check" value="true" ' + (!0 === this.before ? 'checked="checked"' : "") + '><label id="' + e + '1">True</label></div>\n     <div class="lu-checkbox"><input id="' + e + '2" type="radio" name="boolean_check" value="false" ' + (!1 === this.before ? 'checked="checked"' : "") + '><label id="' + e + '2">False</label></div>\n    ');
      }, e.prototype.updateFilter = function (t) {
        Object(f.c)(this.attachment, this.column, null != t), this.column.setFilter(t);
      }, e.prototype.reset = function () {
        this.forEach('input[type="radio"]', function (t) {
          return t.checked = "null" === t.value;
        }), this.updateFilter(null);
      }, e.prototype.submit = function () {
        var t = this.findInput('input[type="radio"][value="true"]').checked,
            e = this.findInput('input[type="radio"][value="false"]').checked;
        return this.updateFilter(!!t || !e && null), !0;
      }, e;
    }(o.c),
        h = n(24),
        g = n(30),
        b = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.column = e, r.before = r.column.getFilter() || {
          filter: r.column.categories.map(function (t) {
            return t.name;
          }),
          filterMissing: !1
        }, r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = this;
        t.classList.add("lu-filter-table");
        var n = Object(a.k)(this.dialog.idPrefix);
        t.insertAdjacentHTML("beforeend", '<div>\n        <div class="lu-checkbox"><input id="' + n + '" type="checkbox" checked><label for="' + n + '"><span></span><div>Un/Select All</div></label></div>\n        ' + this.column.categories.map(function (t) {
          return '<div class="lu-checkbox"><input id="' + n + t.name + '" data-cat="' + t.name + '" type="checkbox"' + (Object(h.d)(e.before, t) ? "checked" : "") + '><label for="' + n + t.name + '"><span style="background-color: ' + t.color + '"></span><div>' + t.label + "</div></label></div>";
        }).join("") + "\n    </div>"), this.findInput("input:not([data-cat])").onchange = function () {
          var e = this;
          Object(a.e)(t, "input[data-cat]", function (t) {
            return t.checked = e.checked;
          });
        }, t.insertAdjacentHTML("beforeend", Object(g.a)(this.before.filterMissing, this.dialog.idPrefix));
      }, e.prototype.updateFilter = function (t, e) {
        var n = null == t && !1 === e;
        Object(f.c)(this.attachment, this.column, !n), this.column.setFilter(n ? null : {
          filter: t,
          filterMissing: e
        });
      }, e.prototype.reset = function () {
        this.forEach("input[data-cat]", function (t) {
          return t.checked = !0;
        }), this.updateFilter(null, !1);
      }, e.prototype.submit = function () {
        var t = this.forEach("input[data-cat]", function (t) {
          return t.checked ? t.dataset.cat : "";
        }).filter(Boolean);
        t.length === this.column.categories.length && (t = null);
        var e = Object(g.c)(this.node).checked;
        return this.updateFilter(t, e), !0;
      }, e;
    }(o.c),
        m = n(16),
        y = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.column = e, r.before = r.column.getFilter() || {
          filter: r.column.categories.map(function (t) {
            return t.name;
          }),
          filterMissing: !1
        }, r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = this;
        t.classList.add("lu-filter-table");
        var n = this.column.categories.map(function (t) {
          return Object.assign({
            range: Object(m.k)(100 * t.value, 2)
          });
        });
        n.sort(function (t, e) {
          return t.label.localeCompare(e.label);
        });
        var r = Object(a.k)(this.dialog.idPrefix);
        t.insertAdjacentHTML("beforeend", '<div>\n        <div class="lu-checkbox"><input id="' + r + '" type="checkbox" checked><label for="' + r + '"><div>Un/Select All</div></label></div>\n        ' + n.map(function (t) {
          var n = t.name,
              i = t.color,
              o = t.label,
              a = t.range;
          return '<input id="' + r + n + '" data-cat="' + n + '" type="checkbox"' + (Object(h.d)(e.before, n) ? "checked" : "") + '>\n        <div class="lu-checkbox"><input type="number" value="' + a + '" min="0" max="100" size="5"><label for="' + r + n + '"><div><div style="background-color: ' + i + "; width: " + a + '%"></div></div><div>' + o + "</div></label></div>";
        }).join("") + "\n    </div>"), this.findInput("input[type=checkbox]:not([data-cat])").onchange = function () {
          var e = this;
          Object(a.e)(t, "[data-cat]", function (t) {
            return t.checked = e.checked;
          });
        }, this.forEach("input[type=number]", function (t) {
          t.oninput = function () {
            t.nextElementSibling.firstElementChild.style.width = t.value + "%";
          };
        }), t.insertAdjacentHTML("beforeend", Object(g.a)(this.before.filterMissing, this.dialog.idPrefix));
      }, e.prototype.updateFilter = function (t, e) {
        var n = null == t && !1 === e;
        Object(f.c)(this.attachment, this.column, !n), this.column.setFilter(n ? null : {
          filter: t,
          filterMissing: e
        });
      }, e.prototype.reset = function () {
        this.forEach("[data-cat]", function (t) {
          t.checked = !1, t.nextElementSibling.value = "50";
        }), this.updateFilter(null, !1), this.column.setMapping(this.column.categories.map(function () {
          return 1;
        }));
      }, e.prototype.submit = function () {
        var t = this.forEach("input[data-cat]", function (t) {
          return {
            checked: t.checked,
            cat: t.dataset.cat,
            range: parseFloat(t.nextElementSibling.value)
          };
        }),
            e = t.filter(function (t) {
          return t.checked;
        }).map(function (t) {
          return t.cat;
        });
        e.length === this.column.categories.length && (e = null);
        var n = Object(g.c)(this.node).checked;
        return this.updateFilter(e, n), this.column.setMapping(t.map(function (t) {
          return t.range / 100;
        })), !0;
      }, e;
    }(o.c),
        v = n(13),
        E = n(55),
        O = n(26),
        C = n(44),
        _ = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.column = e, i.ctx = r, i.id = ".dialog" + Math.random().toString(36).slice(-8).substr(0, 3), i;
      }

      return Object(r.c)(e, t), e.prototype.destroy = function () {
        this.column.on(Object(v.b)(this.id, O.b.EVENT_ADD_COLUMN, O.b.EVENT_REMOVE_COLUMN), null), t.prototype.destroy.call(this);
      }, e.prototype.build = function (t) {
        var e = this;
        t.classList.add("lu-sub-nested");

        var n = function n() {
          e.column.children.forEach(function (n) {
            var r = Object(C.a)(n, e.ctx, {
              mergeDropAble: !1,
              resizeable: !1,
              level: e.dialog.level + 1
            });
            r.className = "lu-header", Object(C.e)(r, n);
            var i = e.ctx.summaryRenderer(n, !1);
            r.insertAdjacentHTML("beforeend", i.template);
            var o = r.lastElementChild;
            o.dataset.renderer = n.getSummaryRenderer(), o.classList.add("lu-summary"), i.update(o, e.ctx.statsOf(n)), t.appendChild(r);
          });
        };

        n(), this.column.on(Object(v.b)(this.id, O.b.EVENT_ADD_COLUMN, O.b.EVENT_REMOVE_COLUMN), Object(E.a)(function () {
          t.parentElement ? (t.innerHTML = "", n()) : e.destroy();
        }));
      }, e;
    }(o.c),
        T = n(45),
        N = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return i.column = e, i.idPrefix = r, i.innerNodes = Object(T.j)(i.column.hierarchy), i.innerNodePaths = i.innerNodes.map(function (t) {
          return t.path;
        }), i.before = e.getCutOff(), i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.insertAdjacentHTML("beforeend", '\n        <input type="text" value="' + this.before.node.label + '" required="required" autofocus="autofocus" list="ui' + this.idPrefix + 'lineupHierarchyList" placeholder="cut off node">\n        <input type="number" value="' + (isFinite(this.before.maxDepth) ? this.before.maxDepth : "") + '" placeholder="max depth (&infin;)">\n        <datalist id="ui' + this.idPrefix + 'lineupHierarchyList">' + this.innerNodes.map(function (t) {
          return '<option value="' + t.path + '">' + t.label + "</option>";
        }) + "</datalist>");
        var e = this.innerNodePaths;
        this.findInput('input[type="text"]').addEventListener("change", function () {
          var t = this.value;
          e.indexOf(t) < 0 ? this.setCustomValidity("invalid node") : this.setCustomValidity("");
        }, {
          passive: !0
        });
      }, e.prototype.reset = function () {
        this.findInput('input[type="text"]').value = this.before.node.label, this.findInput('input[type="number"]').value = isFinite(this.before.maxDepth) ? String(this.before.maxDepth) : "", this.column.setCutOff(this.before);
      }, e.prototype.submit = function () {
        var t = this.findInput('input[type="text"]').value,
            e = this.innerNodePaths.indexOf(t),
            n = this.innerNodes[e],
            r = this.findInput('input[type="number"]').value,
            i = "" === r ? 1 / 0 : parseInt(r, 10);
        return this.column.setCutOff({
          node: n,
          maxDepth: i
        }), !0;
      }, e;
    }(o.c),
        D = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return i.column = e, i.idPrefix = r, i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = this.column.patternTemplates;
        t.insertAdjacentHTML("beforeend", '<strong>Edit Pattern (access via ${value}, ${item})</strong><input\n        type="text"\n        size="30"\n        value="' + this.column.getPattern() + '"\n        required\n        autofocus\n        placeholder="pattern (access via ${value}, ${item})"\n        ' + (e.length > 0 ? 'list="ui' + this.idPrefix + 'lineupPatternList"' : "") + "\n      >"), e.length > 0 && t.insertAdjacentHTML("beforeend", '<datalist id="ui' + this.idPrefix + 'lineupPatternList">' + e.map(function (t) {
          return '<option value="' + t + '">';
        }) + "</datalist>");
      }, e.prototype.reset = function () {
        this.node.querySelector("input").value = "", this.column.setPattern("");
      }, e.prototype.submit = function () {
        var t = this.node.querySelector("input").value;
        return this.column.setPattern(t), !0;
      }, e;
    }(o.c),
        R = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.column = e, i.ctx = r, i.summary = r.summaryRenderer(i.column, !0), i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.classList.add("lu-dialog-mapper"), t.insertAdjacentHTML("beforeend", this.summary.template);
        var e = t.lastElementChild;
        e.classList.add("lu-summary", "lu-renderer"), e.dataset.renderer = this.column.getSummaryRenderer(), e.dataset.interactive = "", t.appendChild(e), this.summary.update(this.node.querySelector(".lu-summary"), this.ctx.statsOf(this.column));
      }, e;
    }(o.c),
        w = n(3),
        A = function (t) {
      function e(e, n) {
        var r = t.call(this, n) || this;
        return r.column = e, r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = this,
            n = {
          getSortMethod: function getSortMethod() {
            return e.column.getReduce();
          },
          setSortMethod: function setSortMethod(t) {
            return e.column.setReduce(t);
          }
        };
        Object(f.b)(t, n, Object.keys(w.b), this.dialog.idPrefix);
      }, e;
    }(o.c),
        M = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.column = e, r.before = e.getScript(), r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.insertAdjacentHTML("beforeend", '<textarea autofocus="true" rows="5" autofocus="autofocus" style="width: 95%;">' + this.column.getScript() + "</textarea>");
      }, e.prototype.reset = function () {
        this.node.querySelector("textarea").value = this.before, this.column.setScript(this.before);
      }, e.prototype.submit = function () {
        return this.column.setScript(this.node.querySelector("textarea").value), !0;
      }, e;
    }(o.c),
        L = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.column = e, i.provider = r, i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = this,
            n = Object(a.k)(this.dialog.idPrefix);
        t.insertAdjacentHTML("beforeend", '<input type="text" size="20" value="" required autofocus placeholder="search... (>= 3 chars)"><div class="lu-checkbox"><input id="' + n + '" type="checkbox"><label for="' + n + '">Use regular expressions</label></div>');

        var r = t.querySelector('input[type="text"]'),
            i = t.querySelector('input[type="checkbox"]'),
            o = function o() {
          var t = r.value;
          t.length < 3 ? r.setCustomValidity("at least 3 characters") : (r.setCustomValidity(""), i.checked && (t = new RegExp(t)), e.provider.searchAndJump(t, e.column));
        };

        r.addEventListener("input", o, {
          passive: !0
        }), i.addEventListener("change", o, {
          passive: !0
        });
      }, e;
    }(o.c),
        j = n(20),
        x = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.column = e, r;
      }

      return Object(r.c)(e, t), e.prototype.updateFilter = function (t) {
        Object(f.c)(this.attachment, this.column, null != t && "" !== t), this.column.setFilter(t);
      }, e.prototype.reset = function () {
        this.findInput('input[type="text"]').value = "", this.forEach("input[type=checkbox]", function (t) {
          return t.checked = !1;
        }), this.updateFilter(null);
      }, e.prototype.submit = function () {
        if (Object(g.c)(this.node).checked) return this.updateFilter(j.d.FILTER_MISSING), !0;
        var t = this.findInput('input[type="text"]').value,
            e = this.findInput('input[type="checkbox"]').checked;
        return this.updateFilter(e ? new RegExp(t) : t), !0;
      }, e.prototype.build = function (t) {
        var e = this,
            n = this.column.getFilter() || "",
            r = n === j.d.FILTER_MISSING;
        r && (n = "");
        var i = Object(a.k)(this.dialog.idPrefix);
        t.insertAdjacentHTML("beforeend", '<input type="text" placeholder="Filter ' + this.column.desc.label + '..." autofocus value="' + (n instanceof RegExp ? n.source : n) + '" style="width: 100%">\n    <span class="lu-checkbox"><input id="' + i + '" type="checkbox" ' + (n instanceof RegExp ? 'checked="checked"' : "") + '><label for="' + i + '">Use regular expressions</label></span>\n    ' + Object(g.a)(r, this.dialog.idPrefix));

        var o = Object(g.c)(t),
            u = t.querySelector('input[type="text"]'),
            c = t.querySelector('input[type="checkbox"]'),
            s = function s() {
          if (u.disabled = o.checked, c.disabled = o.checked, o.checked) e.updateFilter(j.d.FILTER_MISSING);else {
            var t = u.value.trim();
            o.disabled = t.length > 0, t.length <= 0 ? e.updateFilter(null) : e.updateFilter(c.checked ? new RegExp(u.value, "gm") : u.value);
          }
        };

        o.onchange = s, u.onchange = s, c.onchange = s;
      }, e;
    }(o.c),
        S = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.column = e, r.weights = r.column.getWeights(), r;
      }

      return Object(r.c)(e, t), e.prototype.reset = function () {
        var t = this;
        Object(a.e)(this.node, "input[type=number]", function (e) {
          var n = Object(m.k)(100 / t.weights.length, 2);
          e.value = String(n), e.nextElementSibling.firstElementChild.style.width = n + "%";
        }), this.column.setWeights(this.weights.slice().fill(100 / this.weights.length));
      }, e.prototype.build = function (t) {
        t.classList.add("lu-filter-table", "lu-weights-table");
        var e = this.column.children;
        t.insertAdjacentHTML("beforeend", "<div>\n        " + this.weights.map(function (t, n) {
          return '<div><input type="number" value="' + Object(m.k)(100 * t, 2) + '" min="0" max="100" step="any"><span><span style="background-color: ' + Object(f.a)(e[n]) + "; width: " + Object(m.k)(100 * t, 2) + '%"></span></span>' + e[n].label + "</div>";
        }).join("") + "\n    </div>"), this.forEach("input[type=number]", function (t) {
          t.oninput = function () {
            t.nextElementSibling.firstElementChild.style.width = t.value + "%";
          };
        });
      }, e.prototype.submit = function () {
        var t = this.forEach("input[type=number]", function (t) {
          return parseFloat(t.value) / 100;
        });
        return this.column.setWeights(t), !0;
      }, e;
    }(o.c),
        I = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.column = e, i.ctx = r, i.addons = Nt(i.column, "group", r), i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        for (var e = 0, n = this.addons; e < n.length; e++) {
          var r = n[e];
          this.node.insertAdjacentHTML("beforeend", "<strong>" + r.title + "</strong>"), r.append(this.column, this.node, this.dialog, this.ctx);
        }

        !function (t, e, n) {
          var r = e.findMyRanker(),
              i = r.getGroupCriteria(),
              o = i.indexOf(e),
              u = o >= 0;
          o < 0 && (o = i.length);
          var c = Object(a.k)(n);
          t.insertAdjacentHTML("afterbegin", '\n        <strong>Group By</strong>\n        <div class="lu-checkbox"><input id="' + c + 'B" type="radio" name="grouped" value="true" ' + (u ? "checked" : "") + ' ><label for="' + c + 'B">Enabled</label></div>\n        <div class="lu-checkbox"><input id="' + c + 'N" type="radio" name="grouped" value="false" ' + (u ? "" : "checked") + ' ><label for="' + c + 'N">Disabled</label></div>\n        <strong>Group Priority</strong>\n        <input type="number" id="' + c + 'P" step="1" min="1" max="' + (i.length + 1) + '" value="' + (o + 1) + '">\n    ');

          var s = function s(e) {
            Object(a.e)(t, "input:not([name=grouped]), select, textarea", function (t) {
              t.disabled = e;
            });
          };

          s(!u);

          var l = function l() {
            r.groupBy(e, u ? o : -1), s(!u);
          };

          Object(a.e)(t, "input[name=grouped]", function (t) {
            t.addEventListener("change", function () {
              u = "true" === t.value, l();
            }, {
              passive: !0
            });
          });
          var p = t.querySelector("#" + c + "P");
          p.addEventListener("change", function () {
            o = parseInt(p.value, 10) - 1, l();
          }, {
            passive: !0
          });
        }(t, this.column, this.dialog.idPrefix);
      }, e;
    }(o.c);

    var V = function (t) {
      function e(e, n, r, i) {
        var o = t.call(this, r) || this;
        return o.column = e, o.group = n, o.ctx = i, o.addons = Nt(o.column, n ? "sortGroup" : "sort", i), o;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        for (var e = 0, n = this.addons; e < n.length; e++) {
          var r = n[e];
          this.node.insertAdjacentHTML("beforeend", "<strong>" + r.title + "</strong>"), r.append(this.column, this.node, this.dialog, this.ctx);
        }

        !function (t, e, n, r) {
          void 0 === r && (r = !1);
          var i = e.findMyRanker(),
              o = r ? i.getGroupSortCriteria() : i.getSortCriteria(),
              u = Object.assign({}, r ? e.isGroupSortedByMe() : e.isSortedByMe());
          void 0 === u.priority && (u.priority = o.length);
          var c = Object(a.k)(n);
          t.insertAdjacentHTML("afterbegin", '\n        <strong>Sort Order</strong>\n        <div class="lu-checkbox"><input id="' + c + 'B" type="radio" name="sortorder" value="asc"  ' + ("asc" === u.asc ? "checked" : "") + ' ><label for="' + c + 'B">Ascending</label></div>\n        <div class="lu-checkbox"><input id="' + c + 'D" type="radio" name="sortorder" value="desc"  ' + ("desc" === u.asc ? "checked" : "") + ' ><label for="' + c + 'D">Decending</label></div>\n        <div class="lu-checkbox"><input id="' + c + 'N" type="radio" name="sortorder" value="none"  ' + (void 0 === u.asc ? "checked" : "") + ' ><label for="' + c + 'N">Unsorted</label></div>\n        <strong>Sort Priority</strong>\n        <input type="number" id="' + c + 'P" step="1" min="1" max="' + (o.length + 1) + '" value="' + (u.priority + 1) + '">\n    ');

          var s = function s(e) {
            Object(a.e)(t, "input:not([name=sortorder]), select, textarea", function (t) {
              t.disabled = e;
            });
          };

          s(void 0 === u.asc);

          var l = function l() {
            r ? i.groupSortBy(e, "asc" === u.asc, void 0 === u.asc ? -1 : u.priority) : i.sortBy(e, "asc" === u.asc, void 0 === u.asc ? -1 : u.priority), s(void 0 === u.asc);
          };

          Object(a.e)(t, "input[name=sortorder]", function (t) {
            t.addEventListener("change", function () {
              u.asc = "none" === t.value ? void 0 : t.value, l();
            }, {
              passive: !0
            });
          });
          var p = t.querySelector("#" + c + "P");
          p.addEventListener("change", function () {
            u.priority = parseInt(p.value, 10) - 1, l();
          }, {
            passive: !0
          });
        }(t, this.column, this.dialog.idPrefix, this.group);
      }, e;
    }(o.c);

    var k = n(47);

    var H = Object(s.a)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"),
        P = Object(s.a)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"),
        G = Object(s.a)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"),
        F = Object(s.a)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"),
        U = Object(s.a)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"),
        B = Object(s.a)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"),
        Y = Object(s.a)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"),
        W = n(42),
        q = n(28),
        z = function (t) {
      function e(e, n) {
        var r = t.call(this, n) || this;
        return r.column = e, r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.classList.add("lu-dialog-color");
        var e = Object(a.k)("col"),
            n = this.column.getColorMapping(),
            r = "custom" === n.type ? n.entries : [],
            i = "";
        i += '<datalist id="' + e + 'L">' + l.map(function (t) {
          return "<option>" + t + '"</option>';
        }).join("") + "</datalist>", i += '<datalist id="' + e + 'LW"><option>#FFFFFF"</option>' + l.slice(0, -1).map(function (t) {
          return "<option>" + t + "</option>";
        }).join("") + "</datalist>", i += '<strong>Quantization</strong>\n    <div class="lu-checkbox">\n      <input id="' + e + 'KC" name="kind" type="radio" value="continuous" ' + ("quantized" !== n.type ? "checked" : "") + '>\n      <label for="' + e + 'CK">Continuous</label>\n    </div>\n    <div class="lu-checkbox">\n      <input id="' + e + 'KQ" name="kind" type="radio" value="quantized" ' + ("quantized" === n.type ? "checked" : "") + '>\n      <label for="' + e + 'KQ"><input type="number" id="' + e + 'KQS" min="2" step="1" value="' + ("quantized" === n.type ? n.steps : 5) + '">&nbsp; steps</label>\n    </div>', i += '<strong data-toggle="' + ("solid" === n.type ? "open" : "") + '">Solid Color</strong>', i += "<div>";

        for (var o = "solid" === n.type ? n.color : "", u = !1, s = 0, p = [l, H, P, G, F, U, B, Y]; s < p.length; s++) {
          var f = p[s];
          u = u || f.includes(o), i += '<div class="lu-color-line">\n          ' + f.map(function (t) {
            return '<div class="lu-checkbox-color">\n              <input id="' + e + Object(W.d)(t) + '" name="color" type="radio" value="' + t + '" ' + (t === o ? 'checked="checked"' : "") + '>\n              <label for="' + e + Object(W.d)(t) + '" style="background: ' + t + '"></label>\n            </div>';
          }).join("") + "\n        </div>";
        }

        i += '<div class="lu-checkbox"><input id="' + e + 'O" name="color" type="radio" value="custom:solid" ' + (o && !u ? 'checked="checked"' : "") + '>\n        <label for="' + e + 'O"><input type="color" name="solid" list="' + e + 'L" value="' + ("solid" === n.type ? n.color : c.d.DEFAULT_COLOR) + '" ' + (o && !u ? "" : "disabled") + "></label>\n      </div>", i += "</div>", i += '<strong data-toggle="' + ("sequential" === n.type || "custom" === n.type && 2 === r.length ? "open" : "") + '">Sequential Color</strong>', i += "<div>";

        for (var d = "sequential" === n.type ? n.name : "", h = 0, g = q.i; h < g.length; h++) {
          f = g[h];
          i += '<div class="lu-checkbox lu-color-gradient"><input id="' + e + f.name + '" name="color" type="radio" value="' + f.name + '" ' + (f.name === d ? 'checked="checked"' : "") + '>\n        <label for="' + e + f.name + '" data-c="' + f.name + '" style="background: ' + K(f.apply, 9) + '"></label>\n      </div>';
        }

        var b = 2 === r.length;
        i += '<div class="lu-checkbox lu-color-gradient">\n        <input id="' + e + 'S" name="color" type="radio" value="custom:sequential" ' + (b ? "checked" : "") + '>\n        <label for="' + e + 'S" class="lu-color-custom">\n          <input type="color" name="interpolate0" list="' + e + 'LW" ' + (b ? 'value="' + r[0].color + '"' : "disabled") + '>\n          <input type="color" name="interpolate1" list="' + e + 'LW" ' + (b ? 'value="' + r[r.length - 1].color + '"' : "disabled") + ">\n        </label>\n      </div>", i += "</div>", i += '<strong data-toggle="' + ("divergent" === n.type || "custom" === n.type && 3 === r.length ? "open" : "") + '">Diverging Color</strong>', i += "<div>";
        d = "sequential" === n.type ? n.name : "";

        for (var m = 0, y = q.f; m < y.length; m++) {
          f = y[m];
          i += '<div class="lu-checkbox lu-color-gradient"><input id="' + e + f.name + '" name="color" type="radio" value="' + f.name + '" ' + (f.name === d ? 'checked="checked"' : "") + '>\n        <label for="' + e + f.name + '" data-c="' + f.name + '" style="background: ' + K(f.apply, 11) + '"></label>\n      </div>';
        }

        b = 3 === r.length;
        i += '<div class="lu-checkbox lu-color-gradient"><input id="' + e + 'D" name="color" type="radio" value="custom:divergent" ' + (b ? "checked" : "") + '>\n        <label for="' + e + 'D" class="lu-color-custom">\n          <input type="color" name="divergingm1" list="' + e + 'L" ' + (b ? 'value="' + r[0].color + '"' : "disabled") + '>\n          <input type="color" name="diverging0" list="' + e + 'LW" ' + (b ? 'value="' + r[1].color + '"' : "disabled") + '>\n          <input type="color" name="diverging1" list="' + e + 'L" ' + (b ? 'value="' + r[2].color + '"' : "disabled") + ">\n          </label>\n      </div>", i += "</div>", t.insertAdjacentHTML("beforeend", i), this.interactive(t, e);
      }, e.prototype.interactive = function (t, e) {
        var n = this,
            r = this.findInput("#" + e + "KC"),
            i = this.findInput("#" + e + "KQ"),
            o = this.findInput("#" + e + "KQS"),
            a = Array.from(t.querySelectorAll("strong[data-toggle]"));
        r.onchange = function () {
          r.checked && n.updateGradients(-1);
        }, i.onchange = o.onchange = function () {
          i.checked ? ("open" === a[0].dataset.toggle && (a[0].dataset.toggle = "", a[1].dataset.toggle = "open"), n.updateGradients(parseInt(o.value, 10))) : n.updateGradients(-1);
        };

        for (var u = function u(t) {
          t.onclick = function (e) {
            e.preventDefault(), e.stopPropagation();

            for (var n = 0, r = a; n < r.length; n++) {
              var i = r[n];
              i.dataset.toggle = "open" === i.dataset.toggle || t !== i ? "" : "open";
            }
          };
        }, c = 0, s = a; c < s.length; c++) {
          u(s[c]);
        }

        var l = [];
        this.forEach("input[name=color]", function (e) {
          e.value.startsWith("custom:") && l.push(e), e.onchange = function () {
            if (e.checked) {
              for (var r = function r(t) {
                Array.from(t.nextElementSibling.querySelectorAll("input")).forEach(function (n) {
                  return n.disabled = t !== e;
                });
              }, a = 0, u = l; a < u.length; a++) {
                r(u[a]);
              }

              var c = function (e) {
                switch (e.value) {
                  case "custom:solid":
                    return Object(q.d)(t.querySelector("input[name=solid]").value);

                  case "custom:sequential":
                    var n = t.querySelector("input[name=interpolate0]").value,
                        r = t.querySelector("input[name=interpolate1]").value;
                    return new q.a([{
                      color: n,
                      value: 0
                    }, {
                      color: r,
                      value: 1
                    }]);

                  case "custom:diverging":
                    var i = t.querySelector("input[name=divergentm1]").value,
                        o = t.querySelector("input[name=divergent0]").value,
                        a = t.querySelector("input[name=divergent1]").value;
                    return new q.a([{
                      color: i,
                      value: 0
                    }, {
                      color: o,
                      value: .5
                    }, {
                      color: a,
                      value: 1
                    }]);
                }

                return Object(q.e)(e.value);
              }(e);

              i.checked && "solid" !== c.type ? n.column.setColorMapping(new q.c(c, parseInt(o.value, 10))) : n.column.setColorMapping(c);
            }
          };
        }), this.forEach("label > input[type=color]", function (t) {
          t.onchange = function () {
            var e = t.parentElement.previousElementSibling;
            e.onchange.call(e, null);
          };
        });
      }, e.prototype.updateGradients = function (t) {
        this.forEach("label[data-c]", function (e) {
          var n = q.g.get(e.dataset.c);
          e.style.background = t < 0 ? K(n.apply, "sequential" === n.type ? 9 : 11) : function (t, e) {
            void 0 === e && (e = 2);
            if (1 === e) return "" + t(0);

            for (var n = "linear-gradient(to right", r = 1 / e, i = r / 2, o = 0; o < e; ++o) {
              var a = t(o * r + (0 === o ? 0 : o === e - 1 ? r : i));
              n += ", " + a + " " + Object(m.k)(o * r * 100, 2) + "%, " + a + " " + Object(m.k)((o + 1) * r * 100, 2) + "%";
            }

            return n += ")";
          }(n.apply, t);
        });
      }, e;
    }(o.c);

    function K(t, e) {
      if (void 0 === e && (e = 2), e <= 1) return "" + t(0);

      for (var n = 1 / (e - 1), r = "linear-gradient(to right", i = 0; i < e; ++i) {
        r += ", " + t(i * n) + " " + Object(m.k)(i * n * 100, 2) + "%";
      }

      return r += ")";
    }

    var X = n(17),
        $ = n(7),
        J = n(79);

    function Z(t) {
      return Math.max(Math.min(t, 100), 0);
    }

    var Q = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.line = e, i.adapter = r, i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        var e = this,
            n = this.adapter.domain();
        t.insertAdjacentHTML("beforeend", '\n        <strong>Input Domain Value (min ... max)</strong>\n        <input type="number" value="' + Object(m.k)(this.adapter.unnormalizeRaw(this.line.domain), 3) + '" ' + (this.line.frozen ? "readonly" : "") + ' autofocus required min="' + n[0] + '" max="' + n[1] + '" step="any">\n        <strong>Output Normalized Value (0 ... 1)</strong>\n        <input type="number" value="' + Object(m.k)(this.line.range / 100, 3) + '" required min="0" max="1" step="any">\n        <button type="button" ' + (this.line.frozen ? "disabled" : "") + " >Remove Mapping Line</button>\n      "), this.forEach("input", function (t) {
          return t.onchange = function () {
            return e.submit();
          };
        }), this.find("button").addEventListener("click", function () {
          e.destroy(), e.line.destroy();
        }, {
          passive: !0
        });
      }, e.prototype.submit = function () {
        if (!this.node.checkValidity()) return !1;
        var t = this.adapter.normalizeRaw(parseFloat(this.findInput("input[type=number]").value)),
            e = 100 * parseFloat(this.findInput("input[type=number]:last-of-type").value);
        return this.line.update(t, e), !0;
      }, e;
    }(o.c),
        tt = function () {
      function t(t, e, n, i) {
        var o = this;
        this.domain = e, this.range = n, this.adapter = i, t.insertAdjacentHTML("beforeend", '<g class="lu-mapping" transform="translate(' + e + ',0)">\n      <line x1="0" x2="' + (n - e) + '" y2="60"></line>\n      <line x1="0" x2="' + (n - e) + '" y2="60"></line>\n      <circle r="3"></circle>\n      <circle cx="' + (n - e) + '" cy="60" r="3"></circle>\n      <title>Drag the anchor circle to change the mapping, shift click to edit</title>\n    </g>'), this.node = t.lastElementChild, this.node.classList.toggle("lu-frozen", Object(m.l)(0, e) || Object(m.l)(e, 100));

        var a,
            u,
            c,
            s,
            l = function l(e) {
          return 100 * e / t.getBoundingClientRect().width;
        },
            p = {
          container: t.parentElement,
          filter: function filter(t) {
            return 0 === t.button && !t.shiftKey;
          },
          onStart: function onStart(t, e) {
            a = o.domain, u = o.range;
            var n = l(e);
            c = o.domain - n, s = o.range - n;
          },
          onEnd: function onEnd() {
            Object(m.l)(a, o.domain) && Object(m.l)(u, o.range) || o.adapter.updated(o);
          }
        },
            f = this.node.querySelector("line:first-of-type");

        Object(J.a)(f, Object(r.a)(Object(r.a)({}, p), {
          onDrag: function onDrag(t, e) {
            var n = l(e);
            o.update(Z(n + c), Z(n + s));
          }
        }));
        var d = this.node.querySelector("circle:first-of-type");
        Object(J.a)(d, Object(r.a)(Object(r.a)({}, p), {
          onDrag: function onDrag(t, e) {
            var n = l(e);
            o.update(Z(n), o.range);
          }
        }));
        var h = this.node.querySelector("circle:last-of-type");
        Object(J.a)(h, Object(r.a)(Object(r.a)({}, p), {
          onDrag: function onDrag(t, e) {
            var n = l(e);
            o.update(o.domain, Z(n));
          }
        })), this.node.onclick = function (t) {
          if (t.shiftKey) {
            var e = {
              manager: o.adapter.dialog.manager,
              level: o.adapter.dialog.level + 1,
              attachment: o.node,
              idPrefix: o.adapter.dialog.idPrefix
            };
            new Q(o, e, o.adapter).open();
          }
        };
      }

      return Object.defineProperty(t.prototype, "frozen", {
        get: function get() {
          return this.node.classList.contains("lu-frozen");
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.destroy = function () {
        this.node.remove(), this.adapter.destroyed(this);
      }, t.prototype.update = function (t, e) {
        if (!Object(m.l)(t, this.domain) || !Object(m.l)(e, this.range)) {
          this.frozen && (t = this.domain), this.domain = t, this.range = e, this.node.setAttribute("transform", "translate(" + t + ",0)");
          var n = e - t;
          Array.from(this.node.querySelectorAll("line")).forEach(function (t) {
            return t.setAttribute("x2", String(n));
          }), this.node.querySelector("circle[cx]").setAttribute("cx", String(n));
        }
      }, t;
    }(),
        et = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n, {
          fullDialog: !0
        }) || this;
        i.column = e, i.mappingLines = [], i.loadedData = null, i.mappingAdapter = {
          destroyed: function destroyed(t) {
            i.mappingLines.splice(i.mappingLines.indexOf(t), 1);
          },
          updated: function updated() {
            return i.updateLines(i.computeScale());
          },
          domain: function domain() {
            return i.rawDomain;
          },
          normalizeRaw: i.normalizeRaw.bind(i),
          unnormalizeRaw: i.unnormalizeRaw.bind(i),
          dialog: i.dialog
        }, i.idPrefix = "me" + r.idPrefix, i.scale = i.column.getMapping().clone();
        var o = i.scale.domain;
        return i.rawDomain = [o[0], o[o.length - 1]], i.data = Promise.resolve(r.provider.mappingSample(e)), i;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "scaleType", {
        get: function get() {
          if (!(this.scale instanceof X.a)) return "script";
          var t = this.scale.scaleType;
          if ("linear" !== t) return t;
          var e = this.scale.range;
          return 2 === e.length && 1 === e[0] && 0 === e[1] ? "linear_invert" : 3 === e.length && 1 === e[0] && 0 === e[1] && 1 === e[2] ? "linear_abs" : "linear";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.build = function (t) {
        var e = this;
        t.classList.add("lu-dialog-mapper");
        var n = this.column.findMyRanker(),
            r = n ? n.flatColumns.filter(function (t) {
          return Object(X.d)(t) && t !== e.column;
        }) : [];
        t.insertAdjacentHTML("beforeend", '\n        <div><label for="' + this.idPrefix + 'mapping_type"><strong>Normalization Scaling:</strong></label><select id="' + this.idPrefix + 'mapping_type" class="browser-default">\n        <option value="linear">Linear</option>\n        <option value="linear_invert">Invert</option>\n        <option value="linear_abs">Absolute</option>\n        <option value="log">Log</option>\n        <option value="pow1.1">Pow 1.1</option>\n        <option value="pow2">Pow 2</option>\n        <option value="pow3">Pow 3</option>\n        <option value="sqrt">Sqrt</option>\n        <option value="script">Custom Script</option>\n        ' + (r.length > 0 ? '<optgroup label="Copy From">' + r.map(function (t) {
          return '<option value="copy_' + t.id + '">' + t.label + "</option>";
        }).join("") + "</optgroup>" : "") + '\n      </select>\n      </div>\n        <div class="lu-details"><strong>Domain (min - max): </strong><input id="' + this.idPrefix + 'min" required type="number" value="' + Object(m.k)(this.rawDomain[0], 3) + '" step="any"> - <input id="' + this.idPrefix + 'max" required type="number" value="' + Object(m.k)(this.rawDomain[1], 3) + '" step="any"></div>\n        <strong class="lu-details" style="text-align: center">Input Domain (min - max)</strong>\n        <svg class="lu-details" viewBox="0 0 106 66">\n           <g transform="translate(3,3)">\n              <line x2="100"></line>\n              <rect y="-3" width="100" height="10"></rect>\n              <line y1="60" x2="100" y2="60"></line>\n              <rect y="36" width="100" height="10"></rect>\n           </g>\n        </svg>\n        <strong class="lu-details" style="text-align: center; margin-top: 0">Output Normalized Domain (0 - 1)</strong>\n        <div class="lu-script">\n          <strong>Custom Normalization Script</strong>\n          <textarea></textarea>\n        </div>');
        var i = t.querySelector(".lu-details > g");
        this.forEach(".lu-details rect", function (t) {
          return t.onclick = function (n) {
            n.preventDefault(), n.stopPropagation();
            var r = t.getBoundingClientRect(),
                o = Object(m.k)(100 * (n.x - r.left) / r.width, 2),
                a = new tt(i, o, o, e.mappingAdapter);
            e.mappingLines.push(a);
          };
        });
        var o = this.find("select"),
            a = this.find("textarea");

        o.onchange = function (n) {
          var r = n.currentTarget;

          switch (r.value) {
            case "linear_invert":
              e.scale = new X.a(e.rawDomain.slice(), "linear", [1, 0]);
              break;

            case "linear_abs":
              e.scale = new X.a([e.rawDomain[0], (e.rawDomain[1] - e.rawDomain[0]) / 2, e.rawDomain[1]], "linear", [1, 0, 1]);
              break;

            case "script":
              var i = new X.b(e.rawDomain.slice());
              e.scale = i, a.value = i.code;
              break;

            default:
              if (r.value.startsWith("copy_")) return void e.copyMapping(r.value.slice("copy_".length));
              e.scale = new X.a(e.rawDomain.slice(), r.value);
          }

          e.createMappings(), t.dataset.scale = r.value, e.updateLines();
        };

        var u = t.dataset.scale = this.scaleType;
        o.selectedIndex = Array.from(o.options).findIndex(function (t) {
          return t.value === u;
        }), "script" === u && (a.value = this.scale.code), this.createMappings(), this.forEach(".lu-details input[type=number]", function (t, n) {
          return t.onchange = function () {
            var r = parseFloat(t.value);

            if (r !== e.rawDomain[n]) {
              var i = e.rawDomain[1 - n];
              isNaN(r) || 0 === n && r >= i || 1 === n && r <= i ? t.setCustomValidity("value has to be " + (0 === n ? "<= max" : ">= min")) : (t.setCustomValidity(""), e.rawDomain[n] = r, e.scale.domain = e.rawDomain.slice(), e.loadedData && (e.applyMapping(e.scale), e.updateLines()));
            } else t.setCustomValidity("");
          };
        }), this.data.then(function (t) {
          e.loadedData = t, Array.from(t).forEach(function (t) {
            Object($.c)(t) || i.insertAdjacentHTML("afterbegin", '<line data-v="' + t + '" x1="' + Object(m.k)(e.normalizeRaw(t), 2) + '" x2="' + Object(m.k)(100 * e.scale.apply(t), 2) + '" y2="60"></line>');
          });
        });
      }, e.prototype.createMappings = function () {
        var t,
            e = this;

        if (this.mappingLines.splice(0, this.mappingLines.length).forEach(function (t) {
          return t.destroy();
        }), this.scale instanceof X.a) {
          var n = this.node.querySelector(".lu-details > g"),
              r = this.scale.domain,
              i = this.scale.range;
          (t = this.mappingLines).push.apply(t, r.map(function (t, r) {
            return new tt(n, e.normalizeRaw(t), 100 * i[r], e.mappingAdapter);
          }));
        }
      }, e.prototype.update = function () {
        var t = this.node.dataset.scale = this.scaleType,
            e = this.find("select");
        e.selectedIndex = Array.from(e.options).findIndex(function (e) {
          return e.value === t;
        }), "script" === t && (this.find("textarea").value = this.scale.code);
        var n = this.scale.domain;
        this.forEach(".lu-details input[type=number]", function (t, e) {
          t.value = String(n[e]);
        });
      }, e.prototype.updateLines = function (t) {
        var e = this;
        void 0 === t && (t = this.scale), this.forEach(".lu-details > g > line[x1]", function (n) {
          var r = parseFloat(n.getAttribute("data-v"));
          n.setAttribute("x1", Object(m.k)(e.normalizeRaw(r), 2).toString()), n.setAttribute("x2", Object(m.k)(100 * t.apply(r), 2).toString());
        });
      }, e.prototype.applyMapping = function (t) {
        this.column.setMapping(t);
      }, e.prototype.reset = function () {
        this.scale = this.column.getOriginalMapping(), this.rawDomain = this.scale.domain.slice(), this.applyMapping(this.scale), this.update(), this.updateLines(), this.createMappings();
      }, e.prototype.copyMapping = function (t) {
        var e = this.column.findMyRanker();

        if (e) {
          var n = e.find(t);
          this.scale = n.getMapping().clone(), this.rawDomain = this.scale.domain.slice(), this.applyMapping(this.scale), this.update(), this.updateLines();
        }
      }, e.prototype.normalizeRaw = function (t) {
        var e = 100 * (t - this.rawDomain[0]) / (this.rawDomain[1] - this.rawDomain[0]);
        return Math.max(Math.min(e, 100), 0);
      }, e.prototype.unnormalizeRaw = function (t) {
        return t * (this.rawDomain[1] - this.rawDomain[0]) / 100 + this.rawDomain[0];
      }, e.prototype.computeScale = function () {
        var t = this,
            e = this.scale.clone();
        return "script" === this.scaleType && (e.code = this.node.querySelector("textarea").value, e.domain = this.rawDomain.slice()), e instanceof X.a && (this.mappingLines.sort(function (t, e) {
          return t.domain - e.domain;
        }), e.domain = this.mappingLines.map(function (e) {
          return t.unnormalizeRaw(e.domain);
        }), e.range = this.mappingLines.map(function (t) {
          return t.range / 100;
        })), e;
      }, e.prototype.submit = function () {
        var t = this;
        return !!this.node.checkValidity() && ("script" === this.scaleType && (this.scale.code = this.node.querySelector("textarea").value, this.scale.domain = this.rawDomain.slice()), this.scale instanceof X.a && (this.mappingLines.sort(function (t, e) {
          return t.domain - e.domain;
        }), this.scale.domain = this.mappingLines.map(function (e) {
          return t.unnormalizeRaw(e.domain);
        }), this.scale.range = this.mappingLines.map(function (t) {
          return t.range / 100;
        })), this.applyMapping(this.scale), !0);
      }, e;
    }(o.c),
        nt = n(23),
        rt = function (t) {
      function e(e, n) {
        var r = t.call(this, n) || this;
        return r.column = e, r;
      }

      return Object(r.c)(e, t), e.prototype.updateFilter = function (t) {
        Object(f.c)(this.attachment, this.column, null != t && !Object(w.i)(t)), this.column.setFilter(null != t ? t : void 0);
      }, e.prototype.reset = function () {
        this.forEach("input[type=date]", function (t) {
          return t.value = "";
        }), this.forEach("input[type=checkbox]", function (t) {
          return t.checked = !1;
        }), this.updateFilter(null);
      }, e.prototype.submit = function () {
        var t = Object(g.c)(this.node).checked,
            e = this.findInput('input[name="from"]').valueAsDate,
            n = this.findInput('input[name="to"]').valueAsDate;
        return this.updateFilter({
          filterMissing: t,
          min: null == e ? -1 / 0 : e.getTime(),
          max: null == n ? 1 / 0 : n.getTime()
        }), !0;
      }, e.prototype.build = function (t) {
        var e = this,
            n = this.column.getFilter() || Object(w.n)(),
            r = Object(a.k)(this.dialog.idPrefix),
            i = Object(nt.a)("%Y-%m-%d");
        t.insertAdjacentHTML("beforeend", '\n    <label for="' + r + 'F">From: </label>\n    <input type="date" id="' + r + 'F" name="from" placeholder="From..." autofocus value="' + (isFinite(n.min) ? i(new Date(n.min)) : "") + '">\n    <label for="' + r + 'T">To: </label>\n    <input type="date" id="' + r + 'T" name="to" placeholder="To..." value="' + (isFinite(n.max) ? i(new Date(n.max)) : "") + '">\n    ' + Object(g.a)(n.filterMissing, this.dialog.idPrefix));

        var o = function o() {
          e.submit();
        };

        this.forEach("input", function (t) {
          return t.onchange = o;
        });
      }, e;
    }(o.c);

    function it(t, e, n) {
      return void 0 === n && (n = {}), {
        title: t,
        onClick: e,
        options: n
      };
    }

    function ot(t, e, n) {
      return {
        attachment: n.currentTarget,
        level: e,
        manager: t.dialogManager,
        idPrefix: t.idPrefix
      };
    }

    function at(t, e, n, i) {
      return void 0 === n && (n = function n() {
        return [];
      }), void 0 === i && (i = {}), {
        title: t,
        onClick: function onClick(t, i, o, a) {
          new (e.bind.apply(e, Object(r.d)([void 0, t, ot(o, a, i)], n(o))))().open();
        },
        options: i
      };
    }

    function ut(t) {
      return t = t.sort(function (t, e) {
        return t.toLowerCase().localeCompare(e.toLowerCase());
      }), {
        title: "Sort By",
        order: 2,
        append: function append(e, n, r) {
          Object(f.b)(n, e, t, r.idPrefix);
        }
      };
    }

    n.d(e, "a", function () {
      return ot;
    }), n.d(e, "g", function () {
      return vt;
    }), n.d(e, "b", function () {
      return Tt;
    }), n.d(e, "c", function () {
      return Nt;
    }), n.d(e, "f", function () {
      return Dt;
    }), n.d(e, "d", function () {
      return Rt;
    }), n.d(e, "e", function () {
      return wt;
    });
    var ct = {
      title: "Sort",
      onClick: function onClick(t, e, n, r) {
        if (n.dialogManager.removeAboveLevel(r), e.ctrlKey) {
          var o = t.findMyRanker(),
              a = o.getSortCriteria(),
              u = t.isSortedByMe(),
              c = Object(i.k)(t);

          if (void 0 !== u.priority) {
            var s = void 0;
            s = c ? u.asc ? "desc" : void 0 : u.asc ? void 0 : "asc", o.sortBy(t, "asc" === s, s ? u.priority : -1);
          } else o.sortBy(t, c, a.length);
        } else t.toggleMySorting();
      },
      options: {
        shortcut: "only",
        order: 1,
        featureCategory: "ranking",
        featureLevel: "basic"
      }
    },
        st = {
      title: "Sort By &hellip;",
      onClick: function onClick(t, e, n, r) {
        new V(t, !1, ot(n, r, e), n).open();
      },
      options: {
        shortcut: !1,
        order: 1,
        featureCategory: "ranking",
        featureLevel: "advanced"
      }
    },
        lt = {
      title: "Sort Groups By &hellip;",
      onClick: function onClick(t, e, n, r) {
        new V(t, !0, ot(n, r, e), n).open();
      },
      options: {
        shortcut: !1,
        order: 3,
        featureCategory: "ranking",
        featureLevel: "advanced"
      }
    },
        pt = {
      title: "Rename &hellip;",
      onClick: function onClick(t, e, n, r) {
        new p(t, ot(n, r, e)).open();
      },
      options: {
        order: 4,
        featureCategory: "ui",
        featureLevel: "advanced"
      }
    },
        ft = {
      title: "Visualization &hellip;",
      onClick: function onClick(t, e, n, r) {
        new u(t, ot(n, r, e), n).open();
      },
      options: {
        featureCategory: "ui",
        featureLevel: "advanced"
      }
    },
        dt = {
      title: "Clone",
      onClick: function onClick(t, e, n) {
        n.dialogManager.removeAll(), n.provider.takeSnapshot(t);
      },
      options: {
        order: 80,
        featureCategory: "model",
        featureLevel: "advanced"
      }
    },
        ht = {
      title: "Remove",
      onClick: function onClick(t, e, n) {
        n.dialogManager.removeAll();
        var r = t.findMyRanker();
        r.children.every(function (e) {
          return Object(i.l)(e) || e.fixed || e === t;
        }) ? (n.provider.removeRanking(r), n.provider.ensureOneRanking()) : t.removeMe();
      },
      options: {
        order: 90,
        featureCategory: "model",
        featureLevel: "advanced"
      }
    },
        gt = it("Group", function (t, e, n, r) {
      if (n.dialogManager.removeAboveLevel(r), e.ctrlKey) {
        var i = t.findMyRanker(),
            o = i.getGroupCriteria(),
            a = o.indexOf(t);
        i.groupBy(t, a >= 0 ? -1 : o.length);
      } else t.groupByMe();
    }, {
      shortcut: "only",
      order: 2,
      featureCategory: "ranking",
      featureLevel: "basic"
    }),
        bt = it("Group By &hellip;", function (t, e, n, r) {
      new I(t, ot(n, r, e), n).open();
    }, {
      shortcut: !1,
      order: 2,
      featureCategory: "ranking",
      featureLevel: "advanced"
    }),
        mt = it("Compress", function (t, e, n, r) {
      n.dialogManager.removeAboveLevel(r);
      var i = t;
      i.setCollapsed(!i.getCollapsed()), e.currentTarget.title = i.getCollapsed() ? "Expand" : "Compress";
    }, {
      featureCategory: "model",
      featureLevel: "advanced"
    }),
        yt = {
      sortNumber: ut(Object.keys(w.b)),
      sortNumbers: ut(Object.keys(w.b)),
      sortBoxPlot: ut(Object.keys(w.c)),
      sortDates: ut(Object.keys(k.a)),
      sortGroup: ut(["count", "name"]),
      groupNumber: {
        title: "Split",
        order: 2,
        append: function append(t, e, n) {
          var r = t.getMapping().domain,
              i = t.getGroupThresholds(),
              o = i.length <= 1,
              u = t.findMyRanker();
          e.insertAdjacentHTML("beforeend", '\n    <div class="lu-checkbox">\n      <input type="radio" name="threshold" value="threshold" id="' + n.idPrefix + 'T1" ' + (o ? "checked" : "") + '>\n      <label for="' + n.idPrefix + 'T1">at&nbsp;<input type="number" size="10" id="' + n.idPrefix + 'N1" value="' + (i.length > 0 ? i[0] : Object(m.k)((r[1] - r[0]) / 2, 2)) + '"\n          required min="' + r[0] + '" max="' + r[1] + '" step="any" ' + (o ? "" : "disabled") + '>\n      </label>\n    </div>\n    <div class="lu-checkbox">\n      <input type="radio" name="threshold" value="bins" id="' + n.idPrefix + 'T2" ' + (o ? "" : "checked") + '>\n      <label for="' + n.idPrefix + 'T2"> in&nbsp;<input type="number" size="5" id="' + n.idPrefix + 'N2" value="' + (i.length > 1 ? i.length : Object(m.j)(u.getOrder().length)) + '"\n          required min="2" step="1" ' + (o ? "disabled" : "") + ">&nbsp;bins\n      </label>\n    </div>\n  ");

          var c = e.querySelector("#" + n.idPrefix + "N1"),
              s = e.querySelector("#" + n.idPrefix + "N2"),
              l = function l() {
            if (c.disabled = !o, s.disabled = o, o) t.setGroupThresholds([parseFloat(c.value)]);else {
              for (var e = parseInt(s.value, 10), n = (r[1] - r[0]) / e, i = r[0] + n, a = [i], u = 1; u < e - 1; ++u) {
                i += n, a.push(i);
              }

              t.setGroupThresholds(a);
            }
          };

          c.addEventListener("change", l, {
            passive: !0
          }), s.addEventListener("change", l, {
            passive: !0
          }), Object(a.e)(e, "input[name=threshold]", function (t) {
            t.addEventListener("change", function () {
              o = "threshold" === t.value, l();
            }, {
              passive: !0
            });
          });
        }
      },
      groupString: {
        title: "Groups",
        order: 2,
        append: function append(t, e, n) {
          var r = t.getGroupCriteria(),
              i = r.length > 0 && r[0] instanceof RegExp;
          e.insertAdjacentHTML("beforeend", '\n    <div class="lu-checkbox">\n      <input type="radio" name="regex" value="startsWith" id="' + n.idPrefix + 'RW" ' + (i ? "" : "checked") + '>\n      <label for="' + n.idPrefix + 'RW">Text starts with &hellip;</label>\n    </div>\n    <div class="lu-checkbox">\n      <input type="radio" name="regex" value="regex" id="' + n.idPrefix + 'RE" ' + (i ? "checked" : "") + '>\n      <label for="' + n.idPrefix + 'RE">Use regular expressions</label>\n    </div>\n    <textarea required rows="5" placeholder="e.g. Test,a.*" id="' + n.idPrefix + 'T">' + r.map(function (t) {
            return "string" == typeof t ? t : t.source;
          }).join("\n") + '</textarea>\n    <button id="' + n.idPrefix + 'A">Apply</button>\n  ');
          var o = e.querySelector("#" + n.idPrefix + "A"),
              a = e.querySelector("#" + n.idPrefix + "RE"),
              u = e.querySelector("#" + n.idPrefix + "T");

          o.onclick = function (e) {
            e.preventDefault(), e.stopPropagation();
            var n = u.value.trim().split("\n").map(function (t) {
              return t.trim();
            }).filter(function (t) {
              return t.length > 0;
            }),
                r = 0 === n.length;
            u.setCustomValidity(r ? "At least one group is required" : ""), r ? u.reportValidity() : (a.checked && (n = n.map(function (t) {
              return new RegExp(t.toString(), "gm");
            })), t.setGroupCriteria(n));
          };
        }
      },
      groupDate: {
        title: "Granularity",
        order: 2,
        append: function append(t, e, n) {
          for (var r = t.getDateGrouper(), i = r.granularity, o = r.circular, u = "", c = 0, s = ["century", "decade", "year", "month", "week", "day_of_week", "day_of_month", "day_of_year", "hour", "minute", "second"]; c < s.length; c++) {
            var l = s[c];
            u += '<div class="lu-checkbox">\n    <input type="radio" name="granularity" value="' + l + '" id="' + n.idPrefix + "D" + l + '" ' + (i === l ? "checked" : "") + '>\n    <label for="' + n.idPrefix + "D" + l + '"> by ' + l + "\n    </label>\n  </div>";
          }

          u += '<div class="lu-checkbox">\n    <input type="checkbox" name="circular" id="' + n.idPrefix + 'DC" ' + (o ? "checked" : "") + '>\n    <label for="' + n.idPrefix + 'DC"> Circular\n    </label>\n  </div>', e.insertAdjacentHTML("beforeend", u);

          var p = function p() {
            t.setDateGrouper({
              granularity: i,
              circular: o
            });
          };

          e.querySelector("#" + n.idPrefix + "DC").addEventListener("change", function (t) {
            o = t.currentTarget.checked, p();
          }, {
            passive: !0
          }), Object(a.e)(e, "input[name=granularity]", function (t) {
            t.addEventListener("change", function () {
              i = t.value, p();
            }, {
              passive: !0
            });
          });
        }
      }
    },
        vt = Object.assign({
      group: gt,
      groupBy: bt,
      collapse: mt,
      sort: ct,
      sortBy: st,
      sortGroupBy: lt,
      clone: dt,
      remove: ht,
      rename: pt,
      search: at("Search &hellip;", L, function (t) {
        return [t.provider];
      }, {
        shortcut: !0,
        order: 3,
        featureCategory: "ranking",
        featureLevel: "basic"
      }),
      filterNumber: at("Filter &hellip;", R, function (t) {
        return [t];
      }, {
        shortcut: !0,
        featureCategory: "ranking",
        featureLevel: "basic"
      }),
      filterDate: at("Filter &hellip;", rt, function (t) {
        return [t];
      }, {
        shortcut: !0,
        featureCategory: "ranking",
        featureLevel: "basic"
      }),
      filterString: at("Filter &hellip;", x, function () {
        return [];
      }, {
        shortcut: !0,
        featureCategory: "ranking",
        featureLevel: "basic"
      }),
      filterCategorical: at("Filter &hellip;", b, function () {
        return [];
      }, {
        shortcut: !0,
        featureCategory: "ranking",
        featureLevel: "basic"
      }),
      filterOrdinal: at("Filter &hellip;", y, function () {
        return [];
      }, {
        shortcut: !0,
        featureCategory: "ranking",
        featureLevel: "basic"
      }),
      filterBoolean: at("Filter &hellip;", d, function () {
        return [];
      }, {
        shortcut: !0,
        featureCategory: "ranking",
        featureLevel: "basic"
      }),
      colorMapped: at("Color Mapping &hellip;", z, function () {
        return [];
      }, {
        shortcut: !1,
        featureCategory: "ui",
        featureLevel: "advanced"
      }),
      script: at("Edit Combine Script &hellip;", M, function () {
        return [];
      }, {
        shortcut: !0,
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      reduce: at("Reduce by &hellip;", A, function () {
        return [];
      }, {
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      cutoff: at("Set Cut Off &hellip;", N, function (t) {
        return [t.idPrefix];
      }, {
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      editMapping: at("Data Mapping &hellip;", et, function (t) {
        return [t];
      }, {
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      editPattern: at("Edit Pattern &hellip;", D, function (t) {
        return [t.idPrefix];
      }, {
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      editWeights: at("Edit Weights &hellip;", S, function () {
        return [];
      }, {
        shortcut: !0,
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      compositeContained: at("Contained Columns &hellip;", _, function (t) {
        return [t];
      }, {
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      splitCombined: it("Split Combined Column", function (t, e, n, r) {
        n.dialogManager.removeAboveLevel(r), t.children.reverse().forEach(function (e) {
          return t.insertAfterMe(e);
        }), t.removeMe();
      }, {
        featureCategory: "model",
        featureLevel: "advanced"
      }),
      invertSelection: it("Invert Selection", function (t, e, n, r) {
        n.dialogManager.removeAboveLevel(r - 1);
        var i = n.provider.getSelection(),
            o = t.findMyRanker().getOrder();

        if (0 !== i.length) {
          var a = new Set(i),
              u = o.filter(function (t) {
            return !a.has(t);
          });
          n.provider.setSelection(u);
        } else n.provider.setSelection(o);
      }, {
        featureCategory: "model",
        featureLevel: "advanced"
      })
    }, yt);

    function Et(t, e) {
      return t.options.order === e.options.order ? t.title.localeCompare(e.title) : (t.options.order || 50) - (e.options.order || 50);
    }

    var Ot = new Map(),
        Ct = new Map();

    function _t(t, e) {
      if (Ot.has(t.desc.type)) return Ot.get(t.desc.type);
      var n = e.toolbar,
          r = new Set();
      t.fixed || r.add(ht);
      var o = e.getPossibleRenderer(t);
      (o.item.length > 2 || o.group.length > 2 || o.summary.length > 2) && r.add(ft), Object(i.l)(t) || (r.add(ct), r.add(st), r.add(pt), r.add(dt)), Object(i.i)(t).forEach(function (e) {
        n.hasOwnProperty(e) ? r.add(n[e]) : console.warn("cannot find: ", t.desc.type, e);
      });
      var a = Array.from(r).sort(Et);
      return Ot.set(t.desc.type, a), a;
    }

    function Tt(t, e) {
      var n = _t(t, e),
          r = e.flags;

      return n.filter(function (t) {
        return "basic" === t.options.featureLevel || !(!1 === r.advancedModelFeatures && "model" === t.options.featureCategory || !1 === r.advancedRankingFeatures && "ranking" === t.options.featureCategory || !1 === r.advancedUIFeatures && "ui" === t.options.featureCategory);
      });
    }

    function Nt(t, e, n) {
      var r = t.desc.type + "@" + e;
      if (Ct.has(r)) return Ct.get(r);
      var o = n.toolbar,
          a = new Set();
      Object(i.j)(t, e).forEach(function (e) {
        o.hasOwnProperty(e) ? a.add(o[e]) : console.warn("cannot find: ", t.desc.type, e);
      });
      var u = Array.from(a).sort(function (t, e) {
        return t.order === e.order ? t.title.localeCompare(e.title) : (t.order || 50) - (e.order || 50);
      });
      return Ct.set(r, u), u;
    }

    function Dt(t, e) {
      return _t(t, e).includes(st);
    }

    function Rt(t, e) {
      return _t(t, e).includes(bt);
    }

    function wt(t, e) {
      return _t(t, e).includes(lt);
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(2),
        o = n(1),
        a = n(27),
        u = n(22),
        c = n(20),
        s = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.patternFunction = null, r.currentFilter = null, r.currentGroupCriteria = [], r.setDefaultWidth(200), r.alignment = n.alignment || c.a.left, r.escape = !1 !== n.escape, r.pattern = n.pattern || "", r.patternTemplates = n.patternTemplates || [], r.pattern && (r.setDefaultRenderer("link"), r.setDefaultGroupRenderer("link")), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.setPattern = function (t) {
        t !== this.pattern && (this.patternFunction = null, this.fire([n.EVENT_PATTERN_CHANGED, o.d.EVENT_DIRTY_HEADER, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY], this.pattern, this.pattern = t));
      }, e.prototype.getPattern = function () {
        return this.pattern;
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_PATTERN_CHANGED, n.EVENT_GROUPING_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (t) {
        var e = this.getLink(t);
        return null == e ? "" : e.href;
      }, e.prototype.getLink = function (e) {
        var n = t.prototype.getValue.call(this, e);
        return this.transformValue(n, e);
      }, e.prototype.transformValue = function (t, e) {
        return null == t || "" === t ? null : "string" == typeof t ? this.pattern ? (this.patternFunction || (this.patternFunction = Object(a.e)(this.pattern, "item")), {
          alt: t,
          href: this.patternFunction.call(this, t, e.v)
        }) : {
          alt: t,
          href: t
        } : t;
      }, e.prototype.getLabel = function (t) {
        var e = this.getLink(t);
        return null == e ? "" : e.alt;
      }, e.prototype.dump = function (t) {
        var e = c.d.prototype.dump.call(this, t);
        return this.pattern !== this.desc.pattern && (e.pattern = this.pattern), e;
      }, e.prototype.restore = function (t, e) {
        c.d.prototype.restore.call(this, t, e), t.pattern && (this.pattern = t.pattern);
      }, e.prototype.isFiltered = function () {
        return null != this.currentFilter;
      }, e.prototype.filter = function (t) {
        return c.d.prototype.filter.call(this, t);
      }, e.prototype.getFilter = function () {
        return this.currentFilter;
      }, e.prototype.setFilter = function (t) {
        return c.d.prototype.setFilter.call(this, t);
      }, e.prototype.getGroupCriteria = function () {
        return this.currentGroupCriteria.slice();
      }, e.prototype.setGroupCriteria = function (t) {
        return c.d.prototype.setGroupCriteria.call(this, t);
      }, e.prototype.compare = function (t, e) {
        return c.d.prototype.compare.call(this, t, e);
      }, e.prototype.group = function (t) {
        return c.d.prototype.group.call(this, t);
      }, e.EVENT_FILTER_CHANGED = c.d.EVENT_FILTER_CHANGED, e.EVENT_GROUPING_CHANGED = c.d.EVENT_GROUPING_CHANGED, e.EVENT_PATTERN_CHANGED = "patternChanged", e = n = Object(r.b)([Object(i.m)("search", "groupBy", "filterString", "editPattern"), Object(i.h)("group", "groupString"), Object(i.b)("string")], e);
    }(u.b);

    e.d = s;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    });
    var r = {
      name: "Default",
      color: "gray"
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(33),
        o = n(2),
        a = n(1),
        u = n(22),
        c = n(3),
        s = n(17),
        l = n(6),
        p = n(28),
        f = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.currentFilter = Object(c.n)(), r.mapping = Object(s.e)(n), r.original = r.mapping.clone(), r.colorMapping = Object(p.h)(n), r.sort = n.sort || c.c.min, r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.compare = function (t, e) {
        return Object(c.e)(this, t, e);
      }, e.prototype.getBoxPlotData = function (t) {
        return this.getValue(t);
      }, e.prototype.getRange = function () {
        return this.mapping.getRange(n.DEFAULT_FORMATTER);
      }, e.prototype.getRawBoxPlotData = function (t) {
        return this.getRawValue(t);
      }, e.prototype.getRawValue = function (e) {
        return t.prototype.getValue.call(this, e);
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.getRawValue(e) : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.getValue = function (t) {
        var e = this,
            n = this.getRawValue(t);
        if (null == n) return n;
        var r = {
          min: this.mapping.apply(n.min),
          max: this.mapping.apply(n.max),
          median: this.mapping.apply(n.median),
          q1: this.mapping.apply(n.q1),
          q3: this.mapping.apply(n.q3)
        };
        return n.outlier && Object.assign(r, {
          outlier: n.outlier.map(function (t) {
            return e.mapping.apply(t);
          })
        }), null != n.whiskerLow && Object.assign(r, {
          whiskerLow: this.mapping.apply(n.whiskerLow)
        }), null != n.whiskerHigh && Object.assign(r, {
          whiskerHigh: this.mapping.apply(n.whiskerHigh)
        }), r;
      }, e.prototype.getNumber = function (t) {
        return Object(c.g)(this, t, "normalized");
      }, e.prototype.getRawNumber = function (t) {
        return Object(c.g)(this, t, "raw");
      }, e.prototype.getLabel = function (t) {
        var e = this.getRawValue(t);
        if (null == e) return "";
        var r = n.DEFAULT_FORMATTER;
        return "BoxPlot(min = " + r(e.min) + ", q1 = " + r(e.q1) + ", median = " + r(e.median) + ", q3 = " + r(e.q3) + ", max = " + r(e.max) + ")";
      }, e.prototype.getSortMethod = function () {
        return this.sort;
      }, e.prototype.setSortMethod = function (t) {
        this.sort !== t && (this.fire(n.EVENT_SORTMETHOD_CHANGED, this.sort, this.sort = t), this.isSortedByMe().asc || this.sortByMe());
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.sortMethod = this.getSortMethod(), n.filter = Object(c.i)(this.currentFilter) ? null : this.currentFilter, n.map = this.mapping.dump(), n.colorMapping = this.colorMapping.dump(), n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.sortMethod && (this.sort = e.sortMethod), e.filter && (this.currentFilter = Object(c.p)(e.filter)), e.map ? this.mapping = Object(s.c)(e.map) : e.domain && (this.mapping = new s.a(e.domain, "linear", e.range || [0, 1])), e.colorMapping && (this.colorMapping = Object(p.e)(e.colorMapping));
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_SORTMETHOD_CHANGED, n.EVENT_COLOR_MAPPING_CHANGED, n.EVENT_MAPPING_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getOriginalMapping = function () {
        return this.original.clone();
      }, e.prototype.getMapping = function () {
        return this.mapping.clone();
      }, e.prototype.setMapping = function (t) {
        this.mapping.eq(t) || this.fire([n.EVENT_MAPPING_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], this.mapping.clone(), this.mapping = t);
      }, e.prototype.getColor = function (t) {
        return l.b.prototype.getColor.call(this, t);
      }, e.prototype.getColorMapping = function () {
        return this.colorMapping.clone();
      }, e.prototype.setColorMapping = function (t) {
        this.colorMapping.eq(t) || this.fire([n.EVENT_COLOR_MAPPING_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], this.colorMapping.clone(), this.colorMapping = t);
      }, e.prototype.isFiltered = function () {
        return l.b.prototype.isFiltered.call(this);
      }, e.prototype.getFilter = function () {
        return l.b.prototype.getFilter.call(this);
      }, e.prototype.setFilter = function (t) {
        void 0 === t && (t = {
          min: -1 / 0,
          max: 1 / 0,
          filterMissing: !1
        }), l.b.prototype.setFilter.call(this, t);
      }, e.prototype.filter = function (t) {
        return l.b.prototype.filter.call(this, t);
      }, e.EVENT_MAPPING_CHANGED = l.b.EVENT_MAPPING_CHANGED, e.EVENT_COLOR_MAPPING_CHANGED = l.b.EVENT_COLOR_MAPPING_CHANGED, e.EVENT_SORTMETHOD_CHANGED = l.b.EVENT_SORTMETHOD_CHANGED, e.EVENT_FILTER_CHANGED = l.b.EVENT_FILTER_CHANGED, e.DEFAULT_FORMATTER = Object(i.a)(".3n"), e = n = Object(r.b)([Object(o.m)("filterNumber", "colorMapped", "editMapping"), Object(o.h)("sort", "sortBoxPlot"), Object(o.b)("array"), Object(o.d)("descending")], e);
    }(u.b);

    e.c = f;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    });
    var r = n(0),
        i = n(2);

    function o(t) {
      return void 0 === t && (t = "Rank"), {
        type: "rank",
        label: t
      };
    }

    var a = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultWidth(50), r;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "frozen", {
        get: function get() {
          return !1 !== this.desc.frozen;
        },
        enumerable: !0,
        configurable: !0
      }), e = Object(r.b)([Object(i.e)(), Object(i.b)("support")], e);
    }(n(22).b);

    e.b = a;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(2),
        o = n(1),
        a = n(22),
        u = n(12),
        c = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r._dataLength = null == n.dataLength || isNaN(n.dataLength) ? null : n.dataLength, r.originalLabels = n.labels || Object(u.k)(null == r._dataLength ? 0 : r._dataLength).map(function (t, e) {
          return "Column " + e;
        }), r.splicer = {
          length: r._dataLength,
          splice: function splice(t) {
            return t;
          }
        }, r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.setSplicer = function (t) {
        this.fire([n.EVENT_SPLICE_CHANGED, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY_HEADER, o.d.EVENT_DIRTY], this.splicer, this.splicer = t);
      }, Object.defineProperty(e.prototype, "labels", {
        get: function get() {
          return this.splicer ? this.splicer.splice(this.originalLabels) : this.originalLabels;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getSplicer = function () {
        return this.splicer;
      }, Object.defineProperty(e.prototype, "dataLength", {
        get: function get() {
          return this.splicer ? this.splicer.length : this._dataLength;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getValue = function (t) {
        return this.getValues(t);
      }, e.prototype.getValues = function (e) {
        var n = t.prototype.getValue.call(this, e);
        return this.splicer && null != n && (n = this.splicer.splice(n)), null == n ? [] : n;
      }, e.prototype.getLabels = function (t) {
        return this.getValues(t).map(String);
      }, e.prototype.getLabel = function (t) {
        var e = this.getLabels(t);
        return e ? e.toString() : "";
      }, e.prototype.getMap = function (t) {
        var e = this.labels;
        return this.getValues(t).map(function (t, n) {
          return {
            key: e[n],
            value: t
          };
        });
      }, e.prototype.getMapLabel = function (t) {
        var e = this.labels;
        return this.getLabels(t).map(function (t, n) {
          return {
            key: e[n],
            value: t
          };
        });
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_SPLICE_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.EVENT_SPLICE_CHANGED = "spliceChanged", e = n = Object(r.b)([Object(i.b)("array")], e);
    }(a.b);

    e.d = c;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    }), n.d(e, "c", function () {
      return o;
    }), n.d(e, "b", function () {
      return a;
    }), n.d(e, "d", function () {
      return u;
    });
    var r = n(91),
        i = "function" == typeof r ? r : n.n(r).a;

    function o(t) {
      return function (e, n) {
        if (e in t) return t[e];

        if (e.indexOf(".") > 0) {
          var r = e.substring(0, e.indexOf("."));
          if (e = e.substring(e.indexOf(".") + 1), r in t && e in t[r]) return t[r][e];
        }

        return n;
      };
    }

    function a(t, e) {
      return t.length === e.length && t.every(function (t, n) {
        return t === e[n];
      });
    }

    function u(t) {
      return t.replace(/[\s!#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]+/g, "_");
    }
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return s;
    });
    var r = n(0),
        i = n(16),
        o = n(2),
        a = n(1),
        u = n(49),
        c = n(3);

    function s(t) {
      return void 0 === t && (t = "Weighted Sum"), {
        type: "stack",
        label: t
      };
    }

    var l = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        r.collapsed = !1;
        var i = r;
        return r.adaptChange = function (t, e) {
          i.adaptWidthChange(this.source, t, e);
        }, r.setDefaultRenderer("stack"), r.setDefaultGroupRenderer("stack"), r.setDefaultSummaryRenderer("default"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, Object.defineProperty(e.prototype, "label", {
        get: function get() {
          var e = t.prototype.getMetaData.call(this).label,
              n = this._children;
          if ("Weighted Sum" !== e || 0 === n.length) return e;
          var r = this.getWeights();
          return n.map(function (t, e) {
            return t.label + " (" + Object(i.k)(100 * r[e], 1) + "%)";
          }).join(" + ");
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_COLLAPSE_CHANGED, n.EVENT_WEIGHTS_CHANGED, n.EVENT_MULTI_LEVEL_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.setCollapsed = function (t) {
        this.collapsed !== t && this.fire([n.EVENT_COLLAPSE_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], this.collapsed, this.collapsed = t);
      }, e.prototype.getCollapsed = function () {
        return this.collapsed;
      }, Object.defineProperty(e.prototype, "canJustAddNumbers", {
        get: function get() {
          return !0;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.flatten = function (t, e, n, r) {
        void 0 === n && (n = 0), void 0 === r && (r = 0);
        var i = null,
            o = n <= a.d.FLAT_ALL_COLUMNS ? this._children : this._children.filter(function (t) {
          return t.isVisible();
        });

        if (0 === n || n <= a.d.FLAT_ALL_COLUMNS) {
          var u = this.getWidth();
          if (this.collapsed || (u += (o.length - 1) * r), t.push(i = {
            col: this,
            offset: e,
            width: u
          }), 0 === n) return u;
        }

        var c = e;
        return o.forEach(function (e) {
          c += e.flatten(t, c, n - 1, r) + r;
        }), i && (i.width = c - e - r), c - e - r;
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.collapsed = this.collapsed, n;
      }, e.prototype.restore = function (e, n) {
        this.collapsed = !0 === e.collapsed, t.prototype.restore.call(this, e, n);
      }, e.prototype.insert = function (e, n, r) {
        return void 0 === r && (r = NaN), isNaN(r) || e.setWidth(r / (1 - r) * this.getWidth()), e.on(a.d.EVENT_WIDTH_CHANGED + ".stack", this.adaptChange), t.prototype.setWidth.call(this, 0 === this.length ? e.getWidth() : this.getWidth() + e.getWidth()), t.prototype.insert.call(this, e, n);
      }, e.prototype.push = function (t, e) {
        return void 0 === e && (e = NaN), this.insert(t, this.length, e);
      }, e.prototype.insertAfter = function (t, e, n) {
        void 0 === n && (n = NaN);
        var r = this.indexOf(e);
        return r < 0 ? null : this.insert(t, r + 1, n);
      }, e.prototype.adaptWidthChange = function (e, r, o) {
        if (!Object(i.l)(r, o, .5)) {
          var u = this.getWeights(),
              c = this.getWidth(),
              s = r / c,
              l = (1 - s - (o - r) / c) / (1 - s),
              p = this._children.map(function (t) {
            if (t === e) return o;
            var n = t.getWidth() * l,
                r = isNaN(n) || n < 1 ? 0 : n;
            return t.setWidthImpl(r), r;
          });

          t.prototype.setWidth.call(this, p.reduce(function (t, e) {
            return t + e;
          }, 0)), this.fire([n.EVENT_WEIGHTS_CHANGED, n.EVENT_MULTI_LEVEL_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], u, this.getWeights());
        }
      }, e.prototype.getWeights = function () {
        var t = this.getWidth();
        return this._children.map(function (e) {
          return e.getWidth() / t;
        });
      }, e.prototype.setWeights = function (t) {
        var e,
            r = this.getWeights(),
            i = t.length - this.length;
        if (i < 0) if ((e = t.reduce(function (t, e) {
          return t + e;
        }, 0)) <= 1) for (var o = 0; o < -i; ++o) {
          t.push(1 / -i * (1 - e));
        } else if (e <= 100) for (o = 0; o < -i; ++o) {
          t.push(1 / -i * (100 - e));
        }
        t = t.slice(0, this.length), e = t.reduce(function (t, e) {
          return t + e;
        }, 0) / this.getWidth(), t = t.map(function (t) {
          return t / e;
        }), this._children.forEach(function (e, n) {
          e.setWidthImpl(t[n]);
        }), this.fire([n.EVENT_WEIGHTS_CHANGED, n.EVENT_MULTI_LEVEL_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], r, t);
      }, e.prototype.removeImpl = function (e, n) {
        return e.on(a.d.EVENT_WIDTH_CHANGED + ".stack", null), t.prototype.setWidth.call(this, 0 === this.length ? 100 : this.getWidth() - e.getWidth()), t.prototype.removeImpl.call(this, e, n);
      }, e.prototype.setWidth = function (e) {
        var n = e / this.getWidth();
        this._children.forEach(function (t) {
          t.setWidthImpl(t.getWidth() * n);
        }), t.prototype.setWidth.call(this, e);
      }, e.prototype.compute = function (t) {
        var e = this.getWidth();
        return this._children.reduce(function (n, r) {
          return n + r.getValue(t) * (r.getWidth() / e);
        }, 0);
      }, e.prototype.getRenderer = function () {
        return this.getCollapsed() && this.isLoaded() ? n.COLLAPSED_RENDERER : t.prototype.getRenderer.call(this);
      }, e.prototype.isMissing = function (t) {
        return this._children.some(function (e) {
          return Object(c.k)(e) && e.isMissing(t);
        });
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? {
          value: this.getRawNumber(e),
          children: this.children.map(function (t) {
            return t.getExportValue(e, n);
          })
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.EVENT_COLLAPSE_CHANGED = "collapseChanged", e.EVENT_WEIGHTS_CHANGED = "weightsChanged", e.EVENT_MULTI_LEVEL_CHANGED = "nestedChildRatio", e.COLLAPSED_RENDERER = "number", e = n = Object(r.b)([Object(o.m)("editWeights", "collapse")], e);
    }(u.a);

    e.b = l;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(51);
    n(42);

    function o(t) {
      for (var e = [], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }

      console.assert(null != t.dataTransfer);
      var r = t.dataTransfer.types;
      return "function" == typeof r.indexOf ? e.some(function (t) {
        return r.indexOf(t) >= 0;
      }) : "function" == typeof r.includes ? e.some(function (t) {
        return r.includes(t);
      }) : "function" == typeof r.contains && e.some(function (t) {
        return r.contains(t);
      });
    }

    var a = new Map();

    function u(t) {
      return a.size > 0 && o(t, "text/plain");
    }

    function c(t) {
      console.assert(null != t.dataTransfer);
      var e = t.dataTransfer;
      !function (t) {
        console.assert(null != t.dataTransfer);
        var e = t.dataTransfer;
        return Boolean(t.ctrlKey && e.effectAllowed.match(/copy/gi) || !e.effectAllowed.match(/move/gi));
      }(t) ? e.dropEffect = "move" : e.dropEffect = "copy";
    }

    var s = 0;

    function l(t, e, n, i, s) {
      void 0 === i && (i = null), void 0 === s && (s = !1), t.addEventListener("dragenter", function (n) {
        if (!t.classList.contains("lu-dragging") && (o.apply(void 0, Object(r.d)([n], e)) || u(n))) return t.classList.add("lu-dragover"), s && n.stopPropagation(), !1;
        t.classList.remove("lu-dragover");
      }), t.addEventListener("dragover", function (n) {
        if (!t.classList.contains("lu-dragging") && (o.apply(void 0, Object(r.d)([n], e)) || u(n))) return n.preventDefault(), c(n), t.classList.add("lu-dragover"), s && n.stopPropagation(), i && i(n), !1;
      }), t.addEventListener("dragleave", function (t) {
        t.target.classList.remove("lu-dragover");
      }), t.addEventListener("drop", function (i) {
        i.preventDefault(), s && i.stopPropagation(), c(i), console.assert(null != i.dataTransfer);
        var l = i.dataTransfer,
            p = l.dropEffect;

        if (t.classList.remove("lu-dragover"), u(i)) {
          var f = l.getData("text/plain"),
              d = parseInt(f.indexOf(":") >= 0 ? f.substring(0, f.indexOf(":")) : f, 10);

          if (a.has(d)) {
            var h = a.get(d);
            return a.delete(d), !n({
              effect: p,
              data: h
            }, i);
          }
        } else if (o.apply(void 0, Object(r.d)([i], e))) {
          var g = {};
          return e.forEach(function (t) {
            var e = l.getData(t);
            "" !== e && (g[t] = e);
          }), !n({
            effect: p,
            data: g
          }, i);
        }
      });
    }

    var p = n(3),
        f = n(24),
        d = n(59),
        h = n(69),
        g = n(67),
        b = n(68),
        m = n(75),
        y = n(43),
        v = n(80),
        E = n(2),
        O = n(26),
        C = n(36),
        _ = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.column = e, i.ctx = r, i;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.classList.add("lu-more-options"), A(t, this.dialog.level + 1, this.column, this.ctx), D(t, this.column);
      }, e;
    }(n(14).c);

    function T(t, e, n) {
      void 0 === n && (n = {}), n = Object.assign({
        dragAble: !0,
        mergeDropAble: !0,
        rearrangeAble: !0,
        resizeable: !0,
        level: 0
      }, n);
      var a = e.document.createElement("section");
      return a.innerHTML = '\n    <div class="lu-label">' + (t.getWidth() < i.e ? "&nbsp;" : t.label) + '</div>\n    <div class="lu-toolbar"></div>\n    <div class="lu-spacing"></div>\n    <div class="lu-handle lu-feature-advanced lu-feature-ui"></div>\n  ', w(a.querySelector("div.lu-toolbar"), n.level, t, e), M(a, t), n.dragAble && j(a, t, e), n.mergeDropAble && function (t, e, n) {
        var i = function i(t) {
          var r = t.data,
              i = "copy" === t.effect,
              o = L,
              a = Object.keys(r).find(function (t) {
            return t.startsWith(o) && t.endsWith("-ref");
          });

          if (a) {
            var u = r[a],
                c = n.provider.find(u);
            if (i) c = n.provider.clone(c);else {
              if (c === e) return null;
              c.removeMe();
            }
            return c;
          }

          var s = Object.keys(r).find(function (t) {
            return t.startsWith(o);
          });
          if (!s) return null;
          var l = JSON.parse(s);
          return n.provider.create(n.provider.fromDescRef(l));
        },
            a = function a(t) {
          var n = i(t);
          return null != n && null != e.push(n);
        },
            u = function u(t, r) {
          if (null == t) return !1;
          var i = e.findMyRanker(),
              o = i.indexOf(e),
              a = n.provider.create(r);
          return e.removeMe(), a.push(e), a.push(t), null != i.insert(a, o);
        },
            c = function c(t) {
          return function (e) {
            var n = i(e);
            return u(n, t);
          };
        },
            s = [L + "-ref", L],
            d = [L + "-number-ref", L + "-number"],
            E = [L + "-categorical-ref", L + "-categorical"],
            C = [L + "-boxplot-ref", L + "-boxplot"],
            _ = [L + "-numbers-ref", L + "-numbers"];

        if (t.dataset.draginfo = "+", e instanceof b.b) return l(t, E.concat(d), a, function (e) {
          o.apply(void 0, Object(r.d)([e], E)) ? t.dataset.draginfo = "Color by" : o.apply(void 0, Object(r.d)([e], d)) && (t.dataset.draginfo = "Wrap");
        });
        if (e instanceof g.b) return l(t, E.concat(C), a, function (e) {
          o.apply(void 0, Object(r.d)([e], E)) ? t.dataset.draginfo = "Color by" : o.apply(void 0, Object(r.d)([e], C)) && (t.dataset.draginfo = "Wrap");
        });
        if (e instanceof h.b) return l(t, E.concat(_), a, function (e) {
          o.apply(void 0, Object(r.d)([e], E)) ? t.dataset.draginfo = "Color by" : o.apply(void 0, Object(r.d)([e], _)) && (t.dataset.draginfo = "Wrap");
        });
        if (Object(O.c)(e)) return l(t, e.canJustAddNumbers ? d : s, a);
        if (e instanceof O.b) return l(t, e.canJustAddNumbers ? d : s, a);
        if (Object(p.m)(e)) return t.dataset.draginfo = "Color by", l(t, E, c(Object(h.a)()));
        if (Object(p.h)(e)) return t.dataset.draginfo = "Color by", l(t, E, c(Object(g.a)()));
        if (Object(p.k)(e)) return t.dataset.draginfo = "Merge", l(t, E.concat(d), function (t, e) {
          var n = i(t);
          return null != n && (Object(f.c)(n) ? u(n, Object(b.a)()) : !!Object(p.k)(n) && u(n, e.shiftKey ? Object(m.c)() : Object(y.a)()));
        }, function (e) {
          o.apply(void 0, Object(r.d)([e], E)) ? t.dataset.draginfo = "Color by" : o.apply(void 0, Object(r.d)([e], d)) && (t.dataset.draginfo = e.shiftKey ? "Min/Max" : "Sum");
        });
        t.dataset.draginfo = "Group", l(t, s, c(Object(v.a)()));
      }(a, t, e), n.rearrangeAble && function (t, e, n) {
        l(t, [L + "-ref", L], function (t) {
          var r = null,
              i = t.data;

          if (!(L + "-ref" in i)) {
            var o = JSON.parse(i[L]);
            return null != (r = n.provider.create(n.provider.fromDescRef(o))) && null != e.insertAfterMe(r);
          }

          var a = i[L + "-ref"];
          if (!(r = n.provider.find(a)) || r === e && !t.effect.startsWith("copy")) return !1;
          if (t.effect.startsWith("copy")) return null != (r = n.provider.clone(r)) && null != e.insertAfterMe(r);
          var u = r.parent;
          return u ? u === e.parent ? null != u.moveAfter(r, e) : (r.removeMe(), null != e.insertAfterMe(r)) : null != e.insertAfterMe(r);
        }, null, !0);
      }(a.querySelector(".lu-handle"), t, e), n.resizeable && function (t, e) {
        var n,
            r = e.querySelector(".lu-handle"),
            i = 0,
            o = function o(n) {
          n.stopPropagation(), n.preventDefault();
          var r = n.clientX,
              o = r - i,
              a = Math.max(0, t.getWidth() + o);
          Math.abs(i - r) < 2 || (i = r, e.style.width = a + "px", t.setWidth(a), M(e, t));
        },
            a = function a(r) {
          r.stopPropagation(), r.preventDefault();
          var u = r.clientX;

          if (e.classList.remove("lu-change-width"), n.removeEventListener("mousemove", o), n.removeEventListener("mouseup", a), n.removeEventListener("mouseleave", a), e.style.width = null, !(Math.abs(i - u) < 2)) {
            var c = u - i,
                s = Math.max(0, t.getWidth() + c);
            t.setWidth(s), M(e, t);
          }
        };

        r.onmousedown = function (t) {
          t.stopPropagation(), t.preventDefault(), e.classList.add("lu-change-width"), i = t.clientX, (n = e.closest("header")).addEventListener("mousemove", o), n.addEventListener("mouseup", a), n.addEventListener("mouseleave", a);
        }, r.onclick = function (t) {
          t.stopPropagation(), t.preventDefault();
        };
      }(t, a), a;
    }

    function N(t, e) {
      t.querySelector(".lu-label").innerHTML = e.getWidth() < i.e ? "&nbsp;" : e.label, t.title = e.description ? e.label + "\n" + e.description : e.label, t.dataset.colId = e.id, t.dataset.type = e.desc.type, t.dataset.typeCat = Object(E.f)(e).name, D(t, e);
    }

    function D(t, e) {
      var n = t.querySelector("i[title='Sort']");

      if (n) {
        var r = e.isSortedByMe(),
            i = r.asc,
            o = r.priority;
        n.dataset.sort = void 0 !== i ? i : "", void 0 !== o ? n.dataset.priority = (o + 1).toString() : delete n.dataset.priority;
      }

      var a = t.querySelector("i[title='Sort Group']");

      if (a) {
        var u = e.isGroupSortedByMe();
        i = u.asc, o = u.priority;
        a.dataset.sort = void 0 !== i ? i : "", void 0 !== o ? a.dataset.priority = (o + 1).toString() : delete a.dataset.priority;
      }

      var c = t.querySelector("i[title^='Group']");

      if (c) {
        var s = e.isGroupedBy();
        c.dataset.group = s >= 0 ? "true" : "false", s >= 0 ? c.dataset.priority = (s + 1).toString() : delete c.dataset.priority;
      }

      var l = t.querySelector("i[title^='Filter']");
      l && (e.isFiltered() ? l.dataset.active = "" : delete l.dataset.active);
    }

    function R(t, e, n, r, i) {
      return function (o) {
        t.insertAdjacentHTML("beforeend", '<i data-a="' + ("only" === o.options.shortcut ? "o" : o.options.shortcut ? "s" : "r") + '" title="' + o.title + '" class="lu-action lu-feature-' + (o.options.featureLevel || "basic") + " lu-feature-" + (o.options.featureCategory || "others") + '"><span' + (i ? "" : ' aria-hidden="true"') + ">" + o.title + "</span> </i>");
        var a = t.lastElementChild;
        return a.onclick = function (t) {
          t.stopPropagation(), n.dialogManager.setHighlightColumn(e), o.onClick(e, t, n, r, !i);
        }, a;
      };
    }

    function w(t, e, n, r, i) {
      void 0 === i && (i = !0);
      var o = R(t, n, r, e, !1),
          a = Object(C.b)(n, r),
          u = a.filter(function (t) {
        return t.options.shortcut;
      }),
          c = u.reduce(function (t, e) {
        return t + (!0 === e.options.shortcut ? 1 : 0);
      }, 0);
      u.forEach(o);
      var s = a.length - u.length + c;
      u.length === a.length || s === c && !i || (t.insertAdjacentHTML("beforeend", '<i data-a="m" data-m="' + s + '" title="More &hellip;" class="lu-action"><span aria-hidden="true">More &hellip;</span></i>'), t.lastElementChild.onclick = function (t) {
        t.stopPropagation(), r.dialogManager.setHighlightColumn(n), new _(n, Object(C.a)(r, e, t), r).open();
      });
    }

    function A(t, e, n, r) {
      var i = R(t, n, r, e, !0);
      Object(C.b)(n, r).filter(function (t) {
        return "only" !== t.options.shortcut;
      }).forEach(i);
    }

    function M(t, e, n) {
      void 0 === n && (n = 22.5), function (t, e, n) {
        var r = t.querySelector(".lu-label");
        if (e.getWidth() < i.e) r.classList.remove("lu-rotated");else {
          var o = r.clientWidth <= 0 ? e.label.length * n / 3 * .6 > e.getWidth() : .6 * r.scrollWidth > r.clientWidth;
          r.classList.toggle("lu-rotated", o);
        }
      }(t, e, n);
      var r = t.querySelector(".lu-toolbar");

      if (0 !== r.childElementCount) {
        for (var o = e.getWidth(), a = Array.from(r.children).map(function (t) {
          return {
            node: t,
            width: t.clientWidth > 0 ? t.clientWidth : n
          };
        }), u = a.filter(function (t) {
          return "o" === t.node.dataset.a;
        }), c = a.filter(function (t) {
          return "s" === t.node.dataset.a;
        }), s = a.find(function (t) {
          return "m" === t.node.dataset.a;
        }), l = (s ? parseInt(s.node.dataset.m, 10) : 0) > c.length, p = a.reduce(function (t, e) {
          return t + e.width;
        }, 0), f = 0, d = a; f < d.length; f++) {
          (b = d[f]).node.classList.remove("hidden");
        }

        if (!(p < o)) if (s && !l && p - s.width < o) s.node.classList.add("hidden");else for (var h = 0, g = c.reverse().concat(u.reverse()); h < g.length; h++) {
          var b;
          if ((b = g[h]).node.classList.add("hidden"), (p -= b.width) < o) return;
        }
      }
    }

    n.d(e, "a", function () {
      return T;
    }), n.d(e, "e", function () {
      return N;
    }), n.d(e, "f", function () {
      return D;
    }), n.d(e, "b", function () {
      return w;
    }), n.d(e, "c", function () {
      return A;
    }), n.d(e, "d", function () {
      return j;
    });
    var L = "text/x-caleydo-lineup-column";

    function j(t, e, n) {
      !function (t, e, n) {
        void 0 === n && (n = !1);
        var r = ++s;
        t.draggable = !0, t.addEventListener("dragstart", function (i) {
          t.classList.add("lu-dragging");
          var o = e();
          console.assert(null != i.dataTransfer);
          var u = i.dataTransfer;

          if (u.effectAllowed = o.effectAllowed, n && i.stopPropagation(), !Object.keys(o.data).every(function (t) {
            try {
              return u.setData(t, o.data[t]), !0;
            } catch (t) {
              return !1;
            }
          })) {
            var c = o.data["text/plain"] || "";
            u.setData("text/plain", r + (c ? ": " + c : "")), a.set(r, o.data);
          }
        }), t.addEventListener("dragend", function (e) {
          t.classList.remove("lu-dragging"), n && e.stopPropagation(), a.size > 0 && a.delete(r);
          var i = t.ownerDocument.querySelector(".lu-dragover");
          i && i.classList.remove("lu-dragover");
        });
      }(t, function () {
        var t,
            r = JSON.stringify(n.provider.toDescRef(e.desc)),
            i = ((t = {
          "text/plain": e.label
        })[L + "-ref"] = e.id, t[L] = r, t);
        return Object(p.k)(e) && (i[L + "-number"] = r, i[L + "-number-ref"] = e.id), Object(f.c)(e) && (i[L + "-categorical"] = r, i[L + "-categorical-ref"] = e.id), Object(p.h)(e) && (i[L + "-boxplot"] = r, i[L + "-boxplot-ref"] = e.id), Object(d.b)(e) && (i[L + "-map"] = r, i[L + "-map-ref"] = e.id), Object(d.a)(e) && (i[L + "-array"] = r, i[L + "-array-ref"] = e.id), Object(p.m)(e) && (i[L + "-numbers"] = r, i[L + "-numbers-ref"] = e.id), {
          effectAllowed: "copyMove",
          data: i
        };
      }, !0);
    }
  }, function (t, e, n) {
    "use strict";

    n.d(e, "j", function () {
      return p;
    }), n.d(e, "i", function () {
      return f;
    }), n.d(e, "h", function () {
      return d;
    });

    var r = n(0),
        i = n(2),
        o = n(19),
        a = n(1),
        u = n(27),
        c = n(7),
        s = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.currentMaxDepth = 1 / 0, r.currentLeaves = [], r.currentLeavesNameCache = new Map(), r.currentLeavesPathCache = new Map(), r.hierarchySeparator = n.hierarchySeparator || ".", r.hierarchy = r.initHierarchy(n.hierarchy), r.currentNode = r.hierarchy, r.currentLeaves = l(r.currentNode, r.currentMaxDepth), r.updateCaches(), r.setDefaultRenderer("categorical"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.initHierarchy = function (t) {
        var e = Object(u.a)(),
            n = this.hierarchySeparator,
            r = function r(t, i) {
          var o = null == i.name ? String(i.value) : i.name,
              a = (i.children || []).map(function (i) {
            if ("string" == typeof i) {
              var a = t + i;
              return {
                path: a,
                name: i,
                label: a,
                color: e(),
                value: 0,
                children: []
              };
            }

            var u = r("" + t + o + n, i);
            return u.color || (u.color = e()), u;
          }),
              u = t + o,
              c = i.label ? "" + i.label : u;
          return {
            path: u,
            name: o,
            children: a,
            label: c,
            color: i.color,
            value: 0
          };
        };

        return r("", t);
      }, Object.defineProperty(e.prototype, "categories", {
        get: function get() {
          return this.currentLeaves;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_CUTOFF_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getCutOff = function () {
        return {
          node: this.currentNode,
          maxDepth: this.currentMaxDepth
        };
      }, e.prototype.setCutOff = function (t) {
        var e = null == t.maxDepth ? 1 / 0 : t.maxDepth;

        if (this.currentNode !== t.node || this.currentMaxDepth !== e) {
          var r = this.getCutOff();
          this.currentNode = t.node, this.currentMaxDepth = e, this.currentLeaves = l(t.node, e), this.updateCaches(), this.fire([n.EVENT_CUTOFF_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], r, this.getCutOff());
        }
      }, e.prototype.getCategory = function (e) {
        var n = this,
            r = t.prototype.getValue.call(this, e);
        return null == r || "" === r ? null : (r = r.trim(), this.currentLeavesNameCache.has(r) ? this.currentLeavesNameCache.get(r) : this.currentLeavesPathCache.has(r) ? this.currentLeavesPathCache.get(r) : this.currentLeaves.find(function (t) {
          return t.path === r || t.name === r || r.startsWith(t.path + n.hierarchySeparator);
        }) || null);
      }, Object.defineProperty(e.prototype, "dataLength", {
        get: function get() {
          return this.currentLeaves.length;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "labels", {
        get: function get() {
          return this.currentLeaves.map(function (t) {
            return t.label;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getValue = function (t) {
        var e = this.getCategory(t);
        return e ? e.name : null;
      }, e.prototype.getLabel = function (t) {
        return o.a.prototype.getLabel.call(this, t);
      }, e.prototype.getColor = function (t) {
        return o.a.prototype.getColor.call(this, t);
      }, e.prototype.getLabels = function (t) {
        return o.a.prototype.getLabels.call(this, t);
      }, e.prototype.getValues = function (t) {
        return o.a.prototype.getValues.call(this, t);
      }, e.prototype.getMap = function (t) {
        return o.a.prototype.getMap.call(this, t);
      }, e.prototype.getMapLabel = function (t) {
        return o.a.prototype.getMapLabel.call(this, t);
      }, e.prototype.getSet = function (t) {
        return o.a.prototype.getSet.call(this, t);
      }, e.prototype.compare = function (t, e) {
        return o.a.prototype.compare.call(this, t, e);
      }, e.prototype.group = function (e) {
        if (this.isMissing(e)) return c.e;
        var n = this.getCategory(e);
        return n ? {
          name: n.label,
          color: n.color
        } : t.prototype.group.call(this, e);
      }, e.prototype.updateCaches = function () {
        var t = this;
        this.currentLeavesPathCache.clear(), this.currentLeavesNameCache.clear(), this.currentLeaves.forEach(function (e) {
          t.currentLeavesPathCache.set(e.path, e), t.currentLeavesNameCache.set(e.name, e);
        });
      }, e.EVENT_CUTOFF_CHANGED = "cutOffChanged", e = n = Object(r.b)([Object(i.m)("cutoff", "group", "groupBy"), Object(i.b)("categorical")], e);
    }(n(22).b);

    function l(t, e) {
      void 0 === e && (e = 1 / 0);

      var n = [],
          r = function r(t, i) {
        i >= e || 0 === t.children.length ? n.push(t) : t.children.forEach(function (t) {
          return r(t, i + 1);
        });
      };

      return r(t, 0), n;
    }

    function p(t) {
      for (var e = [t], n = 0; n < e.length;) {
        var r = e[n++];
        e.push.apply(e, r.children);
      }

      return e;
    }

    function f(t) {
      return 0 !== t.length && "string" != typeof t[0] && t.some(function (t) {
        return null != t.parent;
      });
    }

    function d(t) {
      var e = new Map();
      t.forEach(function (t) {
        var n = t.parent || "",
            r = Object.assign({
          children: [],
          label: t.name,
          name: t.name,
          color: a.d.DEFAULT_COLOR,
          value: 0
        }, e.get(t.name) || {}, t);
        e.set(t.name, r), e.has(n) || e.set(n, {
          name: n,
          children: [],
          label: n,
          value: 0,
          color: a.d.DEFAULT_COLOR
        }), e.get(n).children.push(r);
      });
      var n = e.get("");
      return console.assert(void 0 !== n, "hierarchy with no root"), 1 === n.children.length ? n.children[0] : n;
    }

    e.g = s;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(2),
        o = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultWidth(200), r;
      }

      return Object(r.c)(e, t), e.prototype.getValue = function (e) {
        return function (t) {
          if (!t) return [];
          if (t instanceof Map) return Array.from(t.entries()).map(function (t) {
            return {
              key: t[0],
              value: t[1]
            };
          }).sort(a);
          if (Array.isArray(t)) return t;
          return Object.keys(t).map(function (e) {
            return {
              key: e,
              value: t[e]
            };
          }).sort(a);
        }(t.prototype.getValue.call(this, e));
      }, e.prototype.getLabels = function (t) {
        return this.getValue(t).map(function (t) {
          var e = t.key,
              n = t.value;
          return {
            key: e,
            value: String(n)
          };
        });
      }, e.prototype.getMap = function (t) {
        return this.getValue(t);
      }, e.prototype.getMapLabel = function (t) {
        return this.getLabels(t);
      }, e.prototype.getLabel = function (t) {
        return "{" + this.getLabels(t).map(function (t) {
          return t.key + ": " + t.value;
        }).join(", ") + "}";
      }, e = Object(r.b)([Object(i.b)("map")], e);
    }(n(22).b);

    function a(t, e) {
      return t === e ? 0 : t.key.localeCompare(e.key);
    }

    e.a = o;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    });
    var r,
        i = n(0),
        o = n(23),
        a = n(12),
        u = n(2),
        c = n(41),
        s = n(3),
        l = n(7),
        p = n(35);
    !function (t) {
      t.min = "min", t.max = "max", t.median = "median";
    }(r || (r = {}));

    var f = function (t) {
      function e(e, n) {
        var i = t.call(this, e, n) || this;
        return i.currentFilter = Object(s.n)(), i.format = Object(o.a)(n.dateFormat || "%x"), i.parse = n.dateParse ? Object(o.b)(n.dateParse) : Object(o.b)(n.dateFormat || "%x"), i.sort = n.sort || r.median, i.setDefaultRenderer("default"), i;
      }

      var n;
      return Object(i.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_SORTMETHOD_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (t) {
        return this.getDates(t);
      }, e.prototype.getLabels = function (t) {
        var e = this;
        return this.getValue(t).map(function (t) {
          return t instanceof Date ? e.format(t) : "";
        });
      }, e.prototype.getDates = function (e) {
        var n = this;
        return t.prototype.getValue.call(this, e).map(function (t) {
          return Object(l.c)(t) ? null : t instanceof Date ? t : n.parse(String(t));
        });
      }, e.prototype.getDate = function (t) {
        var e = this.getDates(t).filter(Boolean);
        return 0 === e.length ? null : new Date(d(e, this.sort));
      }, e.prototype.getSortMethod = function () {
        return this.sort;
      }, e.prototype.setSortMethod = function (t) {
        this.sort !== t && (this.fire([n.EVENT_SORTMETHOD_CHANGED], this.sort, this.sort = t), this.isSortedByMe().asc || this.sortByMe());
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.sortMethod = this.getSortMethod(), n.filter = Object(s.i)(this.currentFilter) ? null : this.currentFilter, n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), e.sortMethod && (this.sort = e.sortMethod), e.filter && (this.currentFilter = Object(s.p)(e.filter));
      }, e.prototype.compare = function (t, e) {
        var n = this.getValue(t).filter(Boolean),
            r = this.getValue(e).filter(Boolean);
        return n === r ? 0 : 0 === n.length ? 0 === r.length ? 0 : l.a : 0 === r.length ? -l.a : d(n, this.sort) - d(r, this.sort);
      }, e.prototype.isFiltered = function () {
        return p.c.prototype.isFiltered.call(this);
      }, e.prototype.getFilter = function () {
        return p.c.prototype.getFilter.call(this);
      }, e.prototype.setFilter = function (t) {
        void 0 === t && (t = {
          min: -1 / 0,
          max: 1 / 0,
          filterMissing: !1
        }), p.c.prototype.setFilter.call(this, t);
      }, e.prototype.filter = function (t) {
        return p.c.prototype.filter.call(this, t);
      }, e.EVENT_SORTMETHOD_CHANGED = "sortMethodChanged", e.EVENT_FILTER_CHANGED = p.c.EVENT_FILTER_CHANGED, e = n = Object(i.b)([Object(u.m)("filterDate"), Object(u.h)("sort", "sortDates")], e);
    }(c.d);

    function d(t, e) {
      switch (e) {
        case r.min:
          return Object(a.i)(t, function (t) {
            return t.getTime();
          });

        case r.max:
          return Object(a.f)(t, function (t) {
            return t.getTime();
          });

        case r.median:
          return Object(a.h)(t, function (t) {
            return t.getTime();
          });
      }
    }

    e.d = f;
  }, function (t, e, n) {
    "use strict";

    var r = n(0);

    var i = function (t) {
      function e(e) {
        void 0 === e && (e = {});
        var n = t.call(this) || this;
        return n.options = {
          formatItem: function formatItem(t) {
            return t.text;
          },
          doc: document,
          placeholder: "Select..."
        }, n.values = [], Object.assign(n.options, e), n.node = n.options.doc.createElement("div"), n.node.classList.add("lu-search"), n.node.innerHTML = '<input type="search" placeholder="' + n.options.placeholder + '"><ul></ul>', n.search = n.node.querySelector("input"), n.body = n.node.querySelector("ul"), n.search.onfocus = function () {
          return n.focus();
        }, n.search.onblur = function () {
          return n.blur();
        }, n.search.oninput = function () {
          return n.filter();
        }, n.search.onkeydown = function (t) {
          return n.handleKey(t);
        }, n;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "data", {
        get: function get() {
          return this.values;
        },
        set: function set(t) {
          this.values = t, this.body.innerHTML = "", this.buildDialog(this.body, this.values);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.buildDialog = function (t, e) {
        var n = this;
        e.forEach(function (e) {
          if (function (t) {
            return void 0 !== t.id;
          }(e)) {
            t.insertAdjacentHTML("beforeend", '<li class="lu-search-item"><span></span></li>');
            var r = t.lastElementChild;
            r.onmousedown = function (t) {
              t.preventDefault();
            }, r.onclick = function () {
              return n.select(e);
            }, r.onmouseenter = function () {
              return n.highlighted = r;
            }, r.onmouseleave = function () {
              return n.highlighted = null;
            };
          } else {
            t.insertAdjacentHTML("beforeend", '<li class="lu-search-group"><span></span><ul></ul></li>');
            var i = t.lastElementChild.lastElementChild;
            n.buildDialog(i, e.children);
          }

          var o = t.lastElementChild.firstElementChild;
          o.innerHTML = n.options.formatItem(e, o);
        });
      }, e.prototype.handleKey = function (t) {
        var e = 27,
            n = 13,
            r = 38,
            i = 40;

        switch (t.which) {
          case e:
            this.search.blur();
            break;

          case n:
            var o = this.highlighted;
            o && o.click();
            break;

          case r:
            this.highlightPrevious();
            break;

          case i:
            this.highlightNext();
        }
      }, e.prototype.select = function (t) {
        this.search.value = "", this.search.blur(), this.fire(e.EVENT_SELECT, t);
      }, e.prototype.focus = function () {
        this.body.style.width = this.search.offsetWidth + "px", this.highlighted = this.body.firstElementChild || null, this.node.classList.add("lu-search-open");
      }, Object.defineProperty(e.prototype, "highlighted", {
        get: function get() {
          return this.body.querySelector(".lu-search-highlighted") || null;
        },
        set: function set(t) {
          var e = this.highlighted;
          e !== t && (e && e.classList.remove("lu-search-highlighted"), t && t.classList.add("lu-search-highlighted"));
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.highlightNext = function () {
        var t = this.highlighted;

        if (t && !t.classList.contains("hidden")) {
          var e = Array.from(this.body.querySelectorAll(".lu-search-item:not(.hidden)")),
              n = e.indexOf(t);
          this.highlighted = e[n + 1] || null;
        } else this.highlighted = this.body.querySelector(".lu-search-item:not(.hidden)") || null;
      }, e.prototype.highlightPrevious = function () {
        var t = this.highlighted,
            e = Array.from(this.body.querySelectorAll(".lu-search-item:not(.hidden)"));

        if (t && !t.classList.contains("hidden")) {
          var n = e.indexOf(t);
          this.highlighted = e[n - 1] || null;
        } else this.highlighted = e[e.length - 1] || null;
      }, e.prototype.blur = function () {
        this.search.value = "", this.filterResults(this.body, ""), this.node.classList.remove("lu-search-open");
      }, e.prototype.filter = function () {
        var t = this.filterResults(this.body, this.search.value.toLowerCase());
        this.body.classList.toggle("lu-search-empty", t);
      }, e.prototype.filterResults = function (t, e) {
        var n = this;
        if ("" === e) return Array.from(t.querySelectorAll(".hidden")).forEach(function (t) {
          return t.classList.remove("hidden");
        }), !1;
        var r = Array.from(t.children);
        return r.forEach(function (t) {
          var r = !t.firstElementChild.innerHTML.toLowerCase().includes(e);

          if (t.classList.contains("lu-search-group")) {
            var i = t.lastElementChild,
                o = n.filterResults(i, e);
            r = r && o;
          }

          t.classList.toggle("hidden", r);
        }), r.every(function (t) {
          return t.classList.contains("hidden");
        });
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_SELECT]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.EVENT_SELECT = "select", e;
    }(n(13).a);

    e.d = i;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(33),
        o = n(26),
        a = n(7),
        u = n(6),
        c = n(2),
        s = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.missingValue = NaN, r.numberFormat = Object(i.a)(".3n"), n.numberFormat && (r.numberFormat = Object(i.a)(n.numberFormat)), void 0 !== n.missingValue && (r.missingValue = n.missingValue), r;
      }

      return Object(r.c)(e, t), e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.missingValue = this.missingValue, n;
      }, e.prototype.restore = function (e, n) {
        void 0 !== e.missingValue && (this.missingValue = e.missingValue), e.numberFormat && (this.numberFormat = Object(i.a)(e.numberFormat)), t.prototype.restore.call(this, e, n);
      }, e.prototype.getLabel = function (t) {
        if (!this.isLoaded()) return "";
        var e = this.getValue(t);
        return String("number" == typeof e && !isNaN(e) && isFinite(e) ? this.numberFormat(e) : e);
      }, e.prototype.getValue = function (t) {
        if (!this.isLoaded()) return null;
        var e = this.compute(t);
        return Object(a.c)(e) ? this.missingValue : e;
      }, e.prototype.compute = function (t) {
        return NaN;
      }, e.prototype.getNumber = function (t) {
        var e = this.getValue(t);
        return null == e ? NaN : e;
      }, e.prototype.getRawNumber = function (t) {
        return this.getNumber(t);
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? {
          value: this.getRawNumber(e),
          children: this.children.map(function (t) {
            return t.getExportValue(e, n);
          })
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.isMissing = function (t) {
        return Object(a.c)(this.compute(t));
      }, e.prototype.compare = function (t, e) {
        return u.b.prototype.compare.call(this, t, e);
      }, e.prototype.groupCompare = function (t, e) {
        return u.b.prototype.groupCompare.call(this, t, e);
      }, e.prototype.getRenderer = function () {
        return u.b.prototype.getRenderer.call(this);
      }, e = Object(r.b)([Object(c.d)("descending")], e);
    }(o.b);

    e.a = s;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return o;
    });
    var r = n(0),
        i = n(2);

    function o(t) {
      return void 0 === t && (t = "Aggregate Groups"), {
        type: "aggregate",
        label: t,
        fixed: !0
      };
    }

    var a = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultWidth(20), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, Object.defineProperty(e.prototype, "frozen", {
        get: function get() {
          return !1 !== this.desc.frozen;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_AGGREGATE]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.isAggregated = function (t) {
        var e = this.findMyRanker();
        return !!this.desc.isAggregated && this.desc.isAggregated(e, t);
      }, e.prototype.setAggregated = function (t, e) {
        var r = this.findMyRanker();
        return (this.desc.isAggregated && this.desc.isAggregated(r, t)) === e || (this.desc.setAggregated && this.desc.setAggregated(r, t, e), this.fire(n.EVENT_AGGREGATE, r, t, e), !1);
      }, e.EVENT_AGGREGATE = "aggregate", e = n = Object(r.b)([Object(i.e)(), Object(i.b)("support")], e);
    }(n(1).d);

    e.c = a;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    }), n.d(e, "e", function () {
      return i;
    }), n.d(e, "b", function () {
      return o;
    });
    var r = 19,
        i = 30,
        o = 500;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    });
    var r = n(56),
        i = n(36);

    function o() {
      return {
        toolbar: Object.assign({}, i.g),
        renderers: Object.assign({}, r.q),
        labelRotation: 0,
        summaryHeader: !0,
        animated: !0,
        expandLineOnHover: !1,
        sidePanel: !0,
        sidePanelCollapsed: !1,
        hierarchyIndicator: !0,
        defaultSlopeGraphMode: "item",
        overviewMode: !1,
        rowHeight: 18,
        groupHeight: 40,
        groupPadding: 5,
        rowPadding: 2,
        levelOfDetail: function levelOfDetail() {
          return "high";
        },
        customRowUpdate: function customRowUpdate() {},
        dynamicHeight: function dynamicHeight() {
          return null;
        },
        flags: {
          disableFrozenColumns: !0,
          advancedRankingFeatures: !0,
          advancedModelFeatures: !0,
          advancedUIFeatures: !0
        },
        ignoreUnsupportedBrowser: !1
      };
    }
  }, function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return c;
    }), n.d(e, "d", function () {
      return s;
    }), n.d(e, "b", function () {
      return l;
    }), n.d(e, "e", function () {
      return p;
    }), n.d(e, "j", function () {
      return f;
    });
    var r = n(23),
        i = n(1),
        o = n(3),
        a = n(15),
        u = n(42);

    function c(t) {
      return t instanceof i.d && "function" == typeof t.getDate || !(t instanceof i.d) && t.type.startsWith("date");
    }

    function s(t, e) {
      return !t || (null != e && e instanceof Date ? Object(o.l)(t, e.getTime()) : !t.filterMissing);
    }

    function l() {
      return {
        granularity: "month",
        circular: !1
      };
    }

    function p(t) {
      return Object(u.a)({
        granularity: "month",
        circular: !1
      }, t);
    }

    function f(t, e) {
      switch (t.granularity) {
        case "century":
          var n = Math.floor(e.getFullYear() / 100);

          if (t.circular) {
            var i = n % 10;
            return {
              value: i,
              name: "*" + i + "00"
            };
          }

          return {
            value: n,
            name: n + "00"
          };

        case "decade":
          var o = Math.floor(e.getFullYear() / 10);

          if (t.circular) {
            var u = o % 10;
            return {
              value: u,
              name: "**" + u + "0"
            };
          }

          return {
            value: o,
            name: o + "0"
          };

        case "year":
          if (t.circular) {
            var c = e.getFullYear() % 10;
            return {
              value: c,
              name: "***" + c
            };
          }

          return {
            value: e.getFullYear(),
            name: String(e.getFullYear())
          };

        case "month":
          return t.circular ? {
            value: e.getMonth(),
            name: Object(r.a)("%B")(e)
          } : {
            value: Object(a.f)(e).getTime(),
            name: Object(r.a)("%B %Y")(e)
          };

        case "week":
          return t.circular ? {
            value: e.getMonth(),
            name: Object(r.a)("%B")(e)
          } : {
            value: Object(a.j)(e).getTime(),
            name: Object(r.a)("%B %Y")(e)
          };

        case "day_of_week":
          return t.circular ? {
            value: e.getDay(),
            name: Object(r.a)("%A")(e)
          } : {
            value: Object(a.a)(e).getTime(),
            name: Object(r.a)("%x")(e)
          };

        case "day_of_month":
          return t.circular ? {
            value: e.getDate(),
            name: Object(r.a)("%d")(e)
          } : {
            value: Object(a.a)(e).getTime(),
            name: Object(r.a)("%x")(e)
          };

        case "day_of_year":
          if (t.circular) {
            var s = Object(r.a)("%j")(e);
            return {
              value: parseInt(s, 10),
              name: s
            };
          }

          return {
            value: Object(a.a)(e).getTime(),
            name: Object(r.a)("%x")(e)
          };

        case "hour":
          return t.circular ? {
            value: e.getHours(),
            name: Object(r.a)("%A")(e)
          } : {
            value: Object(a.b)(e).getTime(),
            name: Object(r.a)("%x")(e)
          };

        case "minute":
          return t.circular ? {
            value: e.getMinutes(),
            name: Object(r.a)("%A")(e)
          } : {
            value: Object(a.d)(e).getTime(),
            name: Object(r.a)("%x")(e)
          };

        case "second":
          return t.circular ? {
            value: e.getSeconds(),
            name: Object(r.a)("%A")(e)
          } : {
            value: Object(a.g)(e).getTime(),
            name: Object(r.a)("%x")(e)
          };
      }

      return {
        value: e.getTime(),
        name: e.toString()
      };
    }

    n.d(e, "a", function () {
      return o.INumberFilter;
    }), n.d(e, "i", function () {
      return o.p;
    }), n.d(e, "h", function () {
      return o.n;
    }), n.d(e, "g", function () {
      return o.j;
    }), n.d(e, "f", function () {
      return o.i;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(31),
        o = n(51),
        a = n(13),
        u = n(55),
        c = n(60),
        s = n(26),
        l = n(22),
        p = n(1),
        f = n(11),
        d = n(43),
        h = n(8);

    function g(t) {
      var e = new Map(),
          n = new Map();
      return t.forEach(function (t, r) {
        Object(c.b)(t) ? t.rows.forEach(function (t) {
          return e.set(t.i, r);
        }) : t.group && 0 === t.relativeIndex && n.set(t.group.name, r);
      }), {
        item2groupIndex: e,
        group2firstItemIndex: n
      };
    }

    function b(t) {
      return Object(c.b)(t) ? t.name : t.i.toString();
    }

    function m(t, e, n) {
      var r,
          o = function o(t) {
        return b(e[t]);
      },
          a = function a(t) {
        return b(n[t]);
      };

      if (e.reduce(function (t, e) {
        return t + (Object(c.b)(e) ? 1 : 0);
      }, 0) === n.reduce(function (t, e) {
        return t + (Object(c.b)(e) ? 1 : 0);
      }, 0)) return {
        currentKey: a,
        previous: t,
        previousKey: o
      };
      var u,
          s = [Object.assign({}, i.defaultPhases[0], {
        apply: function apply(t, a) {
          i.defaultPhases[0].apply(t), t.mode === i.EAnimationMode.SHOW && (t.node.style.transform = "translate(0, " + (function (t, i, a) {
            r || (r = g(e));
            var u = n[t],
                s = Object(c.b)(u) ? r.group2firstItemIndex.get(u.name) : r.item2groupIndex.get(u.i);
            if (void 0 === s) return a;
            var l = i.posByKey(o(s));
            return l.pos >= 0 ? l.pos : a;
          }(t.current.index, a, t.previous.y) - t.nodeY) + "px)");
        }
      }), Object.assign({}, i.defaultPhases[1], {
        apply: function apply(t, r, o) {
          i.defaultPhases[1].apply(t), t.mode === i.EAnimationMode.HIDE && (t.node.style.transform = "translate(0, " + (function (t, r, i) {
            u || (u = g(n));
            var o = e[t],
                s = Object(c.b)(o) ? u.group2firstItemIndex.get(o.name) : u.item2groupIndex.get(o.i);
            if (void 0 === s) return i;
            var l = r.posByKey(a(s));
            return l.pos >= 0 ? l.pos : i;
          }(t.previous.index, o, t.current.y) - t.nodeY) + "px)");
        }
      }), i.defaultPhases[i.defaultPhases.length - 1]];
      return {
        previous: t,
        previousKey: o,
        currentKey: a,
        phases: s
      };
    }

    var y = n(16),
        v = n(64),
        E = n(44),
        O = function () {
      function t(t, e, n, r) {
        this.c = t, this.index = e, this.ctx = n, this.flags = r, this.renderers = null;
      }

      return Object.defineProperty(t.prototype, "width", {
        get: function get() {
          return this.c.getWidth();
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "id", {
        get: function get() {
          return this.c.id;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "frozen", {
        get: function get() {
          return !this.flags.disableFrozenColumns && this.c.frozen;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.singleRenderer = function () {
        if (!this.renderers || !this.renderers.single) return null;
        if (this.renderers.singleTemplate) return this.renderers.singleTemplate.cloneNode(!0);
        var t = C(this.ctx.document, this.renderers.single.template);
        return t.dataset.renderer = this.renderers.singleId, t.dataset.group = "d", this.renderers.singleTemplate = t.cloneNode(!0), t;
      }, t.prototype.groupRenderer = function () {
        if (!this.renderers || !this.renderers.group) return null;
        if (this.renderers.groupTemplate) return this.renderers.groupTemplate.cloneNode(!0);
        var t = C(this.ctx.document, this.renderers.group.template);
        return t.dataset.renderer = this.renderers.groupId, t.dataset.group = "g", this.renderers.groupTemplate = t.cloneNode(!0), t;
      }, t.prototype.summaryRenderer = function () {
        if (!this.renderers || !this.renderers.summary) return null;
        if (this.renderers.summaryTemplate) return this.renderers.summaryTemplate.cloneNode(!0);
        var t = C(this.ctx.document, this.renderers.summary.template);
        return t.dataset.renderer = this.renderers.summaryId, t.classList.add("lu-summary"), this.renderers.summaryTemplate = t.cloneNode(!0), t;
      }, t.prototype.createHeader = function () {
        var t = Object(E.a)(this.c, this.ctx, {
          dragAble: this.flags.advancedUIFeatures,
          mergeDropAble: this.flags.advancedModelFeatures,
          rearrangeAble: this.flags.advancedUIFeatures,
          resizeable: this.flags.advancedUIFeatures
        });

        if (t.className = "lu-header", t.classList.toggle("frozen", this.frozen), this.renderers && this.renderers.summary) {
          var e = this.summaryRenderer();
          t.appendChild(e);
        }

        return this.updateHeader(t), t;
      }, t.prototype.updateHeader = function (t) {
        if (Object(E.e)(t, this.c), this.renderers && this.renderers.summary) {
          var e = t.querySelector(".lu-summary");
          e.dataset.renderer !== this.renderers.summaryId && (e.remove(), e = this.summaryRenderer(), t.appendChild(e)), this.renderers.summary.update(e, this.ctx.statsOf(this.c));
        }
      }, t.prototype.createCell = function (t) {
        var e = this.ctx.isGroup(t) ? this.groupRenderer() : this.singleRenderer();
        return this.updateCell(e, t), e;
      }, t.prototype.updateCell = function (t, e) {
        t.classList.toggle("frozen", this.frozen);
        var n = this.ctx.isGroup(e),
            r = t.dataset.renderer,
            i = n ? this.renderers.groupId : this.renderers.singleId,
            o = t.dataset.group;

        if (r === i && o === (n ? "g" : "d") || (t = n ? this.groupRenderer() : this.singleRenderer()), n) {
          var a = this.ctx.getGroup(e);
          this.renderers.group.update(t, a, a.rows);
        } else {
          var u = this.ctx.getRow(e);
          this.renderers.single.update(t, u, u.relativeIndex, u.group);
        }

        return t;
      }, t.prototype.renderCell = function (t, e) {
        var n = this.ctx.getRow(e);
        this.renderers.single.render(t, n, n.relativeIndex, n.group);
      }, t;
    }();

    function C(t, e) {
      var n = t.createElement("div");
      n.innerHTML = e;
      var r = n.firstElementChild;
      return n.innerHTML = "", r;
    }

    var _ = function (t) {
      function e(e, n, r, i) {
        var o = t.call(this, e, n, r, i) || this;
        return o.summaries = [], o;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "mc", {
        get: function get() {
          return this.c;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "width", {
        get: function get() {
          return this.c.getWidth() + h.d * this.mc.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createHeader = function () {
        var e = this,
            n = t.prototype.createHeader.call(this),
            r = this.ctx.document.createElement("div");
        return r.classList.add("lu-nested"), r.classList.add(Object(v.c)(this.c)), n.appendChild(r), this.summaries.splice(0, this.summaries.length), this.mc.children.forEach(function (t, n) {
          var i = Object(E.a)(t, e.ctx, {
            mergeDropAble: !1,
            dragAble: e.flags.advancedModelFeatures,
            rearrangeAble: e.flags.advancedModelFeatures,
            resizeable: e.flags.advancedModelFeatures
          });

          if (i.classList.add("lu-header"), i.style.gridColumnStart = (n + 1).toString(), r.appendChild(i), e.renderers && e.renderers.summary) {
            var o = e.ctx.summaryRenderer(t, !1);
            i.insertAdjacentHTML("beforeend", o.template);
            var a = i.lastElementChild;
            a.classList.add("lu-summary"), a.dataset.renderer = t.getSummaryRenderer(), e.summaries.push(o), o.update(a, e.ctx.statsOf(t));
          }
        }), this.updateNested(r), n;
      }, e.prototype.updateHeader = function (e) {
        t.prototype.updateHeader.call(this, e);
        var n = e.querySelector(".lu-nested");
        return n ? (e.appendChild(n), this.updateNested(n), e) : e;
      }, e.prototype.updateWidthRule = function (t) {
        var e = this.mc.children.map(function (t) {
          return "minmax(0, " + Object(y.k)(t.getWidth()) + "fr)";
        }),
            n = Object(v.c)(this.c);
        return t.updateRule("stacked-" + this.c.id, ".lineup-engine ." + n + " {\n      display: grid;\n      grid-template-columns: " + e.join(" ") + ";\n    }"), n;
      }, e.prototype.updateNested = function (t) {
        var e = this,
            n = this.mc.children,
            r = Array.from(t.children);
        n.forEach(function (t, n) {
          var i = r[n];

          if (Object(E.e)(i, t), e.renderers && e.renderers.summary) {
            var o = i.querySelector(".lu-summary"),
                a = o.dataset.renderer,
                u = t.getSummaryRenderer();

            if (a !== u) {
              var c = e.ctx.summaryRenderer(t, !1);
              o.remove(), o.innerHTML = c.template, (o = o.firstElementChild).classList.add("lu-summary"), o.dataset.renderer = u, e.summaries[n] = c, i.appendChild(o);
            }

            e.summaries[n].update(o, e.ctx.statsOf(t));
          }
        });
      }, e;
    }(O),
        T = n(87),
        N = n(89),
        D = function (t) {
      function e(e, n) {
        var r = t.call(this) || this;
        r.ctx = e, r.body = n, r.start = null;
        var i = n.parentElement.parentElement,
            o = i.querySelector("hr");
        o || (console.assert(null != i.ownerDocument), o = i.ownerDocument.createElement("hr"), i.appendChild(o)), r.hr = o;

        var a = function a(t) {
          r.showHint(t);
        },
            u = function u(t) {
          if (r.body.removeEventListener("mousemove", a), r.body.removeEventListener("mouseup", u), r.body.removeEventListener("mouseleave", u), r.start) {
            var e = r.start.node.classList.contains("lu-row") ? r.start.node : r.start.node.closest(".lu-row");
            console.assert(null != r.body.ownerDocument);
            var n = r.body.ownerDocument.elementFromPoint(t.clientX, t.clientY),
                i = n.classList.contains("lu-row") ? n : n.closest(".lu-row");
            r.start = null, r.body.classList.remove("lu-selection-active"), r.hr.classList.remove("lu-selection-active"), r.select(t.ctrlKey, e, i);
          }
        };

        return n.addEventListener("mousedown", function (t) {
          var e = i.getBoundingClientRect();
          r.start = {
            x: t.clientX,
            y: t.clientY,
            xShift: e.left,
            yShift: e.top,
            node: t.target
          }, r.body.classList.add("lu-selection-active"), n.addEventListener("mousemove", a, {
            passive: !0
          }), n.addEventListener("mouseup", u, {
            passive: !0
          }), n.addEventListener("mouseleave", u, {
            passive: !0
          });
        }, {
          passive: !0
        }), r;
      }

      return Object(r.c)(e, t), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_SELECT_RANGE]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.select = function (t, n, r) {
        var i = this;

        if (n && r && n !== r) {
          var o = parseInt(n.dataset.index, 10),
              a = parseInt(r.dataset.index, 10),
              u = Math.min(o, a),
              c = Math.max(o, a);
          u !== c && requestAnimationFrame(function () {
            return i.fire(e.EVENT_SELECT_RANGE, u, c, t);
          });
        }
      }, e.prototype.showHint = function (t) {
        var n = this.start,
            r = n.y,
            i = t.clientY,
            o = Math.abs(r - i) > e.MIN_DISTANCE;
        this.hr.classList.toggle("lu-selection-active", o), this.hr.style.transform = "translate(" + (n.x - n.xShift) + "px," + (r - n.yShift) + "px)scale(1," + Math.abs(i - r) + ")rotate(" + (i > r ? 90 : -90) + "deg)";
      }, e.prototype.remove = function (t) {
        t.onclick = void 0;
      }, e.prototype.add = function (t) {
        var e = this;

        t.onclick = function (n) {
          var r = parseInt(t.dataset.i, 10);

          if (n.shiftKey) {
            var i = parseInt(t.dataset.index, 10),
                o = t.parentElement.dataset.ranking;
            if (Object(N.b)(e.ctx.provider, o, r, i, n.ctrlKey)) return;
          }

          e.ctx.provider.toggleSelection(r, n.ctrlKey);
        };
      }, e.prototype.selectRange = function (t, e) {
        void 0 === e && (e = !1);

        var n = new T.a(e ? this.ctx.provider.getSelection() : []),
            r = function r(t) {
          n.has(t) ? n.delete(t) : n.add(t);
        };

        t.forEach(function (t) {
          Object(c.b)(t) ? t.rows.forEach(function (t) {
            return r(t.i);
          }) : r(t.i);
        }), this.ctx.provider.setSelection(Array.from(n));
      }, e.prototype.updateState = function (t, e) {
        this.ctx.provider.isSelected(e) ? t.classList.add("lu-selected") : t.classList.remove("lu-selected");
      }, e.prototype.update = function (t, e) {
        var n = parseInt(t.dataset.i, 10);
        e.has(n) ? t.classList.add("lu-selected") : t.classList.remove("lu-selected");
      }, e.EVENT_SELECT_RANGE = "selectRange", e.MIN_DISTANCE = 10, e;
    }(a.a),
        R = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return Object(r.c)(e, t), e.prototype.fire = function (e) {
        for (var n = [], i = 1; i < arguments.length; i++) {
          n[i - 1] = arguments[i];
        }

        t.prototype.fire.apply(this, Object(r.d)([e], n));
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_WIDTH_CHANGED, e.EVENT_UPDATE_DATA, e.EVENT_UPDATE_HIST, e.EVENT_HIGHLIGHT_CHANGED]);
      }, e.EVENT_WIDTH_CHANGED = "widthChanged", e.EVENT_UPDATE_DATA = "updateData", e.EVENT_UPDATE_HIST = "updateHist", e.EVENT_HIGHLIGHT_CHANGED = "highlightChanged", e;
    }(a.a),
        w = function (t) {
      function e(n, r, a, s, l, d, g) {
        void 0 === g && (g = {});
        var b = t.call(this, r, a, s, l, {
          mixins: [i.PrefetchMixin],
          batchSize: 10
        }) || this;
        b.ranking = n, b.ctx = d, b.data = [], b.highlight = -1, b.canvasPool = [], b.oldLeft = 0, b.events = new R(), b.roptions = {
          animation: !0,
          levelOfDetail: function levelOfDetail() {
            return "high";
          },
          customRowUpdate: function customRowUpdate() {},
          flags: {
            disableFrozenColumns: !1,
            advancedModelFeatures: !0,
            advancedRankingFeatures: !0,
            advancedUIFeatures: !0
          }
        }, b.canvasMouseHandler = {
          timer: -1,
          enter: function enter(t) {
            var e = b.canvasMouseHandler;
            e.timer > 0 && self.clearTimeout(e.timer);
            var n = t.currentTarget;
            n.addEventListener("mouseleave", e.leave, {
              passive: !0
            }), e.timer = self.setTimeout(function () {
              return b.updateHoveredRow(n, !0);
            }, o.b);
          },
          leave: function leave(t) {
            var n = b.canvasMouseHandler;
            n.timer > 0 && (self.clearTimeout(n.timer), n.timer = -1);
            var r = t.currentTarget;
            e.isCanvasRenderedRow(r) || self.setTimeout(function () {
              return b.updateHoveredRow(r, !1);
            }), r.removeEventListener("mouseleave", n.leave);
          }
        }, b.highlightHandler = {
          enabled: !1,
          enter: function enter(t) {
            if (b.highlight >= 0) {
              var n = b.body.querySelector(".le-highlighted");
              n && n.classList.remove("le-highlighted"), b.highlight = -1;
            }

            var r = t.currentTarget,
                i = parseInt(r.dataset.i || "-1", 10);
            b.events.fire(e.EVENT_HIGHLIGHT_CHANGED, i);
          },
          leave: function leave() {
            if (b.highlight >= 0) {
              var t = b.body.querySelector(".le-highlighted");
              t && t.classList.remove("le-highlighted"), b.highlight = -1;
            }

            b.events.fire(e.EVENT_HIGHLIGHT_CHANGED, -1);
          }
        }, Object.assign(b.roptions, g), a.classList.add("lu-row-body"), a.dataset.ranking = n.id;
        var m = b;
        return b.delayedUpdate = Object(u.a)(function () {
          this.type === f.b.EVENT_DIRTY_VALUES ? this.primaryType !== p.d.EVENT_RENDERER_TYPE_CHANGED && this.primaryType !== p.d.EVENT_GROUP_RENDERER_TYPE_CHANGED && this.primaryType !== p.d.EVENT_LABEL_CHANGED && m.updateBody() : m.events.fire(e.EVENT_UPDATE_DATA);
        }, 50, function (t, e) {
          return t.self.type === f.b.EVENT_ORDER_CHANGED ? t : e;
        }), b.delayedUpdateAll = Object(u.a)(function () {
          return b.updateAll();
        }, 50), b.delayedUpdateColumnWidths = Object(u.a)(function () {
          return b.updateColumnWidths();
        }, 50), n.on(f.b.EVENT_ADD_COLUMN + ".hist", function (t, e) {
          b.columns.splice(e, 0, b.createCol(t, e)), b.reindex(), b.updateHist(t), b.delayedUpdateAll();
        }), n.on(f.b.EVENT_REMOVE_COLUMN + ".body", function (t, n) {
          e.disableListener(t), b.columns.splice(n, 1), b.reindex(), b.delayedUpdateAll();
        }), n.on(f.b.EVENT_MOVE_COLUMN + ".body", function (t, e, n) {
          var r = b.columns.splice(n, 1)[0];
          console.assert(r.c === t), b.columns.splice(n < e ? e - 1 : e, 0, r), b.reindex(), b.delayedUpdateAll();
        }), n.on(f.b.EVENT_COLUMN_VISIBILITY_CHANGED + ".body", function (t, r, i) {
          if (i) {
            var o = n.children.indexOf(t);
            b.columns.splice(o, 0, b.createCol(t, o)), b.updateHist(t);
          } else {
            o = b.columns.findIndex(function (e) {
              return e.c === t;
            });
            e.disableListener(t), b.columns.splice(o, 1);
          }

          b.reindex(), b.delayedUpdateAll();
        }), n.on(f.b.EVENT_ORDER_CHANGED + ".body", b.delayedUpdate), b.selection = new D(b.ctx, a), b.selection.on(D.EVENT_SELECT_RANGE, function (t, e, n) {
          b.selection.selectRange(b.data.slice(t, e + 1), n);
        }), b.renderCtx = Object.assign({
          isGroup: function isGroup(t) {
            return Object(c.b)(b.data[t]);
          },
          getRow: function getRow(t) {
            return b.data[t];
          },
          getGroup: function getGroup(t) {
            return b.data[t];
          }
        }, d), b.columns = n.children.filter(function (t) {
          return t.isVisible();
        }).map(function (t, e) {
          return b.createCol(t, e);
        }), b._context = Object.assign({
          columns: b.columns,
          column: Object(i.nonUniformContext)(b.columns.map(function (t) {
            return t.width;
          }), 100, h.d)
        }, Object(i.uniformContext)(0, 20)), b.columns.forEach(function (t) {
          t instanceof _ && t.updateWidthRule(b.style), t.renderers = b.ctx.createRenderer(t.c);
        }), b;
      }

      return Object(r.c)(e, t), e.prototype.on = function (t, e) {
        return this.events.on(t, e), this;
      }, Object.defineProperty(e.prototype, "id", {
        get: function get() {
          return this.ranking.id;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.onVisibilityChanged = function (e) {
        t.prototype.onVisibilityChanged.call(this, e), e && this.delayedUpdate.call({
          type: f.b.EVENT_ORDER_CHANGED
        });
      }, e.prototype.updateHeaders = function () {
        return t.prototype.updateHeaders.call(this);
      }, Object.defineProperty(e.prototype, "currentData", {
        get: function get() {
          return this.data;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "context", {
        get: function get() {
          return this._context;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createHeader = function (t, e) {
        return e.createHeader();
      }, e.prototype.updateHeader = function (t, e) {
        return e instanceof _ && e.updateWidthRule(this.style), e.updateHeader(t);
      }, e.prototype.createCell = function (t, e, n) {
        return n.createCell(e);
      }, e.prototype.updateCell = function (t, e, n) {
        return n.updateCell(t, e);
      }, e.prototype.selectCanvas = function () {
        if (this.canvasPool.length > 0) return this.canvasPool.pop();
        console.assert(null != this.body.ownerDocument);
        var t = this.body.ownerDocument.createElement("canvas");
        return t.classList.add("lu-detail-canvas"), t;
      }, e.prototype.rowFlags = function (t) {
        var e = t,
            n = e.__lu__;
        return null == n ? e.__lu__ = {} : n;
      }, e.prototype.visibleRenderedWidth = function () {
        for (var t = 0, e = 0, n = this.visibleColumns.frozen; e < n.length; e++) {
          var r = n[e];
          t += this.columns[r].width + h.d;
        }

        for (r = this.visibleColumns.first; r <= this.visibleColumns.last; ++r) {
          t += this.columns[r].width + h.d;
        }

        return t > 0 && (t -= h.d), t;
      }, e.prototype.renderRow = function (t, e, n) {
        void 0 === n && (n = this.visibleRenderedWidth()), t.width = n, t.style.width = n + "px", t.height = h.c;
        var r = t.getContext("2d");
        r.imageSmoothingEnabled = !1, r.clearRect(0, 0, t.width, t.height), r.save();

        for (var i = 0, o = this.visibleColumns.frozen; i < o.length; i++) {
          var a = o[i];
          (c = this.columns[a]).renderCell(r, e);
          var u = c.width + h.d;
          r.translate(u, 0);
        }

        for (a = this.visibleColumns.first; a <= this.visibleColumns.last; ++a) {
          var c;
          (c = this.columns[a]).renderCell(r, e);
          u = c.width + h.d;
          r.translate(u, 0);
        }

        r.restore();
      }, e.prototype.updateCanvasCell = function (t, e, n, r) {
        var i = t.getContext("2d");
        i.clearRect(r - 1, 0, n.width + 2, t.height), i.save(), i.translate(r, 0), n.renderCell(i, e), i.restore();
      }, e.prototype.reindex = function () {
        this.columns.forEach(function (t, e) {
          t.index = e;
        });
      }, e.prototype.updateAll = function () {
        var n = this;
        this.columns.forEach(function (t, e) {
          t.index = e, t.renderers = n.ctx.createRenderer(t.c);
        }), this._context = Object.assign({}, this._context, {
          column: Object(i.nonUniformContext)(this.columns.map(function (t) {
            return t.width;
          }), 100, h.d)
        }), t.prototype.recreate.call(this), this.events.fire(e.EVENT_WIDTH_CHANGED);
      }, e.prototype.updateBody = function () {
        var n = this;
        this.hidden || (this.events.fire(e.EVENT_WIDTH_CHANGED), t.prototype.forEachRow.call(this, function (t, e) {
          return n.updateRow(t, e);
        }));
      }, e.prototype.updateHeaderOf = function (t) {
        var e = this._context.columns.findIndex(function (e) {
          return e.c === t;
        });

        if (e < 0) return !1;
        var n = this.header.children[e],
            r = this._context.columns[e];
        return n && r && this.updateHeader(n, r), n && r;
      }, e.prototype.createRow = function (e, n) {
        if (e.classList.add("lu-row"), this.roptions.customRowUpdate(e, n), this.highlightHandler.enabled && (e.addEventListener("mouseenter", this.highlightHandler.enter, {
          passive: !0
        }), this.rowFlags(e).highlight = !0), this.renderCtx.isGroup(n)) return e.dataset.agg = "group", void t.prototype.createRow.call(this, e, n);
        var r = this.renderCtx.getRow(n),
            i = r.i,
            o = r.meta;
        e.classList.toggle("le-highlighted", this.highlight === i), e.dataset.i = i.toString(), e.dataset.agg = "detail", o ? e.dataset.meta = o : delete e.dataset.meta, this.selection.updateState(e, i), this.selection.add(e);
        var a = this.roptions.levelOfDetail(n);
        if ("high" === a ? delete e.dataset.lod : e.dataset.lod = a, "high" === a || o || this.ctx.provider.isSelected(i)) t.prototype.createRow.call(this, e, n);else {
          var u = this.selectCanvas();
          e.appendChild(u), this.renderRow(u, n), e.addEventListener("mouseenter", this.canvasMouseHandler.enter, {
            passive: !0
          });
        }
      }, e.prototype.updateRow = function (e, n, r) {
        this.roptions.customRowUpdate(e, n);
        var i = this.roptions.levelOfDetail(n),
            o = r || i,
            a = e.dataset.lod || "high",
            u = this.renderCtx.isGroup(n),
            c = "group" === e.dataset.agg;
        if ("high" === i ? delete e.dataset.lod : e.dataset.lod = i, this.highlightHandler.enabled && !this.rowFlags(e).highlight && (e.addEventListener("mouseenter", this.highlightHandler.enter, {
          passive: !0
        }), this.rowFlags(e).highlight = !0), e.removeEventListener("mouseenter", this.canvasMouseHandler.enter), u !== c && (e.innerHTML = "", e.dataset.agg = u ? "group" : "detail", u ? (e.dataset.i = "", this.selection.remove(e)) : this.selection.add(e)), u) return e.classList.remove("le-highlighted"), void t.prototype.updateRow.call(this, e, n);
        var s = this.renderCtx.getRow(n),
            l = s.i,
            p = s.meta;
        e.classList.toggle("le-highlighted", this.highlight === l), e.dataset.i = l.toString(), p ? e.dataset.meta = p : delete e.dataset.meta, this.selection.updateState(e, l);
        var f = Array.from(e.children).find(function (t) {
          return t.classList.contains("lu-detail-canvas");
        });
        if ("high" === o || p || this.ctx.provider.isSelected(l)) return f && (this.canvasPool.push(f), f.remove()), void t.prototype.updateRow.call(this, e, n);
        if (e.addEventListener("mouseenter", this.canvasMouseHandler.enter, {
          passive: !0
        }), "high" !== a && f) this.renderRow(f, n);else {
          e.innerHTML = "", e.dataset.agg = "detail";
          var d = this.selectCanvas();
          e.appendChild(d), this.renderRow(d, n);
        }
      }, e.prototype.updateCanvasBody = function () {
        var n = this,
            r = this.visibleRenderedWidth();
        t.prototype.forEachRow.call(this, function (t, i) {
          e.isCanvasRenderedRow(t) && n.renderRow(t.querySelector("canvas"), i, r);
        });
      }, e.prototype.updateShifts = function (e, n) {
        t.prototype.updateShifts.call(this, e, n), n !== this.oldLeft && (this.oldLeft = n, this.updateCanvasBody());
      }, e.prototype.enableHighlightListening = function (e) {
        var n = this;

        if (this.highlightHandler.enabled !== e) {
          if (this.highlightHandler.enabled = e, e) return this.body.addEventListener("mouseleave", this.highlightHandler.leave, {
            passive: !0
          }), void t.prototype.forEachRow.call(this, function (t) {
            t.addEventListener("mouseenter", n.highlightHandler.enter, {
              passive: !0
            }), n.rowFlags(t).highlight = !0;
          });
          this.body.removeEventListener("mouseleave", this.highlightHandler.leave), t.prototype.forEachRow.call(this, function (t) {
            t.removeEventListener("mouseenter", n.highlightHandler.enter), n.rowFlags(t).highlight = !1;
          });
        }
      }, e.prototype.updateHoveredRow = function (t, n) {
        if (e.isCanvasRenderedRow(t) === n) {
          var r = parseInt(t.dataset.index, 10);
          this.updateRow(t, r, n ? "high" : "low");
        }
      }, e.prototype.forEachRow = function (n, r) {
        void 0 === r && (r = !1);
        return t.prototype.forEachRow.call(this, function (t, r) {
          e.isCanvasRenderedRow(t) || n(t, r);
        }, r);
      }, e.prototype.updateSelection = function (e) {
        var n = this;
        t.prototype.forEachRow.call(this, function (t, r) {
          n.renderCtx.isGroup(r) ? n.updateRow(t, r) : n.selection.update(t, e);
        }, !0);
      }, e.prototype.updateColumnWidths = function () {
        var n = this;
        this._context.column = Object(i.nonUniformContext)(this._context.columns.map(function (t) {
          return t.width;
        }), 100, h.d), t.prototype.updateColumnWidths.call(this), this.context.columns.forEach(function (t) {
          t instanceof _ && t.updateWidthRule(n.style), t.renderers = n.ctx.createRenderer(t.c);
        }), this.events.fire(e.EVENT_WIDTH_CHANGED);
      }, e.prototype.updateHist = function (t) {
        this.events.fire(e.EVENT_UPDATE_HIST, t);
      }, e.prototype.updateColumn = function (n) {
        var r = this,
            o = this.context.columns,
            a = o[n];
        if (!a) return !1;

        for (var u = 0, c = this.visibleColumns.first; c < n; ++c) {
          u += o[c].width + h.d;
        }

        return t.prototype.forEachRow.call(this, function (t, o) {
          if (e.isCanvasRenderedRow(t)) r.updateCanvasCell(t.querySelector("canvas"), o, a, u);else {
            var c = t.children[n];

            if (c) {
              var s = r.updateCell(c, o, a);
              c !== s && s && (Object(i.setColumn)(s, a), t.replaceChild(s, c));
            }
          }
        }), !0;
      }, e.prototype.destroy = function () {
        t.prototype.destroy.call(this), this.ranking.flatColumns.forEach(function (t) {
          return e.disableListener(t);
        });
      }, e.prototype.groupData = function (t) {
        var e = this,
            n = this.ranking.getGroups(),
            r = this.ctx.provider,
            i = function i(t, e) {
          return 1 === e ? "first last" : 0 === t ? "first" : t === e - 1 ? "last" : void 0;
        };

        if (1 === n.length) return r.isAggregated(this.ranking, n[0]) ? [Object.assign({
          rows: t
        }, n[0])] : t.map(function (e, r) {
          return Object.assign({
            group: n[0],
            relativeIndex: r,
            meta: i(r, t.length)
          }, e);
        });
        var o = 0,
            a = [];
        return n.forEach(function (n) {
          var u = n.order.length,
              c = t.slice(o, o + u);
          o += u, r.isAggregated(e.ranking, n) ? a.push(Object.assign({
            rows: c
          }, n)) : a.push.apply(a, c.map(function (t, e) {
            return Object.assign({
              group: n,
              relativeIndex: e,
              meta: i(e, c.length)
            }, t);
          }));
        }), a;
      }, e.prototype.render = function (e, n) {
        var r = this,
            o = this._context,
            a = this.data;
        if (this.data = e, this.renderCtx.totalNumberOfRows = e.length, this.columns.forEach(function (t, e) {
          t.index = e, t.renderers = r.ctx.createRenderer(t.c);
        }), this._context = Object.assign({
          columns: this.columns,
          column: Object(i.nonUniformContext)(this.columns.map(function (t) {
            return t.width;
          }), 100, h.d)
        }, n), this.bodyScroller) return t.prototype.recreate.call(this, this.roptions.animation ? m(o, a, this.data) : void 0);
      }, e.prototype.setHighlight = function (t) {
        this.highlight = t;
        var e = this.body.querySelector("[data-i].le-highlighted");

        if (e && e.classList.remove("le-highlighted"), !(t < 0)) {
          var n = this.body.querySelector('[data-i="' + t + '"]');
          return n && n.classList.add("le-highlighted"), null != n;
        }
      }, e.prototype.findNearest = function (t) {
        var e = this,
            n = t.find(function (t) {
          return Boolean(e.body.querySelectorAll('[data-i="' + t + '"]'));
        });
        if (null != n) return n;

        for (var r = this.visible, i = new Set(t), o = -1, a = -1, u = r.first; u >= 0; --u) {
          var s = this.data[u];

          if (!Object(c.b)(s) && i.has(s.i)) {
            o = u;
            break;
          }
        }

        for (u = r.last; u < this.data.length; ++u) {
          s = this.data[u];

          if (!Object(c.b)(s) && i.has(s.i)) {
            a = u;
            break;
          }
        }

        if (o < 0 && o < 0) return -1;
        var l = o >= 0 && r.first - o < a - r.last ? o : a;
        return this.data[l].i;
      }, e.prototype.scrollIntoView = function (t) {
        var e = this,
            n = this.body.querySelector('[data-i="' + t + '"]');
        if (n) return n.scrollIntoView(!0), !0;
        var r = this.data.findIndex(function (e) {
          return !Object(c.b)(e) && e.i === t;
        });
        if (r < 0) return !1;

        var i = function () {
          var t = e._context;
          if (0 === t.exceptions.length || r < t.exceptions[0].index) return r * t.defaultRowHeight;
          var n = t.exceptions.reverse().find(function (t) {
            return t.index <= r;
          });
          if (!n) return -1;
          if (n.index === r) return n.y;
          var i = r - n.index - 1;
          return n.y2 + i * t.defaultRowHeight;
        }();

        if (i < 0) return !1;
        var o = this.bodyScroller;
        if (!o) return !1;
        var a = o.scrollTop;
        o.scrollTop = Math.min(i, o.scrollHeight - o.clientHeight), this.onScrolledVertically(o.scrollTop, o.clientHeight, a < o.scrollTop);
        var u = this.body.querySelector('[data-i="' + t + '"]');
        return !!u && (u.scrollIntoView(!0), !0);
      }, e.prototype.getHighlight = function () {
        var t = this.body.querySelector("[data-i]:hover, [data-i].le-highlighted");
        return t ? parseInt(t.dataset.i, 10) : this.highlight;
      }, e.prototype.createCol = function (t, n) {
        var r = this,
            i = Object(s.c)(t) && !t.getCollapsed() ? new _(t, n, this.renderCtx, this.roptions.flags) : new O(t, n, this.renderCtx, this.roptions.flags);
        t.on(p.d.EVENT_WIDTH_CHANGED + ".body", function () {
          r.delayedUpdateColumnWidths();
        }), t.on(l.b.EVENT_DATA_LOADED + ".hist", function () {
          return r.updateHist(t);
        });
        var o = Object(u.a)(function () {
          r.updateColumn(i.index) || e.disableListener(t);
        }, 25);
        t.on([p.d.EVENT_RENDERER_TYPE_CHANGED + ".body", p.d.EVENT_GROUP_RENDERER_TYPE_CHANGED + ".body"], function () {
          i.renderers = r.ctx.createRenderer(t), o();
        });
        var a = this;
        return t.on(p.d.EVENT_DIRTY_HEADER + ".body", function () {
          a.updateHeaderOf(i.c) || e.disableListener(t), this.primaryType !== p.d.EVENT_SUMMARY_RENDERER_TYPE_CHANGED && this.primaryType !== p.d.EVENT_LABEL_CHANGED && this.primaryType !== p.d.EVENT_METADATA_CHANGED && self.setTimeout(function () {
            return a.updateHist(i.c);
          }, 50);
        }), t.on(p.d.EVENT_SUMMARY_RENDERER_TYPE_CHANGED + ".body", function () {
          i.renderers = r.ctx.createRenderer(t), r.updateHeaderOf(i.c) || e.disableListener(t);
        }), t.on(p.d.EVENT_DIRTY_VALUES + ".body", o), Object(s.c)(t) && !t.getCollapsed() && (i.updateWidthRule(this.style), t.on(d.b.EVENT_MULTI_LEVEL_CHANGED + ".body", function () {
          i.updateWidthRule(r.style);
        }), t.on(d.b.EVENT_MULTI_LEVEL_CHANGED + ".bodyUpdate", o)), i;
      }, e.isCanvasRenderedRow = function (t) {
        return "low" === t.dataset.lod && 1 === t.childElementCount && t.firstElementChild.classList.contains("lu-detail-canvas");
      }, e.disableListener = function (t) {
        t.on(p.d.EVENT_WIDTH_CHANGED + ".body", null), t.on(l.b.EVENT_DATA_LOADED + ".hist", null), t.on([p.d.EVENT_RENDERER_TYPE_CHANGED + ".body", p.d.EVENT_GROUP_RENDERER_TYPE_CHANGED + ".body", p.d.EVENT_SUMMARY_RENDERER_TYPE_CHANGED + ".body", p.d.EVENT_LABEL_CHANGED + ".body"], null), t.on(f.b.EVENT_DIRTY_HEADER + ".body", null), t.on(f.b.EVENT_DIRTY_VALUES + ".body", null), Object(s.c)(t) && (t.on(d.b.EVENT_MULTI_LEVEL_CHANGED + ".body", null), t.on(d.b.EVENT_MULTI_LEVEL_CHANGED + ".bodyUpdate", null));
      }, e.EVENT_WIDTH_CHANGED = R.EVENT_WIDTH_CHANGED, e.EVENT_UPDATE_DATA = R.EVENT_UPDATE_DATA, e.EVENT_UPDATE_HIST = R.EVENT_UPDATE_HIST, e.EVENT_HIGHLIGHT_CHANGED = R.EVENT_HIGHLIGHT_CHANGED, e;
    }(i.ACellTableSection);

    e.c = w;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    var r = n(0);

    function i(t, e, n) {
      void 0 === e && (e = 100);
      var i = -1,
          o = null;
      return function () {
        for (var a = [], u = 0; u < arguments.length; u++) {
          a[u] = arguments[u];
        }

        i >= 0 && (clearTimeout(i), i = -1);
        var c = {
          self: this,
          args: a
        };
        o = o && n ? n(o, c) : c, i = self.setTimeout(function () {
          console.assert(null != o), t.call.apply(t, Object(r.d)([o.self], o.args)), o = null;
        }, e);
      };
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(61),
        i = n(9),
        o = n(4),
        a = function () {
      function t() {
        this.title = "Default";
      }

      return t.prototype.canRender = function (t, e) {
        return t instanceof r.b && e !== i.a.SUMMARY;
      }, t.prototype.create = function (t) {
        var e = t.actions;
        return {
          template: "<div class='actions lu-hover-only'>" + e.map(function (t) {
            return "<span title='" + t.name + "' class='" + (t.className || "") + "'>" + (t.icon || "") + "</span>";
          }).join("") + "</div>",
          update: function update(t, n) {
            Object(o.f)(t, function (t, r) {
              t.onclick = function (t) {
                t.preventDefault(), t.stopPropagation(), e[r].action(n);
              };
            });
          },
          render: o.i
        };
      }, t.prototype.createGroup = function (t) {
        var e = t.groupActions;
        return {
          template: "<div class='actions lu-hover-only'>" + e.map(function (t) {
            return "<span title='" + t.name + "' class='" + (t.className || "") + "'>" + (t.icon || "") + "</span>";
          }).join("") + "</div>",
          update: function update(t, n, r) {
            Object(o.f)(t, function (t, i) {
              t.onclick = function (t) {
                t.preventDefault(), t.stopPropagation(), e[i].action(n, r);
              };
            });
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        u = n(50),
        c = n(8),
        s = function () {
      function t() {
        this.title = "Default";
      }

      return t.prototype.canRender = function (t) {
        return t instanceof u.c;
      }, t.prototype.create = function (t, e) {
        var n = e.colWidth(t);
        return {
          template: '<div title="Collapse Group"></div>',
          update: function update(e, n, r, i) {
            e.onclick = function (e) {
              e.preventDefault(), e.stopPropagation(), t.setAggregated(i, !0);
            };
          },
          render: function render(t) {
            t.fillStyle = c.a.color, t.fillRect(n - c.a.width - 1, 0, c.a.strokeWidth, c.c);
          }
        };
      }, t.prototype.createGroup = function (t) {
        return {
          template: '<div title="Expand Group"></div>',
          update: function update(e, n) {
            e.onclick = function (e) {
              e.preventDefault(), e.stopPropagation(), t.setAggregated(n, !1);
            };
          }
        };
      }, t.prototype.createSummary = function (t, e) {
        return {
          template: '<div title="(Un)Aggregate All" data-icon="caret-down"></div>',
          update: function update(n) {
            var r = t.findMyRanker(),
                i = Boolean(r && r.getGroups().every(function (e) {
              return t.isAggregated(e);
            }));
            n.dataset.icon = i ? "caret-right" : "caret-down", n.onclick = function (r) {
              r.stopPropagation();
              var i = t.findMyRanker();

              if (i && e) {
                var o = "caret-down" === n.dataset.icon;
                n.dataset.icon = o ? "caret-right" : "caret-down", e.provider.aggregateAllOf(i, o);
              }
            };
          }
        };
      }, t;
    }(),
        l = n(0),
        p = n(81),
        f = n(20),
        d = n(30),
        h = n(10),
        g = function () {
      function t() {
        this.title = "Default";
      }

      return t.prototype.canRender = function (t) {
        return t instanceof f.d;
      }, t.prototype.create = function (t) {
        var e = t.alignment || "left";
        return {
          template: "<div" + ("left" !== e ? ' class="lu-' + e + '"' : "") + "> </div>",
          update: function update(e, n) {
            Object(h.b)(e, t, n), t.escape ? Object(o.j)(e, t.getLabel(n)) : e.innerHTML = t.getLabel(n);
          },
          render: o.i
        };
      }, t.prototype.createGroup = function (t) {
        return {
          template: "<div> </div>",
          update: function update(e, n, r) {
            var i = Object(o.d)(t, r);
            t.escape ? Object(o.j)(e, i) : e.innerHTML = i;
          }
        };
      }, t.interactiveSummary = function (t, e) {
        var n = e,
            r = Object(d.c)(e),
            i = e.querySelector('input[type="text"]'),
            o = e.querySelector('input[type="checkbox"]'),
            a = function a() {
          if (i.disabled = r.checked, o.disabled = r.checked, r.checked) t.setFilter(f.d.FILTER_MISSING);else {
            var e = i.value.trim();
            r.disabled = e.length > 0, e.length <= 0 ? t.setFilter(null) : t.setFilter(o.checked ? new RegExp(i.value) : i.value);
          }
        };

        return r.onchange = a, i.onchange = a, o.onchange = a, n.onsubmit = function (t) {
          return t.preventDefault(), t.stopPropagation(), a(), !1;
        }, function (e) {
          var n = (t = e).getFilter() || "",
              a = n === f.d.FILTER_MISSING;
          a && (n = ""), r.checked = a, i.value = n instanceof RegExp ? n.source : n, o.checked = n instanceof RegExp, r.disabled = i.value.trim().length > 0, i.disabled = r.checked, o.disabled = r.checked;
        };
      }, t.prototype.createSummary = function (e, n, r) {
        if (!r) return {
          template: "<div></div>",
          update: function update(t) {
            var n = e.getFilter() || "";

            t.textContent = function (t) {
              if (null == t || "" === t || t === f.d.FILTER_MISSING) return "";
              if (t instanceof RegExp) return t.source;
              return String(t);
            }(n);
          }
        };
        var i,
            a = e.getFilter() || "",
            u = a === f.d.FILTER_MISSING;
        u && (a = "");
        var c = Object(o.k)(n.idPrefix);
        return {
          template: '<form><input type="text" placeholder="Filter ' + e.desc.label + '..." autofocus value="' + (a instanceof RegExp ? a.source : a) + '">\n          <div class="lu-checkbox"><input id="' + c + '" type="checkbox" ' + (a instanceof RegExp ? 'checked="checked"' : "") + '><label for="' + c + '">Use regular expressions</label></div>\n          ' + Object(d.a)(u, n.idPrefix) + "</form>",
          update: function update(n) {
            i || (i = t.interactiveSummary(e, n)), i(e);
          }
        };
      }, t;
    }();

    var b = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.title = "Default", e;
      }

      return Object(l.c)(e, t), e.prototype.canRender = function (e) {
        return t.prototype.canRender.call(this, e) && e instanceof p.a;
      }, e.prototype.create = function (t) {
        return {
          template: "<div class='annotations text'>\n        <input class='lu-hover-only'>\n        <span class='text lu-not-hover'></span>\n       </div>",
          update: function update(e, n) {
            var r = e.firstElementChild;
            r.onchange = function () {
              t.setValue(n, r.value);
            }, r.onclick = function (t) {
              t.stopPropagation();
            }, e.lastElementChild.textContent = r.value = t.getLabel(n);
          },
          render: o.i
        };
      }, e;
    }(g),
        m = n(3),
        y = n(1),
        v = n(17);

    function E(t, e, n, r) {
      return n && n.color ? n.color(e, r) : e ? t.getColor(e) : Object(v.d)(t) ? t.getColorMapping().apply(null != r ? r : 0) : y.d.DEFAULT_COLOR;
    }

    var O = function () {
      function t(t) {
        void 0 === t && (t = !1), this.renderValue = t, this.title = "Bar";
      }

      return t.prototype.canRender = function (t, e) {
        return e === i.a.CELL && Object(m.k)(t) && !Object(m.m)(t);
      }, t.prototype.create = function (t, e, n, r) {
        var i = e.colWidth(t);
        return {
          template: '<div title="">\n          <div style=\'background-color: ' + y.d.DEFAULT_COLOR + "'>\n            <span " + (this.renderValue ? "" : 'class="lu-hover-only"') + "></span>\n          </div>\n        </div>",
          update: function update(e, n) {
            var i = t.getNumber(n),
                a = Object(h.b)(e, t, n),
                u = isNaN(i) ? 0 : Math.round(100 * i * 100) / 100,
                c = t.getLabel(n);
            e.title = c;
            var s = e.firstElementChild;
            s.style.width = a ? "100%" : u + "%";
            var l = E(t, n, r, i);
            s.style.backgroundColor = a ? null : l, Object(o.j)(s.firstElementChild, c);
            var p = s.firstElementChild;
            Object(o.j)(p, c), Object(o.a)(p, l || y.d.DEFAULT_COLOR, c, u / 100);
          },
          render: function render(e, n) {
            if (!Object(h.a)(e, t, n, i)) {
              var o = t.getNumber(n);
              e.fillStyle = E(t, n, r, o) || y.d.DEFAULT_COLOR;
              var a = i * o;
              e.fillRect(0, 0, isNaN(a) ? 0 : a, c.c);
            }
          }
        };
      }, t.prototype.createGroup = function () {
        return o.h;
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        C = n(66),
        _ = function () {
      function t() {
        this.title = "String", this.groupTitle = "None", this.summaryTitle = "None";
      }

      return t.prototype.canRender = function (t, e) {
        return !0;
      }, t.prototype.create = function (t) {
        return {
          template: "<div> </div>",
          update: function update(e, n) {
            Object(h.b)(e, t, n), Object(o.j)(e, t.getLabel(n));
          },
          render: o.i
        };
      }, t.prototype.createGroup = function (t) {
        return o.h;
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        T = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.title = "Default", e;
      }

      return Object(l.c)(e, t), e.prototype.canRender = function (t, e) {
        return t instanceof C.c && e === i.a.CELL;
      }, e.prototype.create = function (e) {
        var n = t.prototype.create.call(this, e);
        return n.template = '<div class="lu-center"> </div>', n;
      }, e;
    }(_),
        N = n(16),
        D = n(39),
        R = n(6);

    var w = function () {
      function t() {
        this.title = "Box Plot";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(m.h)(t) && e === i.a.CELL || Object(m.k)(t) && e !== i.a.CELL;
      }, t.prototype.create = function (t, e, n, r) {
        var i = t.getSortMethod(),
            o = void 0 !== t.isSortedByMe().asc,
            a = e.colWidth(t);
        return {
          template: '<div title="">\n                    <div><div></div><div></div></div>\n                 </div>',
          update: function update(e, n) {
            var a = t.getBoxPlotData(n);
            a && !t.isMissing(n) ? (e.classList.remove("lu-missing"), A(e, a, t.getRawBoxPlotData(n), o ? i : "", E(t, n, r))) : e.classList.add("lu-missing");
          },
          render: function render(e, n) {
            if (!Object(h.a)(e, t, n, a)) {
              var u = t.getBoxPlotData(n);
              if (u) !function (t, e, n, r, i, o) {
                var a = null != e.whiskerLow ? e.whiskerLow : Math.max(e.q1 - 1.5 * (e.q3 - e.q1), e.min),
                    u = null != e.whiskerHigh ? e.whiskerHigh : Math.min(e.q3 + 1.5 * (e.q3 - e.q1), e.max);
                t.fillStyle = r || c.b.box, t.strokeStyle = c.b.stroke, t.beginPath(), t.rect(e.q1, 0, e.q3 - e.q1, i), t.fill(), t.stroke();
                var s = i - o,
                    l = i / 2;
                t.beginPath(), t.moveTo(a, l), t.lineTo(e.q1, l), t.moveTo(a, o), t.lineTo(a, s), t.moveTo(e.median, 0), t.lineTo(e.median, i), t.moveTo(e.q3, l), t.lineTo(u, l), t.moveTo(u, o), t.lineTo(u, s), t.stroke(), t.fill(), "" !== n && (t.strokeStyle = c.b.sort, t.beginPath(), t.moveTo(e[n], o), t.lineTo(e[n], i - o), t.stroke(), t.fill());
                if (!e.outlier) return;
                t.fillStyle = c.b.outlier, e.outlier.forEach(function (e) {
                  t.fillRect(Math.max(e - c.f.size / 2, 0), l - c.f.size / 2, c.f.size, c.f.size);
                });
              }(e, {
                min: u.min * a,
                median: u.median * a,
                q1: u.q1 * a,
                q3: u.q3 * a,
                max: u.max * a,
                outlier: u.outlier ? u.outlier.map(function (t) {
                  return t * a;
                }) : void 0,
                whiskerLow: null != u.whiskerLow ? u.whiskerLow * a : void 0,
                whiskerHigh: null != u.whiskerHigh ? u.whiskerHigh * a : void 0
              }, o ? i : "", E(t, n, r), c.c, 0);
            }
          }
        };
      }, t.createAggregatedBoxPlot = function (t, e, n) {
        var r;
        void 0 === n && (n = !1);
        var i = (r = []).concat.apply(r, e.map(function (e) {
          return n ? t.getRawNumbers(e) : t.getNumber(e);
        }));
        return new N.g(i);
      }, t.prototype.createGroup = function (e, n, r, i) {
        var o = e instanceof R.b && void 0 !== e.isGroupSortedByMe().asc ? e.getSortMethod() : "";
        return {
          template: '<div title="">\n                    <div><div></div><div></div></div>\n                 </div>',
          update: function update(n, r, a) {
            var u, c;
            a.every(function (t) {
              return e.isMissing(t);
            }) ? Object(h.b)(n, e, a[0]) : (n.classList.remove("lu-missing"), Object(m.m)(e) ? (u = t.createAggregatedBoxPlot(e, a), c = t.createAggregatedBoxPlot(e, a, !0)) : (u = new N.g(a.map(function (t) {
              return e.getNumber(t);
            })), c = new N.g(a.map(function (t) {
              return e.getRawNumber(t);
            }))), A(n, u, c, o, E(e, null, i)));
          }
        };
      }, t.prototype.createSummary = function (t, e, n, r) {
        var i = '<div title="">\n    <div><div></div><div></div></div>';

        if (Object(v.d)(t)) {
          var o = t.getRange();
          i += "<span>" + o[0] + "</span><span>" + o[1] + "</span>";
        }

        return {
          template: i += "</div>",
          update: function update(e, n) {
            if (null != n && 0 !== n.count) {
              e.classList.remove("lu-missing");
              var i = t instanceof R.b && void 0 !== t.isGroupSortedByMe().asc ? t.getSortMethod() : "";

              if (Object(v.d)(t)) {
                var o = t.getRange();
                Array.from(e.querySelectorAll("span")).forEach(function (t, e) {
                  return t.textContent = o[e];
                });
              }

              A(e, n, n, i, E(t, null, r), Object(v.d)(t));
            } else e.classList.add("lu-missing");
          }
        };
      }, t;
    }();

    function A(t, e, n, r, i, o) {
      void 0 === o && (o = !1), t.title = function (t) {
        if (null == t) return "";
        var e = D.c.DEFAULT_FORMATTER,
            n = null != t.mean ? "mean = " + e(t.mean) + "\n" : "";
        return "min = " + e(t.min) + "\nq1 = " + e(t.q1) + "\nmedian = " + e(t.median) + "\n" + n + "q3 = " + e(t.q3) + "\nmax = " + e(t.max);
      }(n);
      var a = t.firstElementChild,
          u = a.firstElementChild,
          c = a.lastElementChild,
          s = null != e.whiskerLow ? e.whiskerLow : Math.max(e.q1 - 1.5 * (e.q3 - e.q1), e.min),
          l = null != e.whiskerHigh ? e.whiskerHigh : Math.min(e.q3 + 1.5 * (e.q3 - e.q1), e.max);
      a.style.left = Object(N.k)(100 * s, 2) + "%";
      var p = l - s;
      a.style.width = Object(N.k)(100 * p, 2) + "%", u.style.left = Object(N.k)((e.q1 - s) / p * 100, 2) + "%", u.style.width = Object(N.k)((e.q3 - e.q1) / p * 100, 2) + "%", u.style.backgroundColor = i, c.style.left = Object(N.k)((e.median - s) / p * 100, 2) + "%";
      var f = Array.from(t.children).slice(1, o ? -2 : void 0),
          d = e.outlier ? e.outlier.length : 0;

      if (f.splice(d, f.length - d).forEach(function (t) {
        return t.remove();
      }), a.dataset.sort = r, e.outlier && 0 !== d) {
        for (var h = f.length; h < d; ++h) {
          console.assert(null != t.ownerDocument);
          var g = t.ownerDocument.createElement("div");
          f.unshift(g), a.insertAdjacentElement("afterend", g);
        }

        e.outlier.forEach(function (t, e) {
          delete f[e].dataset.sort, f[e].style.left = Object(N.k)(100 * t, 2) + "%";
        }), "min" === r && e.outlier[0] <= s ? (a.dataset.sort = "", f[0].dataset.sort = "min", f.length > 1 && f[f.length - 1].insertAdjacentElement("afterend", f[0])) : "max" === r && e.outlier[f.length - 1] >= l && (a.dataset.sort = "", f[f.length - 1].dataset.sort = "max");
      }
    }

    var M = n(25);

    function L(t, e, n, r) {
      if ((null == t || isNaN(t)) && (t = 1), r || !Object(v.d)(n)) return (i = Object(M.d)(E(n, e, r, t) || y.d.DEFAULT_COLOR)).l = 1 - t, i.toString();
      var i,
          o = n.getColorMapping(),
          a = o.apply(t);
      return "solid" === o.type ? ((i = Object(M.d)(a)).l = 1 - t, i.toString()) : a;
    }

    var j = function () {
      function t() {
        this.title = "Brightness";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(m.k)(t) && e === i.a.CELL && !Object(m.m)(t);
      }, t.prototype.create = function (t, e, n, r) {
        var i = e.colWidth(t);
        return {
          template: '<div title="">\n        <div style="background-color: ' + y.d.DEFAULT_COLOR + '"></div><div> </div>\n      </div>',
          update: function update(e, n) {
            var i = Object(h.b)(e, t, n);
            e.title = t.getLabel(n), e.firstElementChild.style.backgroundColor = i ? null : L(t.getNumber(n), n, t, r), Object(o.j)(e.lastElementChild, e.title);
          },
          render: function render(e, n) {
            Object(h.a)(e, t, n, i) || (e.fillStyle = L(t.getNumber(n), n, t, r), e.fillRect(0, 0, i, c.c));
          }
        };
      }, t.prototype.createGroup = function () {
        return o.h;
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        x = n(51),
        S = n(24),
        I = n(19),
        V = n(63),
        k = function () {
      function t() {
        this.title = "Color", this.groupTitle = "Histogram";
      }

      return t.prototype.canRender = function (t) {
        return Object(S.c)(t);
      }, t.prototype.create = function (t, e) {
        var n = e.colWidth(t);
        return {
          template: "<div>\n        <div></div><div></div>\n      </div>",
          update: function update(e, n) {
            Object(h.b)(e, t, n);
            var r = t.getCategory(n);
            e.firstElementChild.style.backgroundColor = r ? r.color : null, Object(o.j)(e.lastElementChild, t.getLabel(n));
          },
          render: function render(e, r) {
            if (!Object(h.a)(e, t, r, n)) {
              var i = t.getCategory(r);
              e.fillStyle = i ? i.color : "", e.fillRect(0, 0, n, c.c);
            }
          }
        };
      }, t.prototype.createGroup = function (t, e, n) {
        var r = H(t, !1),
            i = r.template,
            o = r.update;
        return {
          template: i + "</div>",
          update: function update(e, r, i) {
            var a = Object(N.h)(i, function (e) {
              return t.getCategory(e);
            }, t.categories),
                u = a.maxBin,
                c = a.hist,
                s = Math.max(u, n ? n.maxBin : 0);
            o(e, s, c);
          }
        };
      }, t.prototype.createSummary = function (t, e, n) {
        return t instanceof I.a || t instanceof V.b ? function (t, e, n) {
          var r,
              i = H(t, e || Object(o.l)(t)),
              a = i.template,
              u = i.update;
          return {
            template: "" + a + (e ? Object(d.b)(!1, 0, n) : "") + "</div>",
            update: function update(e, n) {
              r || (r = P(t, e)), r(n ? n.missing : 0, t), e.classList.toggle("lu-missing", !n), n && u(e, n.maxBin, n.hist);
            }
          };
        }(t, n, e.idPrefix) : function (t, e) {
          var n = H(t, e),
              r = n.template,
              i = n.update;
          return {
            template: r + "</div>",
            update: function update(t, e) {
              t.classList.toggle("lu-missing", !e), e && i(t, e.maxBin, e.hist);
            }
          };
        }(t, n);
      }, t;
    }();

    function H(t, e) {
      var n = t.categories.map(function (t) {
        return '<div title="' + t.label + ': 0" data-cat="' + t.name + '" ' + (e ? 'data-title="' + t.label + '"' : "") + '><div style="height: 0; background-color: ' + t.color + '"></div></div>';
      }).join("");
      return {
        template: "<div" + (t.dataLength > x.a ? 'class="lu-dense"' : "") + ">" + n,
        update: function update(e, n, r) {
          Object(o.e)(e, "[data-cat]", function (e, i) {
            var o = r[i].y;
            e.title = t.categories[i].label + ": " + o, e.firstElementChild.style.height = Math.round(100 * o / n) + "%";
          });
        }
      };
    }

    function P(t, e) {
      var n = Array.from(e.querySelectorAll("[data-cat]"));
      n.forEach(function (e, n) {
        var r = t.categories[n];

        e.onclick = function (i) {
          i.preventDefault(), i.stopPropagation();
          var o = t.getFilter();

          if (null == o || !Array.isArray(o.filter)) {
            var a = t.categories.slice();
            return e.dataset.filtered = "filtered", a.splice(n, 1), void t.setFilter({
              filterMissing: !!o && o.filterMissing,
              filter: a.map(function (t) {
                return t.name;
              })
            });
          }

          var u = o.filter.slice(),
              c = u.indexOf(r.name);
          c >= 0 ? (e.dataset.filtered = "filtered", u.splice(c, 1)) : (delete e.dataset.filtered, u.push(r.name)), t.setFilter({
            filterMissing: o.filterMissing,
            filter: u
          });
        };
      });
      var r = e.querySelector("input");
      return r && (r.onchange = function () {
        var e = r.checked,
            n = t.getFilter();
        null == n ? t.setFilter(e ? {
          filterMissing: e,
          filter: t.categories.map(function (t) {
            return t.name;
          })
        } : null) : t.setFilter({
          filterMissing: e,
          filter: n.filter
        });
      }), function (e, i) {
        var o = (t = i).categories,
            a = t.getFilter();
        n.forEach(function (t, e) {
          Object(S.d)(a, o[e]) ? delete t.dataset.filtered : t.dataset.filtered = "filtered";
        }), r && (r.checked = null != a && a.filterMissing, Object(d.d)(r.parentElement, e));
      };
    }

    var G = function () {
      function t() {
        this.title = "Matrix";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(S.f)(t) && e !== i.a.SUMMARY;
      }, t.calculateSetPath = function (t, e) {
        var n = [];
        return t.forEach(function (t, e) {
          return t ? n.push(e) : -1;
        }), {
          left: n[0] * e + e / 2,
          right: n[n.length - 1] * e + e / 2
        };
      }, t.createDOMContext = function (t) {
        for (var e = "", n = 0, r = t.categories; n < r.length; n++) {
          e += '<div title="' + r[n].label + '"></div>';
        }

        return {
          templateRow: e,
          render: function render(t, e) {
            Array.from(t.children).slice(1).forEach(function (t, n) {
              var r = e[n];
              t.classList.toggle("enabled", r);
            });
            var n = t.firstElementChild,
                r = e.findIndex(function (t) {
              return t;
            }),
                i = e.length - 1 - e.reverse().findIndex(function (t) {
              return t;
            });
            r < 0 || r === i ? n.style.display = "none" : (n.style.display = null, n.style.left = Math.round(100 * (r + .5) / e.length) + "%", n.style.width = Math.round(100 * (i - r) / e.length) + "%");
          }
        };
      }, t.prototype.create = function (e, n) {
        var r = t.createDOMContext(e),
            i = r.templateRow,
            o = r.render,
            a = n.colWidth(e),
            u = a / e.dataLength;
        return {
          template: "<div><div></div>" + i + "</div>",
          update: function update(t, n) {
            Object(h.b)(t, e, n) || o(t, e.getValues(n));
          },
          render: function render(n, r) {
            if (!Object(h.a)(n, e, r, a)) {
              var i = e.getValues(r),
                  o = i.some(function (t) {
                return t;
              });

              if (n.save(), n.fillStyle = c.h.circle, n.strokeStyle = c.h.stroke, o) {
                var s = t.calculateSetPath(i, u),
                    l = s.left,
                    p = s.right;
                n.beginPath(), n.moveTo(l, c.c / 2), n.lineTo(p, c.c / 2), n.stroke();
              }

              i.forEach(function (t, e) {
                var r = e * u;
                n.beginPath(), n.globalAlpha = t ? 1 : c.h.inactive, n.fillRect(r, 0, u, c.c), n.fill();
              }), n.restore();
            }
          }
        };
      }, t.prototype.createGroup = function (e) {
        var n = t.createDOMContext(e),
            r = n.templateRow,
            i = n.render;
        return {
          template: "<div><div></div>" + r + "</div>",
          update: function update(t, n, r) {
            var o = F(e, r);
            i(t, o);
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }();

    function F(t, e) {
      var n = new Set();
      return e.forEach(function (e) {
        t.getSet(e).forEach(function (t) {
          return n.add(t);
        });
      }), t.categories.map(function (t) {
        return n.has(t);
      });
    }

    var U = function () {
      function t() {
        this.title = "Heatmap";
      }

      return t.prototype.canRender = function (t) {
        return Object(S.f)(t);
      }, t.createDOMContext = function (t) {
        for (var e = "", n = 0, r = t.categories; n < r.length; n++) {
          var i = r[n];
          e += '<div title="' + i.label + '" style="background-color: ' + i.color + '"></div>';
        }

        return {
          templateRow: e,
          render: function render(t, e) {
            Object(o.f)(t, function (t, n) {
              var r = e[n];
              t.style.visibility = r ? null : "hidden";
            });
          }
        };
      }, t.prototype.create = function (e, n) {
        var r = t.createDOMContext(e),
            i = r.templateRow,
            o = r.render,
            a = n.colWidth(e),
            u = a / e.dataLength,
            s = e.categories;
        return {
          template: "<div>" + i + "</div>",
          update: function update(t, n) {
            Object(h.b)(t, e, n) || o(t, e.getValues(n));
          },
          render: function render(t, n) {
            if (!Object(h.a)(t, e, n, a)) {
              var r = e.getValues(n);
              t.save(), s.forEach(function (e, n) {
                if (r[n]) {
                  var i = n * u;
                  t.fillStyle = e.color, t.fillRect(i, 0, u, c.c);
                }
              }), t.restore();
            }
          }
        };
      }, t.prototype.createGroup = function (e) {
        var n = t.createDOMContext(e),
            r = n.templateRow,
            i = n.render;
        return {
          template: "<div>" + r + "</div>",
          update: function update(t, n, r) {
            var o = F(e, r);
            i(t, o);
          }
        };
      }, t.prototype.createSummary = function (t) {
        for (var e = t.categories, n = "<div>", r = Object(o.l)(t), i = 0, a = e; i < a.length; i++) {
          var u = a[i];
          n += '<div title="' + u.label + '"' + (r ? ' data-title="' + u.label + '"' : "") + ' style="background-color: ' + u.color + '"></div>';
        }

        return {
          template: n += "</div>",
          update: o.i
        };
      }, t;
    }(),
        B = function () {
      function t() {
        this.title = "Distribution Bar";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(S.c)(t) && e !== i.a.CELL;
      }, t.prototype.create = function () {
        return o.h;
      }, t.prototype.createGroup = function (t) {
        var e = Y(t),
            n = e.template,
            r = e.update;
        return {
          template: n + "</div>",
          update: function update(e, n, i) {
            var o = Object(N.h)(i, function (e) {
              return t.getCategory(e);
            }, t.categories),
                a = o.hist,
                u = o.missing;
            r(e, a, u);
          }
        };
      }, t.prototype.createSummary = function (t, e, n) {
        return t instanceof I.a || t instanceof V.b ? function (t, e, n) {
          var r,
              i = Y(t),
              o = i.template,
              a = i.update;
          return {
            template: "" + o + (e ? Object(d.b)(!1, 0, n) : "") + "</div>",
            update: function update(e, n) {
              r || (r = P(t, e)), r(n ? n.missing : 0, t), e.classList.toggle("lu-missing", !n), n && a(e, n.hist, n.missing);
            }
          };
        }(t, n, e.idPrefix) : function (t) {
          var e = Y(t),
              n = e.template,
              r = e.update;
          return {
            template: n + "</div>",
            update: function update(t, e) {
              t.classList.toggle("lu-missing", !e), e && r(t, e.hist, e.missing);
            }
          };
        }(t);
      }, t;
    }();

    function Y(t) {
      var e = t.categories;
      return {
        template: "<div>" + e.map(function (t) {
          return '<div style="background-color: ' + t.color + "; color: " + Object(o.b)(t.color) + '" title="' + t.label + ': 0" data-cat="' + t.name + '"><span>' + t.label + "</span></div>";
        }).join("") + '<div title="Missing Values"></div>',
        update: function update(t, n, r) {
          var i = n.reduce(function (t, e) {
            return t + e.y;
          }, r);
          Object(o.f)(t, function (t, o) {
            var a, u;
            o >= n.length ? (a = r, u = "Missing Values") : (a = n[o].y, u = e[o].label), t.style.flexGrow = "" + Math.round(0 === i ? 0 : a), t.title = u + ": " + a;
          });
        }
      };
    }

    var W = function () {
      function t() {
        this.title = "Proportional Symbol";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(m.k)(t) && e === i.a.CELL && !Object(m.m)(t);
      }, t.prototype.create = function (t, e, n, r) {
        return {
          template: '<div style="background: radial-gradient(circle closest-side, red 100%, transparent 100%)" title="">\n              <div class="lu-hover-only"></div>\n          </div>',
          update: function update(e, n) {
            var i = t.getNumber(n),
                a = Math.round(100 * i),
                u = Object(h.b)(e, t, n);
            Object(o.c)(e, {}, {
              background: u ? null : "radial-gradient(circle closest-side, " + E(t, n, r) + " " + a + "%, transparent " + a + "%)"
            }), Object(o.j)(e.firstElementChild, t.getLabel(n));
          },
          render: o.i
        };
      }, t.prototype.createGroup = function () {
        return o.h;
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        q = n(7),
        z = function () {
      function t() {
        this.title = "Dot", this.groupTitle = "Dots";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(m.k)(t) && e !== i.a.SUMMARY;
      }, t.getDOMRenderer = function (t) {
        for (var e = Object(m.m)(t) ? t.dataLength : 1, n = "", r = 0; r < e; ++r) {
          n += "<div style='background-color: " + y.d.DEFAULT_COLOR + "' title=''></div>";
        }

        return {
          template: "<div>" + n + "</div>",
          update: function update(t, e, n, r) {
            if (t.children.length !== e.length) {
              for (var i = "", a = 0; a < e.length; ++a) {
                i += "<div style='background-color: " + r[a] + "' title='" + n[a] + "'></div>";
              }

              t.innerHTML = i;
            }

            Object(o.f)(t, function (t, i) {
              var a = e[i];
              Object(o.c)(t, {
                title: n[i]
              }, {
                display: Object(q.c)(a) ? "none" : null,
                left: Math.round(100 * a) + "%",
                top: e.length > 1 ? Math.round(80 * Math.random() + 10) + "%" : null,
                "background-color": r[i]
              });
            });
          },
          render: function render(t, e, n, r) {
            t.save(), t.globalAlpha = c.f.opacity, e.forEach(function (e, i) {
              t.fillStyle = n[i] || c.f.color, t.fillRect(Math.max(0, e * r - c.f.size / 2), 0, c.f.size, c.c);
            }), t.restore();
          }
        };
      }, t.prototype.create = function (e, n, r, i) {
        var o = t.getDOMRenderer(e),
            a = o.template,
            u = o.render,
            c = o.update,
            s = n.colWidth(e);
        return {
          template: a,
          update: function update(t, n) {
            if (!Object(h.b)(t, e, n)) {
              var r = E(e, n, i),
                  o = e.getValue(n);
              if (!Object(m.m)(e)) return c(t, [o], [e.getLabel(n)], [r]);
              var a = o.filter(function (t) {
                return !Object(q.c)(t);
              });
              return c(t, a, a.map(m.a), a.map(function (t) {
                return r;
              }));
            }
          },
          render: function render(t, n) {
            if (!Object(h.a)(t, e, n, s)) {
              var r = E(e, n, i),
                  o = e.getValue(n);
              if (!Object(m.m)(e)) return u(t, [o], [r], s);
              var a = o.filter(function (t) {
                return !Object(q.c)(t);
              });
              return u(t, a, a.map(function (t) {
                return r;
              }), s);
            }
          }
        };
      }, t.prototype.createGroup = function (e, n, r, i) {
        var o = t.getDOMRenderer(e),
            a = o.template,
            u = o.update;
        return {
          template: a,
          update: function update(t, n, r) {
            var o,
                a = r.map(function (t) {
              return e.getValue(t);
            }),
                c = r.map(function (t) {
              return E(e, t, i);
            });
            if (!Object(m.m)(e)) return u(t, a, r.map(function (t) {
              return e.getLabel(t);
            }), c);
            var s = (o = []).concat.apply(o, a.filter(function (t) {
              return !Object(q.c)(t);
            }));
            return u(t, s, s.map(m.a), a.map(function (t, e) {
              return c[e];
            }));
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        K = n(62),
        X = function () {
      function t() {
        this.title = "Default";
      }

      return t.prototype.canRender = function (t) {
        return t instanceof K.c;
      }, t.prototype.create = function () {
        return {
          template: "<div><div></div></div>",
          update: function update(t, e, n, r) {
            var i = t.firstElementChild;
            0 !== n ? i.innerText = "" : Array.isArray(r.order) ? i.innerText = r.name + " (" + r.order.length + ")" : i.innerText = r.name;
          },
          render: o.i
        };
      }, t.prototype.createGroup = function () {
        return {
          template: "<div><div></div></div>",
          update: function update(t, e, n) {
            t.firstElementChild.innerText = e.name + " (" + n.length + ")";
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        $ = function () {
      function t() {}

      return t.choose = function (t, e) {
        for (var n = e.map(function (e) {
          return {
            n: t.getNumbers(e),
            raw: t.getRawNumbers(e)
          };
        }), r = t.dataLength, i = [], o = [], a = function a(e) {
          var r = n.map(function (t) {
            return {
              n: t.n[e],
              raw: t.raw[e]
            };
          }).filter(function (t) {
            return !Object(q.c)(t.n);
          });
          if (0 === r.length) i.push(NaN), o.push(NaN);else {
            var a = new N.g(r.map(function (t) {
              return t.n;
            })),
                u = new N.g(r.map(function (t) {
              return t.raw;
            }));
            i.push(a[t.getSortMethod()]), o.push(u[t.getSortMethod()]);
          }
        }, u = 0; u < r; ++u) {
          a(u);
        }

        return {
          normalized: i,
          raw: o
        };
      }, t.prototype.create = function (t, e, n, r) {
        var i = e.colWidth(t),
            o = this.createContext(t, e, r),
            a = o.templateRow,
            u = o.render,
            c = o.update;
        return {
          template: "<div>" + a + "</div>",
          update: function update(e, n) {
            Object(h.b)(e, t, n) || c(e, t.getNumbers(n), t.getRawNumbers(n), n);
          },
          render: function render(e, n) {
            Object(h.a)(e, t, n, i) || u(e, t.getNumbers(n), n);
          }
        };
      }, t.prototype.createGroup = function (e, n, r, i) {
        var o = this.createContext(e, n, i),
            a = o.templateRow,
            u = o.update;
        return {
          template: "<div>" + a + "</div>",
          update: function update(n, r, i) {
            var o = t.choose(e, i),
                a = o.normalized,
                c = o.raw;
            u(n, a, c, i[0]);
          }
        };
      }, t;
    }();

    var J = function () {
      function t() {
        this.title = "Heatmap";
      }

      return t.prototype.canRender = function (t) {
        return Object(m.m)(t) && Boolean(t.dataLength);
      }, t.prototype.createContext = function (t, e, n, r) {
        var i = e.colWidth(t),
            o = i / t.dataLength,
            a = t.labels;
        return {
          template: '<canvas height="20" title=""></canvas>',
          render: function render(e, n, i, a) {
            n.forEach(function (n, u) {
              var c = u * o;
              Object(q.c)(n) ? Object(h.c)(e, o, a, c, 0) : (e.fillStyle = L(n, i, t, r), e.fillRect(c, 0, o, a));
            });
          },
          width: i,
          mover: function mover(e, n) {
            return function (r) {
              var o = r.offsetX / i,
                  u = Math.max(0, Math.min(t.dataLength - 1, Math.floor(o * (t.dataLength - 1) + .5)));
              e.title = a[u] + ": " + n[u];
            };
          }
        };
      }, t.prototype.create = function (t, e, n, r) {
        var i = this.createContext(t, e, n, r),
            o = i.template,
            a = i.render,
            u = i.mover,
            s = i.width;
        return {
          template: o,
          update: function update(e, n) {
            var r = e.getContext("2d");
            r.canvas.width = s, r.clearRect(0, 0, r.canvas.width, r.canvas.height), Object(h.b)(e, t, n) || (e.onmousemove = u(e, t.getRawNumbers(n).map(m.a)), e.onmouseleave = function () {
              return e.title = "";
            }, a(r, t.getNumbers(n), n, 20));
          },
          render: function render(e, n) {
            a(e, t.getNumbers(n), n, c.c);
          }
        };
      }, t.prototype.createGroup = function (t, e, n, r) {
        var i = this.createContext(t, e, n, r),
            o = i.template,
            a = i.render,
            u = i.mover,
            c = i.width;
        return {
          template: o,
          update: function update(e, n, r) {
            var i = $.choose(t, r),
                o = i.normalized,
                s = i.raw,
                l = e.getContext("2d");
            l.canvas.width = c, l.clearRect(0, 0, l.canvas.width, l.canvas.height), e.onmousemove = u(e, s.map(m.a)), e.onmouseleave = function () {
              return e.title = "";
            }, a(l, o, r[0], 20);
          }
        };
      }, t.prototype.createSummary = function (t) {
        for (var e = t.labels.slice(); e.length > 0 && !Object(o.l)(t, e.length);) {
          e = e.filter(function (t, e) {
            return e % 2 == 0;
          });
        }

        for (var n = "<div>", r = 0, i = e; r < i.length; r++) {
          var a = i[r];
          n += '<div title="' + a + '" data-title="' + a + '"></div>';
        }

        return {
          template: n += "</div>",
          update: o.i
        };
      }, t;
    }(),
        Z = function (t) {
      function e(e, n, r) {
        void 0 === r && (r = {});
        var i = t.call(this, e) || this;
        return i.callback = n, i.ioptions = {
          min: NaN,
          max: NaN,
          step: "any",
          value: NaN,
          label: null
        }, Object.assign(i.ioptions, r), i;
      }

      return Object(l.c)(e, t), e.prototype.build = function (t) {
        var e = this.ioptions;
        t.insertAdjacentHTML("beforeend", '\n     <input type="number" value="' + (isNaN(e.value) ? "" : String(e.value)) + '" required autofocus placeholder="' + (e.label ? e.label : "enter number") + '" ' + (isNaN(e.min) ? "" : ' min="' + e.min + '"') + " " + (isNaN(e.max) ? "" : ' max="' + e.max + '"') + ' step="' + e.step + '">\n    ');
      }, e.prototype.submit = function () {
        return this.callback(parseFloat(this.findInput("input[type=number]").value)), !0;
      }, e;
    }(n(14).c),
        Q = n(79),
        tt = function () {
      function t() {
        this.title = "Histogram";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(m.k)(t) && e !== i.a.CELL || Object(m.m)(t) && e === i.a.CELL;
      }, t.prototype.create = function (t, e, n, r) {
        var i = nt(e.totalNumberOfRows, t, r),
            a = i.template,
            u = i.render,
            c = i.guessedBins;
        return {
          template: a + "</div>",
          update: function update(e, r) {
            Object(h.b)(e, t, r) || u(e, et(n, c, [r], t));
          },
          render: o.i
        };
      }, t.prototype.createGroup = function (t, e, n, r) {
        var i = nt(e.totalNumberOfRows, t, r),
            o = i.template,
            a = i.render,
            u = i.guessedBins;
        return {
          template: o + "</div>",
          update: function update(e, r, i) {
            a(e, et(n, u, i, t));
          }
        };
      }, t.prototype.createSummary = function (t, e, n, r) {
        var i = nt(e.totalNumberOfRows, t, r);
        return !n || !Object(v.d)(t) ? function (t, e, n) {
          if (Object(v.d)(t)) {
            var r = t.getRange();
            e += "<span>" + r[0] + "</span><span>" + r[1] + "</span>";
          }

          return {
            template: e + "</div>",
            update: function update(e, r) {
              if (Object(v.d)(t)) {
                var i = t.getRange();
                Array.from(e.querySelectorAll("span")).forEach(function (t, e) {
                  return t.textContent = i[e];
                });
              }

              e.classList.toggle("lu-missing", !r), r && n(e, {
                bins: r.hist.length,
                max: r.maxBin,
                hist: r.hist
              });
            }
          };
        }(t, i.template, i.render) : function (t, e, n, r) {
          var i,
              o = rt(t);
          return {
            template: (n += '\n      <div data-handle="min-hint" style="width: ' + o.percent(o.filterMin) + '%"></div>\n      <div data-handle="max-hint" style="width: ' + (100 - o.percent(o.filterMax)) + '%"></div>\n      <div data-handle="min" data-value="' + Object(N.k)(o.filterMin, 2) + '" style="left: ' + o.percent(o.filterMin) + '%" title="min filter, drag or shift click to change"></div>\n      <div data-handle=\'max\' data-value="' + Object(N.k)(o.filterMax, 2) + '" style="right: ' + (100 - o.percent(o.filterMax)) + '%" title="max filter, drag or shift click to change"></div>\n      ' + Object(d.b)(o.filterMissing, 0, e.idPrefix) + "\n    ") + "</div>",
            update: function update(n, o) {
              i || (i = function (t, e, n) {
                var r = t.querySelector("[data-handle=min]"),
                    i = t.querySelector("[data-handle=max]"),
                    o = t.querySelector("[data-handle=min-hint]"),
                    a = t.querySelector("[data-handle=max-hint]"),
                    u = t.querySelector("input"),
                    c = function c() {
                  var t = rt(e),
                      n = t.unpercent(parseFloat(r.style.left)),
                      o = t.unpercent(100 - parseFloat(i.style.right));
                  e.setFilter({
                    filterMissing: u.checked,
                    min: Math.abs(n - t.domain[0]) < .001 ? NaN : n,
                    max: Math.abs(o - t.domain[1]) < .001 ? NaN : o
                  });
                };

                r.onclick = function (t) {
                  if (t.shiftKey) {
                    t.preventDefault(), t.stopPropagation();
                    var i = rt(e),
                        a = i.unpercent(parseFloat(r.style.left)),
                        u = {
                      attachment: r,
                      manager: n.dialogManager,
                      level: 1,
                      idPrefix: n.idPrefix
                    };
                    new Z(u, function (t) {
                      o.style.width = i.percent(t) + "%", r.dataset.value = Object(N.k)(t, 2).toString(), r.style.left = i.percent(t) + "%", r.classList.toggle("lu-swap-hint", i.percent(t) > 15), c();
                    }, {
                      value: a,
                      min: i.domain[0],
                      max: i.domain[1]
                    }).open();
                  }
                }, i.onclick = function (t) {
                  if (t.shiftKey) {
                    t.preventDefault(), t.stopPropagation();
                    var o = rt(e),
                        u = o.unpercent(100 - parseFloat(i.style.right)),
                        s = {
                      attachment: i,
                      manager: n.dialogManager,
                      level: 1,
                      idPrefix: n.idPrefix
                    };
                    new Z(s, function (t) {
                      a.style.width = 100 - o.percent(t) + "%", i.dataset.value = Object(N.k)(t, 2).toString(), i.style.right = 100 - o.percent(t) + "%", r.classList.toggle("lu-swap-hint", o.percent(t) < 85), c();
                    }, {
                      value: u,
                      min: o.domain[0],
                      max: o.domain[1]
                    }).open();
                  }
                }, u.onchange = function () {
                  return c();
                };
                var s = {
                  minDelta: 0,
                  filter: function filter(t) {
                    return 0 === t.button && !t.shiftKey;
                  },
                  onStart: function onStart(t) {
                    return t.classList.add("lu-dragging");
                  },
                  onDrag: function onDrag(n, r) {
                    var i = t.clientWidth,
                        u = Math.max(0, Math.min(r, i)),
                        c = Math.round(100 * u / i),
                        s = e.getMapping().domain;
                    if (n.dataset.value = Object(N.k)(c / 100 * (s[1] - s[0]) + s[0], 2).toString(), "min" === n.dataset.handle) return n.style.left = c + "%", n.classList.toggle("lu-swap-hint", c > 15), void (o.style.width = c + "%");
                    n.style.right = 100 - c + "%", n.classList.toggle("lu-swap-hint", c < 85), a.style.width = 100 - c + "%";
                  },
                  onEnd: function onEnd(t) {
                    t.classList.remove("lu-dragging"), c();
                  }
                };
                return Object(Q.a)(r, s), Object(Q.a)(i, s), function (t, n) {
                  var c = rt(e = n);
                  o.style.width = c.percent(c.filterMin) + "%", a.style.width = 100 - c.percent(c.filterMax) + "%", r.dataset.value = Object(N.k)(c.filterMin, 2).toString(), i.dataset.value = Object(N.k)(c.filterMax, 2).toString(), r.style.left = c.percent(c.filterMin) + "%", i.style.right = 100 - c.percent(c.filterMax) + "%", u.checked = c.filterMissing, Object(d.d)(u.parentElement, t);
                };
              }(n, t, e)), i(o ? o.missing : 0, t), n.classList.toggle("lu-missing", !o), o && r(n, {
                bins: o.hist.length,
                max: o.maxBin,
                hist: o.hist
              });
            }
          };
        }(t, e, i.template, i.render);
      }, t;
    }();

    function et(t, e, n, r) {
      var i,
          o,
          a = t ? t.hist.length : e;

      if (Object(m.m)(r)) {
        var u = (i = []).concat.apply(i, n.map(function (t) {
          return r.getNumbers(t);
        }));
        o = Object(N.i)(u, function (t) {
          return t;
        }, q.c, [0, 1], a);
      } else o = Object(N.i)(n, function (t) {
        return r.getNumber(t);
      }, function (t) {
        return r.isMissing(t);
      }, [0, 1], a);

      return {
        bins: a,
        max: Math.max(o.maxBin, t ? t.maxBin : 0),
        hist: o.hist
      };
    }

    function nt(t, e, n) {
      for (var r = Object(N.j)(t), i = "", o = 0; o < r; ++o) {
        i += '<div title="Bin ' + o + ': 0" data-x=""><div style="height: 0" ></div></div>';
      }

      return {
        template: "<div" + (r > x.a ? ' class="lu-dense' : "") + ">" + i,
        render: function render(t, r) {
          var i = r.bins,
              o = r.max,
              a = r.hist,
              u = Array.from(t.querySelectorAll("[data-x]"));
          if (u.length > i) u.splice(i, u.length - i).forEach(function (t) {
            return t.remove();
          });else if (u.length < i) {
            for (var c = u.length; c < i; ++c) {
              t.insertAdjacentHTML("afterbegin", '<div title="Bin ' + c + ': 0" data-x=""><div style="height: 0" ></div></div>');
            }

            u = Array.from(t.querySelectorAll("[data-x]"));
          }
          t.classList.toggle("lu-dense", i > x.a), u.forEach(function (t, r) {
            var i = a[r],
                u = i.x0,
                c = i.x1,
                s = i.length,
                l = t.firstElementChild;
            t.title = Object(m.a)(u) + " - " + Object(m.a)(c) + " (" + s + ")", t.dataset.x = Object(m.a)(u), l.style.height = Math.round(100 * s / o) + "%", l.style.backgroundColor = E(e, null, n, (c + u) / 2);
          });
        },
        guessedBins: r
      };
    }

    function rt(t) {
      var e = t.getFilter(),
          n = t.getMapping().domain,
          r = isFinite(e.min) ? e.min : n[0],
          i = isFinite(e.max) ? e.max : n[1];
      return {
        filterMissing: e.filterMissing,
        domain: n,
        percent: function percent(t) {
          return Math.round(100 * (t - n[0]) / (n[1] - n[0]));
        },
        unpercent: function unpercent(t) {
          return t / 100 * (n[1] - n[0]) + n[0];
        },
        filterMin: r,
        filterMax: i
      };
    }

    var it = n(37),
        ot = function () {
      function t() {
        this.title = "Image";
      }

      return t.prototype.canRender = function (t, e) {
        return t instanceof it.d && e === i.a.CELL;
      }, t.prototype.create = function (t) {
        return {
          template: "<div></div>",
          update: function update(e, n) {
            var r = Object(h.b)(e, t, n),
                i = t.getLink(n);
            e.title = i ? i.alt : "", e.style.backgroundImage = r || !i ? null : "url('" + i.href + "')";
          },
          render: o.i
        };
      }, t.prototype.createGroup = function () {
        return o.h;
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        at = n(49),
        ut = n(64),
        ct = n(32),
        st = function () {
      function t() {
        this.title = "Interleaved";
      }

      return t.prototype.canRender = function (t) {
        return t instanceof at.a;
      }, t.prototype.create = function (t, e) {
        var n = Object(ut.a)(t, e, !1, i.a.CELL).cols,
            r = e.colWidth(t);
        return {
          template: "<div>" + n.map(function (t) {
            return t.template;
          }).join("") + "</div>",
          update: function update(e, r, i, a) {
            Object(h.b)(e, t, r) || (Object(o.g)(e, n), Object(o.f)(e, function (t, e) {
              n[e].renderer.update(t, r, i, a);
            }));
          },
          render: function render(e, i, o, a) {
            Object(h.a)(e, t, i, r) || (e.save(), e.scale(1, 1 / n.length), n.forEach(function (t, n) {
              t.renderer.render(e, i, n, a), e.translate(0, c.c);
            }), e.restore());
          }
        };
      }, t.prototype.createGroup = function (t, e) {
        var n = Object(ut.a)(t, e, !1, i.a.GROUP).cols;
        return {
          template: "<div>" + n.map(function (t) {
            return t.template;
          }).join("") + "</div>",
          update: function update(t, e, r) {
            Object(o.g)(t, n), Object(o.f)(t, function (t, i) {
              n[i].groupRenderer.update(t, e, r);
            });
          }
        };
      }, t.prototype.createSummary = function (t, e) {
        var n = t.children,
            r = 0,
            i = nt(e.totalNumberOfRows, t, {
          color: function color() {
            return Object(ct.a)(n[r++ % n.length]);
          }
        }),
            o = i.template,
            a = i.render;
        return {
          template: o,
          update: function update(t) {
            var r = n.map(function (t) {
              return e.statsOf(t);
            });

            if (r.some(Boolean)) {
              t.classList.remove("lu-missing");

              var i = function (t) {
                for (var e = t.find(Boolean).hist.length, n = [], r = 0, i = function i(e) {
                  t.forEach(function (t) {
                    var i = t ? t.hist[e] : null;
                    i ? (i.length > r && (r = i.length), n.push(i)) : n.push(lt);
                  });
                }, o = 0; o < e; ++o) {
                  i(o);
                }

                return {
                  bins: e,
                  max: r,
                  hist: n
                };
              }(r);

              a(t, i);
            } else t.classList.add("lu-missing");
          }
        };
      }, t;
    }(),
        lt = {
      length: 0,
      x0: 0,
      x1: 0
    };

    var pt = function () {
      function t() {
        this.title = "Link";
      }

      return t.prototype.canRender = function (t, e) {
        return t instanceof it.d && e !== i.a.SUMMARY;
      }, t.prototype.create = function (t) {
        var e = t.alignment || "left";
        return {
          template: "<a" + ("left" !== e ? ' class="lu-' + e + '"' : "") + ' target="_blank" href=""></a>',
          update: function update(e, n) {
            if (!Object(h.b)(e, t, n)) {
              var r = t.getLink(n);
              e.href = r ? r.href : "", t.escape ? Object(o.j)(e, r ? r.alt : "") : e.innerHTML = r ? r.alt : "";
            }
          },
          render: o.i
        };
      }, t.exampleText = function (t, e) {
        for (var n = [], r = 0, i = e; r < i.length; r++) {
          var o = i[r];

          if (!t.isMissing(o)) {
            var a = t.getLink(o);
            if (n.push('<a target="_blank" href="' + (a ? a.href : "") + '">' + (a ? a.alt : "") + "</a>"), n.length >= 5) break;
          }
        }

        return n.join(", ") + (n.length < e.length ? ", &hellip;" : "");
      }, t.prototype.createGroup = function (e) {
        return {
          template: "<div> </div>",
          update: function update(n, r, i) {
            n.innerHTML = t.exampleText(e, i);
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        ft = n(59),
        dt = function () {
      function t() {
        this.title = "Table";
      }

      return t.prototype.canRender = function (t) {
        return Object(ft.b)(t);
      }, t.prototype.create = function (t) {
        return Object(ft.a)(t) && t.dataLength ? this.createFixed(t) : {
          template: "<div></div>",
          update: function update(e, n) {
            Object(h.b)(e, t, n) || (e.innerHTML = t.getMapLabel(n).map(function (t) {
              return "<div>" + t.key + "</div><div>" + t.value + "</div>";
            }).join(""));
          },
          render: o.i
        };
      }, t.template = function (t) {
        return "<div>" + t.labels.map(function (t) {
          return "<div>" + t + "</div><div data-v></div>";
        }).join("\n") + "</div>";
      }, t.prototype.createFixed = function (e) {
        return {
          template: t.template(e),
          update: function update(t, n) {
            if (!Object(h.b)(t, e, n)) {
              var r = e.getLabels(n);
              Object(o.e)(t, "[data-v]", function (t, e) {
                t.innerHTML = r[e];
              });
            }
          },
          render: o.i
        };
      }, t.example = function (t) {
        return t.slice(0, 5).map(function (t) {
          return t.value;
        }).join(", ") + (5 < t.length ? ", &hellip;" : "");
      }, t.prototype.createGroup = function (e) {
        return Object(ft.a)(e) && e.dataLength ? this.createFixedGroup(e) : {
          template: "<div></div>",
          update: function update(n, r, i) {
            var o = ht(i.filter(function (t) {
              return !e.isMissing(t);
            }).map(function (t) {
              return e.getMapLabel(t);
            }));
            n.innerHTML = o.map(function (e) {
              var n = e.key,
                  r = e.values;
              return "<div>" + n + "</div><div>" + t.example(r) + "</div>";
            }).join("");
          }
        };
      }, t.prototype.createFixedGroup = function (e) {
        return {
          template: t.template(e),
          update: function update(t, n, r) {
            var i = r.filter(function (t) {
              return !e.isMissing(t);
            }).map(function (t) {
              return e.getLabels(t);
            });
            Object(o.e)(t, "[data-v]", function (t, e) {
              for (var n = [], r = 0, o = i; r < o.length; r++) {
                var a = o[r][e];
                if (!Object(q.c)(a) && (n.push(a), n.length >= 5)) break;
              }

              t.innerHTML = n.join(", ") + (5 < i.length ? ", &hellip;" : "");
            });
          }
        };
      }, t.prototype.createSummary = function () {
        return {
          template: "<div><div>Key</div><div>Value</div></div>",
          update: o.i
        };
      }, t;
    }();

    function ht(t) {
      var e = new Map();
      return t.forEach(function (t) {
        return t.forEach(function (t) {
          e.has(t.key) ? e.get(t.key).push(t) : e.set(t.key, [t]);
        });
      }), Array.from(e).sort(function (t, e) {
        return t[0].localeCompare(e[0]);
      }).map(function (t) {
        return {
          key: t[0],
          values: t[1]
        };
      });
    }

    var gt = n(70),
        bt = function () {
      function t() {
        this.title = "Table with Links";
      }

      return t.prototype.canRender = function (t, e) {
        return t instanceof gt.a && e !== i.a.SUMMARY;
      }, t.prototype.create = function (t) {
        var e = t.alignment || "left";
        return {
          template: "<div></div>",
          update: function update(n, r) {
            Object(h.b)(n, t, r) || (n.innerHTML = t.getLinkMap(r).map(function (t) {
              var n = t.key,
                  r = t.value;
              return "<div>" + n + "</div><div" + ("left" !== e ? ' class="lu-' + e + '"' : "") + '><a href="' + r.href + '" target="_blank">' + r.alt + "</a></div>";
            }).join(""));
          },
          render: o.i
        };
      }, t.example = function (t) {
        for (var e = [], n = 0, r = t; n < r.length; n++) {
          var i = r[n];
          if (e.push('<a target="_blank" href="' + i.value.href + '">' + i.value.alt + "</a>"), e.length >= 5) break;
        }

        return "" + e.join(", ") + (e.length < t.length) + " ? ', &hellip;': ''}";
      }, t.prototype.createGroup = function (e) {
        var n = e.alignment || "left";
        return {
          template: "<div></div>",
          update: function update(r, i, o) {
            var a = ht(o.filter(function (t) {
              return !e.isMissing(t);
            }).map(function (t) {
              return e.getLinkMap(t);
            }));
            r.innerHTML = a.map(function (e) {
              var r = e.key,
                  i = e.values;
              return "<div>" + r + "</div><div" + ("left" !== n ? ' class="lu-' + n + '"' : "") + ">" + t.example(i) + "</div>";
            }).join("");
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        mt = function () {
      function t() {
        this.title = "Loading";
      }

      return t.prototype.canRender = function () {
        return !1;
      }, t.prototype.create = function () {
        return {
          template: "<div>Loading…</div>",
          update: o.i,
          render: o.i
        };
      }, t.prototype.createGroup = function () {
        return this.create();
      }, t.prototype.createSummary = function () {
        return this.create();
      }, t;
    }(),
        yt = function () {
      function t() {
        this.title = "Bar Table";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(ft.b)(t) && Object(m.k)(t) && (e === i.a.CELL || e === i.a.SUMMARY && Object(v.d)(t));
      }, t.prototype.create = function (t, e, n, r) {
        return {
          template: "<div></div>",
          update: function update(e, n) {
            Object(h.b)(e, t, n) || (e.innerHTML = t.getMap(n).map(function (e) {
              var i = e.key,
                  o = e.value;
              if (Object(q.c)(o)) return "<div>" + i + '</div><div class="lu-missing"></div>';
              var a = isNaN(o) ? 0 : Math.round(100 * o * 100) / 100;
              return "<div>" + i + '</div><div title="' + Object(m.a)(o) + '"><div style="width: ' + a + "%; background-color: " + E(t, n, r) + '"><span class="lu-hover-only">' + o + "</span></div></div>";
            }).join(""));
          },
          render: o.i
        };
      }, t.prototype.createGroup = function () {
        return o.h;
      }, t.prototype.createSummary = function (t) {
        return {
          template: "<div><div>Key</div><div><span></span><span></span>Value</div></div>",
          update: function update(e) {
            var n = t.getRange(),
                r = e.lastElementChild;
            r.firstElementChild.textContent = n[0], r.children[1].textContent = n[1];
          }
        };
      }, t;
    }(),
        vt = n(40),
        Et = function () {
      function t() {
        this.title = "Default";
      }

      return t.prototype.canRender = function (t) {
        return t instanceof vt.b;
      }, t.prototype.create = function (t) {
        return {
          template: '<div class="lu-right"> </div>',
          update: function update(e, n) {
            Object(h.b)(e, t, n), Object(o.j)(e, t.getLabel(n));
          },
          render: o.i
        };
      }, t.prototype.createGroup = function (t) {
        return {
          template: "<div><div></div><div></div></div>",
          update: function update(e, n, r) {
            var i = e.firstElementChild,
                o = e.lastElementChild;
            if (0 === r.length) return i.textContent = "", void (o.textContent = "");
            i.textContent = t.getLabel(r[0]), o.textContent = t.getLabel(r[r.length - 1]);
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        Ot = n(89),
        Ct = n(29);

    function _t(t) {
      if (0 === t.length) return "";
      var e = "",
          n = !0;
      return t.forEach(function (t, r) {
        Object(q.c)(t) ? n = !0 : n ? (e += "M" + r + "," + (1 - t) + " ", n = !1) : e += "L" + r + "," + (1 - t) + " ";
      }), e;
    }

    var Tt = function () {
      function t() {
        this.title = "Sparkline";
      }

      return t.prototype.canRender = function (t, e) {
        return Object(m.m)(t) && e !== i.a.SUMMARY;
      }, t.prototype.create = function (t) {
        var e = t.dataLength,
            n = 1 - t.getMapping().apply(Ct.c.CENTER);
        return {
          template: '<svg viewBox="0 0 ' + (e - 1) + ' 1" preserveAspectRatio="none meet"><line x1="0" x2="' + (e - 1) + '" y1="' + n + '" y2="' + n + '"></line><path></path></svg>',
          update: function update(e, n) {
            if (!Object(h.b)(e, t, n)) {
              var r = t.getNumbers(n);
              e.querySelector("path").setAttribute("d", _t(r));
            }
          },
          render: o.i
        };
      }, t.prototype.createGroup = function (t) {
        var e = t.dataLength,
            n = 1 - t.getMapping().apply(Ct.c.CENTER);
        return {
          template: '<svg viewBox="0 0 ' + e + ' 1" preserveAspectRatio="none meet"><line x1="0" x2="' + (e - 1) + '" y1="' + n + '" y2="' + n + '"></line><path></path></svg>',
          update: function update(e, n, r) {
            !function (t, e, n) {
              var r = Array.from(t.children);
              r.length > e.length ? r.slice(e.length).forEach(function (t) {
                return t.remove();
              }) : e.length > r.length && t.insertAdjacentHTML("beforeend", n.repeat(e.length - r.length));
            }(e, r, "<path></path>"), Object(o.f)(e, function (e, n) {
              var i = r[n];
              e.setAttribute("d", _t(t.getNumbers(i)));
            });
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }(),
        Nt = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.title = "Bar Chart", e;
      }

      return Object(l.c)(e, t), e.prototype.canRender = function (t, e) {
        return Object(m.m)(t) && Boolean(t.dataLength) && e === i.a.CELL;
      }, e.compute = function (t, e, n) {
        return t < e ? {
          height: e - t,
          bottom: t - n[0]
        } : {
          height: t - e,
          bottom: e - n[0]
        };
      }, e.prototype.createContext = function (t, n, r) {
        for (var i = n.colWidth(t) / t.dataLength, a = t.getMapping().apply(Ct.c.CENTER), u = "", s = 0; s < t.dataLength; ++s) {
          u += '<div style="background-color: white" title=""></div>';
        }

        return {
          templateRow: u,
          update: function update(n, i, u, c) {
            var s = L(0, c, t, r),
                l = L(1, c, t, r);
            Object(o.f)(n, function (t, n) {
              var r = i[n],
                  c = e.compute(r, a, [0, 1]),
                  p = c.bottom,
                  f = c.height;
              Object(o.c)(t, {
                title: Object(m.a)(u[n])
              }, {
                "background-color": r < a ? s : l,
                bottom: Math.round(100 * p / 1) + "%",
                height: Math.round(100 * f / 1) + "%"
              });
            });
          },
          render: function render(n, o, u) {
            var s = L(0, u, t, r),
                l = L(1, u, t, r),
                p = c.c / 1;
            o.forEach(function (t, r) {
              n.fillStyle = t < a ? s : l;
              var o = r * i,
                  u = e.compute(t, a, [0, 1]),
                  c = u.bottom,
                  f = u.height;
              n.fillRect(o, (1 - f - c) * p, i, f * p);
            });
          }
        };
      }, e.prototype.createSummary = function () {
        return o.h;
      }, e;
    }($),
        Dt = n(35),
        Rt = function () {
      function t() {
        this.title = "Date", this.groupTitle = "Date", this.summaryTitle = "Date";
      }

      return t.prototype.canRender = function (t) {
        return t instanceof Dt.c;
      }, t.prototype.create = function (t) {
        return {
          template: "<div> </div>",
          update: function update(e, n) {
            Object(h.b)(e, t, n), Object(o.j)(e, t.getLabel(n));
          },
          render: o.i
        };
      }, t.prototype.createGroup = function (t) {
        var e = t.isGroupedBy() >= 0,
            n = t.getDateGrouper();
        return {
          template: "<div> </div>",
          update: function update(r, i, a) {
            if (e) {
              var u = Object(Dt.b)(a, n, t);
              Object(o.j)(r, u.name);
            } else Object(o.j)(r, Object(o.d)(t, a));
          }
        };
      }, t.prototype.createSummary = function () {
        return o.h;
      }, t;
    }();

    n.d(e, "q", function () {
      return At;
    }), n.d(e, "i", function () {
      return Mt;
    }), n.d(e, "h", function () {
      return Lt;
    }), n.d(e, "j", function () {
      return jt;
    }), n.d(e, "m", function () {
      return xt;
    }), n.d(e, "l", function () {
      return St;
    }), n.d(e, "n", function () {
      return It;
    }), n.d(e, "f", function () {
      return i.default;
    }), n.d(e, "e", function () {
      return i.IImposer;
    }), n.d(e, "a", function () {
      return i.a;
    }), n.d(e, "g", function () {
      return i.ISummaryRenderer;
    }), n.d(e, "d", function () {
      return i.IGroupCellRenderer;
    }), n.d(e, "b", function () {
      return i.ICellRenderer;
    }), n.d(e, "c", function () {
      return i.ICellRendererFactory;
    }), n.d(e, "k", function () {
      return E;
    }), n.d(e, "p", function () {
      return h.b;
    }), n.d(e, "o", function () {
      return h.a;
    });
    var wt = new _(),
        At = {
      actions: new a(),
      aggregate: new s(),
      annotate: new b(),
      boolean: new T(),
      boxplot: new w(),
      brightness: new j(),
      catdistributionbar: new B(),
      categorical: new k(),
      circle: new W(),
      date: new Rt(),
      default: wt,
      dot: new z(),
      group: new X(),
      heatmap: new J(),
      catheatmap: new U(),
      histogram: new tt(),
      image: new ot(),
      interleaving: new st(),
      link: new pt(),
      linkMap: new bt(),
      loading: new mt(),
      nested: new ut.b(!1),
      number: new O(),
      mapbars: new yt(),
      rank: new Et(),
      selection: new Ot.a(),
      sparkline: new Tt(),
      stack: new ut.b(),
      string: new g(),
      table: new dt(),
      upset: new G(),
      verticalbar: new Nt()
    };

    function Mt(t, e) {
      return e[t.getRenderer()] || wt;
    }

    function Lt(t, e) {
      return e[t.getGroupRenderer()] || wt;
    }

    function jt(t, e) {
      return e[t.getSummaryRenderer()] || wt;
    }

    function xt(t, e, n) {
      return void 0 === n && (n = i.a.CELL), Object.keys(e).filter(function (r) {
        return e[r].canRender(t, n);
      }).map(function (t) {
        var r = e[t];
        return {
          type: t,
          label: n === i.a.CELL ? r.title : n === i.a.GROUP ? r.groupTitle || r.title : r.summaryTitle || r.groupTitle || r.title
        };
      });
    }

    function St(t, e) {
      return xt(t, e, i.a.GROUP);
    }

    function It(t, e) {
      return xt(t, e, i.a.SUMMARY);
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(25);

    function i(t, e, n, r, i) {
      var o = t * t,
          a = o * t;
      return ((1 - 3 * t + 3 * o - a) * e + (4 - 6 * o + 3 * a) * n + (1 + 3 * t + 3 * o - 3 * a) * r + a * i) / 6;
    }

    var o = function o(t) {
      return function () {
        return t;
      };
    };

    function a(t, e) {
      return function (n) {
        return t + n * e;
      };
    }

    function u(t, e) {
      var n = e - t;
      return n ? a(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : o(isNaN(t) ? e : t);
    }

    function c(t) {
      return 1 == (t = +t) ? s : function (e, n) {
        return n - e ? function (t, e, n) {
          return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
            return Math.pow(t + r * e, n);
          };
        }(e, n, t) : o(isNaN(e) ? n : e);
      };
    }

    function s(t, e) {
      var n = e - t;
      return n ? a(t, n) : o(isNaN(t) ? e : t);
    }

    var l = function t(e) {
      var n = c(e);

      function i(t, e) {
        var i = n((t = Object(r.f)(t)).r, (e = Object(r.f)(e)).r),
            o = n(t.g, e.g),
            a = n(t.b, e.b),
            u = s(t.opacity, e.opacity);
        return function (e) {
          return t.r = i(e), t.g = o(e), t.b = a(e), t.opacity = u(e), t + "";
        };
      }

      return i.gamma = t, i;
    }(1);

    function p(t) {
      return function (e) {
        var n,
            i,
            o = e.length,
            a = new Array(o),
            u = new Array(o),
            c = new Array(o);

        for (n = 0; n < o; ++n) {
          i = Object(r.f)(e[n]), a[n] = i.r || 0, u[n] = i.g || 0, c[n] = i.b || 0;
        }

        return a = t(a), u = t(u), c = t(c), i.opacity = 1, function (t) {
          return i.r = a(t), i.g = u(t), i.b = c(t), i + "";
        };
      };
    }

    var f = p(function (t) {
      var e = t.length - 1;
      return function (n) {
        var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
            o = t[r],
            a = t[r + 1],
            u = r > 0 ? t[r - 1] : 2 * o - a,
            c = r < e - 1 ? t[r + 2] : 2 * a - o;
        return i((n - r / e) * e, u, o, a, c);
      };
    }),
        d = (p(function (t) {
      var e = t.length;
      return function (n) {
        var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
            o = t[(r + e - 1) % e],
            a = t[r % e],
            u = t[(r + 1) % e],
            c = t[(r + 2) % e];
        return i((n - r / e) * e, o, a, u, c);
      };
    }), function (t, e) {
      var n,
          r = e ? e.length : 0,
          i = t ? Math.min(r, t.length) : 0,
          o = new Array(i),
          a = new Array(r);

      for (n = 0; n < i; ++n) {
        o[n] = T(t[n], e[n]);
      }

      for (; n < r; ++n) {
        a[n] = e[n];
      }

      return function (t) {
        for (n = 0; n < i; ++n) {
          a[n] = o[n](t);
        }

        return a;
      };
    }),
        h = function h(t, e) {
      var n = new Date();
      return e -= t = +t, function (r) {
        return n.setTime(t + e * r), n;
      };
    },
        g = function g(t, e) {
      return e -= t = +t, function (n) {
        return t + e * n;
      };
    },
        b = function b(t, e) {
      var n,
          r = {},
          i = {};

      for (n in null !== t && "object" == typeof t || (t = {}), null !== e && "object" == typeof e || (e = {}), e) {
        n in t ? r[n] = T(t[n], e[n]) : i[n] = e[n];
      }

      return function (t) {
        for (n in r) {
          i[n] = r[n](t);
        }

        return i;
      };
    },
        m = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        y = new RegExp(m.source, "g");

    var v,
        E,
        O,
        C,
        _ = function _(t, e) {
      var n,
          r,
          i,
          o = m.lastIndex = y.lastIndex = 0,
          a = -1,
          u = [],
          c = [];

      for (t += "", e += ""; (n = m.exec(t)) && (r = y.exec(e));) {
        (i = r.index) > o && (i = e.slice(o, i), u[a] ? u[a] += i : u[++a] = i), (n = n[0]) === (r = r[0]) ? u[a] ? u[a] += r : u[++a] = r : (u[++a] = null, c.push({
          i: a,
          x: g(n, r)
        })), o = y.lastIndex;
      }

      return o < e.length && (i = e.slice(o), u[a] ? u[a] += i : u[++a] = i), u.length < 2 ? c[0] ? function (t) {
        return function (e) {
          return t(e) + "";
        };
      }(c[0].x) : function (t) {
        return function () {
          return t;
        };
      }(e) : (e = c.length, function (t) {
        for (var n, r = 0; r < e; ++r) {
          u[(n = c[r]).i] = n.x(t);
        }

        return u.join("");
      });
    },
        T = function T(t, e) {
      var n,
          i = typeof e;
      return null == e || "boolean" === i ? o(e) : ("number" === i ? g : "string" === i ? (n = Object(r.a)(e)) ? (e = n, l) : _ : e instanceof r.a ? l : e instanceof Date ? h : Array.isArray(e) ? d : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? b : g)(t, e);
    },
        N = function N(t, e) {
      return e -= t = +t, function (n) {
        return Math.round(t + e * n);
      };
    },
        D = 180 / Math.PI,
        R = {
      translateX: 0,
      translateY: 0,
      rotate: 0,
      skewX: 0,
      scaleX: 1,
      scaleY: 1
    },
        w = function w(t, e, n, r, i, o) {
      var a, u, c;
      return (a = Math.sqrt(t * t + e * e)) && (t /= a, e /= a), (c = t * n + e * r) && (n -= t * c, r -= e * c), (u = Math.sqrt(n * n + r * r)) && (n /= u, r /= u, c /= u), t * r < e * n && (t = -t, e = -e, c = -c, a = -a), {
        translateX: i,
        translateY: o,
        rotate: Math.atan2(e, t) * D,
        skewX: Math.atan(c) * D,
        scaleX: a,
        scaleY: u
      };
    };

    function A(t, e, n, r) {
      function i(t) {
        return t.length ? t.pop() + " " : "";
      }

      return function (o, a) {
        var u = [],
            c = [];
        return o = t(o), a = t(a), function (t, r, i, o, a, u) {
          if (t !== i || r !== o) {
            var c = a.push("translate(", null, e, null, n);
            u.push({
              i: c - 4,
              x: g(t, i)
            }, {
              i: c - 2,
              x: g(r, o)
            });
          } else (i || o) && a.push("translate(" + i + e + o + n);
        }(o.translateX, o.translateY, a.translateX, a.translateY, u, c), function (t, e, n, o) {
          t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), o.push({
            i: n.push(i(n) + "rotate(", null, r) - 2,
            x: g(t, e)
          })) : e && n.push(i(n) + "rotate(" + e + r);
        }(o.rotate, a.rotate, u, c), function (t, e, n, o) {
          t !== e ? o.push({
            i: n.push(i(n) + "skewX(", null, r) - 2,
            x: g(t, e)
          }) : e && n.push(i(n) + "skewX(" + e + r);
        }(o.skewX, a.skewX, u, c), function (t, e, n, r, o, a) {
          if (t !== n || e !== r) {
            var u = o.push(i(o) + "scale(", null, ",", null, ")");
            a.push({
              i: u - 4,
              x: g(t, n)
            }, {
              i: u - 2,
              x: g(e, r)
            });
          } else 1 === n && 1 === r || o.push(i(o) + "scale(" + n + "," + r + ")");
        }(o.scaleX, o.scaleY, a.scaleX, a.scaleY, u, c), o = a = null, function (t) {
          for (var e, n = -1, r = c.length; ++n < r;) {
            u[(e = c[n]).i] = e.x(t);
          }

          return u.join("");
        };
      };
    }

    A(function (t) {
      return "none" === t ? R : (v || (v = document.createElement("DIV"), E = document.documentElement, O = document.defaultView), v.style.transform = t, t = O.getComputedStyle(E.appendChild(v), null).getPropertyValue("transform"), E.removeChild(v), t = t.slice(7, -1).split(","), w(+t[0], +t[1], +t[2], +t[3], +t[4], +t[5]));
    }, "px, ", "px)", "deg)"), A(function (t) {
      return null == t ? R : (C || (C = document.createElementNS("http://www.w3.org/2000/svg", "g")), C.setAttribute("transform", t), (t = C.transform.baseVal.consolidate()) ? (t = t.matrix, w(t.a, t.b, t.c, t.d, t.e, t.f)) : R);
    }, ", ", ")", ")"), Math.SQRT2;

    function M(t) {
      return function (e, n) {
        var i = t((e = Object(r.d)(e)).h, (n = Object(r.d)(n)).h),
            o = s(e.s, n.s),
            a = s(e.l, n.l),
            u = s(e.opacity, n.opacity);
        return function (t) {
          return e.h = i(t), e.s = o(t), e.l = a(t), e.opacity = u(t), e + "";
        };
      };
    }

    M(u), M(s);

    function L(t) {
      return function (e, n) {
        var i = t((e = Object(r.c)(e)).h, (n = Object(r.c)(n)).h),
            o = s(e.c, n.c),
            a = s(e.l, n.l),
            u = s(e.opacity, n.opacity);
        return function (t) {
          return e.h = i(t), e.c = o(t), e.l = a(t), e.opacity = u(t), e + "";
        };
      };
    }

    L(u), L(s);

    function j(t) {
      return function e(n) {
        function i(e, i) {
          var o = t((e = Object(r.b)(e)).h, (i = Object(r.b)(i)).h),
              a = s(e.s, i.s),
              u = s(e.l, i.l),
              c = s(e.opacity, i.opacity);
          return function (t) {
            return e.h = o(t), e.s = a(t), e.l = u(Math.pow(t, n)), e.opacity = c(t), e + "";
          };
        }

        return n = +n, i.gamma = e, i;
      }(1);
    }

    j(u);
    var x = j(s);
    n.d(e, "a", function () {
      return T;
    }), n.d(e, "c", function () {
      return g;
    }), n.d(e, "e", function () {
      return N;
    }), n.d(e, "d", function () {
      return f;
    }), n.d(e, "b", function () {
      return x;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return o;
    });
    var r = n(0),
        i = n(2);

    function o(t) {
      return void 0 === t && (t = "Selection Checkboxes"), {
        type: "selection",
        label: t,
        fixed: !0
      };
    }

    var a = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultWidth(20), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, Object.defineProperty(e.prototype, "frozen", {
        get: function get() {
          return !1 !== this.desc.frozen;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_SELECT]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.setValue = function (t, e) {
        return this.getValue(t) === e || this.setImpl(t, e);
      }, e.prototype.setValues = function (t, e) {
        if (0 !== t.length) return this.desc.setterAll && this.desc.setterAll(t, e), this.fire(n.EVENT_SELECT, t[0], e, t), !0;
      }, e.prototype.setImpl = function (t, e) {
        return this.desc.setter && this.desc.setter(t, e), this.fire(n.EVENT_SELECT, t, e), !0;
      }, e.prototype.toggleValue = function (t) {
        var e = this.getValue(t);
        return this.setImpl(t, !e), !e;
      }, e.prototype.compare = function (t, e) {
        var n = !0 === this.getValue(t),
            r = !0 === this.getValue(e);
        return n === r ? 0 : n < r ? -1 : 1;
      }, e.prototype.group = function (t) {
        return this.getValue(t) ? n.SELECTED_GROUP : n.NOT_SELECTED_GROUP;
      }, e.SELECTED_GROUP = {
        name: "Selected",
        color: "orange"
      }, e.NOT_SELECTED_GROUP = {
        name: "Unselected",
        color: "gray"
      }, e.EVENT_SELECT = "select", e = n = Object(r.b)([Object(i.e)(), Object(i.m)("sort", "sortBy", "group", "groupBy", "invertSelection"), Object(i.b)("support")], e);
    }(n(22).b);

    e.c = a;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return "function" == typeof t.getMap && "function" == typeof t.getMapLabel;
    }

    function i(t) {
      return "function" == typeof t.getLabels && "function" == typeof t.getValues && r(t);
    }

    n.d(e, "b", function () {
      return r;
    }), n.d(e, "a", function () {
      return i;
    });
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && void 0 !== t.name;
    }

    n.d(e, "b", function () {
      return r;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return o;
    });
    var r = n(0),
        i = n(2);

    function o(t, e, n) {
      return void 0 === t && (t = "actions"), void 0 === e && (e = []), void 0 === n && (n = []), {
        type: "actions",
        label: t,
        actions: e,
        groupActions: n,
        fixed: !0
      };
    }

    var a = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.actions = n.actions || [], r.groupActions = n.groupActions || [], r;
      }

      return Object(r.c)(e, t), e.prototype.getLabel = function () {
        return "";
      }, e.prototype.getValue = function () {
        return "";
      }, e.prototype.compare = function () {
        return 0;
      }, e = Object(r.b)([Object(i.e)(), Object(i.b)("support")], e);
    }(n(1).d);

    e.b = a;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return c;
    }), n.d(e, "a", function () {
      return r;
    });
    var r,
        i = n(0),
        o = n(2),
        a = n(1),
        u = n(7);

    function c(t) {
      return void 0 === t && (t = "Group Name"), {
        type: "group",
        label: t
      };
    }

    !function (t) {
      t.name = "name", t.count = "count";
    }(r || (r = {}));

    var s = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.groupSortMethod = r.name, e;
      }

      var n;
      return Object(i.c)(e, t), n = e, Object.defineProperty(e.prototype, "frozen", {
        get: function get() {
          return !1 !== this.desc.frozen;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_SORTMETHOD_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getLabel = function () {
        return "";
      }, e.prototype.getValue = function () {
        return "";
      }, e.prototype.compare = function () {
        return 0;
      }, e.prototype.getSortMethod = function () {
        return this.groupSortMethod;
      }, e.prototype.setSortMethod = function (t) {
        this.groupSortMethod !== t && (this.fire([n.EVENT_SORTMETHOD_CHANGED], this.groupSortMethod, this.groupSortMethod = t), this.isGroupSortedByMe().asc || this.toggleMyGroupSorting());
      }, e.prototype.groupCompare = function (t, e) {
        switch (this.groupSortMethod) {
          case "count":
            return t.rows.length - e.rows.length;

          default:
            return t.name === u.e.name ? e.name === u.e.name ? 0 : u.b : e.name === u.e.name ? -u.b : t.name.toLowerCase().localeCompare(e.name.toLowerCase());
        }
      }, e.EVENT_SORTMETHOD_CHANGED = "sortMethodChanged", e = n = Object(i.b)([Object(o.e)(), Object(o.m)("sortGroupBy"), Object(o.h)("sortGroup", "sortGroups"), Object(o.b)("support")], e);
    }(a.d);

    e.c = s;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(12),
        o = n(42),
        a = n(2),
        u = n(19),
        c = n(1),
        s = n(24),
        l = n(6),
        p = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.lookup = new Map(), r.currentFilter = null, r.categories = Object(s.g)(n), r.missingCategory = n.missingCategory ? Object(s.h)(n.missingCategory, NaN) : null, r.categories.forEach(function (t) {
          return r.lookup.set(t.name, t);
        }), r.setDefaultRenderer("number"), r.setDefaultGroupRenderer("boxplot"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_MAPPING_CHANGED, n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, Object.defineProperty(e.prototype, "dataLength", {
        get: function get() {
          return this.categories.length;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "labels", {
        get: function get() {
          return this.categories.map(function (t) {
            return t.label;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getValue = function (t) {
        var e = this.getCategory(t);
        return e ? e.value : NaN;
      }, e.prototype.getCategory = function (e) {
        var n = t.prototype.getValue.call(this, e);
        if (!n) return this.missingCategory;
        var r = String(n);
        return this.lookup.has(r) ? this.lookup.get(r) : this.missingCategory;
      }, e.prototype.getColor = function (t) {
        return u.a.prototype.getColor.call(this, t);
      }, e.prototype.getLabel = function (t) {
        return u.a.prototype.getLabel.call(this, t);
      }, e.prototype.getLabels = function (t) {
        return u.a.prototype.getLabels.call(this, t);
      }, e.prototype.getValues = function (t) {
        return u.a.prototype.getValues.call(this, t);
      }, e.prototype.getMap = function (t) {
        return u.a.prototype.getMap.call(this, t);
      }, e.prototype.getMapLabel = function (t) {
        return u.a.prototype.getMapLabel.call(this, t);
      }, e.prototype.getSet = function (t) {
        return u.a.prototype.getSet.call(this, t);
      }, e.prototype.getNumber = function (t) {
        return this.getValue(t);
      }, e.prototype.isMissing = function (t) {
        return u.a.prototype.isMissing.call(this, t);
      }, e.prototype.getRawNumber = function (t) {
        return this.getNumber(t);
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.isMissing(e) ? null : {
          name: this.getLabel(e),
          value: this.getValue(e)
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.dump = function (t) {
        var e = u.a.prototype.dump.call(this, t);
        return e.mapping = this.getMapping(), e;
      }, e.prototype.restore = function (t, e) {
        u.a.prototype.restore.call(this, t, e), t.mapping && this.setMapping(t.mapping);
      }, e.prototype.getMapping = function () {
        return this.categories.map(function (t) {
          return t.value;
        });
      }, e.prototype.setMapping = function (t) {
        var e = Object(i.d)(t);
        t = t.map(function (t) {
          return (t - e[0]) / (e[1] - e[0]);
        });
        var r = this.getMapping();
        Object(o.b)(r, t) || (this.categories.forEach(function (e, n) {
          return e.value = t[n] || 0;
        }), this.fire([n.EVENT_MAPPING_CHANGED, c.d.EVENT_DIRTY_HEADER, c.d.EVENT_DIRTY_VALUES, c.d.EVENT_DIRTY], r, this.getMapping()));
      }, e.prototype.isFiltered = function () {
        return null != this.currentFilter;
      }, e.prototype.filter = function (t) {
        return u.a.prototype.filter.call(this, t);
      }, e.prototype.group = function (t) {
        return u.a.prototype.group.call(this, t);
      }, e.prototype.getFilter = function () {
        return this.currentFilter;
      }, e.prototype.setFilter = function (t) {
        return u.a.prototype.setFilter.call(this, t);
      }, e.prototype.compare = function (t, e) {
        return u.a.prototype.compare.call(this, t, e);
      }, e.prototype.getRenderer = function () {
        return l.b.prototype.getRenderer.call(this);
      }, e.EVENT_MAPPING_CHANGED = l.b.EVENT_MAPPING_CHANGED, e.EVENT_FILTER_CHANGED = u.a.EVENT_FILTER_CHANGED, e = n = Object(r.b)([Object(a.m)("group", "filterOrdinal"), Object(a.b)("categorical")], e);
    }(n(22).b);

    e.b = p;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(16),
        o = n(26),
        a = n(27),
        u = n(3),
        c = n(8),
        s = n(4),
        l = function () {
      function t() {}

      return t.prototype.createGroup = function (t, e, n, r) {
        var i = this,
            o = this.create(t, e, n, r);
        return {
          template: "<div>" + o.template + "</div>",
          update: function update(e, n, r) {
            var a = i.aggregatedIndex(r, t);
            o.update(e.firstElementChild, r[a], a, n);
          }
        };
      }, t.prototype.createSummary = function () {
        return s.h;
      }, t;
    }(),
        p = n(9),
        f = n(10);

    function d(t) {
      return "lu-stacked-" + t.id;
    }

    function h(t, e, n, r, i) {
      var o = c.d,
          a = 0;
      return {
        cols: t.children.map(function (u) {
          var c = a,
              s = u.getWidth();
          a += s, a += n ? 0 : o;
          var l = r === p.a.CELL ? e.renderer(u, i) : null,
              f = r === p.a.GROUP ? e.groupRenderer(u, i) : null,
              d = r === p.a.GROUP ? e.summaryRenderer(u, !1, i) : null,
              h = "",
              g = "";

          switch (r) {
            case p.a.CELL:
              h = l.template, g = t.getRenderer();
              break;

            case p.a.GROUP:
              h = f.template, g = t.getGroupRenderer();
              break;

            case p.a.SUMMARY:
              h = d.template, g = t.getSummaryRenderer();
          }

          return {
            column: u,
            shift: c,
            width: s,
            template: h = h.replace(/^<([^ >]+)([ >])/, '<$1 data-column-id="' + u.id + '" data-renderer="' + g + '"$2'),
            rendererId: g,
            renderer: l,
            groupRenderer: f,
            summaryRenderer: d
          };
        }),
        stacked: n,
        padding: o
      };
    }

    n.d(e, "c", function () {
      return d;
    }), n.d(e, "a", function () {
      return h;
    });

    var g = function (t) {
      function e(e) {
        void 0 === e && (e = !0);
        var n = t.call(this) || this;
        return n.stacked = e, n.title = n.stacked ? "Stacked Bar" : "Nested", n;
      }

      return Object(r.c)(e, t), e.prototype.canRender = function (t, e) {
        return Object(o.c)(t) && e !== p.a.SUMMARY;
      }, e.prototype.create = function (t, e, n, r) {
        var o = h(t, e, this.stacked, p.a.CELL, r),
            a = o.cols,
            u = o.stacked,
            c = o.padding,
            l = e.option("useGridLayout", !1),
            g = e.colWidth(t);
        return {
          template: "<div class='" + (l ? d(t) : "") + (l && !u ? " lu-grid-space" : "") + "'>" + a.map(function (t) {
            return t.template;
          }).join("") + "</div>",
          update: function update(e, n, r, o) {
            if (!Object(f.b)(e, t, n)) {
              Object(s.g)(e, a);
              var p = Array.from(e.children),
                  d = t.getWidth(),
                  h = 0;
              a.forEach(function (t, e) {
                var a = t.column.getWidth() / d,
                    s = p[e];
                s.style.transform = u ? "translate(-" + Object(i.k)(h / a * 100, 4) + "%,0)" : "", l ? s.style.gridColumnStart = (e + 1).toString() : (s.style.width = Object(i.k)(100 * a, 2) + "%", s.style.marginRight = u ? null : c + "px"), t.renderer.update(s, n, r, o), u && (h += (1 - t.column.getValue(n)) * a);
              });
            }
          },
          render: function render(e, n, r, i) {
            if (!Object(f.a)(e, t, n, g)) {
              var o = 0;
              a.forEach(function (t) {
                var a = t.shift - o;
                e.translate(a, 0), t.renderer.render(e, n, r, i), e.translate(-a, 0), u && (o += t.width * (1 - t.column.getValue(n)));
              });
            }
          }
        };
      }, e.prototype.createGroup = function (e, n, r, o) {
        if (this.stacked && Object(u.k)(e)) return t.prototype.createGroup.call(this, e, n, r, o);
        var a = h(e, n, !1, p.a.GROUP, o),
            c = a.cols,
            l = a.padding,
            f = n.option("useGridLayout", !1);
        return {
          template: "<div class='" + (f ? d(e) : "") + (f ? " lu-grid-space" : "") + "'>" + c.map(function (t) {
            return t.template;
          }).join("") + "</div>",
          update: function update(t, n, r) {
            Object(s.g)(t, c);
            var o = Array.from(t.children),
                a = e.getWidth();
            c.forEach(function (t, e) {
              var u = t.column.getWidth() / a,
                  c = o[e];
              f ? c.style.gridColumnStart = (e + 1).toString() : (c.style.width = Object(i.k)(100 * u, 2) + "%", c.style.marginRight = l + "px"), t.groupRenderer.update(c, n, r);
            });
          }
        };
      }, e.prototype.aggregatedIndex = function (t, e) {
        return console.assert(Object(u.k)(e)), Object(a.d)(t, e);
      }, e;
    }(l);

    e.b = g;
  }, function (t, e, n) {
    "use strict";

    var r = n(12);

    function i(t, e) {
      switch (arguments.length) {
        case 0:
          break;

        case 1:
          this.range(t);
          break;

        default:
          this.range(e).domain(t);
      }

      return this;
    }

    function o() {}

    function a(t, e) {
      var n = new o();
      if (t instanceof o) t.each(function (t, e) {
        n.set(e, t);
      });else if (Array.isArray(t)) {
        var r,
            i = -1,
            a = t.length;
        if (null == e) for (; ++i < a;) {
          n.set(i, t[i]);
        } else for (; ++i < a;) {
          n.set(e(r = t[i], i, t), r);
        }
      } else if (t) for (var u in t) {
        n.set(u, t[u]);
      }
      return n;
    }

    o.prototype = a.prototype = {
      constructor: o,
      has: function has(t) {
        return "$" + t in this;
      },
      get: function get(t) {
        return this["$" + t];
      },
      set: function set(t, e) {
        return this["$" + t] = e, this;
      },
      remove: function remove(t) {
        var e = "$" + t;
        return e in this && delete this[e];
      },
      clear: function clear() {
        for (var t in this) {
          "$" === t[0] && delete this[t];
        }
      },
      keys: function keys() {
        var t = [];

        for (var e in this) {
          "$" === e[0] && t.push(e.slice(1));
        }

        return t;
      },
      values: function values() {
        var t = [];

        for (var e in this) {
          "$" === e[0] && t.push(this[e]);
        }

        return t;
      },
      entries: function entries() {
        var t = [];

        for (var e in this) {
          "$" === e[0] && t.push({
            key: e.slice(1),
            value: this[e]
          });
        }

        return t;
      },
      size: function size() {
        var t = 0;

        for (var e in this) {
          "$" === e[0] && ++t;
        }

        return t;
      },
      empty: function empty() {
        for (var t in this) {
          if ("$" === t[0]) return !1;
        }

        return !0;
      },
      each: function each(t) {
        for (var e in this) {
          "$" === e[0] && t(this[e], e.slice(1), this);
        }
      }
    };
    var u = a;

    function c() {}

    var s = u.prototype;

    function l(t, e) {
      var n = new c();
      if (t instanceof c) t.each(function (t) {
        n.add(t);
      });else if (t) {
        var r = -1,
            i = t.length;
        if (null == e) for (; ++r < i;) {
          n.add(t[r]);
        } else for (; ++r < i;) {
          n.add(e(t[r], r, t));
        }
      }
      return n;
    }

    c.prototype = l.prototype = {
      constructor: c,
      has: s.has,
      add: function add(t) {
        return this["$" + (t += "")] = t, this;
      },
      remove: s.remove,
      clear: s.clear,
      values: s.keys,
      size: s.size,
      empty: s.empty,
      each: s.each
    };
    var p = Array.prototype,
        f = p.map,
        d = p.slice;

    var h = n(57),
        g = function g(t) {
      return function () {
        return t;
      };
    },
        b = function b(t) {
      return +t;
    },
        m = [0, 1];

    function y(t) {
      return t;
    }

    function v(t, e) {
      return (e -= t = +t) ? function (n) {
        return (n - t) / e;
      } : g(isNaN(e) ? NaN : .5);
    }

    function E(t) {
      var e,
          n = t[0],
          r = t[t.length - 1];
      return n > r && (e = n, n = r, r = e), function (t) {
        return Math.max(n, Math.min(r, t));
      };
    }

    function O(t, e, n) {
      var r = t[0],
          i = t[1],
          o = e[0],
          a = e[1];
      return i < r ? (r = v(i, r), o = n(a, o)) : (r = v(r, i), o = n(o, a)), function (t) {
        return o(r(t));
      };
    }

    function C(t, e, n) {
      var i = Math.min(t.length, e.length) - 1,
          o = new Array(i),
          a = new Array(i),
          u = -1;

      for (t[i] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++u < i;) {
        o[u] = v(t[u], t[u + 1]), a[u] = n(e[u], e[u + 1]);
      }

      return function (e) {
        var n = Object(r.b)(t, e, 1, i) - 1;
        return a[n](o[n](e));
      };
    }

    function _(t, e) {
      return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
    }

    function T() {
      var t,
          e,
          n,
          r,
          i,
          o,
          a = m,
          u = m,
          c = h.a,
          s = y;

      function l() {
        return r = Math.min(a.length, u.length) > 2 ? C : O, i = o = null, p;
      }

      function p(e) {
        return isNaN(e = +e) ? n : (i || (i = r(a.map(t), u, c)))(t(s(e)));
      }

      return p.invert = function (n) {
        return s(e((o || (o = r(u, a.map(t), h.c)))(n)));
      }, p.domain = function (t) {
        return arguments.length ? (a = f.call(t, b), s === y || (s = E(a)), l()) : a.slice();
      }, p.range = function (t) {
        return arguments.length ? (u = d.call(t), l()) : u.slice();
      }, p.rangeRound = function (t) {
        return u = d.call(t), c = h.e, l();
      }, p.clamp = function (t) {
        return arguments.length ? (s = t ? E(a) : y, p) : s !== y;
      }, p.interpolate = function (t) {
        return arguments.length ? (c = t, l()) : c;
      }, p.unknown = function (t) {
        return arguments.length ? (n = t, p) : n;
      }, function (n, r) {
        return t = n, e = r, l();
      };
    }

    function N(t, e) {
      return T()(t, e);
    }

    var D = n(33),
        R = function R(t, e, n, i) {
      var o,
          a = Object(r.m)(t, e, n);

      switch ((i = Object(D.c)(null == i ? ",f" : i)).type) {
        case "s":
          var u = Math.max(Math.abs(t), Math.abs(e));
          return null != i.precision || isNaN(o = Object(D.e)(a, u)) || (i.precision = o), Object(D.b)(i, u);

        case "":
        case "e":
        case "g":
        case "p":
        case "r":
          null != i.precision || isNaN(o = Object(D.f)(a, Math.max(Math.abs(t), Math.abs(e)))) || (i.precision = o - ("e" === i.type));
          break;

        case "f":
        case "%":
          null != i.precision || isNaN(o = Object(D.d)(a)) || (i.precision = o - 2 * ("%" === i.type));
      }

      return Object(D.a)(i);
    };

    function w(t) {
      var e = t.domain;
      return t.ticks = function (t) {
        var n = e();
        return Object(r.n)(n[0], n[n.length - 1], null == t ? 10 : t);
      }, t.tickFormat = function (t, n) {
        var r = e();
        return R(r[0], r[r.length - 1], null == t ? 10 : t, n);
      }, t.nice = function (n) {
        null == n && (n = 10);
        var i,
            o = e(),
            a = 0,
            u = o.length - 1,
            c = o[a],
            s = o[u];
        return s < c && (i = c, c = s, s = i, i = a, a = u, u = i), (i = Object(r.l)(c, s, n)) > 0 ? (c = Math.floor(c / i) * i, s = Math.ceil(s / i) * i, i = Object(r.l)(c, s, n)) : i < 0 && (c = Math.ceil(c * i) / i, s = Math.floor(s * i) / i, i = Object(r.l)(c, s, n)), i > 0 ? (o[a] = Math.floor(c / i) * i, o[u] = Math.ceil(s / i) * i, e(o)) : i < 0 && (o[a] = Math.ceil(c * i) / i, o[u] = Math.floor(s * i) / i, e(o)), t;
      }, t;
    }

    function A() {
      var t = N(y, y);
      return t.copy = function () {
        return _(t, A());
      }, i.apply(t, arguments), w(t);
    }

    var M = function M(t, e) {
      var n,
          r = 0,
          i = (t = t.slice()).length - 1,
          o = t[r],
          a = t[i];
      return a < o && (n = r, r = i, i = n, n = o, o = a, a = n), t[r] = e.floor(o), t[i] = e.ceil(a), t;
    };

    function L(t) {
      return Math.log(t);
    }

    function j(t) {
      return Math.exp(t);
    }

    function x(t) {
      return -Math.log(-t);
    }

    function S(t) {
      return -Math.exp(-t);
    }

    function I(t) {
      return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
    }

    function V(t) {
      return function (e) {
        return -t(-e);
      };
    }

    function k(t) {
      var e,
          n,
          i = t(L, j),
          o = i.domain,
          a = 10;

      function u() {
        return e = function (t) {
          return t === Math.E ? Math.log : 10 === t && Math.log10 || 2 === t && Math.log2 || (t = Math.log(t), function (e) {
            return Math.log(e) / t;
          });
        }(a), n = function (t) {
          return 10 === t ? I : t === Math.E ? Math.exp : function (e) {
            return Math.pow(t, e);
          };
        }(a), o()[0] < 0 ? (e = V(e), n = V(n), t(x, S)) : t(L, j), i;
      }

      return i.base = function (t) {
        return arguments.length ? (a = +t, u()) : a;
      }, i.domain = function (t) {
        return arguments.length ? (o(t), u()) : o();
      }, i.ticks = function (t) {
        var i,
            u = o(),
            c = u[0],
            s = u[u.length - 1];
        (i = s < c) && (d = c, c = s, s = d);
        var l,
            p,
            f,
            d = e(c),
            h = e(s),
            g = null == t ? 10 : +t,
            b = [];

        if (!(a % 1) && h - d < g) {
          if (d = Math.round(d) - 1, h = Math.round(h) + 1, c > 0) {
            for (; d < h; ++d) {
              for (p = 1, l = n(d); p < a; ++p) {
                if (!((f = l * p) < c)) {
                  if (f > s) break;
                  b.push(f);
                }
              }
            }
          } else for (; d < h; ++d) {
            for (p = a - 1, l = n(d); p >= 1; --p) {
              if (!((f = l * p) < c)) {
                if (f > s) break;
                b.push(f);
              }
            }
          }
        } else b = Object(r.n)(d, h, Math.min(h - d, g)).map(n);

        return i ? b.reverse() : b;
      }, i.tickFormat = function (t, r) {
        if (null == r && (r = 10 === a ? ".0e" : ","), "function" != typeof r && (r = Object(D.a)(r)), t === 1 / 0) return r;
        null == t && (t = 10);
        var o = Math.max(1, a * t / i.ticks().length);
        return function (t) {
          var i = t / n(Math.round(e(t)));
          return i * a < a - .5 && (i *= a), i <= o ? r(t) : "";
        };
      }, i.nice = function () {
        return o(M(o(), {
          floor: function floor(t) {
            return n(Math.floor(e(t)));
          },
          ceil: function ceil(t) {
            return n(Math.ceil(e(t)));
          }
        }));
      }, i;
    }

    function H() {
      var t = k(T()).domain([1, 10]);
      return t.copy = function () {
        return _(t, H()).base(t.base());
      }, i.apply(t, arguments), t;
    }

    function P(t) {
      return function (e) {
        return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
      };
    }

    function G(t) {
      return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
    }

    function F(t) {
      return t < 0 ? -t * t : t * t;
    }

    function U(t) {
      var e = t(y, y),
          n = 1;

      function r() {
        return 1 === n ? t(y, y) : .5 === n ? t(G, F) : t(P(n), P(1 / n));
      }

      return e.exponent = function (t) {
        return arguments.length ? (n = +t, r()) : n;
      }, w(e);
    }

    function B() {
      var t = U(T());
      return t.copy = function () {
        return _(t, B()).exponent(t.exponent());
      }, i.apply(t, arguments), t;
    }

    function Y() {
      return B.apply(null, arguments).exponent(.5);
    }

    n(15), n(23);
    n.d(e, "a", function () {
      return A;
    }), n.d(e, "b", function () {
      return H;
    }), n.d(e, "c", function () {
      return B;
    }), n.d(e, "d", function () {
      return Y;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(2),
        o = n(19),
        a = n(1),
        u = function (t) {
      function e(e, r) {
        var i = t.call(this, e, r) || this;
        return i.currentFilter = null, i.setWidthImpl(30), i.categories = [{
          name: r.trueMarker || "✓",
          color: n.GROUP_TRUE.color,
          label: n.GROUP_TRUE.name,
          value: 0
        }, {
          name: r.trueMarker || "",
          color: n.GROUP_FALSE.color,
          label: n.GROUP_FALSE.name,
          value: 1
        }], i;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_FILTER_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, Object.defineProperty(e.prototype, "dataLength", {
        get: function get() {
          return this.categories.length;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "labels", {
        get: function get() {
          return this.categories.map(function (t) {
            return t.label;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getValue = function (e) {
        var n = t.prototype.getValue.call(this, e);
        return void 0 !== n && null != n && (!0 === n || "true" === n || "yes" === n || "x" === n);
      }, e.prototype.isMissing = function () {
        return !1;
      }, e.prototype.getCategory = function (t) {
        var e = this.getValue(t);
        return this.categories[e ? 0 : 1];
      }, e.prototype.getColor = function (t) {
        return o.a.prototype.getColor.call(this, t);
      }, e.prototype.getLabel = function (t) {
        return o.a.prototype.getLabel.call(this, t);
      }, e.prototype.getLabels = function (t) {
        return o.a.prototype.getLabels.call(this, t);
      }, e.prototype.getValues = function (t) {
        return o.a.prototype.getValues.call(this, t);
      }, e.prototype.getMap = function (t) {
        return o.a.prototype.getMap.call(this, t);
      }, e.prototype.getMapLabel = function (t) {
        return o.a.prototype.getMapLabel.call(this, t);
      }, e.prototype.getSet = function (t) {
        var e = this.getValue(t),
            n = new Set();
        return n.add(this.categories[e ? 0 : 1]), n;
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return null != this.currentFilter && (n.filter = this.currentFilter), n;
      }, e.prototype.restore = function (e, n) {
        t.prototype.restore.call(this, e, n), void 0 !== e.filter && (this.currentFilter = e.filter);
      }, e.prototype.isFiltered = function () {
        return null != this.currentFilter;
      }, e.prototype.filter = function (t) {
        return !this.isFiltered() || this.getValue(t) === this.currentFilter;
      }, e.prototype.getFilter = function () {
        return this.currentFilter;
      }, e.prototype.setFilter = function (t) {
        this.currentFilter !== t && this.fire([n.EVENT_FILTER_CHANGED, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], this.currentFilter, this.currentFilter = t);
      }, e.prototype.compare = function (t, e) {
        var n = this.getValue(t),
            r = this.getValue(e);
        return n === r ? 0 : n < r ? -1 : 1;
      }, e.prototype.group = function (t) {
        return this.getValue(t) ? n.GROUP_TRUE : n.GROUP_FALSE;
      }, e.EVENT_FILTER_CHANGED = "filterChanged", e.GROUP_TRUE = {
        name: "True",
        color: "black"
      }, e.GROUP_FALSE = {
        name: "False",
        color: "white"
      }, e = n = Object(r.b)([Object(i.m)("group", "groupBy", "filterBoolean"), Object(i.b)("categorical")], e);
    }(n(22).b);

    e.c = u;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return d;
    });
    var r = n(0),
        i = n(13),
        o = n(2),
        a = n(39),
        u = n(1),
        c = n(26),
        s = n(3),
        l = n(17),
        p = n(29),
        f = n(28);

    function d(t) {
      return void 0 === t && (t = "Imposition"), {
        type: "impositions",
        label: t
      };
    }

    var h = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultRenderer("boxplot"), r.setDefaultGroupRenderer("boxplot"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, Object.defineProperty(e.prototype, "label", {
        get: function get() {
          var e = t.prototype.getMetaData.call(this).label,
              n = this._children;
          return "Imposition" !== e || 0 === n.length ? e : 1 === n.length ? n[0].label : n[0].label + " (" + n.slice(1).map(function (t) {
            return t.label;
          }).join(", ") + ")";
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "wrapper", {
        get: function get() {
          var t = this._children;
          return 0 === t.length ? null : t[0];
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getLabel = function (t) {
        var e = this._children;
        return 0 === e.length ? "" : 1 === e.length ? e[0].getLabel(t) : e[0].getLabel(t) + " (" + e.slice(1).map(function (e) {
          return e.label + " = " + e.getLabel(t);
        }) + ")";
      }, e.prototype.getColor = function (t) {
        var e = this._children;

        switch (e.length) {
          case 0:
            return u.d.DEFAULT_COLOR;

          case 1:
            return e[0].getColor(t);

          default:
            return e[1].getColor(t);
        }
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_MAPPING_CHANGED, n.EVENT_COLOR_MAPPING_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (t) {
        var e = this.wrapper;
        return e ? e.getValue(t) : null;
      }, e.prototype.getNumber = function (t) {
        var e = this.wrapper;
        return e ? e.getNumber(t) : NaN;
      }, e.prototype.getRawNumber = function (t) {
        var e = this.wrapper;
        return e ? e.getRawNumber(t) : NaN;
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.isMissing(e) ? null : {
          label: this.getLabel(e),
          color: this.getColor(e),
          value: this.getRawNumber(e)
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.getBoxPlotData = function (t) {
        var e = this.wrapper;
        return e ? e.getBoxPlotData(t) : null;
      }, e.prototype.getRawBoxPlotData = function (t) {
        var e = this.wrapper;
        return e ? e.getRawBoxPlotData(t) : null;
      }, e.prototype.getMapping = function () {
        var t = this.wrapper;
        return t ? t.getMapping() : new l.a();
      }, e.prototype.getOriginalMapping = function () {
        var t = this.wrapper;
        return t ? t.getOriginalMapping() : new l.a();
      }, e.prototype.getSortMethod = function () {
        var t = this.wrapper;
        return t ? t.getSortMethod() : s.c.min;
      }, e.prototype.setSortMethod = function (t) {
        var e = this.wrapper;
        return e ? e.setSortMethod(t) : void 0;
      }, e.prototype.isMissing = function (t) {
        var e = this.wrapper;
        return !e || e.isMissing(t);
      }, e.prototype.setMapping = function (t) {
        var e = this.wrapper;
        return e ? e.setMapping(t) : void 0;
      }, e.prototype.getColorMapping = function () {
        var t = this.wrapper;
        return t ? t.getColorMapping() : f.b;
      }, e.prototype.setColorMapping = function (t) {
        var e = this.wrapper;
        return e ? e.setColorMapping(t) : void 0;
      }, e.prototype.getFilter = function () {
        var t = this.wrapper;
        return t ? t.getFilter() : Object(s.n)();
      }, e.prototype.setFilter = function (t) {
        var e = this.wrapper;
        return e ? e.setFilter(t) : void 0;
      }, e.prototype.getRange = function () {
        var t = this.wrapper;
        return t ? t.getRange() : ["0", "1"];
      }, e.prototype.compare = function (t, e) {
        return a.c.prototype.compare.call(this, t, e);
      }, e.prototype.group = function (t) {
        return a.c.prototype.group.call(this, t);
      }, e.prototype.groupCompare = function (t, e) {
        return a.c.prototype.groupCompare.call(this, t, e);
      }, e.prototype.insert = function (e, n) {
        return 0 !== this._children.length || Object(s.h)(e) ? this._children.length >= 2 ? null : t.prototype.insert.call(this, e, n) : null;
      }, e.prototype.insertImpl = function (e, n) {
        return Object(s.h)(e) && this.forward.apply(this, Object(r.d)([e], Object(i.b)(".impose", a.c.EVENT_MAPPING_CHANGED, a.c.EVENT_COLOR_MAPPING_CHANGED))), Object(l.d)(e) && this.forward.apply(this, Object(r.d)([e], Object(i.b)(".impose", a.c.EVENT_COLOR_MAPPING_CHANGED))), t.prototype.insertImpl.call(this, e, n);
      }, e.prototype.removeImpl = function (e, n) {
        return Object(s.h)(e) && this.unforward.apply(this, Object(r.d)([e], Object(i.b)(".impose", a.c.EVENT_MAPPING_CHANGED, a.c.EVENT_COLOR_MAPPING_CHANGED))), Object(l.d)(e) && this.unforward.apply(this, Object(r.d)([e], Object(i.b)(".impose", a.c.EVENT_COLOR_MAPPING_CHANGED))), t.prototype.removeImpl.call(this, e, n);
      }, e.EVENT_MAPPING_CHANGED = p.c.EVENT_MAPPING_CHANGED, e.EVENT_COLOR_MAPPING_CHANGED = p.c.EVENT_COLOR_MAPPING_CHANGED, e = n = Object(r.b)([Object(o.m)("filterNumber", "colorMapped", "editMapping"), Object(o.h)("sort", "sortBoxPlot"), Object(o.d)("descending")], e);
    }(c.b);

    e.b = h;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return p;
    });
    var r = n(0),
        i = n(13),
        o = n(2),
        a = n(1),
        u = n(26),
        c = n(3),
        s = n(6),
        l = n(17);

    function p(t) {
      return void 0 === t && (t = "Imposition"), {
        type: "imposition",
        label: t
      };
    }

    var f = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultRenderer("number"), r.setDefaultGroupRenderer("boxplot"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, Object.defineProperty(e.prototype, "label", {
        get: function get() {
          var e = t.prototype.getMetaData.call(this).label,
              n = this._children;
          return "Imposition" !== e || 0 === n.length ? e : 1 === n.length ? n[0].label : n[0].label + " (" + n.slice(1).map(function (t) {
            return t.label;
          }).join(", ") + ")";
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "wrapper", {
        get: function get() {
          var t = this._children;
          return 0 === t.length ? null : t[0];
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_MAPPING_CHANGED, n.EVENT_COLOR_MAPPING_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getLabel = function (t) {
        var e = this._children;
        return 0 === e.length ? "" : 1 === e.length ? e[0].getLabel(t) : e[0].getLabel(t) + " (" + e.slice(1).map(function (e) {
          return e.label + " = " + e.getLabel(t);
        }).join(", ") + ")";
      }, e.prototype.getColor = function (t) {
        var e = this._children;

        switch (e.length) {
          case 0:
            return a.d.DEFAULT_COLOR;

          case 1:
            return e[0].getColor(t);

          default:
            return e[1].getColor(t);
        }
      }, e.prototype.getValue = function (t) {
        var e = this.wrapper;
        return e ? e.getValue(t) : NaN;
      }, e.prototype.getNumber = function (t) {
        var e = this.wrapper;
        return e ? e.getNumber(t) : NaN;
      }, e.prototype.getRawNumber = function (t) {
        var e = this.wrapper;
        return e ? e.getRawNumber(t) : NaN;
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.isMissing(e) ? null : {
          label: this.getLabel(e),
          color: this.getColor(e),
          value: this.getRawNumber(e)
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.isMissing = function (t) {
        var e = this.wrapper;
        return !e || e.isMissing(t);
      }, e.prototype.compare = function (t, e) {
        return s.b.prototype.compare.call(this, t, e);
      }, e.prototype.group = function (t) {
        return s.b.prototype.group.call(this, t);
      }, e.prototype.groupCompare = function (t, e) {
        return s.b.prototype.groupCompare.call(this, t, e);
      }, e.prototype.insert = function (e, n) {
        return 0 !== this._children.length || Object(c.k)(e) ? this._children.length >= 2 ? null : t.prototype.insert.call(this, e, n) : null;
      }, e.prototype.insertImpl = function (e, n) {
        return Object(c.k)(e) && this.forward.apply(this, Object(r.d)([e], Object(i.b)(".impose", s.b.EVENT_MAPPING_CHANGED))), Object(l.d)(e) && this.forward.apply(this, Object(r.d)([e], Object(i.b)(".impose", s.b.EVENT_COLOR_MAPPING_CHANGED))), t.prototype.insertImpl.call(this, e, n);
      }, e.prototype.removeImpl = function (e, n) {
        return Object(c.k)(e) && this.unforward.apply(this, Object(r.d)([e], Object(i.b)(".impose", s.b.EVENT_MAPPING_CHANGED))), Object(l.d)(e) && this.unforward.apply(this, Object(r.d)([e], Object(i.b)(".impose", s.b.EVENT_COLOR_MAPPING_CHANGED))), t.prototype.removeImpl.call(this, e, n);
      }, e.EVENT_MAPPING_CHANGED = s.b.EVENT_MAPPING_CHANGED, e.EVENT_COLOR_MAPPING_CHANGED = s.b.EVENT_COLOR_MAPPING_CHANGED, e = n = Object(r.b)([Object(o.m)("filterNumber", "colorMapped", "editMapping"), Object(o.d)("descending")], e);
    }(u.b);

    e.b = f;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return f;
    });
    var r = n(0),
        i = n(13),
        o = n(2),
        a = n(1),
        u = n(26),
        c = n(3),
        s = n(17),
        l = n(29),
        p = n(28);

    function f(t) {
      return void 0 === t && (t = "Imposition"), {
        type: "impositions",
        label: t
      };
    }

    var d = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.setDefaultRenderer("numbers"), r.setDefaultGroupRenderer("numbers"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, Object.defineProperty(e.prototype, "label", {
        get: function get() {
          var e = t.prototype.getMetaData.call(this).label,
              n = this._children;
          return "Imposition" !== e || 0 === n.length ? e : 1 === n.length ? n[0].label : n[0].label + " (" + n.slice(1).map(function (t) {
            return t.label;
          }).join(", ") + ")";
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "wrapper", {
        get: function get() {
          var t = this._children;
          return 0 === t.length ? null : t[0];
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getLabel = function (t) {
        var e = this._children;
        return 0 === e.length ? "" : 1 === e.length ? e[0].getLabel(t) : e[0].getLabel(t) + " (" + e.slice(1).map(function (e) {
          return e.label + " = " + e.getLabel(t);
        }) + ")";
      }, e.prototype.getColor = function (t) {
        var e = this._children;

        switch (e.length) {
          case 0:
            return a.d.DEFAULT_COLOR;

          case 1:
            return e[0].getColor(t);

          default:
            return e[1].getColor(t);
        }
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_MAPPING_CHANGED, n.EVENT_COLOR_MAPPING_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, Object.defineProperty(e.prototype, "labels", {
        get: function get() {
          var t = this.wrapper;
          return t ? t.labels : [];
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dataLength", {
        get: function get() {
          var t = this.wrapper;
          return t ? t.dataLength : null;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getValue = function (t) {
        var e = this.wrapper;
        return e ? e.getValue(t) : [];
      }, e.prototype.getNumber = function (t) {
        var e = this.wrapper;
        return e ? e.getNumber(t) : NaN;
      }, e.prototype.getRawNumber = function (t) {
        var e = this.wrapper;
        return e ? e.getRawNumber(t) : NaN;
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? this.isMissing(e) ? null : {
          label: this.getLabels(e),
          color: this.getColor(e),
          value: this.getRawNumbers(e)
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.prototype.getNumbers = function (t) {
        var e = this.wrapper;
        return e ? e.getNumbers(t) : [];
      }, e.prototype.getRawNumbers = function (t) {
        var e = this.wrapper;
        return e ? e.getRawNumbers(t) : [];
      }, e.prototype.getBoxPlotData = function (t) {
        var e = this.wrapper;
        return e ? e.getBoxPlotData(t) : null;
      }, e.prototype.getRawBoxPlotData = function (t) {
        var e = this.wrapper;
        return e ? e.getRawBoxPlotData(t) : null;
      }, e.prototype.getMapping = function () {
        var t = this.wrapper;
        return t ? t.getMapping() : new s.a();
      }, e.prototype.getOriginalMapping = function () {
        var t = this.wrapper;
        return t ? t.getOriginalMapping() : new s.a();
      }, e.prototype.getSortMethod = function () {
        var t = this.wrapper;
        return t ? t.getSortMethod() : c.b.min;
      }, e.prototype.setSortMethod = function (t) {
        var e = this.wrapper;
        return e ? e.setSortMethod(t) : void 0;
      }, e.prototype.isMissing = function (t) {
        var e = this.wrapper;
        return !e || e.isMissing(t);
      }, e.prototype.setMapping = function (t) {
        var e = this.wrapper;
        return e ? e.setMapping(t) : void 0;
      }, e.prototype.getColorMapping = function () {
        var t = this.wrapper;
        return t ? t.getColorMapping() : p.b;
      }, e.prototype.setColorMapping = function (t) {
        var e = this.wrapper;
        return e ? e.setColorMapping(t) : void 0;
      }, e.prototype.getFilter = function () {
        var t = this.wrapper;
        return t ? t.getFilter() : Object(c.n)();
      }, e.prototype.setFilter = function (t) {
        var e = this.wrapper;
        return e ? e.setFilter(t) : void 0;
      }, e.prototype.getRange = function () {
        var t = this.wrapper;
        return t ? t.getRange() : ["0", "1"];
      }, e.prototype.getMap = function (t) {
        var e = this.wrapper;
        return e ? e.getMap(t) : [];
      }, e.prototype.getMapLabel = function (t) {
        var e = this.wrapper;
        return e ? e.getMapLabel(t) : [];
      }, e.prototype.getLabels = function (t) {
        var e = this.wrapper;
        return e ? e.getLabels(t) : [];
      }, e.prototype.getValues = function (t) {
        var e = this.wrapper;
        return e ? e.getValues(t) : [];
      }, e.prototype.compare = function (t, e) {
        return l.c.prototype.compare.call(this, t, e);
      }, e.prototype.group = function (t) {
        return l.c.prototype.group.call(this, t);
      }, e.prototype.groupCompare = function (t, e) {
        return l.c.prototype.groupCompare.call(this, t, e);
      }, e.prototype.insert = function (e, n) {
        return 0 !== this._children.length || Object(c.m)(e) ? this._children.length >= 2 ? null : t.prototype.insert.call(this, e, n) : null;
      }, e.prototype.insertImpl = function (e, n) {
        return Object(c.m)(e) && this.forward.apply(this, Object(r.d)([e], Object(i.b)(".impose", l.c.EVENT_MAPPING_CHANGED))), Object(s.d)(e) && this.forward.apply(this, Object(r.d)([e], Object(i.b)(".impose", l.c.EVENT_COLOR_MAPPING_CHANGED))), t.prototype.insertImpl.call(this, e, n);
      }, e.prototype.removeImpl = function (e, n) {
        return Object(c.m)(e) && this.unforward.apply(this, Object(r.d)([e], Object(i.b)(".impose", l.c.EVENT_MAPPING_CHANGED))), Object(s.d)(e) && this.unforward.apply(this, Object(r.d)([e], Object(i.b)(".impose", l.c.EVENT_COLOR_MAPPING_CHANGED))), t.prototype.removeImpl.call(this, e, n);
      }, e.EVENT_MAPPING_CHANGED = l.c.EVENT_MAPPING_CHANGED, e.EVENT_COLOR_MAPPING_CHANGED = l.c.EVENT_COLOR_MAPPING_CHANGED, e = n = Object(r.b)([Object(o.m)("filterNumber", "colorMapped", "editMapping"), Object(o.h)("sort", "sortNumbers"), Object(o.d)("descending")], e);
    }(u.b);

    e.b = d;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(2),
        o = n(27),
        a = n(46),
        u = n(37),
        c = n(20),
        s = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.patternFunction = null, r.setDefaultWidth(200), r.alignment = n.alignment || c.a.left, r.escape = !1 !== n.escape, r.pattern = n.pattern || "", r.patternTemplates = n.patternTemplates || [], r.setDefaultRenderer("map"), r;
      }

      return Object(r.c)(e, t), e.prototype.setPattern = function (t) {
        u.d.prototype.setPattern.call(this, t);
      }, e.prototype.getPattern = function () {
        return this.pattern;
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([u.d.EVENT_PATTERN_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (t) {
        return this.getLinkMap(t).map(function (t) {
          var e = t.key,
              n = t.value;
          return {
            key: e,
            value: n ? n.href : ""
          };
        });
      }, e.prototype.getLabels = function (t) {
        return this.getLinkMap(t).map(function (t) {
          var e = t.key,
              n = t.value;
          return {
            key: e,
            value: n ? n.alt : ""
          };
        });
      }, e.prototype.getLinkMap = function (e) {
        var n = this;
        return t.prototype.getValue.call(this, e).map(function (t) {
          var r = t.key,
              i = t.value;
          return {
            key: r,
            value: n.transformValue(i, e, r)
          };
        });
      }, e.prototype.transformValue = function (t, e, n) {
        return null == t || "" === t ? null : "string" == typeof t ? this.pattern ? (this.patternFunction || (this.patternFunction = Object(o.e)(this.pattern, "item", "key")), {
          alt: t,
          href: this.patternFunction.call(this, t, e.v, n)
        }) : {
          alt: t,
          href: t
        } : t;
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return this.pattern !== this.desc.pattern && (n.pattern = this.pattern), n;
      }, e.prototype.restore = function (e, n) {
        e.pattern && (this.pattern = e.pattern), t.prototype.restore.call(this, e, n);
      }, e.EVENT_PATTERN_CHANGED = u.d.EVENT_PATTERN_CHANGED, e = Object(r.b)([Object(i.m)("search", "editPattern")], e);
    }(a.a);

    e.a = s;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return c;
    }), n.d(e, "d", function () {
      return l;
    }), n.d(e, "c", function () {
      return p;
    }), n.d(e, "e", function () {
      return f;
    });
    var r = n(12),
        i = n(2),
        o = n(3),
        a = n(1),
        u = n(27);

    function c(t) {
      return t.delete(null), t.delete(void 0), t.delete(""), t.delete("NA"), t.delete("NaN"), t.delete("na"), Array.from(t).map(String).sort();
    }

    function s(t, e, n, i, o) {
      var a,
          u,
          s = {
        type: "string",
        label: t,
        column: n
      };
      if ("number" == typeof e) return s.type = "number", s.domain = Object(r.d)(i, function (t) {
        return t[n];
      }), s;
      if (e && e instanceof Date) return s.type = "date", s;
      if ("boolean" == typeof e) return s.type = "boolean", s;
      if ("string" == typeof e) return (l = new Set(i.map(function (t) {
        return t[n];
      }))).size < i.length * o.categoricalThreshold && (s.type = "categorical", s.categories = c(l)), s;

      if (Array.isArray(e)) {
        s.type = "strings", s.dataLength = e.length;
        var l,
            p = e[0];
        if ("number" == typeof p) return s.type = "numbers", s.domain = Object(r.d)((a = []).concat.apply(a, i.map(function (t) {
          return t[n];
        }))), s;
        if (p && e instanceof Date) return s.type = "dates", s;
        if ("boolean" == typeof e) return s.type = "booleans", s;
        if ("string" == typeof e) return (l = new Set((u = []).concat.apply(u, i.map(function (t) {
          return t[n];
        })))).size < i.length * o.categoricalThreshold && (s.type = "categoricals", s.categories = c(l)), s;
      }

      return console.log("cannot infer type of column:", n), s;
    }

    function l(t, e) {
      void 0 === e && (e = {});
      var n = Object.assign({
        categoricalThreshold: .7,
        columns: []
      }, e);
      if (0 === t.length) return [];
      var r = t[0];
      return Array.isArray(r) ? r.map(function (e, r) {
        return s("Col" + r, e, r, t, n);
      }) : (n.columns.length > 0 ? n.columns : Object.keys(r)).map(function (e) {
        return s(e, r[e], e, t, n);
      });
    }

    function p(t) {
      var e = Object(u.a)();
      return t.forEach(function (t) {
        switch (t.type) {
          case "number":
            t.color = t.color || e() || a.d.DEFAULT_COLOR;
        }
      }), t;
    }

    function f(t, e, n) {
      void 0 === n && (n = {});
      var r = Object.assign({
        separator: "\t",
        newline: "\n",
        header: !0,
        quote: !1,
        quoteChar: '"',
        filter: function filter(t) {
          return !Object(i.l)(t);
        },
        verboseColumnHeaders: !1
      }, n),
          a = new RegExp("[" + r.quoteChar + "]", "g");

      function u(t, e) {
        var n = String(t);
        return !(r.quote || n.indexOf("\n") >= 0) || e && Object(o.k)(e) ? n : "" + r.quoteChar + n.replace(a, r.quoteChar + r.quoteChar) + r.quoteChar;
      }

      var c = t.flatColumns.filter(function (t) {
        return r.filter(t);
      }),
          s = t.getOrder(),
          l = [];
      return r.header && l.push(c.map(function (t) {
        return u(t.label + (r.verboseColumnHeaders && t.description ? "\n" + t.description : ""));
      }).join(r.separator)), e.forEach(function (t, e) {
        l.push(c.map(function (n) {
          return u(n.getExportValue({
            v: t,
            i: s[e]
          }, "text"), n);
        }).join(r.separator));
      }), l.join(r.newline);
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(16),
        o = n(6),
        a = n(38),
        u = function (t) {
      function e(e, n, r) {
        void 0 === n && (n = []), void 0 === r && (r = {});
        var i = t.call(this, n, r) || this;
        i._data = e, i.options = {
          filterGlobally: !1,
          jumpToSearchResult: !1,
          maxNestedSortingCriteria: 1 / 0,
          maxGroupColumns: 1 / 0
        }, i.filter = null, Object.assign(i.options, r), i._dataRows = c(e);
        var o = i;
        return i.reorderAll = function () {
          var t = this.source;
          o.getRankings().forEach(function (e) {
            e !== t && e.dirtyOrder();
          });
        }, i;
      }

      return Object(r.c)(e, t), e.prototype.setFilter = function (t) {
        this.filter = t, this.reorderAll();
      }, e.prototype.getFilter = function () {
        return this.filter;
      }, e.prototype.getTotalNumberOfRows = function () {
        return this.data.length;
      }, e.prototype.getMaxGroupColumns = function () {
        return this.options.maxGroupColumns;
      }, e.prototype.getMaxNestedSortingCriteria = function () {
        return this.options.maxNestedSortingCriteria;
      }, Object.defineProperty(e.prototype, "data", {
        get: function get() {
          return this._data;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.setData = function (t) {
        this._data = t, this._dataRows = c(t), this.reorderAll();
      }, e.prototype.clearData = function () {
        this.setData([]);
      }, e.prototype.appendData = function (t) {
        var e, n;
        (e = this._data).push.apply(e, t), (n = this._dataRows).push.apply(n, c(t)), this.reorderAll();
      }, e.prototype.cloneRanking = function (e) {
        var n = t.prototype.cloneRanking.call(this, e);
        return this.options.filterGlobally && n.on(o.b.EVENT_FILTER_CHANGED + ".reorderAll", this.reorderAll), n;
      }, e.prototype.cleanUpRanking = function (e) {
        this.options.filterGlobally && e.on(o.b.EVENT_FILTER_CHANGED + ".reorderAll", null), t.prototype.cleanUpRanking.call(this, e);
      }, e.prototype.sortImpl = function (t) {
        var e = this;
        if (0 === this._data.length) return [];

        var n = this._data.map(function (t, e) {
          return {
            v: t,
            i: e,
            group: null
          };
        }),
            r = null;

        if (this.options.filterGlobally) {
          var i = this.getRankings().filter(function (t) {
            return t.isFiltered();
          });
          i.length > 0 && (r = function r(t) {
            return i.every(function (e) {
              return e.filter(t);
            });
          });
        } else t.isFiltered() && (r = function r(e) {
          return t.filter(e);
        });

        if ((r || this.filter) && (n = n.filter(function (t) {
          return (!e.filter || e.filter(t)) && (!r || r(t));
        })), 0 === n.length) return [];

        if (n.forEach(function (e) {
          return e.group = t.grouper(e) || a.a;
        }), 1 === new Set(n.map(function (t) {
          return t.group.name;
        })).size) {
          var o = n[0].group;
          n.sort(function (e, n) {
            return t.comparator(e, n);
          });
          var u = n.map(function (t) {
            return t.i;
          });
          return [Object.assign({
            order: u
          }, o)];
        }

        n.sort(function (e, n) {
          var r = e.group,
              i = n.group;
          return r.name !== i.name ? r.name.toLowerCase().localeCompare(i.name.toLowerCase()) : t.comparator(e, n);
        });
        var c = [Object.assign({
          order: [],
          rows: []
        }, n[0].group)],
            s = c[0];
        return n.forEach(function (t) {
          var e = t.group;
          e.name === s.name ? (s.order.push(t.i), s.rows.push(t)) : (s = Object.assign({
            order: [t.i],
            rows: [t]
          }, e), c.push(s));
        }), c.sort(function (e, n) {
          return t.groupComparator(e, n);
        }), c;
      }, e.prototype.viewRaw = function (t) {
        var e = this;
        return t.map(function (t) {
          return e._data[t];
        });
      }, e.prototype.viewRawRows = function (t) {
        var e = this;
        return t.map(function (t) {
          return e._dataRows[t];
        });
      }, e.prototype.view = function (t) {
        return this.viewRaw(t);
      }, e.prototype.fetch = function (t) {
        var e = this;
        return t.map(function (t) {
          return t.map(function (t) {
            return e._dataRows[t];
          });
        });
      }, e.prototype.stats = function (t) {
        var e = this,
            n = null,
            r = function r() {
          return null == n && (n = e.viewRawRows(t)), n;
        };

        return {
          stats: function stats(t) {
            return Object(i.i)(r(), function (e) {
              return t.getNumber(e);
            }, function (e) {
              return t.isMissing(e);
            }, [0, 1]);
          },
          hist: function hist(t) {
            return Object(i.h)(r(), function (e) {
              return t.getCategory(e);
            }, t.categories);
          }
        };
      }, e.prototype.mappingSample = function (t) {
        var e = this,
            n = this._dataRows.length;
        if (n <= 120) return this._dataRows.map(t.getRawNumber.bind(t));

        for (var r = [], i = 0; i < 120; ++i) {
          for (var o = Math.floor(Math.random() * (n - 1)); r.indexOf(o) >= 0;) {
            o = Math.floor(Math.random() * (n - 1));
          }

          r.push(o);
        }

        return r.map(function (n) {
          return t.getRawNumber(e._dataRows[n]);
        });
      }, e.prototype.searchAndJump = function (t, e) {
        for (var n = "string" == typeof (t = "string" == typeof t ? t.toLowerCase() : t) ? function (e) {
          return e.toLowerCase().indexOf(t) >= 0;
        } : t.test.bind(t), r = [], i = 0; i < this._dataRows.length; ++i) {
          n(e.getLabel(this._dataRows[i])) && r.push(i);
        }

        this.jumpToNearest(r);
      }, e;
    }(n(88).a);

    function c(t) {
      return t.map(function (t, e) {
        return {
          v: t,
          i: e
        };
      });
    }

    e.a = u;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(52),
        o = n(82),
        a = n(83),
        u = n(74),
        c = n(77),
        s = function (t) {
      function e(e, n, r) {
        void 0 === r && (r = {});
        var a = t.call(this, e, n, r && !0 === r.ignoreUnsupportedBrowser) || this;
        return a.options = Object(i.a)(), Object(o.a)(a.options, r), a.isBrowserSupported ? (a.node.classList.add("lu"), a.renderer = new u.a(n, a.node, a.options), a.options.sidePanel ? (console.assert(null != a.node.ownerDocument), a.panel = new c.b(a.renderer.ctx, a.node.ownerDocument, {
          collapseable: !a.options.sidePanelCollapsed || "collapsed",
          hierarchy: a.options.hierarchyIndicator && a.options.flags.advancedRankingFeatures
        }), a.renderer.pushUpdateAble(function (t) {
          return a.panel.update(t);
        }), a.node.insertBefore(a.panel.node, a.node.firstChild)) : a.panel = null, a.forward(a.renderer, u.a.EVENT_HIGHLIGHT_CHANGED + ".main"), a) : (a.renderer = null, a.panel = null, a);
      }

      return Object(r.c)(e, t), e.prototype.destroy = function () {
        this.node.classList.remove("lu"), this.renderer && this.renderer.destroy(), this.panel && this.panel.destroy(), t.prototype.destroy.call(this);
      }, e.prototype.update = function () {
        this.renderer && this.renderer.update();
      }, e.prototype.setDataProvider = function (e, n) {
        t.prototype.setDataProvider.call(this, e, n), this.renderer && (this.renderer.setDataProvider(e), this.update(), this.panel && this.panel.update(this.renderer.ctx));
      }, e.prototype.setHighlight = function (t, e) {
        return void 0 === e && (e = !0), null != this.renderer && this.renderer.setHighlight(t, e);
      }, e.prototype.getHighlight = function () {
        return this.renderer ? this.renderer.getHighlight() : -1;
      }, e.prototype.enableHighlightListening = function (t) {
        this.renderer && this.renderer.enableHighlightListening(t);
      }, e;
    }(a.a);

    e.a = s;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(31),
        o = n(42),
        a = n(16),
        u = n(13),
        c = n(3),
        s = n(24),
        l = n(60),
        p = n(11),
        f = n(18),
        d = n(56),
        h = n(54),
        g = n(78),
        b = function () {
      function t(t) {
        var e = this;
        void 0 === t && (t = document), this.escKeyListener = function (t) {
          27 === t.which && e.removeLast();
        }, this.openDialogs = [], this.node = t.createElement("div"), this.node.classList.add("lu-backdrop"), this.node.innerHTML = "<div></div>", this.node.onclick = function () {
          e.removeAll();
        };
      }

      return t.prototype.setHighlight = function (t) {
        this.node.firstElementChild.style.clipPath = "polygon(\n      0% 0%,\n      0% 100%,\n      " + t.left + "px 100%,\n      " + t.left + "px " + t.top + "px,\n      " + (t.left + t.width) + "px " + t.top + "px,\n      " + (t.left + t.width) + "px " + (t.top + t.height) + "px,\n      " + t.left + "px " + (t.top + t.height) + "px,\n      " + t.left + "px 100%,\n      100% 100%,\n      100% 0%\n    )";
      }, t.prototype.setHighlightColumn = function (t) {
        var e = this.node.parentElement;

        if (e) {
          var n = e.querySelector('.lu-header[data-col-id="' + t.id + '"]');

          if (n) {
            var r = n.getBoundingClientRect(),
                i = e.getBoundingClientRect();
            this.setHighlight({
              left: r.left - i.left,
              top: r.top - i.top,
              width: r.width,
              height: i.height
            });
          } else this.clearHighlight();
        } else this.clearHighlight();
      }, t.prototype.clearHighlight = function () {
        this.node.firstElementChild.style.clipPath = "";
      }, t.prototype.removeLast = function () {
        0 !== this.openDialogs.length && this.remove(this.openDialogs[this.openDialogs.length - 1]);
      }, t.prototype.removeAll = function () {
        0 !== this.openDialogs.length && (this.openDialogs.splice(0, this.openDialogs.length).forEach(function (t) {
          return t.destroy();
        }), this.takeDown());
      }, t.prototype.remove = function (t) {
        var e = this.openDialogs.indexOf(t);
        return !(e < 0) && (this.openDialogs.splice(e, this.openDialogs.length - e).reverse().forEach(function (t) {
          return t.destroy();
        }), 0 === this.openDialogs.length && this.takeDown(), !0);
      }, t.prototype.removeAboveLevel = function (t) {
        var e = this;
        this.openDialogs.filter(function (e) {
          return e.level >= t;
        }).reverse().forEach(function (t) {
          return e.remove(t);
        });
      }, t.prototype.removeLike = function (t) {
        var e = this.openDialogs.find(function (e) {
          return t.equals(e);
        });
        return !!e && (this.remove(e), !0);
      }, t.prototype.setUp = function () {
        console.assert(null != this.node.ownerDocument), this.node.ownerDocument.addEventListener("keyup", this.escKeyListener, {
          passive: !0
        }), this.node.style.display = "block";
      }, t.prototype.takeDown = function () {
        this.clearHighlight(), console.assert(null != this.node.ownerDocument), this.node.ownerDocument.removeEventListener("keyup", this.escKeyListener), this.node.style.display = null;
      }, t.prototype.push = function (t) {
        this.removeAboveLevel(t.level), 0 === this.openDialogs.length && this.setUp(), this.openDialogs.push(t);
      }, t;
    }(),
        m = function (t) {
      function e(e, n, r) {
        var a = t.call(this) || this;
        a.data = e, a.histCache = new Map(), a.rankings = [], a.slopeGraphs = [], a.updateAbles = [], a.zoomFactor = 1, a.idPrefix = "lu" + Math.random().toString(36).slice(-8).substr(0, 3), a.enabledHighlightListening = !1, a.options = r, console.assert(null != n.ownerDocument), a.node = n.ownerDocument.createElement("main"), a.node.id = a.idPrefix, a.node.classList.toggle("lu-whole-hover", r.expandLineOnHover), n.appendChild(a.node);

        var u = function u(t) {
          var e = a.histCache.get(t.id);
          return null == e || e instanceof Promise ? null : e;
        },
            c = new b(n.ownerDocument);

        n.appendChild(c.node), a.ctx = {
          idPrefix: a.idPrefix,
          document: n.ownerDocument,
          provider: e,
          dialogManager: c,
          toolbar: a.options.toolbar,
          flags: a.options.flags,
          option: Object(o.c)(Object.assign({
            useGridLayout: !0
          }, a.options)),
          statsOf: u,
          renderer: function renderer(t, e) {
            return Object(d.i)(t, a.options.renderers).create(t, a.ctx, u(t), e);
          },
          groupRenderer: function groupRenderer(t, e) {
            return Object(d.h)(t, a.options.renderers).createGroup(t, a.ctx, u(t), e);
          },
          summaryRenderer: function summaryRenderer(t, e, n) {
            return Object(d.j)(t, a.options.renderers).createSummary(t, a.ctx, e, n);
          },
          totalNumberOfRows: 0,
          createRenderer: function createRenderer(t, e) {
            return {
              single: this.renderer(t, e),
              group: this.groupRenderer(t, e),
              summary: r.summaryHeader ? this.summaryRenderer(t, !1, e) : null,
              singleId: t.getRenderer(),
              groupId: t.getGroupRenderer(),
              summaryId: t.getSummaryRenderer(),
              singleTemplate: null,
              groupTemplate: null,
              summaryTemplate: null
            };
          },
          getPossibleRenderer: function getPossibleRenderer(t) {
            return {
              item: Object(d.m)(t, a.options.renderers),
              group: Object(d.l)(t, a.options.renderers),
              summary: Object(d.n)(t, a.options.renderers)
            };
          },
          colWidth: function colWidth(t) {
            return t.isVisible() ? t.getWidth() : 0;
          }
        }, a.table = new i.MultiTableRowRenderer(a.node, "#" + a.idPrefix), a.style.addRule("lineup_groupPadding", "\n       #" + a.idPrefix + " .lu-row[data-agg=group],\n       #" + a.idPrefix + " .lu-row[data-meta~=last] {\n        margin-bottom: " + r.groupPadding + "px;\n       }", !1), a.style.addRule("lineup_rowPadding", "\n       #" + a.idPrefix + " .lu-row[data-lod] {\n         padding-top: 0;\n       }", !1), a.style.addRule("lineup_rowPadding2", "\n        #" + a.idPrefix + " .lu-row,\n        #" + a.idPrefix + " .lu-row[data-lod]:hover,\n        #" + a.idPrefix + " .lu-row[data-lod].le-highlighted,\n        #" + a.idPrefix + " .lu-row[data-lod].lu-selected,\n        #" + a.idPrefix + " .lu-row[data-lod]:hover + .lu-row,\n        #" + a.idPrefix + " .lu-row[data-lod].le-highlighted + .lu-row,\n        #" + a.idPrefix + " .lu-row[data-lod].lu-selected + .lu-row {\n          padding-top: " + r.rowPadding + "px;\n        }", !1), a.style.addRule("lineup_rotation", "\n       #" + a.idPrefix + ".lu-rotated-label .lu-label.lu-rotated {\n           transform: rotate(" + -a.options.labelRotation + "deg);\n       }");
        var s = [];
        return a.options.flags.advancedRankingFeatures || s.push("ranking"), a.options.flags.advancedModelFeatures || s.push("model"), a.options.flags.advancedUIFeatures || s.push("ui"), s.length > 0 && a.style.addRule("lineup_feature_disable", "\n        " + s.map(function (t) {
          return ".lu-feature-" + t + ".lu-feature-advanced";
        }).join(", ") + " {\n            display: none !important;\n        }"), a.initProvider(e), a;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "style", {
        get: function get() {
          return this.table.style;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.zoomOut = function () {
        this.zoomFactor = Math.max(this.zoomFactor - .1, .5), this.updateZoomFactor(), this.update();
      }, e.prototype.zoomIn = function () {
        this.zoomFactor = Math.min(this.zoomFactor + .1, 2), this.updateZoomFactor(), this.update();
      }, e.prototype.updateZoomFactor = function () {
        this.node.querySelector("main").style.fontSize = 100 * this.zoomFactor + "%";
      }, e.prototype.pushUpdateAble = function (t) {
        this.updateAbles.push(t);
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_HIGHLIGHT_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.setDataProvider = function (t) {
        this.takeDownProvider(), this.data = t, this.ctx.provider = t, this.initProvider(t);
      }, e.prototype.takeDownProvider = function () {
        var t = this;
        this.data.on(f.d.EVENT_SELECTION_CHANGED + ".body", null), this.data.on(f.d.EVENT_ADD_RANKING + ".body", null), this.data.on(f.d.EVENT_REMOVE_RANKING + ".body", null), this.data.on(f.d.EVENT_GROUP_AGGREGATION_CHANGED + ".body", null), this.data.on(f.d.EVENT_JUMP_TO_NEAREST + ".body", null), this.rankings.forEach(function (e) {
          return t.table.remove(e);
        }), this.rankings.splice(0, this.rankings.length), this.slopeGraphs.forEach(function (e) {
          return t.table.remove(e);
        }), this.slopeGraphs.splice(0, this.slopeGraphs.length);
      }, e.prototype.initProvider = function (t) {
        var e = this;
        t.on(f.d.EVENT_SELECTION_CHANGED + ".body", function () {
          return e.updateSelection(t.getSelection());
        }), t.on(f.d.EVENT_ADD_RANKING + ".body", function (t) {
          e.addRanking(t);
        }), t.on(f.d.EVENT_REMOVE_RANKING + ".body", function (t) {
          e.removeRanking(t);
        }), t.on(f.d.EVENT_GROUP_AGGREGATION_CHANGED + ".body", function (t) {
          e.update(e.rankings.filter(function (e) {
            return e.ranking === t;
          }));
        }), t.on(f.d.EVENT_JUMP_TO_NEAREST + ".body", function (t) {
          e.setHighlightToNearest(t, !0);
        }), this.data.getRankings().forEach(function (t) {
          return e.addRanking(t);
        });
      }, e.prototype.updateSelection = function (t) {
        var e = new Set(t);
        this.rankings.forEach(function (t) {
          return t.updateSelection(e);
        }), this.slopeGraphs.forEach(function (t) {
          return t.updateSelection(e);
        });
      }, e.prototype.updateHist = function (t, e) {
        var n = this;
        this.options.summaryHeader && ((t ? [t] : this.rankings).forEach(function (t) {
          var r = t.ranking,
              i = r.getOrder(),
              o = e ? [e] : r.flatColumns,
              a = null == i ? null : n.data.stats(i);
          o.filter(function (t) {
            return t.isVisible() && Object(c.k)(t);
          }).forEach(function (t) {
            n.histCache.set(t.id, null == a ? null : a.stats(t));
          }), o.filter(function (t) {
            return Object(s.c)(t) && t.isVisible();
          }).forEach(function (t) {
            n.histCache.set(t.id, null == a ? null : a.hist(t));
          }), e ? t.updateHeaderOf(e) : t.updateHeaders();
        }), this.updateAbles.forEach(function (t) {
          return t(n.ctx);
        }));
      }, e.prototype.addRanking = function (t) {
        var e = this;

        if (this.rankings.length > 0) {
          var n = this.table.pushSeparator(function (n, r) {
            return new g.b(n, r, t.id + "S", e.ctx, {
              mode: "band" === e.options.defaultSlopeGraphMode ? g.a.BAND : g.a.ITEM
            });
          });
          this.slopeGraphs.push(n);
        }

        var r = this.table.pushTable(function (n, r, i, o) {
          return new h.c(t, n, r, i, o, e.ctx, {
            animation: e.options.animated,
            customRowUpdate: e.options.customRowUpdate || function () {},
            levelOfDetail: e.options.levelOfDetail || function () {
              return "high";
            },
            flags: e.options.flags
          });
        });
        r.on(h.c.EVENT_WIDTH_CHANGED, function () {
          e.updateRotatedHeaderState(), e.table.widthChanged();
        }), r.on(h.c.EVENT_UPDATE_DATA, function () {
          return e.update([r]);
        }), r.on(h.c.EVENT_UPDATE_HIST, function (t) {
          return e.updateHist(r, t);
        }), this.forward(r, h.c.EVENT_HIGHLIGHT_CHANGED), this.enabledHighlightListening && r.enableHighlightListening(!0), t.on(Object(u.b)(".renderer", p.b.EVENT_ORDER_CHANGED), function () {
          return e.updateHist(r);
        }), this.rankings.push(r), this.update([r]);
      }, e.prototype.updateRotatedHeaderState = function () {
        if (0 !== this.options.labelRotation) {
          var t = this.node.querySelector(".lu-label.lu-rotated");
          this.node.classList.toggle("lu-rotated-label", Boolean(t));
        }
      }, e.prototype.removeRanking = function (t) {
        if (!t) return this.rankings.splice(0, this.rankings.length), this.slopeGraphs.splice(0, this.slopeGraphs.length), void this.table.clear();
        var e = this.rankings.findIndex(function (e) {
          return e.ranking === t;
        });

        if (!(e < 0)) {
          var n = this.rankings.splice(e, 1)[0],
              r = this.slopeGraphs.splice(0 === e ? e : e - 1, 1)[0];
          this.table.remove(n), r && this.table.remove(r);
        }
      }, e.prototype.update = function (t) {
        var e = this;

        if (void 0 === t && (t = this.rankings), 0 !== (t = t.filter(function (t) {
          return !t.hidden && t.body.parentElement;
        })).length) {
          var n = t.map(function (t) {
            return t.ranking.getOrder();
          }),
              r = this.data.fetch(n);
          this.ctx.totalNumberOfRows = Math.max.apply(Math, r.map(function (t) {
            return t.length;
          }));
          var o = r.map(function (t) {
            return t.map(function (t) {
              return t;
            });
          });
          0 === this.histCache.size && this.updateHist();

          var u = function u(t) {
            return Object(a.k)(t, 2);
          },
              c = u(this.zoomFactor * this.options.rowPadding),
              s = u(this.zoomFactor * this.options.groupPadding);

          t.forEach(function (t, n) {
            var r = t.groupData(o[n]),
                a = function (t, n) {
              if (e.options.dynamicHeight) {
                var r = e.options.dynamicHeight(n, t),
                    i = function i(t, e) {
                  return "number" == typeof t ? t : t(e);
                };

                if (r) return {
                  defaultHeight: u(e.zoomFactor * r.defaultHeight),
                  height: function height(t) {
                    return u(e.zoomFactor * i(r.height, t));
                  },
                  padding: function padding(t) {
                    return u(e.zoomFactor * i(r.padding, t));
                  }
                };
              }

              var o = u(e.zoomFactor * e.options.rowHeight),
                  a = u(e.zoomFactor * e.options.groupHeight);
              return {
                defaultHeight: o,
                height: function height(t) {
                  return Object(l.b)(t) ? a : o;
                },
                padding: c
              };
            }(t.ranking, r),
                p = a.height,
                f = a.defaultHeight,
                d = a.padding,
                h = Object(i.nonUniformContext)(r.map(p), f, function (t) {
              var e = "number" == typeof d ? d : d(r[t] || null);
              return t >= 0 && r[t] && (Object(l.b)(r[t]) || "last" === r[t].meta || "first last" === r[t].meta) ? s + e : e;
            });

            t.render(r, h);
          }), this.updateSlopeGraphs(t), this.updateRotatedHeaderState(), this.table.widthChanged();
        }
      }, e.prototype.updateSlopeGraphs = function (t) {
        var e = this;
        void 0 === t && (t = this.rankings);
        var n = new Set(t.map(function (t) {
          return e.rankings.indexOf(t);
        }));
        this.slopeGraphs.forEach(function (t, r) {
          if (!t.hidden) {
            var i = r,
                o = r + 1;

            if (n.has(i) || n.has(o)) {
              var a = e.rankings[i],
                  u = e.rankings[o];
              t.rebuild(a.currentData, a.context, u.currentData, u.context);
            }
          }
        });
      }, e.prototype.setHighlight = function (t, n) {
        var r = this.rankings.map(function (e) {
          return e.setHighlight(t);
        });
        return this.fire(e.EVENT_HIGHLIGHT_CHANGED, t), !(0 === this.rankings.length || t < 0) && (n ? this.rankings[0].scrollIntoView(t) : r[0]);
      }, e.prototype.setHighlightToNearest = function (t, e) {
        if (0 === this.rankings.length) return !1;
        var n = this.rankings[0].findNearest(t);
        return n >= 0 && this.setHighlight(n, e);
      }, e.prototype.getHighlight = function () {
        for (var t = 0, e = this.rankings; t < e.length; t++) {
          var n = e[t].getHighlight();
          if (n >= 0) return n;
        }

        return -1;
      }, e.prototype.enableHighlightListening = function (t) {
        for (var e = 0, n = this.rankings; e < n.length; e++) {
          n[e].enableHighlightListening(t);
        }

        this.enabledHighlightListening = t;
      }, e.prototype.destroy = function () {
        this.takeDownProvider(), this.table.destroy(), this.node.remove();
      }, e.EVENT_HIGHLIGHT_CHANGED = h.c.EVENT_HIGHLIGHT_CHANGED, e;
    }(u.a);

    e.a = m;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return s;
    });
    var r = n(0),
        i = n(12),
        o = n(2),
        a = n(1),
        u = n(49),
        c = n(3);

    function s(t) {
      return void 0 === t && (t = "Reduce"), {
        type: "reduce",
        label: t
      };
    }

    var l = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        return r.reduce = n.reduce || c.b.max, r.setDefaultRenderer("interleaving"), r.setDefaultGroupRenderer("interleaving"), r.setDefaultSummaryRenderer("interleaving"), r;
      }

      var n;
      return Object(r.c)(e, t), n = e, Object.defineProperty(e.prototype, "label", {
        get: function get() {
          var e = t.prototype.getMetaData.call(this).label;
          return "Reduce" !== e ? e : "" + this.reduce[0].toUpperCase() + this.reduce.slice(1) + "(" + this.children.map(function (t) {
            return t.label;
          }).join(", ") + ")";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getColor = function (t) {
        var e = this._children;
        if (0 === e.length || this.reduce === c.b.q1 || this.reduce === c.b.q3 || this.reduce === c.b.mean) return a.d.DEFAULT_COLOR;
        var n = this.compute(t),
            r = e.find(function (e) {
          return e.getValue(t) === n;
        });
        return r ? r.getColor(t) : a.d.DEFAULT_COLOR;
      }, e.prototype.compute = function (t) {
        var e = this._children.map(function (e) {
          return e.getValue(t);
        }).filter(function (t) {
          return !isNaN(t);
        });

        if (0 === e.length) return NaN;

        switch (this.reduce) {
          case c.b.mean:
            return e.reduce(function (t, e) {
              return t + e;
            }, 0) / e.length;

          case c.b.max:
            return Math.max.apply(Math, e);

          case c.b.min:
            return Math.min.apply(Math, e);

          case c.b.median:
            return Object(i.h)(e);

          case c.b.q1:
            return Object(i.j)(e.sort(function (t, e) {
              return t - e;
            }), .25);

          case c.b.q3:
            return Object(i.j)(e.sort(function (t, e) {
              return t - e;
            }), .75);
        }
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_REDUCE_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getReduce = function () {
        return this.reduce;
      }, e.prototype.setReduce = function (t) {
        this.reduce !== t && this.fire([n.EVENT_REDUCE_CHANGED, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], this.reduce, this.reduce = t);
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.reduce = this.reduce, n;
      }, e.prototype.restore = function (e, n) {
        this.reduce = e.reduce || this.reduce, t.prototype.restore.call(this, e, n);
      }, Object.defineProperty(e.prototype, "canJustAddNumbers", {
        get: function get() {
          return !0;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getExportValue = function (e, n) {
        return "json" === n ? {
          value: this.getRawNumber(e),
          children: this.children.map(function (t) {
            return t.getExportValue(e, n);
          })
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.EVENT_REDUCE_CHANGED = "reduceChanged", e = n = Object(r.b)([Object(o.m)("reduce")], e);
    }(u.a);

    e.d = l;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "c", function () {
      return s;
    });
    var r = n(0),
        i = n(2),
        o = n(1),
        a = n(49),
        u = n(3),
        c = "let s = 0;\ncol.forEach((c) => s += c.v);\nreturn s / col.length";

    function s(t) {
      return void 0 === t && (t = "script"), {
        type: "script",
        label: t,
        script: c
      };
    }

    var l = function () {
      function t(t, e, n) {
        this.c = t, this.v = e, this.raw = n;
      }

      return Object.defineProperty(t.prototype, "type", {
        get: function get() {
          return this.c.desc.type;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "name", {
        get: function get() {
          return this.c.getMetaData().label;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "id", {
        get: function get() {
          return this.c.id;
        },
        enumerable: !0,
        configurable: !0
      }), t;
    }(),
        p = function () {
      function t(t, e) {
        var n = this;
        this.children = t, this.allFactory = e, this.lookup = new Map(), this._all = null, t.forEach(function (t) {
          n.lookup.set("ID@" + t.id, t), n.lookup.set("NAME@" + t.name, t);
        });
      }

      return t.prototype.byName = function (t) {
        return this.lookup.get("NAME@" + t);
      }, t.prototype.byID = function (t) {
        return this.lookup.get("ID@" + t);
      }, t.prototype.byIndex = function (t) {
        return this.children[t];
      }, t.prototype.forEach = function (t) {
        return this.children.forEach(t);
      }, Object.defineProperty(t.prototype, "length", {
        get: function get() {
          return this.children.length;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "all", {
        get: function get() {
          return null == this._all && (this._all = this.allFactory ? this.allFactory() : null), this._all;
        },
        enumerable: !0,
        configurable: !0
      }), t;
    }(),
        f = function (t) {
      function e(e, r) {
        var i = t.call(this, e, r) || this;
        return i.script = n.DEFAULT_SCRIPT, i.f = null, i.script = r.script || i.script, i.setDefaultRenderer("number"), i.setDefaultGroupRenderer("number"), i.setDefaultSummaryRenderer("number"), i;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_SCRIPT_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.setScript = function (t) {
        this.script !== t && (this.f = null, this.fire([n.EVENT_SCRIPT_CHANGED, o.d.EVENT_DIRTY_VALUES, o.d.EVENT_DIRTY], this.script, this.script = t));
      }, e.prototype.getScript = function () {
        return this.script;
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.script = this.script, n;
      }, e.prototype.restore = function (e, n) {
        this.script = e.script || this.script, t.prototype.restore.call(this, e, n);
      }, e.prototype.compute = function (t) {
        var e,
            n,
            r = this;
        null == this.f && (this.f = new Function("children", "values", "raws", "col", "row", "index", (e = this.script, (n = e.trim()).includes("return") || (n = "return (" + n + ");"), "\n  const max = function(arr) { return Math.max.apply(Math, arr); };\n  const min = function(arr) { return Math.min.apply(Math, arr); };\n  const extent = function(arr) { return [min(arr), max(arr)]; };\n  const clamp = function(v, minValue, maxValue) { return v < minValue ? minValue : (v > maxValue ? maxValue : v); };\n  const normalize = function(v, minMax, max) {\n    if (Array.isArray(minMax)) {\n      minMax = minMax[0];\n      max = minMax[1];\n    }\n    return (v - minMax) / (max - minMax);\n  };\n  const denormalize = function(v, minMax, max) {\n    if (Array.isArray(minMax)) {\n      minMax = minMax[0];\n      max = minMax[1];\n    }\n    return v * (max - minMax) + minMax;\n  };\n  const linear = function(v, source, target) {\n    target = target || [0, 1];\n    return denormalize(normalize(v, source), target);\n  };\n  const v = (function custom() {\n    " + n + "\n  })();\n\n  return typeof v === 'number' ? v : NaN")));

        var i = this._children,
            o = this._children.map(function (e) {
          return e.getValue(t);
        }),
            a = this._children.map(function (e) {
          return Object(u.k)(e) ? e.getRawNumber(t) : null;
        }),
            c = new p(i.map(function (t, e) {
          return new l(t, o[e], a[e]);
        }), function () {
          var e = r.findMyRanker().flatColumns;
          return new p(e.map(function (e) {
            return new l(e, e.getValue(t), Object(u.k)(e) ? e.getRawNumber(t) : null);
          }));
        });

        return this.f.call(this, i, o, a, c, t.v, t.i);
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? {
          value: this.getRawNumber(e),
          children: this.children.map(function (t) {
            return t.getExportValue(e, n);
          })
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.EVENT_SCRIPT_CHANGED = "scriptChanged", e.DEFAULT_SCRIPT = c, e = n = Object(r.b)([Object(i.m)("script")], e);
    }(a.a);

    e.d = f;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(13),
        o = n(43),
        a = n(76),
        u = n(80),
        c = n(75),
        s = n(68),
        l = n(40),
        p = n(58),
        f = n(62),
        d = n(50),
        h = n(2),
        g = n(18),
        b = n(48),
        m = n(11),
        y = n(44),
        v = n(36),
        E = n(14),
        O = function (t) {
      function e(e, n, r, i, o) {
        var a = t.call(this, r, {
          fullDialog: Boolean(o),
          resetPossible: !1
        }) || this;
        return a.column = e, a.addons = n, a.ctx = i, a.onClick = o, a;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        for (var e = 0, n = this.addons; e < n.length; e++) {
          var r = n[e];
          this.node.insertAdjacentHTML("beforeend", "<strong>" + r.title + "</strong>"), r.append(this.column, t, this.dialog, this.ctx);
        }
      }, e.prototype.submit = function () {
        return this.onClick && this.onClick(), !0;
      }, e;
    }(E.c),
        C = function () {
      function t(t, e) {
        this.ctx = t, this.node = e.createElement("aside"), this.node.classList.add("lu-hierarchy", "lu-feature-advanced", "lu-feature-ranking"), this.node.innerHTML = '\n      <section class="lu-hierarchy-group">\n      </section>\n      <section class="lu-hierarchy-sort">\n      </section>\n      <section class="lu-hierarchy-sortgroup">\n      </section>\n    ';
        var n = {
          doc: e,
          placeholder: "Add Sort Criteria...",
          formatItem: function formatItem(t, e) {
            return e.dataset.typeCat = Object(h.f)(t.col).name, e.dataset.type = t.col.desc.type, t.text;
          }
        };
        this.groupAdder = new b.d(Object.assign({}, n, {
          placeholder: "Add Grouping Criteria..."
        })), this.groupSortAdder = new b.d(Object.assign({}, n, {
          placeholder: "Add Grouping Sort Criteria..."
        })), this.sortAdder = new b.d(n);
      }

      return t.prototype.update = function (t) {
        t ? (this.node.style.display = null, this.renderGroups(t, this.node.firstElementChild), this.renderSorting(t, this.node.children[1]), this.renderGroupSorting(t, this.node.lastElementChild)) : this.node.style.display = "none";
      }, t.prototype.render = function (t, e, n, r, i, o) {
        var a = this,
            u = new Map(Array.from(t.children).map(function (t) {
          return [t.dataset.id, t];
        }));
        t.innerHTML = "", e.forEach(function (e) {
          var c = n(e),
              s = u.get(c.id);
          if (s) return t.appendChild(s), void Object(y.e)(s, c);
          var l = Object(v.c)(c, i, a.ctx);
          t.insertAdjacentHTML("beforeend", '<div data-id="' + c.id + '" class="lu-toolbar">\n      <div class="lu-label">' + c.label + "</div>\n      " + (l.length > 0 ? '<i title="Customize" class="lu-action"><span aria-hidden="true">Customize</span> </i>' : "") + '\n      <i title="Move Up" class="lu-action"><span aria-hidden="true">Move Up</span> </i>\n      <i title="Move Down" class="lu-action"><span aria-hidden="true">Move Down</span> </i>\n      <i title="Remove from hierarchy" class="lu-action"><span aria-hidden="true">Remove from hierarchy</span> </i>\n      </div>');
          var p = t.lastElementChild;

          function f(t) {
            t.preventDefault(), t.stopPropagation();
          }

          p.querySelector('i[title="Move Down"]').onclick = function (t) {
            f(t), o(e, 1);
          }, p.querySelector('i[title="Move Up"]').onclick = function (t) {
            f(t), o(e, -1);
          }, p.querySelector("i[title^=Remove]").onclick = function (t) {
            f(t), o(e, 0);
          }, l.length > 0 && (p.querySelector("i[title=Customize]").onclick = function (t) {
            f(t), a.customize(c, l, t);
          }), r(e, p), Object(y.e)(p, c);
        });
      }, t.prototype.renderGroups = function (t, e) {
        var n = t.getGroupCriteria();

        if (0 !== n.length) {
          this.render(e, n, function (t) {
            return t;
          }, function (t, e) {
            e.insertAdjacentHTML("afterbegin", '<i title="Group" class="lu-action" data-group="true"><span aria-hidden="true">Group</span> </i>');
          }, "group", function (t, e) {
            if (0 !== e) {
              var n = t.isGroupedBy();
              t.findMyRanker().groupBy(t, n + e);
            } else t.groupByMe();
          }), this.addGroupAdder(t, n, e);
        } else e.innerHTML = "";
      }, t.prototype.renderSorting = function (t, e) {
        var n = t.getSortCriteria();

        if (0 !== n.length) {
          var r = function r(t, e) {
            var n = t.col,
                r = n.isSortedByMe();
            isFinite(e) ? 0 !== e ? n.sortByMe("asc" === r.asc, r.priority + e) : n.sortByMe("asc" === r.asc, -1) : n.sortByMe("desc" === r.asc, r.priority);
          };

          this.render(e, n, function (t) {
            return t.col;
          }, function (t, e) {
            e.insertAdjacentHTML("afterbegin", '\n      <i title="Sort" class="lu-action" data-sort="' + (t.asc ? "asc" : "desc") + '"><span aria-hidden="true">Toggle Sorting</span> </i>'), e.querySelector("i[title=Sort]").onclick = function (e) {
              e.preventDefault(), e.stopPropagation(), r(t, 1 / 0);
            };
          }, "sort", r), this.addSortAdder(t, n, e);
        } else e.innerHTML = "";
      }, t.prototype.renderGroupSorting = function (t, e) {
        var n = t.getGroupSortCriteria();

        if (0 !== n.length) {
          var r = function r(t, e) {
            var n = t.col,
                r = n.isGroupSortedByMe();
            isFinite(e) ? 0 !== e ? n.groupSortByMe("asc" === r.asc, r.priority + e) : n.groupSortByMe("asc" === r.asc, -1) : n.groupSortByMe("desc" === r.asc, r.priority);
          };

          this.render(e, n, function (t) {
            return t.col;
          }, function (t, e) {
            e.insertAdjacentHTML("afterbegin", '\n      <i title="Sort Group" class="lu-action" data-sort="' + (t.asc ? "asc" : "desc") + '"><span aria-hidden="true">Toggle Sorting</span> </i>'), e.querySelector('i[title="Sort Group"]').onclick = function (e) {
              e.preventDefault(), e.stopPropagation(), r(t, 1 / 0);
            };
          }, "sortGroup", r), this.addGroupSortAdder(t, n, e);
        } else e.innerHTML = "";
      }, t.prototype.addAdder = function (t, e, n, r, i, o, a) {
        var u = this,
            c = new Set(r);

        if (t.data = e.children.filter(function (t) {
          return !Object(h.l)(t) && !c.has(t) && o(t);
        }).map(function (t) {
          return {
            col: t,
            id: t.id,
            text: t.label
          };
        }), t.on(b.d.EVENT_SELECT, function (e) {
          var r = Object(v.c)(e.col, n, u.ctx);
          r.length > 0 ? u.customize(e.col, r, {
            currentTarget: t.node
          }, function () {
            return a(e.col);
          }) : a(e.col);
        }), !(t.data.length <= 0)) {
          console.assert(null != i.ownerDocument);
          var s = i.ownerDocument.createElement("footer");
          s.appendChild(t.node), i.appendChild(s);
        }
      }, t.prototype.addSortAdder = function (t, e, n) {
        var r = this;
        this.addAdder(this.sortAdder, t, "sort", e.map(function (t) {
          return t.col;
        }), n, function (t) {
          return Object(v.f)(t, r.ctx);
        }, function (n) {
          t.sortBy(n, Object(h.k)(n), e.length);
        });
      }, t.prototype.addGroupAdder = function (t, e, n) {
        var r = this;
        this.addAdder(this.groupAdder, t, "group", e, n, function (t) {
          return Object(v.d)(t, r.ctx);
        }, function (n) {
          t.groupBy(n, e.length);
        });
      }, t.prototype.addGroupSortAdder = function (t, e, n) {
        var r = this;
        this.addAdder(this.groupSortAdder, t, "sortGroup", e.map(function (t) {
          return t.col;
        }), n, function (t) {
          return Object(v.e)(t, r.ctx);
        }, function (n) {
          t.groupSortBy(n, Object(h.k)(n), e.length);
        });
      }, t.prototype.customize = function (t, e, n, r) {
        new O(t, e, Object(v.a)(this.ctx, 0, n), this.ctx, r).open();
      }, t;
    }(),
        _ = n(1),
        T = n(6),
        N = function () {
      function t(t, e, n) {
        var r = this;
        this.column = t, this.ctx = e, this.node = n.createElement("article"), this.node.classList.add("lu-side-panel-entry"), this.node.dataset.colId = t.id, this.node.dataset.type = t.desc.type, this.summary = e.summaryRenderer(t, !0), this.column.on([T.b.EVENT_FILTER_CHANGED + ".panel", _.d.EVENT_DIRTY_HEADER + ".panel"], function () {
          r.update();
        }), this.init(), this.update();
      }

      return t.prototype.init = function () {
        this.node.innerHTML = '\n      <header><div class="lu-label"></div><div class="lu-toolbar"></div></header>' + this.summary.template, Object(y.b)(this.node.querySelector(".lu-toolbar"), 0, this.column, this.ctx, !1), Object(y.d)(this.node.querySelector("header"), this.column, this.ctx);
        var t = this.node.lastElementChild;
        t.classList.add("lu-summary"), t.dataset.renderer = this.column.getSummaryRenderer(), t.dataset.interactive = "";
      }, t.prototype.update = function (t) {
        void 0 === t && (t = this.ctx), this.ctx = t, Object(y.e)(this.node, this.column), this.summary.update(this.node.querySelector(".lu-summary"), t.statsOf(this.column));
      }, t.prototype.destroy = function () {
        this.column.on([T.b.EVENT_FILTER_CHANGED + ".panel", _.d.EVENT_DIRTY_HEADER + ".panel"], null), this.node.remove();
      }, t;
    }(),
        D = function (t) {
      function e(e, n) {
        var r = t.call(this, n, {
          fullDialog: !0
        }) || this;
        return r.ranking = e, r.before = e.getLabel(), r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.classList.add("lu-rename-dialog"), t.insertAdjacentHTML("beforeend", '\n      <input type="text" value="' + this.ranking.getLabel() + '" required autofocus placeholder="name">');
      }, e.prototype.reset = function () {
        this.findInput('input[type="text"]').value = this.before, this.ranking.setLabel(this.before);
      }, e.prototype.submit = function () {
        var t = this.findInput('input[type="text"]').value;
        return this.ranking.setLabel(t), !0;
      }, e;
    }(E.c),
        R = function (t) {
      function e(e, n, r) {
        var i = t.call(this, n) || this;
        return i.ranking = e, i.ctx = r, i;
      }

      return Object(r.c)(e, t), e.prototype.addIcon = function (t, e, n) {
        t.insertAdjacentHTML("beforeend", '<i title="' + e + '" class="lu-action"><span>' + e + "</span> </i>"), t.lastElementChild.onclick = function (t) {
          t.stopPropagation(), n(t);
        };
      }, e.prototype.build = function (t) {
        var e = this;
        t.classList.add("lu-more-options"), this.addIcon(t, "Rename", function (t) {
          new D(e.ranking, Object(v.a)(e.ctx, e.level + 1, t)).open();
        }), this.addIcon(t, "Remove", function () {
          e.destroy(), e.ctx.provider.removeRanking(e.ranking);
        });
      }, e;
    }(E.c),
        w = function () {
      function t(t, e, n, r) {
        this.ranking = t, this.ctx = e, this.options = r, this.entries = new Map(), this.node = n.createElement("section"), this.header = n.createElement("div"), this.dropdown = n.createElement("div"), this.dropdown.innerHTML = this.header.innerHTML = "<span>" + t.getLabel() + '</span><i class="lu-action" title="More &hellip;"><span aria-hidden="true">More &hellip;"></span></i>', this.header.lastElementChild.onclick = this.dropdown.lastElementChild.onclick = function (n) {
          n.stopPropagation(), new R(t, Object(v.a)(e, 1, n), e).open();
        }, this.hierarchy = this.options.hierarchy ? new C(e, n) : null, this.init();
      }

      return t.prototype.init = function () {
        var t = this;
        this.node.innerHTML = "\n      <div><main></main></div>\n    ", this.hierarchy && this.node.insertBefore(this.hierarchy.node, this.node.firstChild), this.hierarchy && this.ranking.on(Object(i.b)(".panel", m.b.EVENT_GROUP_CRITERIA_CHANGED, m.b.EVENT_SORT_CRITERIA_CHANGED, m.b.EVENT_GROUP_SORT_CRITERIA_CHANGED), function () {
          t.updateHierarchy();
        }), this.ranking.on(Object(i.b)(".panel", m.b.EVENT_ADD_COLUMN, m.b.EVENT_REMOVE_COLUMN, m.b.EVENT_MOVE_COLUMN), function () {
          t.updateList(), t.updateHierarchy();
        }), this.ranking.on(Object(i.b)(".panel", m.b.EVENT_LABEL_CHANGED), function () {
          t.dropdown.firstElementChild.textContent = t.header.firstElementChild.textContent = t.ranking.getLabel();
        });
      }, Object.defineProperty(t.prototype, "active", {
        get: function get() {
          return this.node.classList.contains("lu-active");
        },
        set: function set(t) {
          this.node.classList.toggle("lu-active", t), this.header.classList.toggle("lu-active", t), this.dropdown.classList.toggle("lu-active", t), t || (this.updateList(), this.updateHierarchy());
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.update = function (t) {
        this.ctx = t, this.updateList(), this.updateHierarchy();
      }, t.prototype.updateHierarchy = function () {
        this.hierarchy && this.active && this.hierarchy.update(this.ranking);
      }, t.prototype.updateList = function () {
        var t = this;

        if (this.active) {
          var e = this.node.querySelector("main"),
              n = this.ranking.flatColumns.filter(function (t) {
            return !Object(h.l)(t);
          });
          if (0 === n.length) return e.innerHTML = "", this.entries.forEach(function (t) {
            return t.destroy();
          }), void this.entries.clear();
          e.innerHTML = "";
          var r = new Map(this.entries);
          this.entries.clear(), n.forEach(function (n) {
            var i = r.get(n.id);
            if (i) return i.update(t.ctx), e.appendChild(i.node), t.entries.set(n.id, i), void r.delete(n.id);
            console.assert(null != e.ownerDocument);
            var o = new N(n, t.ctx, e.ownerDocument);
            e.appendChild(o.node), t.entries.set(n.id, o);
          }), r.forEach(function (t) {
            return t.destroy();
          });
        }
      }, t.prototype.destroy = function () {
        this.header.remove(), this.node.remove(), this.ranking.on(Object(i.b)(".panel", m.b.EVENT_GROUP_CRITERIA_CHANGED, m.b.EVENT_SORT_CRITERIA_CHANGED, m.b.EVENT_GROUP_SORT_CRITERIA_CHANGED, m.b.EVENT_ADD_COLUMN, m.b.EVENT_MOVE_COLUMN, m.b.EVENT_REMOVE_COLUMN, m.b.EVENT_LABEL_CHANGED), null), this.entries.forEach(function (t) {
          return t.destroy();
        }), this.entries.clear();
      }, t;
    }(),
        A = function (t) {
      function e(e, n) {
        var r = t.call(this, n) || this;
        return r.items = e, r;
      }

      return Object(r.c)(e, t), e.prototype.build = function (t) {
        t.classList.add("lu-more-options", "lu-choose-options");

        for (var e = 0, n = this.items; e < n.length; e++) {
          var r = n[e];
          t.appendChild(r);
        }
      }, e;
    }(E.c);

    function M(t) {
      return null != t.desc;
    }

    var L = function () {
      function t(t, e, n) {
        void 0 === n && (n = {}), this.ctx = t, this.options = {
          additionalDescs: [Object(o.a)("Weighted Sum"), Object(a.c)("Scripted Formula"), Object(u.a)("Nested"), Object(c.c)(), Object(s.a)(), Object(l.a)(), Object(p.b)(), Object(f.b)(), Object(d.b)()],
          chooser: !0,
          hierarchy: !0,
          placeholder: "Add Column...",
          formatItem: function formatItem(t, e) {
            var n = M(t) ? t : t.children[0];
            return e.dataset.typeCat = n.category.name, M(t) && (e.dataset.type = n.desc.type), e.parentElement && (e.parentElement.classList.add("lu-feature-model"), e.parentElement.classList.toggle("lu-feature-advanced", "advanced" === n.category.featureLevel), e.parentElement.classList.toggle("lu-feature-basic", "basic" === n.category.featureLevel)), t.text;
          },
          collapseable: !0
        }, this.chooser = null, this.descs = [], this.rankings = [], Object.assign(this.options, n), this.node = e.createElement("aside"), this.node.classList.add("lu-side-panel"), this.search = this.options.chooser ? new b.d(this.options) : null, this.data = t.provider, this.init(), this.update(t);
      }

      return t.prototype.init = function () {
        var t = this;
        (this.node.innerHTML = '\n      <aside class="lu-stats"></aside>\n      <header>\n        <i class="lu-action" title="Choose &hellip;"><span aria-hidden="true">Choose &hellip;</span></i>\n      </header>\n      <main></main>\n    ', this.node.querySelector("header > i").onclick = function (e) {
          e.stopPropagation(), new A(t.rankings.map(function (t) {
            return t.dropdown;
          }), Object(v.a)(t.ctx, 1, e)).open();
        }, this.options.collapseable) && (this.node.insertAdjacentHTML("beforeend", '<div class="lu-collapser" title="Collapse Panel"></div>'), this.node.lastElementChild.onclick = function () {
          return t.collapsed = !t.collapsed;
        }, this.collapsed = "collapsed" === this.options.collapseable);
        this.initChooser(), this.changeDataStorage(null, this.data);
      }, t.prototype.initChooser = function () {
        var t = this;
        this.search && (console.assert(null != this.node.ownerDocument), this.chooser = this.node.ownerDocument.createElement("header"), this.chooser.innerHTML = "<form></form>", this.chooser.firstElementChild.appendChild(this.search.node), this.search.on(b.d.EVENT_SELECT, function (e) {
          var n = t.data.create(e.desc);

          if (n) {
            var r = t.active;
            r && r.ranking.push(n);
          }
        }));
      }, Object.defineProperty(t.prototype, "active", {
        get: function get() {
          return this.rankings.find(function (t) {
            return t.active;
          });
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.changeDataStorage = function (t, e) {
        var n,
            o = this;
        t && t.on(Object(i.b)(".panel", g.d.EVENT_ADD_RANKING, g.d.EVENT_REMOVE_RANKING, g.d.EVENT_ADD_DESC, g.d.EVENT_CLEAR_DESC, g.d.EVENT_ORDER_CHANGED, g.d.EVENT_SELECTION_CHANGED), null), this.data = e;

        var a = function a(t) {
          return {
            desc: t,
            category: Object(h.g)(t, e.columnTypes),
            id: t.type + "@" + t.label,
            text: t.label
          };
        };

        (n = this.descs).splice.apply(n, Object(r.d)([0, this.descs.length], e.getColumns().concat(this.options.additionalDescs).map(a))), e.on(g.d.EVENT_ADD_DESC + ".panel", function (t) {
          o.descs.push(a(t)), o.updateChooser();
        }), e.on(g.d.EVENT_CLEAR_DESC + ".panel", function () {
          o.descs.splice(0, o.descs.length), o.updateChooser();
        }), e.on(Object(i.b)(".panel", g.d.EVENT_SELECTION_CHANGED, g.d.EVENT_ORDER_CHANGED), function () {
          o.updateStats();
        }), e.on(Object(i.b)(".panel", g.d.EVENT_ADD_RANKING), function (t, e) {
          o.createEntry(t, e), o.makeActive(e);
        }), e.on(Object(i.b)(".panel", g.d.EVENT_REMOVE_RANKING), function (t, e) {
          if (e < 0) return o.rankings.splice(0, o.rankings.length).forEach(function (t) {
            return t.destroy();
          }), o.node.querySelector("header").dataset.count = "0", void o.makeActive(-1);
          var n = o.rankings.splice(e, 1)[0];
          o.node.querySelector("header").dataset.count = String(o.rankings.length), n.destroy(), n.active && o.makeActive(0 === o.rankings.length ? -1 : Math.max(e - 1, 0));
        }), this.rankings.splice(0, this.rankings.length).forEach(function (t) {
          return t.destroy();
        }), e.getRankings().forEach(function (t, e) {
          o.createEntry(t, e);
        }), this.rankings.length > 0 && this.makeActive(0), this.updateStats();
      }, t.prototype.createEntry = function (t, e) {
        var n = this;
        console.assert(null != this.node.ownerDocument);
        var r = new w(t, this.ctx, this.node.ownerDocument, this.options),
            i = this.node.querySelector("header"),
            o = this.node.querySelector("main");
        i.insertBefore(r.header, i.children[e + 1]), i.dataset.count = String(this.rankings.length + 1), r.header.onclick = function (t) {
          t.preventDefault(), t.stopPropagation(), n.makeActive(n.rankings.indexOf(r));
        }, r.dropdown.onclick = r.header.onclick = function (t) {
          t.preventDefault(), t.stopPropagation(), n.ctx.dialogManager.removeAboveLevel(0), n.makeActive(n.rankings.indexOf(r));
        }, o.insertBefore(r.node, o.children[e]), this.rankings.splice(e, 0, r);
      }, Object.defineProperty(t.prototype, "collapsed", {
        get: function get() {
          return this.node.classList.contains("lu-collapsed");
        },
        set: function set(t) {
          this.node.classList.toggle("lu-collapsed", t), t || (this.updateChooser(), this.updateStats(), this.updateRanking());
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.makeActive = function (t) {
        this.rankings.forEach(function (e, n) {
          return e.active = t === n;
        });
        var e = this.active;

        if (e && this.chooser) {
          e.node.insertAdjacentElement("afterbegin", this.chooser);
          var n = this.node.closest(".lu"),
              r = n ? n.querySelector('article[data-ranking="' + e.ranking.id + '"]') : null;
          r && r.scrollIntoView();
        }

        this.updateRanking();
      }, t.prototype.updateRanking = function () {
        var t = this.active;
        t && !this.collapsed && t.update(this.ctx);
      }, t.prototype.update = function (t) {
        var e = this.data;
        this.ctx = t, t.provider !== e && this.changeDataStorage(e, t.provider), this.updateChooser(), this.updateStats();
        var n = this.active;
        n && n.update(t);
      }, t.prototype.updateStats = function () {
        if (!this.collapsed) {
          var t = this.node.querySelector("aside.lu-stats"),
              e = this.data.getSelection(),
              n = this.data.getFirstRanking(),
              r = n ? n.getGroups().reduce(function (t, e) {
            return t + e.order.length;
          }, 0) : 0;
          t.innerHTML = "Showing <strong>" + r + "</strong> of " + this.data.getTotalNumberOfRows() + " items" + (e.length > 0 ? "; <span>" + e.length + " selected</span>" : "");
        }
      }, t.prototype.destroy = function () {
        this.node.remove(), this.data && (this.rankings.forEach(function (t) {
          return t.destroy();
        }), this.rankings.length = 0, this.data.on(Object(i.b)(".panel", g.d.EVENT_ADD_RANKING, g.d.EVENT_REMOVE_RANKING, g.d.EVENT_ADD_DESC), null));
      }, t.groupByType = function (t) {
        var e = new Map();
        return t.forEach(function (t) {
          e.has(t.category) ? e.get(t.category).push(t) : e.set(t.category, [t]);
        }), Array.from(e).map(function (t) {
          var e = t[0],
              n = t[1];
          return {
            text: e.label,
            order: e.order,
            children: n.sort(function (t, e) {
              return t.text.localeCompare(e.text);
            })
          };
        }).sort(function (t, e) {
          return t.order - e.order;
        });
      }, t.prototype.updateChooser = function () {
        this.search && !this.collapsed && (this.search.data = t.groupByType(this.descs));
      }, t;
    }();

    e.b = L;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return r;
    });

    var r,
        i = n(31),
        o = n(60),
        a = n(8),
        u = function () {
      function t(t, e, n) {
        this.left = t, this.right = e, this.dataIndices = n;
      }

      return t.prototype.isSelected = function (t) {
        return 1 === this.dataIndices.length ? t.has(this.dataIndices[0]) : this.dataIndices.some(function (e) {
          return t.has(e);
        });
      }, t.prototype.update = function (t, e) {
        t.setAttribute("data-i", String(this.dataIndices[0])), t.setAttribute("class", "lu-slope"), t.setAttribute("d", "M0," + this.left + "L" + e + "," + this.right);
      }, t;
    }(),
        c = function () {
      function t(t, e, n) {
        this.left = t, this.right = e, this.dataIndices = n;
      }

      return t.prototype.isSelected = function (t) {
        return this.dataIndices.some(function (e) {
          return t.has(e);
        });
      }, t.prototype.update = function (t, e) {
        t.setAttribute("class", "lu-group-slope"), t.setAttribute("d", "M0," + this.left[0] + "L" + e + "," + this.right[0] + "L" + e + "," + this.right[1] + "L0," + this.left[1] + "Z");
      }, t;
    }();

    !function (t) {
      t.ITEM = "item", t.BAND = "band";
    }(r || (r = {}));

    var s = function () {
      function t(t, e, n, i, o) {
        void 0 === o && (o = {}), this.header = t, this.body = e, this.id = n, this.ctx = i, this.leftSlopes = [], this.rightSlopes = [], this.pool = [], this.scrollListener = null, this.width = a.g, this.height = 0, this.current = null, this._mode = r.ITEM, console.assert(null != t.ownerDocument), this.node = t.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "svg"), this.node.innerHTML = '<g transform="translate(0,0)"></g>', t.classList.add("lu-slopegraph-header"), this._mode = o.mode === r.BAND ? r.BAND : r.ITEM, this.initHeader(t), e.classList.add("lu-slopegraph"), this.body.style.height = "1px", e.appendChild(this.node);
      }

      return t.prototype.init = function () {
        var t = this;
        this.hide();
        var e = this.body.parentElement.__le_scroller__,
            n = e.asInfo();
        e.push("animation", this.scrollListener = function (e) {
          Math.abs(n.top - e.top) < 5 || (n = e, t.onScrolledVertically(e.top, e.height));
        });
      }, t.prototype.initHeader = function (t) {
        var e = this;
        t.innerHTML = '<i title="Item" class="' + (this._mode === r.ITEM ? "active" : "") + '"><span aria-hidden="true">Item</span></i>\n        <i title="Band" class="' + (this._mode === r.BAND ? "active" : "") + '"><span aria-hidden="true">Band</span></i>';
        var n = Array.from(t.children);
        n.forEach(function (t, i) {
          t.onclick = function (o) {
            o.preventDefault(), o.stopPropagation(), t.classList.contains("active") || (e.mode = 0 === i ? r.ITEM : r.BAND, n.forEach(function (t, e) {
              return t.classList.toggle("active", e === i);
            }));
          };
        });
      }, Object.defineProperty(t.prototype, "mode", {
        get: function get() {
          return this._mode;
        },
        set: function set(t) {
          t !== this._mode && (this._mode = t, this.current && this.rebuild(this.current.left, this.current.leftContext, this.current.right, this.current.rightContext));
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(t.prototype, "hidden", {
        get: function get() {
          return this.header.classList.contains("loading");
        },
        set: function set(t) {
          this.header.classList.toggle("loading", t), this.body.classList.toggle("loading", t);
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.hide = function () {
        this.hidden = !0;
      }, t.prototype.show = function () {
        var t = this.hidden;
        this.hidden = !1, t && this.revalidate();
      }, t.prototype.destroy = function () {
        (this.header.remove(), this.scrollListener) && this.body.parentElement.__le_scroller__.remove(this.scrollListener);
        this.body.remove();
      }, t.prototype.rebuild = function (t, e, n, r) {
        this.current = {
          left: t,
          leftContext: e,
          right: n,
          rightContext: r
        };
        var i = this.prepareRightSlopes(n, r);
        this.computeSlopes(t, e, i), this.revalidate();
      }, t.prototype.computeSlopes = function (t, e, n) {
        var i = this,
            a = this.mode,
            s = new Map(),
            l = 0;
        this.leftSlopes = t.map(function (p, f) {
          var d = e.exceptionsLookup.get(f) || e.defaultRowHeight,
              h = d - 0,
              g = [],
              b = l;
          l += d;

          var m,
              y = 0,
              v = function v(t, e, n, r) {
            void 0 === n && (n = 1), void 0 === r && (r = 0), g.push(t), e.ref.forEach(function (e) {
              return i.rightSlopes[e].push(t);
            }), e.offset += n * e.heightPerRow, y += n * r;
          };

          if (Object(o.b)(p)) m = p;else {
            var E = p,
                O = E.i,
                C = n.get(O);
            if (!C) return g;

            if (a === r.ITEM) {
              var _ = new u(b + h / 2, C.start + C.offset + C.heightPerRow / 2, [O]);

              return v(_, C), g;
            }

            if (s.has(E.group)) return s.get(E.group);

            var T = function (n, r) {
              for (var i = 0, a = 0, u = [], c = n; c < t.length; ++c) {
                var s = t[c];
                if (Object(o.b)(s) || s.group !== r) break;
                i++, a += e.exceptionsLookup.get(c) || e.defaultRowHeight, u.push(s);
              }

              var l = a - e.padding(n + i - 1);
              return {
                gr: Object.assign({
                  rows: u
                }, r),
                padded: l,
                height: a
              };
            }(f, E.group);

            m = T.gr, d = T.height, h = T.padded, s.set(E.group, g);
          }
          var N = new Set(m.rows.map(function (t) {
            return t.i;
          })),
              D = h / m.rows.length;
          return m.rows.forEach(function (t) {
            if (N.has(t.i)) {
              N.delete(t.i);
              var e = n.get(t.i);

              if (e) {
                var i = e.rows.filter(function (t) {
                  return N.delete(t);
                });
                i.push(t.i);
                var o,
                    s = i.length;
                o = 1 === s ? new u(b + y + D / 2, e.start + e.offset + e.heightPerRow / 2, [t.i]) : a === r.ITEM ? new u(b + y + D * s / 2, e.start + e.offset + e.heightPerRow * s / 2, i) : new c([b + y, b + y + D * s], [e.start + e.offset, e.start + e.offset + e.heightPerRow * s], i), v(o, e, s, D);
              }
            }
          }), g;
        });
      }, t.prototype.prepareRightSlopes = function (t, e) {
        var n = new Map(),
            i = this.mode,
            a = new Map(),
            u = 0;
        return this.rightSlopes = t.map(function (t, c) {
          var s = e.exceptionsLookup.get(c) || e.defaultRowHeight,
              l = s - 0,
              p = u;
          u += s;
          var f = [],
              d = {
            start: p,
            offset: 0,
            ref: [c]
          };

          if (Object(o.b)(t)) {
            var h = Object.assign(d, {
              rows: t.rows.map(function (t) {
                return t.i;
              }),
              heightPerRow: l / t.rows.length,
              group: t
            });
            return t.rows.forEach(function (t) {
              return n.set(t.i, h);
            }), f;
          }

          var g = t,
              b = t.i,
              m = Object.assign(d, {
            rows: [b],
            heightPerRow: l,
            group: g.group
          });
          return i === r.ITEM ? (n.set(b, m), f) : (a.has(g.group) ? ((m = a.get(g.group)).rows.push(b), m.ref.push(c)) : (m.heightPerRow = s, a.set(g.group, m)), n.set(b, m), f);
        }), n;
      }, t.prototype.revalidate = function () {
        if (this.current && !this.hidden) {
          var t = this.body.parentElement;
          this.onScrolledVertically(t.scrollTop, t.clientHeight);
        }
      }, t.prototype.highlight = function (t) {
        var e = this.body.querySelector("[data-i].le-highlighted");

        if (e && e.classList.remove("le-highlighted"), !(t < 0)) {
          var n = this.body.querySelector('[data-i="' + t + '"]');
          return n && n.classList.add("le-highlighted"), null != n;
        }
      }, t.prototype.onScrolledVertically = function (t, e) {
        if (this.current) {
          var n = this.current,
              r = n.leftContext,
              o = n.rightContext,
              a = Object(i.range)(t, e, r.defaultRowHeight, r.exceptions, r.numberOfRows),
              u = Object(i.range)(t, e, o.defaultRowHeight, o.exceptions, o.numberOfRows),
              c = Math.min(a.firstRowPos, u.firstRowPos),
              s = Math.max(a.endPos, u.endPos);
          this.body.style.transform = "translate(0, " + c.toFixed(0) + "px)", this.body.style.height = (s - c).toFixed(0) + "px", this.node.firstElementChild.setAttribute("transform", "translate(0,-" + c.toFixed(0) + ")"), this.choose(a.first, a.last, u.first, u.last);
        }
      }, t.prototype.choose = function (t, e, n, r) {
        for (var i = new Set(), o = t; o <= e; ++o) {
          this.leftSlopes[o].forEach(function (t) {
            return i.add(t);
          });
        }

        for (o = n; o <= r; ++o) {
          this.rightSlopes[o].forEach(function (t) {
            return i.add(t);
          });
        }

        this.render(i);
      }, t.prototype.render = function (t) {
        var e = this.node.firstElementChild,
            n = e.ownerSVGElement.getBoundingClientRect().width,
            r = this.matchLength(t, e),
            i = this.ctx.provider,
            o = {
          has: function has(t) {
            return i.isSelected(t);
          }
        },
            a = 0;
        t.forEach(function (t) {
          var i = r[a++];
          t.update(i, n), i.__data__ = t;
          var u = t.isSelected(o);
          i.classList.toggle("lu-selected", u), u && e.appendChild(i);
        });
      }, t.prototype.matchLength = function (t, e) {
        for (var n = this, r = Array.from(e.children), i = t.size; i < r.length; ++i) {
          var o = r[i];
          this.pool.push(o), o.remove();
        }

        var a = function a(t) {
          var i = u.pool.pop();
          if (i) e.appendChild(i), r.push(i);else {
            console.assert(null != e.ownerDocument);
            var o = e.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "path");
            o.onclick = function (t) {
              var e = o.__data__,
                  r = n.ctx.provider,
                  i = e.dataIndices;
              if (t.ctrlKey) i.forEach(function (t) {
                return r.toggleSelection(t, !0);
              });else {
                var a = r.isSelected(i[0]);
                r.setSelection(a ? [] : i);
              }
            }, e.appendChild(o), r.push(o);
          }
        },
            u = this;

        for (i = r.length; i < t.size; ++i) {
          a();
        }

        return r;
      }, t.prototype.updateSelection = function (t) {
        var e = this.node.firstElementChild;
        Array.from(e.children).forEach(function (n) {
          var r = n.__data__.isSelected(t);

          n.classList.toggle("lu-selected", r), r && e.appendChild(n);
        });
      }, t;
    }();

    e.b = s;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      void 0 === e && (e = {});

      var n = Object.assign({
        container: t.parentElement,
        filter: function filter() {
          return !0;
        },
        onStart: function onStart() {},
        onDrag: function onDrag() {},
        onEnd: function onEnd() {},
        minDelta: 2
      }, e),
          r = function r(t, e) {
        return t - e.getBoundingClientRect().left - e.clientLeft;
      },
          i = 0,
          o = 0,
          a = 0,
          u = function u(e) {
        if (n.filter(e)) {
          e.stopPropagation(), e.preventDefault();
          var i = r(e.clientX, n.container) - a;
          Math.abs(o - i) < n.minDelta || (o = i, n.onDrag(t, i, o - i, e));
        }
      },
          c = function c(e) {
        if (n.filter(e)) {
          e.stopPropagation(), e.preventDefault();
          var o = r(e.clientX, n.container) - a;
          n.container.removeEventListener("mousemove", u), n.container.removeEventListener("mouseup", c), n.container.removeEventListener("mouseleave", c), Math.abs(i - o) < 2 || n.onEnd(t, o, i - o, e);
        }
      };

      t.onmousedown = function (e) {
        n.filter(e) && (e.stopPropagation(), e.preventDefault(), a = r(e.clientX, t), i = o = r(e.clientX, n.container) - a, n.container.addEventListener("mousemove", u), n.container.addEventListener("mouseup", c), n.container.addEventListener("mouseleave", c), n.onStart(t, i, 0, e));
      };
    }

    n.d(e, "a", function () {
      return r;
    });
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    var r = n(0);

    function i(t) {
      return void 0 === t && (t = "Nested"), {
        type: "nested",
        label: t
      };
    }

    var o = function (t) {
      function e() {
        return null !== t && t.apply(this, arguments) || this;
      }

      return Object(r.c)(e, t), e.prototype.compare = function (t, e) {
        for (var n = 0, r = this.children; n < r.length; n++) {
          var i = r[n].compare(t, e);
          if (0 !== i) return i;
        }

        return 0;
      }, e.prototype.getLabel = function (t) {
        return this.children.map(function (e) {
          return e.getLabel(t);
        }).join(";");
      }, e.prototype.getValue = function (t) {
        return this.children.map(function (e) {
          return e.getValue(t);
        }).join(";");
      }, e;
    }(n(86).a);

    e.b = o;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(1),
        o = function (t) {
      function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.annotations = new Map(), e;
      }

      return Object(r.c)(e, t), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_VALUE_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.getValue = function (e) {
        return this.annotations.has(e.i) ? this.annotations.get(e.i) : t.prototype.getValue.call(this, e);
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.annotations = {}, this.annotations.forEach(function (t, e) {
          n.annotations[e] = t;
        }), n;
      }, e.prototype.restore = function (e, n) {
        var r = this;
        t.prototype.restore.call(this, e, n), e.annotations && Object.keys(e.annotations).forEach(function (t) {
          r.annotations.set(Number(t), e.annotations[t]);
        });
      }, e.prototype.setValue = function (t, n) {
        var r = this.getValue(t);
        return r === n || ("" === n || null == n ? this.annotations.delete(t.i) : this.annotations.set(t.i, n), this.fire([e.EVENT_VALUE_CHANGED, i.d.EVENT_DIRTY_VALUES, i.d.EVENT_DIRTY], t.i, r, n), !0);
      }, e.EVENT_VALUE_CHANGED = "valueChanged", e;
    }(n(20).d);

    e.a = o;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    var r = "[object Object]";

    function i() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }

      for (var n = null, o = 0, a = t; o < a.length; o++) {
        var u = a[o],
            c = Object.keys(u);
        if (null != n) for (var s = 0, l = c; s < l.length; s++) {
          var p = l[s],
              f = u[p];
          Object.prototype.toString.call(f) === r && Object.getPrototypeOf(f) === Object.prototype ? (void 0 === n[p] && (n[p] = {}), n[p] = i(n[p], f)) : Array.isArray(f) ? (void 0 === n[p] && (n[p] = []), n[p] = f.concat(n[p])) : n[p] = f;
        } else n = u;
      }

      return n;
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(13),
        o = n(18),
        a = n(100),
        u = 57,
        c = 64,
        s = 16;

    function l() {
      var t = Object(a.detect)();
      if (!t) return "browser cannot be detected";
      var e = "unsupported browser detected:";

      switch (t.name) {
        case "firefox":
          var n = parseInt(t.version.slice(0, t.version.indexOf(".")), 10);
          return n <= u && 52 !== n ? e + " Firefox " + t.version + " (&lt; " + u + ")" : null;

        case "edge":
          return parseInt(t.version.slice(0, t.version.indexOf(".")), 10) <= s ? e + " Edge " + t.version + " (&lt; " + s + ")" : null;

        case "chrome":
          return parseInt(t.version.slice(0, t.version.indexOf(".")), 10) <= c ? e + " Chrome " + t.version + " (&lt; " + c + ")" : null;

        case "ie":
          return e + " Internet Explorer";
      }

      return console.warn("unknown browser detected", t, "assuming fine..."), null;
    }

    n.d(e, "a", function () {
      return p;
    });

    var p = function (t) {
      function e(e, n, r) {
        var i = t.call(this) || this;
        i.node = e, i.data = n, i.highlightListeners = 0;
        var a = l();
        return i.isBrowserSupported = r || !a, i.isBrowserSupported || (i.node.classList.add("lu-unsupported-browser"), i.node.innerHTML = "<span>" + a + '</span>\n      <div class="lu-unsupported-browser-hint">\n        <a href="https://www.mozilla.org/en-US/firefox/" rel="noopener" target="_blank" data-browser="firefox" data-version="' + u + '"></a>\n        <a href="https://www.google.com/chrome/index.html" rel="noopener" target="_blank" data-browser="chrome" data-version="' + c + '" title="best support"></a>\n        <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" rel="noopener" target="_blank" data-browser="edge" data-version="' + s + '"></a>\n      </div><span>use the <code>ignoreUnsupportedBrowser=true</code> option to ignore this error at your own risk</span>'), i.forward(i.data, o.d.EVENT_SELECTION_CHANGED + ".main"), i;
      }

      return Object(r.c)(e, t), e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_HIGHLIGHT_CHANGED, e.EVENT_SELECTION_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.destroy = function () {
        this.node.innerHTML = "";
      }, e.prototype.dump = function () {
        return this.data.dump();
      }, e.prototype.setDataProvider = function (t, e) {
        this.data && this.unforward(this.data, o.d.EVENT_SELECTION_CHANGED + ".taggle"), this.data = t, e && this.data.restore(e), this.forward(this.data, o.d.EVENT_SELECTION_CHANGED + ".taggle");
      }, e.prototype.getSelection = function () {
        return this.data.getSelection();
      }, e.prototype.setSelection = function (t) {
        this.data.setSelection(t);
      }, e.prototype.sortBy = function (t, e) {
        void 0 === e && (e = !1);
        var n = this.data.find(t);
        return n && n.sortByMe(e), null != n;
      }, e.prototype.listenersChanged = function (n, r) {
        t.prototype.listenersChanged.call(this, n, r), n.startsWith(e.EVENT_HIGHLIGHT_CHANGED) && (r ? (this.highlightListeners += 1, 1 === this.highlightListeners && this.enableHighlightListening(!0)) : (this.highlightListeners -= 1, 0 === this.highlightListeners && this.enableHighlightListening(!1)));
      }, e.prototype.enableHighlightListening = function (t) {}, e.EVENT_SELECTION_CHANGED = o.d.EVENT_SELECTION_CHANGED, e.EVENT_HIGHLIGHT_CHANGED = "highlightChanged", e;
    }(i.a);
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(90);
    n.d(e, "Taggle", function () {
      return r.a;
    });
    var i = n(51);
    n.d(e, "ITaggleOptions", function () {
      return i.ITaggleOptions;
    });
    var o = n(92);
    n.d(e, "TaggleRenderer", function () {
      return o.a;
    });
    var a = n(95);
    n.d(e, "IRuleInstance", function () {
      return a.IRuleInstance;
    }), n.d(e, "IRule", function () {
      return a.IRule;
    });
    var u = n(93);
    n.d(e, "spaceFillingRule", function () {
      return u.a;
    });
    var c = n(74);
    n.d(e, "EngineRenderer", function () {
      return c.a;
    });
    var s = n(54);
    n.d(e, "EngineRanking", function () {
      return s.c;
    }), n.d(e, "IEngineRankingContext", function () {
      return s.IEngineRankingContext;
    }), n.d(e, "IEngineRankingOptions", function () {
      return s.IEngineRankingOptions;
    });
    var l = n(78);
    n.d(e, "SlopeGraph", function () {
      return l.b;
    }), n.d(e, "EMode", function () {
      return l.a;
    });
    var p = n(96);
    n.d(e, "IDialogOptions", function () {
      return p.c;
    }), n.d(e, "ADialog", function () {
      return p.a;
    }), n.d(e, "IDialogContext", function () {
      return p.b;
    });
    var f = n(97);
    n.d(e, "SidePanel", function () {
      return f.f;
    }), n.d(e, "ISidePanelOptions", function () {
      return f.d;
    }), n.d(e, "SearchBox", function () {
      return f.e;
    }), n.d(e, "IGroupSearchItem", function () {
      return f.a;
    }), n.d(e, "IItem", function () {
      return f.b;
    }), n.d(e, "ISearchBoxOptions", function () {
      return f.c;
    });
    var d = n(36);
    n.d(e, "dialogContext", function () {
      return d.a;
    }), n.d(e, "toolbarActions", function () {
      return d.g;
    }), n.d(e, "getToolbar", function () {
      return d.b;
    }), n.d(e, "getToolbarDialogAddons", function () {
      return d.c;
    }), n.d(e, "isSortAble", function () {
      return d.f;
    }), n.d(e, "isGroupAble", function () {
      return d.d;
    }), n.d(e, "isGroupSortAble", function () {
      return d.e;
    });
    var h = n(98);

    for (var g in h) {
      ["Taggle", "ITaggleOptions", "TaggleRenderer", "IRuleInstance", "IRule", "spaceFillingRule", "EngineRenderer", "EngineRanking", "IEngineRankingContext", "IEngineRankingOptions", "SlopeGraph", "EMode", "LineUp", "ILineUpOptions", "IDialogOptions", "ADialog", "IDialogContext", "SidePanel", "ISidePanelOptions", "SearchBox", "IGroupSearchItem", "IItem", "ISearchBoxOptions", "dialogContext", "toolbarActions", "getToolbar", "getToolbarDialogAddons", "isSortAble", "isGroupAble", "isGroupSortAble", "default"].indexOf(g) < 0 && function (t) {
        n.d(e, t, function () {
          return h[t];
        });
      }(g);
    }

    var b = n(73);
    n.d(e, "LineUp", function () {
      return b.a;
    }), n.d(e, "ILineUpOptions", function () {
      return i.ILineUpOptions;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(18),
        i = n(71),
        o = n(72),
        a = n(0),
        u = n(38),
        c = function (t) {
      function e(e, n, r) {
        void 0 === n && (n = []), void 0 === r && (r = {});
        var i = t.call(this, n, r) || this;
        return i.server = e, i.options = {
          maxCacheSize: 1e3
        }, i.cache = new Map(), Object.assign(i.options, r), i;
      }

      return Object(a.c)(e, t), e.prototype.getTotalNumberOfRows = function () {
        return this.cache.size;
      }, e.prototype.sortImpl = function (t) {
        return this.server.sort(t).then(function (t) {
          return [Object.assign({
            order: t
          }, u.a)];
        });
      }, e.prototype.loadFromServer = function (t) {
        return this.server.view(t).then(function (e) {
          return e.map(function (e, n) {
            return {
              v: e,
              dataIndex: t[n]
            };
          });
        });
      }, e.prototype.view = function (t) {
        if (0 === t.length) return Promise.resolve([]);
        var e = this.fetch([t])[0];
        return Promise.all(e).then(function (t) {
          return t.map(function (t) {
            return t.v;
          });
        });
      }, e.prototype.computeMissing = function (t) {
        var e = new Set(),
            n = e.add.bind(e);
        return t.forEach(function (t) {
          return t.forEach(n);
        }), this.cache.forEach(function (t, n) {
          return e.delete(n);
        }), this.cache.size, e.size, this.options.maxCacheSize, Array.from(e);
      }, e.prototype.loadInCache = function (t) {
        var e = this;

        if (0 !== t.length) {
          var n = this.loadFromServer(t);
          t.forEach(function (r, i) {
            var o = t[i];
            e.cache.set(o, n.then(function (t) {
              return {
                v: t[i],
                i: o
              };
            }));
          });
        }
      }, e.prototype.fetch = function (t) {
        var e = this,
            n = this.computeMissing(t);
        return this.loadInCache(n), t.map(function (t) {
          return t.map(function (t) {
            return e.cache.get(t);
          });
        });
      }, e.prototype.mappingSample = function (t) {
        return this.server.mappingSample(t.desc.column);
      }, e.prototype.searchAndJump = function (t, e) {
        var n = this;
        this.server.search(t, e.desc.column).then(function (t) {
          n.jumpToNearest(t);
        });
      }, e.prototype.stats = function (t) {
        return this.server.stats(t);
      }, e;
    }(n(88).a);

    n.d(e, "a", function () {
      return r.d;
    }), n.d(e, "e", function () {
      return r.IStatsBuilder;
    }), n.d(e, "c", function () {
      return r.IDataProviderOptions;
    }), n.d(e, "b", function () {
      return r.IDataProvider;
    }), n.d(e, "d", function () {
      return i.IExportOptions;
    }), n.d(e, "f", function () {
      return o.a;
    }), n.d(e, "g", function () {
      return c;
    }), n.d(e, "h", function () {
      return i.b;
    }), n.d(e, "j", function () {
      return i.d;
    }), n.d(e, "i", function () {
      return i.c;
    }), n.d(e, "k", function () {
      return i.e;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(16),
        o = n(2),
        a = n(1),
        u = n(26),
        c = n(3),
        s = n(43),
        l = function (t) {
      function e(e, n) {
        var r = t.call(this, e, n) || this;
        r.collapsed = !1;
        var i = r;
        return r.adaptChange = function (t, e) {
          i.adaptWidthChange(t, e);
        }, r;
      }

      var n;
      return Object(r.c)(e, t), n = e, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([n.EVENT_COLLAPSE_CHANGED, n.EVENT_MULTI_LEVEL_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.setCollapsed = function (t) {
        this.collapsed !== t && this.fire([s.b.EVENT_COLLAPSE_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY_VALUES, a.d.EVENT_DIRTY], this.collapsed, this.collapsed = t);
      }, e.prototype.getCollapsed = function () {
        return this.collapsed;
      }, e.prototype.dump = function (e) {
        var n = t.prototype.dump.call(this, e);
        return n.collapsed = this.collapsed, n;
      }, e.prototype.restore = function (e, n) {
        this.collapsed = !0 === e.collapsed, t.prototype.restore.call(this, e, n);
      }, e.prototype.flatten = function (t, e, n, r) {
        return void 0 === n && (n = 0), void 0 === r && (r = 0), s.b.prototype.flatten.call(this, t, e, n, r);
      }, e.prototype.insert = function (e, n) {
        return e.on(a.d.EVENT_WIDTH_CHANGED + ".stack", this.adaptChange), t.prototype.setWidth.call(this, 0 === this.length ? e.getWidth() : this.getWidth() + e.getWidth()), t.prototype.insert.call(this, e, n);
      }, e.prototype.adaptWidthChange = function (e, r) {
        if (!Object(i.l)(e, r, .5)) {
          var o = this.getWidth(),
              u = o + (r - e);
          this.fire([n.EVENT_MULTI_LEVEL_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY], o, u), t.prototype.setWidth.call(this, u);
        }
      }, e.prototype.removeImpl = function (e, n) {
        return e.on(a.d.EVENT_WIDTH_CHANGED + ".stack", null), t.prototype.setWidth.call(this, 0 === this.length ? 100 : this.getWidth() - e.getWidth()), t.prototype.removeImpl.call(this, e, n);
      }, e.prototype.setWidth = function (e) {
        var r = this.getWidth(),
            o = e / r;
        this._children.forEach(function (t) {
          t.setWidthImpl(t.getWidth() * o);
        }), Object(i.l)(r, e, .5) || this.fire([n.EVENT_MULTI_LEVEL_CHANGED, a.d.EVENT_DIRTY_HEADER, a.d.EVENT_DIRTY], r, e), t.prototype.setWidth.call(this, e);
      }, e.prototype.getRenderer = function () {
        return this.getCollapsed() ? n.EVENT_COLLAPSE_CHANGED : t.prototype.getRenderer.call(this);
      }, e.prototype.isMissing = function (t) {
        return !!this.getCollapsed() && this._children.some(function (e) {
          return (Object(c.k)(e) || Object(u.c)(e)) && e.isMissing(t);
        });
      }, e.prototype.getExportValue = function (e, n) {
        return "json" === n ? {
          children: this.children.map(function (t) {
            return t.getExportValue(e, n);
          })
        } : t.prototype.getExportValue.call(this, e, n);
      }, e.EVENT_COLLAPSE_CHANGED = s.b.EVENT_COLLAPSE_CHANGED, e.EVENT_MULTI_LEVEL_CHANGED = s.b.EVENT_MULTI_LEVEL_CHANGED, e = n = Object(r.b)([Object(o.m)("collapse")], e);
    }(u.b);

    e.a = l;
  }, function (t, e, n) {
    "use strict";

    var r = function () {
      function t(t) {
        void 0 === t && (t = []), this[Symbol.toStringTag] = Symbol("OrderedSet"), this.set = new Set(), this.list = [], this.addAll(t);
      }

      return Object.defineProperty(t.prototype, "size", {
        get: function get() {
          return this.set.size;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.clear = function () {
        this.set.clear(), this.list.splice(0, this.list.length);
      }, t.prototype.addAll = function (t) {
        var e = this;
        return t.forEach(function (t) {
          return e.add(t);
        }), this;
      }, t.prototype.add = function (t) {
        return this.set.has(t) ? this : (this.set.add(t), this.list.push(t), this);
      }, t.prototype.has = function (t) {
        return this.set.has(t);
      }, t.prototype.delete = function (t) {
        if (!this.set.delete(t)) return !1;
        var e = this.list.indexOf(t);
        return console.assert(e >= 0), this.list.splice(e, 1), !0;
      }, t.prototype.deleteAll = function (t) {
        var e = this;
        return t.reduce(function (t, n) {
          return e.delete(n) && t;
        }, !0);
      }, t.prototype.forEach = function (t, e) {
        this.list.forEach(function (e) {
          t.call(this, e, e, this);
        }, e);
      }, t.prototype[Symbol.iterator] = function () {
        return this.list[Symbol.iterator]();
      }, t;
    }();

    e.a = r;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(50),
        o = n(40),
        a = n(58),
        u = n(2),
        c = n(11),
        s = n(18);

    function l(t, e, n) {
      var r = n.column;
      return function (t) {
        return "string" == typeof t && t.indexOf(".") >= 0;
      }(r) ? function (t, e) {
        return e.hasOwnProperty(t) ? e[t] : t.split(".").reduce(function (t, e) {
          return void 0 === t ? t : /\d+/.test(e) ? t[+e] : t[e];
        }, e);
      }(r, t.v) : t.v[r];
    }

    var p = function (t) {
      function e(e, n) {
        void 0 === e && (e = []), void 0 === n && (n = {});
        var r = t.call(this, n) || this;
        return r.columns = e, r.rankingIndex = 0, r.ranks = new Map(), e.forEach(function (t) {
          t.accessor = t.accessor || l, t.label = t.label || t.column;
        }), r;
      }

      return Object(r.c)(e, t), e.prototype.rankAccessor = function (t, e, n, r) {
        for (var i = 0, o = 0, a = this.ranks.get(r.id) || []; o < a.length; o++) {
          var u = a[o],
              c = u.order.indexOf(t.i);
          if (c >= 0) return i + c + 1;
          i += u.order.length;
        }

        return -1;
      }, e.prototype.getMaxNestedSortingCriteria = function () {
        return 1;
      }, e.prototype.getMaxGroupColumns = function () {
        return 1;
      }, e.prototype.cloneRanking = function (t) {
        var e = this,
            n = this.nextRankingId(),
            r = new c.b(n, this.getMaxNestedSortingCriteria(), this.getMaxGroupColumns());
        return t && (this.ranks.set(n, this.ranks.get(t.id)), t.children.forEach(function (t) {
          e.push(r, t.desc);
        })), r;
      }, e.prototype.cleanUpRanking = function (t) {
        this.ranks.delete(t.id);
      }, e.prototype.sort = function (t) {
        var e = this,
            n = this.sortImpl(t);
        return Array.isArray(n) ? (this.ranks.set(t.id, n), n) : n.then(function (n) {
          return e.ranks.set(t.id, n), n;
        });
      }, e.prototype.pushDesc = function (t) {
        var e = t;
        e.accessor = e.accessor || l, e.label = t.label || e.column, this.columns.push(t), this.fire(s.d.EVENT_ADD_DESC, e);
      }, e.prototype.clearColumns = function () {
        this.clearRankings(), this.columns.splice(0, this.columns.length), this.fire(s.d.EVENT_CLEAR_DESC);
      }, e.prototype.getColumns = function () {
        return this.columns.slice();
      }, e.prototype.findDesc = function (t) {
        return this.columns.filter(function (e) {
          return e.column === t;
        })[0];
      }, e.prototype.toDescRef = function (t) {
        return void 0 !== t.column ? t.type + "@" + t.column : t;
      }, e.prototype.deriveDefault = function (t) {
        var e = this;
        void 0 === t && (t = !0);
        var n = this.pushRanking();
        return t && (this.getMaxGroupColumns() > 0 && n.push(this.create(Object(i.b)())), n.push(this.create(Object(o.a)())), this.multiSelections && n.push(this.create(Object(a.b)()))), this.getColumns().forEach(function (t) {
          var r = e.create(t);
          r && !Object(u.l)(r) && n.push(r);
        }), n;
      }, e.prototype.fromDescRef = function (t) {
        if ("string" == typeof t) return this.columns.find(function (e) {
          return e.type + "@" + e.column === t;
        });
        var e = this.columns.find(function (e) {
          return t.column === e.column && t.label === e.label && t.type === e.type;
        });
        return e || t;
      }, e.prototype.restore = function (e) {
        t.prototype.restore.call(this, e), this.rankingIndex = 1 + Math.max.apply(Math, this.getRankings().map(function (t) {
          return +t.id.substring(4);
        }));
      }, e.prototype.nextRankingId = function () {
        return "rank" + this.rankingIndex++;
      }, e;
    }(s.d);

    e.a = p;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return a;
    });

    var r = n(58),
        i = n(4),
        o = function () {
      function t() {
        this.title = "Default";
      }

      return t.prototype.canRender = function (t) {
        return t instanceof r.c;
      }, t.prototype.create = function (t, e) {
        return {
          template: "<div></div>",
          update: function update(n, r, i) {
            n.onclick = function (n) {
              if (n.preventDefault(), n.stopPropagation(), n.shiftKey) {
                var o = t.findMyRanker().id;
                if (a(e.provider, o, r.i, i, n.ctrlKey)) return;
              }

              t.toggleValue(r);
            };
          },
          render: i.i
        };
      }, t.prototype.createGroup = function (t) {
        return {
          template: "<div></div>",
          update: function update(e, n, r) {
            r.reduce(function (e, n) {
              return t.getValue(n) ? e + 1 : e;
            }, 0) >= r.length / 2 ? e.classList.add("lu-group-selected") : e.classList.remove("lu-group-selected"), e.onclick = function (n) {
              n.preventDefault(), n.stopPropagation();
              var i = e.classList.toggle("lu-group-selected");
              t.setValues(r, i);
            };
          }
        };
      }, t.prototype.createSummary = function (t, e) {
        return {
          template: '<div title="(Un)Select All" data-icon="unchecked"></div>',
          update: function update(n) {
            n.onclick = function (r) {
              r.stopPropagation(), "unchecked" === n.dataset.icon ? (e.provider.selectAllOf(t.findMyRanker()), n.dataset.icon = "checked") : (e.provider.setSelection([]), n.dataset.icon = "unchecked");
            };
          }
        };
      }, t;
    }();

    function a(t, e, n, r, i) {
      var o = t.getRankings().find(function (t) {
        return t.id === e;
      });
      if (!o) return !1;
      var a = t.getSelection();
      if (0 === a.length || a.includes(n)) return !1;
      var u = o.getOrder(),
          c = new Map(o.getOrder().map(function (t, e) {
        return [t, e];
      })),
          s = a.map(function (t) {
        var e = c.has(t) ? c.get(t) : 1 / 0;
        return {
          s: t,
          index: e,
          distance: Math.abs(r - e)
        };
      }).sort(function (t, e) {
        return t.distance - e.distance;
      })[0];
      if (!isFinite(s.distance)) return !1;
      if (i || (a.splice(0, a.length), a.push(s.s)), s.index < r) for (var l = s.index + 1; l <= r; ++l) {
        a.push(u[l]);
      } else for (l = r; l <= s.index; ++l) {
        a.push(u[l]);
      }
      return t.setSelection(a), !0;
    }

    e.a = o;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(52),
        o = n(82),
        a = n(83),
        u = n(77),
        c = n(93),
        s = n(92),
        l = function (t) {
      function e(e, n, r) {
        void 0 === r && (r = {});
        var l = t.call(this, e, n, r && !0 === r.ignoreUnsupportedBrowser) || this;
        if (l.options = Object(i.a)(), Object(o.a)(l.options, r, {
          violationChanged: function violationChanged(t, e) {
            return l.setViolation(e);
          }
        }), !l.isBrowserSupported) return l.spaceFilling = null, l.renderer = null, l.panel = null, l;
        l.node.classList.add("lu-taggle", "lu"), l.renderer = new s.a(n, l.node, l.options), console.assert(null != l.node.ownerDocument), l.panel = new u.b(l.renderer.ctx, l.node.ownerDocument, {
          collapseable: !l.options.sidePanelCollapsed || "collapsed",
          hierarchy: l.options.hierarchyIndicator && l.options.flags.advancedRankingFeatures
        }), l.renderer.pushUpdateAble(function (t) {
          return l.panel.update(t);
        }), l.node.insertBefore(l.panel.node, l.node.firstChild), l.panel.node.insertAdjacentHTML("afterbegin", '<div class="lu-rule-button-chooser lu-feature-advanced lu-feature-ui"><label>\n            <input type="checkbox">\n            <span>Overview</span>\n            <div></div>\n          </label></div>');
        var p = Object(c.a)(l.options);
        l.spaceFilling = l.node.querySelector(".lu-rule-button-chooser");
        var f = l.spaceFilling.querySelector("input");
        return f.onchange = function () {
          var t = l.spaceFilling.classList.toggle("chosen");
          self.setTimeout(function () {
            return l.renderer.switchRule(t ? p : null);
          });
        }, l.options.overviewMode && (f.checked = !0, l.spaceFilling.classList.toggle("chosen"), l.renderer.switchRule(p)), l.forward(l.renderer, a.a.EVENT_HIGHLIGHT_CHANGED + ".main"), l;
      }

      return Object(r.c)(e, t), e.prototype.setViolation = function (t) {
        t = t || "", this.spaceFilling && (this.spaceFilling.classList.toggle("violated", Boolean(t)), this.spaceFilling.lastElementChild.innerHTML = t.replace(/\n/g, "<br>"));
      }, e.prototype.destroy = function () {
        this.node.classList.remove("lu-taggle", "lu"), this.renderer && this.renderer.destroy(), this.panel && this.panel.destroy(), t.prototype.destroy.call(this);
      }, e.prototype.update = function () {
        this.renderer && this.renderer.update();
      }, e.prototype.setHighlight = function (t, e) {
        return void 0 === e && (e = !0), null != this.renderer && this.renderer.setHighlight(t, e);
      }, e.prototype.getHighlight = function () {
        return this.renderer ? this.renderer.getHighlight() : -1;
      }, e.prototype.enableHighlightListening = function (t) {
        this.renderer && this.renderer.enableHighlightListening(t);
      }, e.prototype.setDataProvider = function (e, n) {
        t.prototype.setDataProvider.call(this, e, n), this.renderer && (this.renderer.setDataProvider(e), this.update(), this.panel.update(this.renderer.ctx));
      }, e;
    }(a.a);

    e.a = l;
  }, function (t, e, n) {
    "use strict";

    var r = Array.isArray,
        i = Object.keys,
        o = Object.prototype.hasOwnProperty;

    t.exports = function t(e, n) {
      if (e === n) return !0;

      if (e && n && "object" == typeof e && "object" == typeof n) {
        var a,
            u,
            c,
            s = r(e),
            l = r(n);

        if (s && l) {
          if ((u = e.length) != n.length) return !1;

          for (a = u; 0 != a--;) {
            if (!t(e[a], n[a])) return !1;
          }

          return !0;
        }

        if (s != l) return !1;
        var p = e instanceof Date,
            f = n instanceof Date;
        if (p != f) return !1;
        if (p && f) return e.getTime() == n.getTime();
        var d = e instanceof RegExp,
            h = n instanceof RegExp;
        if (d != h) return !1;
        if (d && h) return e.toString() == n.toString();
        var g = i(e);
        if ((u = g.length) !== i(n).length) return !1;

        for (a = u; 0 != a--;) {
          if (!o.call(n, g[a])) return !1;
        }

        for (a = u; 0 != a--;) {
          if (!t(e[c = g[a]], n[c])) return !1;
        }

        return !0;
      }

      return e != e && n != n;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(13),
        o = n(55),
        a = n(60),
        u = n(18),
        c = n(74),
        s = function (t) {
      function e(n, r, i) {
        var a = t.call(this) || this;
        return a.data = n, a.isDynamicLeafHeight = !1, a.rule = null, a.levelOfDetail = null, a.resizeListener = function () {
          return Object(o.a)(function () {
            return a.update();
          }, 100);
        }, a.options = {
          violationChanged: function violationChanged() {},
          rowPadding: 2
        }, a.renderer = new c.a(n, r, Object.assign({}, i, {
          dynamicHeight: function dynamicHeight(t, e) {
            var n = a.dynamicHeight(t);
            return n || (i.dynamicHeight ? i.dynamicHeight(t, e) : null);
          },
          levelOfDetail: function levelOfDetail(t) {
            return a.levelOfDetail ? a.levelOfDetail(t) : "high";
          }
        })), a.renderer.style.addRule("taggle_lod_rule", "\n      #" + a.renderer.idPrefix + " [data-lod=low][data-agg=detail]:hover {\n        /* show regular height for hovered rows in low + medium LOD */\n        height: " + i.rowHeight + "px !important;\n      }\n    "), a.data.on(u.d.EVENT_SELECTION_CHANGED + ".rule", function () {
          a.isDynamicLeafHeight && a.update();
        }), a.forward(a.renderer, e.EVENT_HIGHLIGHT_CHANGED + ".main"), window.addEventListener("resize", a.resizeListener, {
          passive: !0
        }), a;
      }

      return Object(r.c)(e, t), Object.defineProperty(e.prototype, "ctx", {
        get: function get() {
          return this.renderer.ctx;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.pushUpdateAble = function (t) {
        this.renderer.pushUpdateAble(t);
      }, e.prototype.dynamicHeight = function (t) {
        var e = this;
        if (!this.rule) return this.levelOfDetail = null, null;
        var n = this.renderer ? this.renderer.node.querySelector("main").clientHeight : 100,
            r = this.rule.apply(t, n, new Set(this.data.getSelection()));
        this.isDynamicLeafHeight = "function" == typeof r.item, this.options.violationChanged(this.rule, r.violation || "");

        var i = function i(t) {
          return Object(a.b)(t) ? "number" == typeof r.group ? r.group : r.group(t) : "number" == typeof r.item ? r.item : r.item(t);
        };

        return this.levelOfDetail = function (n) {
          var r = t[n];
          return e.rule ? e.rule.levelOfDetail(r, i(r)) : "high";
        }, {
          defaultHeight: "number" == typeof r.item ? r.item : NaN,
          height: i,
          padding: 0
        };
      }, e.prototype.createEventList = function () {
        return t.prototype.createEventList.call(this).concat([e.EVENT_HIGHLIGHT_CHANGED]);
      }, e.prototype.on = function (e, n) {
        return t.prototype.on.call(this, e, n);
      }, e.prototype.zoomOut = function () {
        this.renderer.zoomOut();
      }, e.prototype.zoomIn = function () {
        this.renderer.zoomIn();
      }, e.prototype.switchRule = function (t) {
        this.rule !== t && (this.rule = t, this.update());
      }, e.prototype.destroy = function () {
        this.renderer.destroy(), window.removeEventListener("resize", this.resizeListener);
      }, e.prototype.update = function () {
        this.renderer.update();
      }, e.prototype.setDataProvider = function (t) {
        var e = this;
        this.data && this.data.on(u.d.EVENT_SELECTION_CHANGED + ".rule", null), this.data = t, this.data.on(u.d.EVENT_SELECTION_CHANGED + ".rule", function () {
          e.isDynamicLeafHeight && e.update();
        }), this.renderer.setDataProvider(t), this.update();
      }, e.prototype.setHighlight = function (t, e) {
        return this.renderer.setHighlight(t, e);
      }, e.prototype.getHighlight = function () {
        return this.renderer.getHighlight();
      }, e.prototype.enableHighlightListening = function (t) {
        this.renderer.enableHighlightListening(t);
      }, e.EVENT_HIGHLIGHT_CHANGED = c.a.EVENT_HIGHLIGHT_CHANGED, e;
    }(i.a);

    e.a = s;
  }, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    var r = n(60);

    function i(t) {
      return {
        apply: function apply(e, n, i) {
          var o = function (e, n, i) {
            var o = n - t.rowHeight - 5,
                a = e.filter(function (t) {
              return !Object(r.b)(t);
            }),
                u = e.length - a.length,
                c = a.reduce(function (t, e) {
              return t + ("last" === e.meta || "first last" === e.meta ? 1 : 0);
            }, 0),
                s = a.reduce(function (t, e) {
              return t + (i.has(e.i) ? 1 : 0);
            }, 0),
                l = a.length - s,
                p = u + c;
            if (l <= 0) return {
              height: t.rowHeight,
              violation: ""
            };
            var f = (o - u * t.groupHeight - p * t.groupPadding - s * t.rowHeight) / l;
            return f < 1 ? {
              height: 1,
              violation: "Not possible to fit all rows on the screen. Set filters or aggregate groups to make it fit again."
            } : f > t.rowHeight ? {
              height: t.rowHeight,
              violation: ""
            } : {
              height: f,
              violation: ""
            };
          }(e, n, i),
              a = o.violation,
              u = o.height;

          return {
            item: function item(e) {
              return i.has(e.i) ? t.rowHeight : u;
            },
            group: t.groupHeight,
            violation: a
          };
        },
        levelOfDetail: function levelOfDetail(e, n) {
          return n >= .9 * (Object(r.b)(e) ? t.groupHeight : t.rowHeight) ? "high" : "low";
        }
      };
    }
  },, function (t, e) {}, function (t, e, n) {
    "use strict";

    var r = n(14);
    n.d(e, "c", function () {
      return r.IDialogOptions;
    }), n.d(e, "a", function () {
      return r.c;
    }), n.d(e, "b", function () {
      return r.IDialogContext;
    });
  }, function (t, e, n) {
    "use strict";

    var r = n(77);
    n.d(e, "f", function () {
      return r.b;
    }), n.d(e, "d", function () {
      return r.ISidePanelOptions;
    });
    var i = n(48);
    n.d(e, "e", function () {
      return i.d;
    }), n.d(e, "a", function () {
      return i.IGroupSearchItem;
    }), n.d(e, "b", function () {
      return i.IItem;
    }), n.d(e, "c", function () {
      return i.ISearchBoxOptions;
    });
  }, function (t, e) {}, function (t, e, n) {
    "use strict";

    var r = n(0),
        i = n(71),
        o = n(72),
        a = n(73),
        u = n(90),
        c = function () {
      function t(t, e) {
        this.desc = {
          column: e,
          type: t,
          label: e ? e[0].toUpperCase() + e.slice(1) : t
        };
      }

      return t.prototype.label = function (t) {
        return this.desc.label = t, this;
      }, t.prototype.description = function (t) {
        return this.desc.description = t, this;
      }, t.prototype.frozen = function () {
        return this.desc.frozen = !0, this;
      }, t.prototype.renderer = function (t, e, n) {
        return t && (this.desc.renderer = t), e && (this.desc.groupRenderer = e), n && (this.desc.summaryRenderer = n), this;
      }, t.prototype.custom = function (t, e) {
        return this.desc[t] = e, this;
      }, t.prototype.width = function (t) {
        return this.desc.width = t, this;
      }, t.prototype.color = function (t) {
        return this;
      }, t.prototype.asArray = function (t) {
        console.assert(["boolean", "categorical", "date", "number", "string", "link"].includes(this.desc.type)), this.desc.type += "s";
        var e = this.desc;
        return Array.isArray(t) ? (e.labels = t, e.dataLength = t.length) : "number" == typeof t && (e.dataLength = t), this;
      }, t.prototype.asMap = function () {
        return console.assert(["categorical", "date", "number", "string", "link"].includes(this.desc.type)), this.desc.type += "Map", this;
      }, t.prototype.build = function (t) {
        return this.desc;
      }, t;
    }(),
        s = c;

    function l(t, e) {
      return new c(t, e);
    }

    var p = function () {
      function t() {
        this.options = {
          renderers: {},
          toolbar: {},
          flags: {}
        };
      }

      return t.prototype.animated = function (t) {
        return this.options.animated = t, this;
      }, t.prototype.labelRotation = function (t) {
        return this.options.labelRotation = t, this;
      }, t.prototype.sidePanel = function (t, e) {
        return void 0 === e && (e = !1), this.options.sidePanel = t, this.options.sidePanelCollapsed = e, this;
      }, t.prototype.hierarchyIndicator = function (t) {
        return this.options.hierarchyIndicator = t, this;
      }, t.prototype.defaultSlopeGraphMode = function (t) {
        return this.options.defaultSlopeGraphMode = t, this;
      }, t.prototype.summaryHeader = function (t) {
        return this.options.summaryHeader = t, this;
      }, t.prototype.expandLineOnHover = function (t) {
        return this.options.expandLineOnHover = t, this;
      }, t.prototype.overviewMode = function () {
        return this.options.overviewMode = !0, this;
      }, t.prototype.ignoreUnsupportedBrowser = function () {
        return this.options.ignoreUnsupportedBrowser = !0, this;
      }, t.prototype.registerRenderer = function (t, e) {
        return this.options.renderers[t] = e, this;
      }, t.prototype.registerToolbarAction = function (t, e) {
        return this.options.toolbar[t] = e, this;
      }, t.prototype.registerToolbarDialogAddon = function (t, e) {
        return this.options.toolbar[t] = e, this;
      }, t.prototype.rowHeight = function (t, e) {
        return this.options.rowHeight = t, this.options.rowPadding = e, this;
      }, t.prototype.groupRowHeight = function (t, e) {
        return this.options.groupHeight = t, this.options.groupPadding = e, this;
      }, t.prototype.dynamicHeight = function (t) {
        return this.options.dynamicHeight = t, this;
      }, t.prototype.disableAdvancedRankingFeatures = function () {
        return this.options.flags.advancedRankingFeatures = !1, this;
      }, t.prototype.disableAdvancedModelFeatures = function () {
        return this.options.flags.advancedModelFeatures = !1, this;
      }, t.prototype.disableAdvancedUIFeatures = function () {
        return this.options.flags.advancedUIFeatures = !1, this;
      }, t;
    }(),
        f = n(67),
        d = n(69),
        h = n(68),
        g = n(80),
        b = n(43),
        m = n(75),
        y = n(76),
        v = n(58),
        E = n(62),
        O = n(50),
        C = n(40),
        _ = function () {
      function t() {
        this.columns = [], this.sort = [], this.groups = [];
      }

      return t.prototype.sortBy = function (t, e) {
        if (void 0 === e && (e = !0), t.includes(":")) {
          var n = t.indexOf(":");
          e = t.slice(n + 1), t = t.slice(0, n);
        }

        return this.sort.push({
          column: t,
          asc: !0 === e || "a" === String(e)[0]
        }), this;
      }, t.prototype.groupBy = function () {
        for (var t, e = [], n = 0; n < arguments.length; n++) {
          e[n] = arguments[n];
        }

        return (t = this.groups).push.apply(t, e), this;
      }, t.prototype.column = function (t) {
        if ("string" == typeof t) {
          switch (t) {
            case "_aggregate":
              return this.aggregate();

            case "_selection":
              return this.selection();

            case "_group":
              return this.group();

            case "_rank":
              return this.rank();

            case "_*":
              return this.supportTypes();

            case "*":
              return this.allColumns();
          }

          return this.columns.push(t), this;
        }

        var e = t.label || null;

        switch (t.type) {
          case "impose":
            return this.impose(e, t.column, t.categoricalColumn);

          case "min":
          case "max":
          case "median":
          case "mean":
            return console.assert(t.columns.length >= 2), this.reduce.apply(this, Object(r.d)([e, t.type, t.columns[0], t.columns[1]], t.columns.slice(2)));

          case "nested":
            return console.assert(t.columns.length >= 1), this.nested.apply(this, Object(r.d)([e, t.columns[0]], t.columns.slice(1)));

          case "script":
            return console.assert(t.columns.length >= 2), this.scripted.apply(this, Object(r.d)([e, t.code, t.columns[0], t.columns[1]], t.columns.slice(2)));

          case "weightedSum":
            console.assert(t.columns.length >= 2), console.assert(t.columns.length === t.weights.length);
            var n = [];
            return t.columns.slice(2).forEach(function (e, r) {
              n.push(e), n.push(t.weights[r + 2]);
            }), this.weightedSum.apply(this, Object(r.d)([e, t.columns[0], t.weights[0], t.columns[1], t.weights[1]], n));
        }

        return console.error("invalid column type: ", t), this;
      }, t.prototype.impose = function (t, e, n) {
        return this.columns.push({
          desc: function desc(n) {
            var r = n.getColumns().find(function (t) {
              return t.label === e || t.column === e;
            });

            switch (r ? r.type : "") {
              case "boxplot":
                return Object(f.a)(t || void 0);

              case "numbers":
                return Object(d.a)(t || void 0);

              default:
                return Object(h.a)(t || void 0);
            }
          },
          columns: [e, n]
        }), this;
      }, t.prototype.nested = function (t, e) {
        for (var n = [], r = 2; r < arguments.length; r++) {
          n[r - 2] = arguments[r];
        }

        return this.columns.push({
          desc: Object(g.a)(t || void 0),
          columns: [e].concat(n)
        }), this;
      }, t.prototype.weightedSum = function (t, e, n, r, i) {
        for (var o = [], a = 5; a < arguments.length; a++) {
          o[a - 5] = arguments[a];
        }

        var u = [n, i].concat(o.filter(function (t, e) {
          return e % 2 == 1;
        }));
        return this.columns.push({
          desc: Object(b.a)(t || void 0),
          columns: [e, r].concat(o.filter(function (t, e) {
            return e % 2 == 0;
          })),
          post: function post(t) {
            t.setWeights(u);
          }
        }), this;
      }, t.prototype.reduce = function (t, e, n, r) {
        for (var i = [], o = 4; o < arguments.length; o++) {
          i[o - 4] = arguments[o];
        }

        return this.columns.push({
          desc: Object(m.c)(t || void 0),
          columns: [n, r].concat(i),
          post: function post(t) {
            t.setReduce(e);
          }
        }), this;
      }, t.prototype.scripted = function (t, e, n, r) {
        for (var i = [], o = 4; o < arguments.length; o++) {
          i[o - 4] = arguments[o];
        }

        return this.columns.push({
          desc: Object(y.c)(t || void 0),
          columns: [n, r].concat(i),
          post: function post(t) {
            t.setScript(e);
          }
        }), this;
      }, t.prototype.selection = function () {
        return this.columns.push({
          desc: Object(v.b)(),
          columns: []
        }), this;
      }, t.prototype.group = function () {
        return this.columns.push({
          desc: Object(E.b)(),
          columns: []
        }), this;
      }, t.prototype.aggregate = function () {
        return this.columns.push({
          desc: Object(O.b)(),
          columns: []
        }), this;
      }, t.prototype.rank = function () {
        return this.columns.push({
          desc: Object(C.a)(),
          columns: []
        }), this;
      }, t.prototype.supportTypes = function () {
        return this.aggregate().rank().selection();
      }, t.prototype.allColumns = function () {
        return this.columns.push(t.ALL_MAGIC_FLAG), this;
      }, t.prototype.build = function (e) {
        var n = e.pushRanking(),
            r = e.getColumns(),
            i = function i(t) {
          return r.find(function (e) {
            return e.label === t || e.column === t;
          });
        };

        this.columns.forEach(function (o) {
          if (o !== t.ALL_MAGIC_FLAG) {
            if ("string" != typeof o) {
              var a = e.create("function" == typeof o.desc ? o.desc(e) : o.desc);
              n.push(a), o.columns.forEach(function (t) {
                var n = i(t),
                    r = n ? e.create(n) : null;
                r ? a.push(r) : console.warn("invalid column: ", t);
              }), o.post && o.post(a);
            } else !function (t) {
              var r = i(t);
              r ? e.push(n, r) : console.warn("invalid column: ", t);
            }(o);
          } else r.forEach(function (t) {
            return e.push(n, t);
          });
        });
        var o = n.children,
            a = [];
        this.groups.forEach(function (t) {
          var r = o.find(function (e) {
            return e.desc.label === t || e.desc.column === t;
          });
          if (r) a.push(r);else {
            var u = i(t);
            u && e.push(n, u) || console.warn("invalid group criteria column: ", t);
          }
        }), a.length > 0 && n.setGroupCriteria(a);
        var u = [];
        return this.sort.forEach(function (t) {
          var r = t.column,
              a = t.asc,
              c = o.find(function (t) {
            return t.desc.label === r || t.desc.column === r;
          });
          if (c) u.push({
            col: c,
            asc: a
          });else {
            var s = i(r);
            s && e.push(n, s) || console.warn("invalid sort criteria column: ", r);
          }
        }), u.length > 0 && n.setSortCriteria(u), n;
      }, t.ALL_MAGIC_FLAG = "*", t;
    }(),
        T = _;

    function N() {
      return new _();
    }

    var D = function (t) {
      function e(e) {
        var n = t.call(this) || this;
        return n.data = e, n.columns = [], n.providerOptions = {
          columnTypes: {}
        }, n.rankBuilders = [], n._deriveColors = !1, n;
      }

      return Object(r.c)(e, t), e.prototype.singleSelection = function () {
        return this.providerOptions.multiSelection = !1, this;
      }, e.prototype.filterGlobally = function () {
        return this.providerOptions.filterGlobally = !0, this;
      }, e.prototype.noCriteriaLimits = function () {
        return this.providerOptions.maxGroupColumns = 1 / 0, this.providerOptions.maxNestedSortingCriteria = 1 / 0, this;
      }, e.prototype.limitCriteria = function (t, e) {
        return this.providerOptions.maxGroupColumns = t, this.providerOptions.maxNestedSortingCriteria = e, this;
      }, e.prototype.deriveColumns = function () {
        for (var t, e = [], n = 0; n < arguments.length; n++) {
          e[n] = arguments[n];
        }

        return (t = this.columns).push.apply(t, Object(i.d)(this.data, {
          columns: e
        })), this;
      }, e.prototype.deriveColors = function () {
        return this._deriveColors = !0, this;
      }, e.prototype.registerColumnType = function (t, e) {
        return this.providerOptions.columnTypes[t] = e, this;
      }, e.prototype.column = function (t) {
        return this.columns.push(t instanceof s ? t.build.bind(t) : t), this;
      }, e.prototype.restore = function (t) {
        return this.rankBuilders.push(function (e) {
          return e.restore(t);
        }), this;
      }, e.prototype.defaultRanking = function (t) {
        return void 0 === t && (t = !0), this.rankBuilders.push(function (e) {
          return e.deriveDefault(t);
        }), this;
      }, e.prototype.ranking = function (t) {
        return this.rankBuilders.push(t instanceof T ? t.build.bind(t) : t), this;
      }, e.prototype.buildData = function () {
        var t = this,
            e = this.columns.map(function (e) {
          return "function" == typeof e ? e(t.data) : e;
        });
        this._deriveColors && Object(i.c)(e);
        var n = new o.a(this.data, e, this.providerOptions);
        return 0 === this.rankBuilders.length && this.defaultRanking(), this.rankBuilders.forEach(function (t) {
          return t(n);
        }), n;
      }, e.prototype.build = function (t) {
        return new a.a(t, this.buildData(), this.options);
      }, e.prototype.buildTaggle = function (t) {
        return new u.a(t, this.buildData(), this.options);
      }, e;
    }(p);

    function R(t) {
      return new D(t);
    }

    var w = function (t) {
      function e(e) {
        return t.call(this, "categorical", e) || this;
      }

      return Object(r.c)(e, t), e.prototype.asOrdinal = function () {
        return this.desc.type = "ordinal", this;
      }, e.prototype.categories = function (t) {
        return this.desc.categories = t, this;
      }, e.prototype.missingCategory = function (t) {
        return this.desc.missingCategory = t, this;
      }, e.prototype.asSet = function (t) {
        return t && (this.desc.separator = t), this.desc.type = "set", this;
      }, e.prototype.derive = function (t) {
        var e = this,
            n = new Set(),
            r = "set" === this.desc.type,
            o = this.desc.separator || ";",
            a = function a(t) {
          return "string" == typeof t && "" !== t ? t : null != t && "string" == typeof t.value && "" !== t.value ? t.value : null;
        };

        t.forEach(function (t) {
          var i = t[e.desc.column];
          if (Array.isArray(i)) i.forEach(function (t) {
            return n.add(a(t));
          });else if (null != i && "" !== i) {
            (r ? [i.toString()] : i.toString().split(o)).forEach(function (t) {
              return n.add(a(t));
            });
          }
        }), this.categories(Object(i.b)(n));
      }, e.prototype.build = function (e) {
        return this.desc.categories || this.derive(e), t.prototype.build.call(this, e);
      }, e;
    }(s);

    function A(t, e) {
      var n = new w(t);
      return e && n.categories(e), n;
    }

    var M = n(12),
        L = function (t) {
      function e(e) {
        return t.call(this, "number", e) || this;
      }

      return Object(r.c)(e, t), e.prototype.mapping = function (t, e, n) {
        return "linear" === t ? (this.desc.domain = e, void (n && (this.desc.range = n))) : (this.desc.map = {
          type: t,
          domain: e,
          range: n || [0, 1]
        }, this);
      }, e.prototype.color = function (t) {
        return this.colorMapping(t);
      }, e.prototype.colorMapping = function (t) {
        return this.desc.colorMapping = t, this;
      }, e.prototype.scripted = function (t, e) {
        return this.desc.map = {
          domain: e,
          code: t,
          type: "script"
        }, this;
      }, e.prototype.asArray = function (e, n) {
        return n && (this.desc.sort = n), t.prototype.asArray.call(this, e);
      }, e.prototype.asMap = function (e) {
        return e && (this.desc.sort = e), t.prototype.asMap.call(this);
      }, e.prototype.asBoxPlot = function (t) {
        return t && (this.desc.sort = t), this.desc.type = "boxplot", this;
      }, e.prototype.derive = function (t) {
        var e = this.desc.column,
            n = function n(t, e) {
          var n = [];
          return (Array.isArray(t) ? t : [t]).forEach(function (t) {
            "number" != typeof t || isNaN(t) || n.push(t), null == t || "number" != typeof t.value || isNaN(t.value) || n.push(t.value), null == t || "number" != typeof t[e] || isNaN(t[e]) || n.push(t[e]);
          }), n;
        };

        return [Object(M.i)(t, function (t) {
          var r = t[e],
              i = n(r, "min");
          return 0 === i.length ? 1 / 0 : Object(M.i)(i);
        }), Object(M.f)(t, function (t) {
          var r = t[e],
              i = n(r, "max");
          return 0 === i.length ? -1 / 0 : Object(M.f)(i);
        })];
      }, e.prototype.build = function (e) {
        if (this.desc.map || this.desc.domain) {
          var n = this.desc.domain || this.desc.map.domain;

          if (isNaN(n[0]) || isNaN(n[1])) {
            var r = this.derive(e);
            isNaN(n[0]) && (n[0] = r[0]), isNaN(n[1]) && (n[1] = r[1]);
          }
        } else this.mapping("linear", this.derive(e));

        return t.prototype.build.call(this, e);
      }, e;
    }(s);

    function j(t, e) {
      var n = new L(t);
      return e && n.mapping("linear", e), n;
    }

    var x = function (t) {
      function e(e) {
        return t.call(this, "string", e) || this;
      }

      return Object(r.c)(e, t), e.prototype.editable = function () {
        return this.desc.type = "annotate", this;
      }, e.prototype.alignment = function (t) {
        return this.desc.alignment = t, this;
      }, e.prototype.html = function () {
        return this.desc.escape = !1, this;
      }, e.prototype.pattern = function (t, e) {
        return this.desc.type = "link", this.desc.pattern = t, e && (this.desc.patternTemplates = e), this;
      }, e;
    }(s);

    function S(t) {
      return new x(t);
    }

    var I = function (t) {
      function e(e) {
        return t.call(this, "date", e) || this;
      }

      return Object(r.c)(e, t), e.prototype.format = function (t, e) {
        return this.desc.dateFormat = t, e && (this.desc.dateParse = e), this;
      }, e;
    }(s);

    function V(t) {
      return new I(t);
    }

    var k = function (t) {
      function e(e) {
        return t.call(this, "hierarchy", e) || this;
      }

      return Object(r.c)(e, t), e.prototype.hierarchy = function (t, e) {
        return this.desc.hierarchy = t, e && (this.desc.hierarchySeparator = e), this;
      }, e.prototype.build = function (e) {
        return console.assert(Boolean(this.desc.hierarchy)), t.prototype.build.call(this, e);
      }, e;
    }(s);

    function H(t, e) {
      var n = new k(t);
      return e && n.hierarchy(e), n;
    }

    var P = function (t) {
      function e() {
        return t.call(this, "actions", "") || this;
      }

      return Object(r.c)(e, t), e.prototype.action = function (t) {
        return this.actions([t]);
      }, e.prototype.actions = function (t) {
        var e;
        return this.desc.actions || (this.desc.actions = []), (e = this.desc.actions).push.apply(e, t), this;
      }, e.prototype.groupAction = function (t) {
        return this.groupActions([t]);
      }, e.prototype.groupActions = function (t) {
        var e;
        return this.desc.groupActions || (this.desc.groupActions = []), (e = this.desc.groupActions).push.apply(e, t), this;
      }, e;
    }(s);

    function G() {
      return new P();
    }

    function F(t, e) {
      var n = t.column,
          r = {
        column: n,
        type: t.type,
        label: n ? n[0].toUpperCase() + n.slice(1) : t.type
      };

      if (["label", "description", "frozen", "width", "renderer", "groupRenderer", "summaryRenderer", "visible", "fixed"].forEach(function (e) {
        t.hasOwnProperty(e) && (r[e] = t[e]);
      }), t.custom && Object.assign(r, t.custom), t.asMap && (console.assert(["categorical", "date", "number", "string", "link"].includes(r.type)), r.type += "Map"), null != t.asArray) {
        console.assert(["boolean", "categorical", "date", "number", "string", "link"].includes(r.type)), r.type += "s";
        var i = r,
            o = t.asArray;
        Array.isArray(o) ? (i.labels = o, i.dataLength = o.length) : "number" == typeof o && (i.dataLength = o);
      }

      return r;
    }

    function U(t, e) {
      var n = N();
      t.sortBy && (r = Array.isArray(t.sortBy) ? t.sortBy : [t.sortBy]).forEach(function (t) {
        "string" == typeof t ? n.sortBy(t) : n.sortBy(t.column, t.asc);
      });

      if (t.groupBy) {
        var r = Array.isArray(t.groupBy) ? t.groupBy : [t.groupBy];
        n.groupBy.apply(n, r);
      }

      return t.columns && t.columns.forEach(function (t) {
        return n.column(t);
      }), n.build(e);
    }

    var B = n(42);

    function Y(t, e) {
      var n = {};
      return e.forEach(function (e) {
        t.hasOwnProperty(e) && (n[e] = t[e]);
      }), n;
    }

    function W(t, e, n) {
      return n.every(function (t) {
        return !e(t);
      }) ? null : Y(t, n);
    }

    var q = ["singleSelection", "filterGlobally", "noCriteriaLimits", "maxGroupColumns", "maxNestedSortingCriteria", "columnTypes"],
        z = ["animated", "sidePanel", "sidePanelCollapsed", "hierarchyIndicator", "defaultSlopeGraphMode", "summaryHeader", "expandLineOnHover", "overviewMode", "renderers", "toolbar", "rowHeight", "rowPadding", "groupHeight", "groupPadding", "dynamicHeight", "labelRotation", "ignoreUnsupportedBrowser"],
        K = function () {
      function t(t) {
        var e = this;
        this.adapter = t, this.data = null, this.instance = null, this.prevRankings = null, this.prevColumns = null, this.prevHighlight = null, this.onSelectionChanged = function (t) {
          e.props.onSelectionChanged && !Object(B.a)(e.props.selection, t) && e.props.onSelectionChanged(t);
        }, this.onHighlightChanged = function (t) {
          (null != e.prevHighlight ? e.prevHighlight : -1) !== t && (e.prevHighlight = t, e.props.onHighlightChanged && e.props.onHighlightChanged(t));
        };
      }

      return Object.defineProperty(t.prototype, "props", {
        get: function get() {
          return this.adapter.props();
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.componentDidMount = function () {
        this.data = this.buildProvider(), this.instance = this.adapter.createInstance(this.data, Y(this.props, z)), this.instance.on(a.a.EVENT_HIGHLIGHT_CHANGED, this.onHighlightChanged);
      }, t.prototype.resolveColumnDescs = function (t) {
        var e = this.adapter.columnDescs(t),
            n = 0 === e.length || Boolean(this.props.deriveColumns),
            r = Array.isArray(this.props.deriveColumns) ? this.props.deriveColumns : [];
        return {
          columns: e,
          deriveColors: Boolean(this.props.deriveColors),
          deriveColumns: n,
          deriveColumnNames: r
        };
      }, t.prototype.resolveRankings = function () {
        var t = this.adapter.rankingBuilders();
        return {
          builders: t,
          restore: this.props.restore,
          derive: 0 === t.length && !this.props.restore || Boolean(this.props.defaultRanking),
          supportTypes: "noSupportTypes" !== this.props.defaultRanking
        };
      }, t.prototype.buildColumns = function (t, e) {
        this.prevColumns = e;
        var n = e.columns.map(function (t) {
          return Object.assign({}, t);
        });
        return e.deriveColumns && n.push.apply(n, Object(i.d)(t, {
          columns: e.deriveColumnNames
        })), e.deriveColors && Object(i.c)(n), n;
      }, t.prototype.buildRankings = function (t, e) {
        t.clearRankings(), this.prevRankings = e, e.derive && t.deriveDefault(e.supportTypes), e.restore && t.restore(e.restore), e.builders.forEach(function (e) {
          return U(e, t);
        });
      }, t.prototype.buildProvider = function () {
        var t = this.buildColumns(this.props.data, this.resolveColumnDescs(this.props.data)),
            e = new o.a(this.props.data, t, Y(this.props, q));
        return this.buildRankings(e, this.resolveRankings()), e.setSelection(this.props.selection || []), e.on(o.a.EVENT_SELECTION_CHANGED, this.onSelectionChanged), e;
      }, t.prototype.updateLineUp = function (t, e) {
        var n = W(this.props, t, z);
        return n ? (this.instance && this.instance.destroy(), this.instance = this.adapter.createInstance(this.data, n), this.prevHighlight = null == this.props.highlight ? -1 : this.props.highlight, this.instance.setHighlight(this.prevHighlight), this.instance.on(a.a.EVENT_HIGHLIGHT_CHANGED, this.onHighlightChanged), !0) : (e && this.instance.setDataProvider(this.data), !!(e || null != this.props.highlight && this.prevHighlight !== this.props.highlight) && (this.prevHighlight = null == this.props.highlight ? -1 : this.props.highlight, this.instance.on(a.a.EVENT_HIGHLIGHT_CHANGED, null), this.instance.setHighlight(this.prevHighlight), this.instance.on(a.a.EVENT_HIGHLIGHT_CHANGED, this.onHighlightChanged), !0));
      }, t.prototype.updateProvider = function (t) {
        var e = this;
        if (W(this.props, t, q) || !this.data || t("data")) return this.data = this.buildProvider(), !0;
        var n = this.resolveRankings(),
            r = this.resolveColumnDescs(this.props.data),
            i = !Object(B.a)(this.prevColumns, r);

        if (i) {
          var a = this.buildColumns(this.props.data, r);
          this.data.clearColumns(), a.forEach(function (t) {
            return e.data.pushDesc(t);
          });
        }

        return !i && Object(B.a)(n, this.prevRankings) || this.buildRankings(this.data, n), this.data.on(o.a.EVENT_SELECTION_CHANGED, null), this.data.setSelection(this.props.selection || []), this.data.on(o.a.EVENT_SELECTION_CHANGED, this.onSelectionChanged), !1;
      }, t.prototype.componentDidUpdate = function (t) {
        var e = this.updateProvider(t);
        this.updateLineUp(t, e);
      }, t.prototype.componentWillUnmount = function () {
        this.instance && (this.instance.destroy(), this.instance = null), this.data = null;
      }, t;
    }(),
        X = {
      buildString: function buildString(t) {
        var e = F(Object(r.a)(Object(r.a)({}, t), {
          type: "string"
        }));
        return ["pattern", "patternTemplate", "alignment"].forEach(function (n) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }), t.editable && (e.type = "annotate"), t.pattern && (e.type = "link"), t.html && (e.escape = !1), e;
      },
      buildNumber: function buildNumber(t, e) {
        var n = F(Object(r.a)(Object(r.a)({}, t), {
          type: "number"
        })),
            i = t.domain ? t.domain : Object(M.d)(e, function (t) {
          return t[n.column];
        });
        return t.hasOwnProperty("color") && (n.colorMapping = t.color), ["sort", "colorMapping"].forEach(function (e) {
          t.hasOwnProperty(e) && (n[e] = t[e]);
        }), t.scripted ? n.map = {
          domain: i,
          code: t.scripted,
          type: "script"
        } : t.mapping && "linear" !== t.mapping ? n.map = {
          type: t.mapping,
          domain: i,
          range: t.range || [0, 1]
        } : (n.domain = i, t.range && (n.range = t.range)), n;
      },
      buildHierarchy: function buildHierarchy(t) {
        var e = F(Object(r.a)(Object(r.a)({}, t), {
          type: "hierarchy"
        }));
        return ["hierarchy", "hierarchySeparator"].forEach(function (n) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }), e;
      },
      buildDate: function buildDate(t) {
        var e = F(Object(r.a)(Object(r.a)({}, t), {
          type: "date"
        }));
        return ["dateFormat", "dateParse"].forEach(function (n) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }), e;
      },
      buildCategorical: function buildCategorical(t, e) {
        var n = F(Object(r.a)(Object(r.a)({}, t), {
          type: "categorical"
        }));
        if (t.asOrdinal && (n.type = "ordinal"), t.missingCategory && (n.missingCategory = t.missingCategory), t.asSet && ("string" == typeof t.asSet && (n.separator = t.asSet), n.type = "set"), t.categories) n.categories = t.categories;else {
          var i = new Set(e.map(function (t) {
            return t[n.column];
          }));
          n.categories = Array.from(i).sort();
        }
        return n;
      },
      buildActions: function buildActions(t) {
        var e = F(Object(r.a)(Object(r.a)({}, t), {
          type: "actions"
        }));
        return ["actions", "groupActions"].forEach(function (n) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }), e;
      },
      build: F,
      buildGeneric: function buildGeneric(t) {
        return t.column;
      },
      buildWeightedSumRanking: function buildWeightedSumRanking(t, e) {
        var n = {
          type: "weightedSum",
          columns: e.map(function (t) {
            return t.column;
          }),
          weights: e.map(function (t) {
            return t.weight;
          })
        };
        return t.label && (n.label = t.label), n;
      },
      buildSupportRanking: function buildSupportRanking(t) {
        return "_" + t.type;
      },
      buildScriptRanking: function buildScriptRanking(t, e) {
        var n = {
          type: "script",
          code: t.code,
          columns: e
        };
        return t.label && (n.label = t.label), n;
      },
      buildReduceRanking: function buildReduceRanking(t, e) {
        var n = {
          type: t.type,
          columns: e
        };
        return t.label && (n.label = t.label), n;
      },
      buildRanking: U,
      buildNestedRanking: function buildNestedRanking(t, e) {
        var n = {
          type: "nested",
          columns: e
        };
        return t.label && (n.label = t.label), n;
      },
      buildImposeRanking: function buildImposeRanking(t) {
        return Object.assign({
          type: "impose"
        }, t);
      },
      buildAllColumnsRanking: function buildAllColumnsRanking() {
        return "*";
      },
      equal: B.a,
      isSame: W,
      isTypeInstance: function isTypeInstance(t, e) {
        for (var n = t; n && n !== e;) {
          n = n.__proto__;
        }

        return n === e;
      },
      Adapter: K
    };

    function $(t, e) {
      for (var n, r = [], i = 2; i < arguments.length; i++) {
        r[i - 2] = arguments[i];
      }

      return (n = R(e)).deriveColumns.apply(n, r).deriveColors().defaultRanking().buildTaggle(t);
    }

    function J(t, e) {
      for (var n, r = [], i = 2; i < arguments.length; i++) {
        r[i - 2] = arguments[i];
      }

      return (n = R(e)).deriveColumns.apply(n, r).deriveColors().defaultRanking().build(t);
    }

    n.d(e, "t", function () {
      return $;
    }), n.d(e, "s", function () {
      return J;
    }), n.d(e, "C", function () {
      return R;
    }), n.d(e, "w", function () {
      return l;
    }), n.d(e, "v", function () {
      return A;
    }), n.d(e, "z", function () {
      return j;
    }), n.d(e, "B", function () {
      return S;
    }), n.d(e, "x", function () {
      return V;
    }), n.d(e, "y", function () {
      return H;
    }), n.d(e, "u", function () {
      return G;
    }), n.d(e, "A", function () {
      return N;
    }), n.d(e, "c", function () {}), n.d(e, "d", function () {}), n.d(e, "f", function () {}), n.d(e, "g", function () {}), n.d(e, "j", function () {}), n.d(e, "o", function () {}), n.d(e, "b", function () {}), n.d(e, "r", function () {}), n.d(e, "a", function () {}), n.d(e, "e", function () {}), n.d(e, "k", function () {}), n.d(e, "h", function () {}), n.d(e, "i", function () {}), n.d(e, "l", function () {}), n.d(e, "m", function () {}), n.d(e, "n", function () {}), n.d(e, "p", function () {}), n.d(e, "q", function () {}), n.d(e, "D", function () {
      return X;
    });
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__spreadArrays || function () {
      for (var t = 0, e = 0, n = arguments.length; e < n; e++) {
        t += arguments[e].length;
      }

      var r = Array(t),
          i = 0;

      for (e = 0; e < n; e++) {
        for (var o = arguments[e], a = 0, u = o.length; a < u; a++, i++) {
          r[i] = o[a];
        }
      }

      return r;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var i = function i(t, e, n) {
      this.name = t, this.version = e, this.os = n;
    };

    e.BrowserInfo = i;

    var o = function o(t) {
      this.version = t, this.name = "node", this.os = process.platform;
    };

    e.NodeInfo = o;

    var a = function a() {
      this.bot = !0, this.name = "bot", this.version = null, this.os = null;
    };

    e.BotInfo = a;
    var u = 3,
        c = [["aol", /AOLShield\/([0-9\._]+)/], ["edge", /Edge\/([0-9\._]+)/], ["yandexbrowser", /YaBrowser\/([0-9\._]+)/], ["vivaldi", /Vivaldi\/([0-9\.]+)/], ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/], ["samsung", /SamsungBrowser\/([0-9\.]+)/], ["silk", /\bSilk\/([0-9._-]+)\b/], ["miui", /MiuiBrowser\/([0-9\.]+)$/], ["beaker", /BeakerBrowser\/([0-9\.]+)/], ["edge-chromium", /Edg\/([0-9\.]+)/], ["chromium-webview", /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/], ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/], ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/], ["fxios", /FxiOS\/([0-9\.]+)/], ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/], ["opera", /Opera\/([0-9\.]+)(?:\s|$)/], ["opera", /OPR\/([0-9\.]+)(:?\s|$)/], ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/], ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ["ie", /MSIE\s(7\.0)/], ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/], ["android", /Android\s([0-9\.]+)/], ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/], ["safari", /Version\/([0-9\._]+).*Safari/], ["facebook", /FBAV\/([0-9\.]+)/], ["instagram", /Instagram\s([0-9\.]+)/], ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/], ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/], ["searchbot", /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/]],
        s = [["iOS", /iP(hone|od|ad)/], ["Android OS", /Android/], ["BlackBerry OS", /BlackBerry|BB10/], ["Windows Mobile", /IEMobile/], ["Amazon OS", /Kindle/], ["Windows 3.11", /Win16/], ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/], ["Windows 98", /(Windows 98)|(Win98)/], ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/], ["Windows XP", /(Windows NT 5.1)|(Windows XP)/], ["Windows Server 2003", /(Windows NT 5.2)/], ["Windows Vista", /(Windows NT 6.0)/], ["Windows 7", /(Windows NT 6.1)/], ["Windows 8", /(Windows NT 6.2)/], ["Windows 8.1", /(Windows NT 6.3)/], ["Windows 10", /(Windows NT 10.0)/], ["Windows ME", /Windows ME/], ["Open BSD", /OpenBSD/], ["Sun OS", /SunOS/], ["Chrome OS", /CrOS/], ["Linux", /(Linux)|(X11)/], ["Mac OS", /(Mac_PowerPC)|(Macintosh)/], ["QNX", /QNX/], ["BeOS", /BeOS/], ["OS/2", /OS\/2/], ["Search Bot", /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/]];

    function l(t) {
      var e = "" !== t && c.reduce(function (e, n) {
        var r = n[0],
            i = n[1];
        if (e) return e;
        var o = i.exec(t);
        return !!o && [r, o];
      }, !1);
      if (!e) return null;
      var n = e[0],
          o = e[1];
      if ("searchbot" === n) return new a();
      var s = o[1] && o[1].split(/[._]/).slice(0, 3);
      return s ? s.length < u && (s = r(s, function (t) {
        for (var e = [], n = 0; n < t; n++) {
          e.push("0");
        }

        return e;
      }(u - s.length))) : s = [], new i(n, s.join("."), p(t));
    }

    function p(t) {
      for (var e = 0, n = s.length; e < n; e++) {
        var r = s[e],
            i = r[0];
        if (r[1].test(t)) return i;
      }

      return null;
    }

    function f() {
      return "undefined" != typeof process && process.version ? new o(process.version.slice(1)) : null;
    }

    e.detect = function (t) {
      return t ? l(t) : "undefined" != typeof navigator ? l(navigator.userAgent) : f();
    }, e.parseUserAgent = l, e.detectOS = p, e.getNodeVersion = f;
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "version", function () {
      return g;
    }), n.d(e, "buildId", function () {
      return b;
    }), n.d(e, "license", function () {
      return m;
    }), n.d(e, "createLocalDataProvider", function () {
      return y;
    }), n.d(e, "createLineUp", function () {
      return v;
    }), n.d(e, "createTaggle", function () {
      return E;
    });
    n(109);
    var r = n(72),
        i = n(73),
        o = n(90),
        a = n(85);
    n.d(e, "DataProvider", function () {
      return a.a;
    }), n.d(e, "IStatsBuilder", function () {
      return a.e;
    }), n.d(e, "IDataProviderOptions", function () {
      return a.c;
    }), n.d(e, "IDataProvider", function () {
      return a.b;
    }), n.d(e, "IExportOptions", function () {
      return a.d;
    }), n.d(e, "LocalDataProvider", function () {
      return a.f;
    }), n.d(e, "RemoteDataProvider", function () {
      return a.g;
    }), n.d(e, "cleanCategories", function () {
      return a.h;
    }), n.d(e, "deriveColumnDescriptions", function () {
      return a.j;
    }), n.d(e, "deriveColors", function () {
      return a.i;
    }), n.d(e, "exportRanking", function () {
      return a.k;
    });
    var u = n(56);
    n.d(e, "IRenderContext", function () {
      return u.f;
    }), n.d(e, "IImposer", function () {
      return u.e;
    }), n.d(e, "ERenderMode", function () {
      return u.a;
    }), n.d(e, "ISummaryRenderer", function () {
      return u.g;
    }), n.d(e, "IGroupCellRenderer", function () {
      return u.d;
    }), n.d(e, "ICellRenderer", function () {
      return u.b;
    }), n.d(e, "ICellRendererFactory", function () {
      return u.c;
    }), n.d(e, "colorOf", function () {
      return u.k;
    }), n.d(e, "renderMissingDOM", function () {
      return u.p;
    }), n.d(e, "renderMissingCanvas", function () {
      return u.o;
    }), n.d(e, "renderers", function () {
      return u.q;
    }), n.d(e, "chooseRenderer", function () {
      return u.i;
    }), n.d(e, "chooseGroupRenderer", function () {
      return u.h;
    }), n.d(e, "chooseSummaryRenderer", function () {
      return u.j;
    }), n.d(e, "possibleRenderer", function () {
      return u.m;
    }), n.d(e, "possibleGroupRenderer", function () {
      return u.l;
    }), n.d(e, "possibleSummaryRenderer", function () {
      return u.n;
    });
    var c = n(21);
    n.d(e, "isSupportType", function () {
      return c.Sc;
    }), n.d(e, "Category", function () {
      return c.l;
    }), n.d(e, "SupportType", function () {
      return c.Wb;
    }), n.d(e, "SortByDefault", function () {
      return c.Rb;
    }), n.d(e, "Categories", function () {
      return c.k;
    }), n.d(e, "toolbar", function () {
      return c.gd;
    }), n.d(e, "dialogAddons", function () {
      return c.tc;
    }), n.d(e, "categoryOfDesc", function () {
      return c.Zb;
    }), n.d(e, "categoryOf", function () {
      return c.Yb;
    }), n.d(e, "IColumnCategory", function () {
      return c.M;
    }), n.d(e, "isMissingValue", function () {
      return c.Mc;
    }), n.d(e, "isUnknown", function () {
      return c.Tc;
    }), n.d(e, "FIRST_IS_NAN", function () {
      return c.z;
    }), n.d(e, "FIRST_IS_MISSING", function () {
      return c.y;
    }), n.d(e, "missingGroup", function () {
      return c.Uc;
    }), n.d(e, "ActionColumn", function () {
      return c.a;
    }), n.d(e, "AggregateGroupColumn", function () {
      return c.b;
    }), n.d(e, "createAggregateDesc", function () {
      return c.dc;
    }), n.d(e, "IAggregateGroupColumnDesc", function () {
      return c.C;
    }), n.d(e, "AnnotateColumn", function () {
      return c.c;
    }), n.d(e, "ArrayColumn", function () {
      return c.d;
    }), n.d(e, "IArrayColumnDesc", function () {
      return c.D;
    }), n.d(e, "IArrayDesc", function () {
      return c.E;
    }), n.d(e, "ISplicer", function () {
      return c.sb;
    }), n.d(e, "BooleanColumn", function () {
      return c.e;
    }), n.d(e, "IBooleanColumnDesc", function () {
      return c.F;
    }), n.d(e, "IBooleanDesc", function () {
      return c.G;
    }), n.d(e, "BooleansColumn", function () {
      return c.f;
    }), n.d(e, "BoxPlotColumn", function () {
      return c.g;
    }), n.d(e, "IBoxPlotColumnDesc", function () {
      return c.H;
    }), n.d(e, "IBoxPlotDesc", function () {
      return c.I;
    }), n.d(e, "CategoricalColumn", function () {
      return c.h;
    }), n.d(e, "CategoricalMapColumn", function () {
      return c.i;
    }), n.d(e, "CategoricalsColumn", function () {
      return c.j;
    }), n.d(e, "Column", function () {
      return c.m;
    }), n.d(e, "IFlatColumn", function () {
      return c.W;
    }), n.d(e, "IColumnParent", function () {
      return c.P;
    }), n.d(e, "IColumnMetaData", function () {
      return c.O;
    }), n.d(e, "IColumnDesc", function () {
      return c.N;
    }), n.d(e, "CompositeColumn", function () {
      return c.n;
    }), n.d(e, "isMultiLevelColumn", function () {
      return c.Nc;
    }), n.d(e, "IMultiLevelColumn", function () {
      return c.cb;
    }), n.d(e, "CompositeNumberColumn", function () {
      return c.o;
    }), n.d(e, "DateColumn", function () {
      return c.q;
    }), n.d(e, "IDateColumnDesc", function () {
      return c.R;
    }), n.d(e, "DatesMapColumn", function () {
      return c.s;
    }), n.d(e, "IDateMapColumnDesc", function () {
      return c.T;
    }), n.d(e, "DatesColumn", function () {
      return c.r;
    }), n.d(e, "IDatesDesc", function () {
      return c.V;
    }), n.d(e, "IDatesColumnDesc", function () {
      return c.U;
    }), n.d(e, "DummyColumn", function () {
      return c.t;
    }), n.d(e, "GroupColumn", function () {
      return c.A;
    }), n.d(e, "createGroupDesc", function () {
      return c.ec;
    }), n.d(e, "EGroupSortMethod", function () {
      return c.w;
    }), n.d(e, "HierarchyColumn", function () {
      return c.B;
    }), n.d(e, "ICategoryNode", function () {
      return c.L;
    }), n.d(e, "IPartialCategoryNode", function () {
      return c.jb;
    }), n.d(e, "IHierarchyColumnDesc", function () {
      return c.X;
    }), n.d(e, "IHierarchyDesc", function () {
      return c.Y;
    }), n.d(e, "ICategoryInternalNode", function () {
      return c.K;
    }), n.d(e, "ICutOffNode", function () {
      return c.Q;
    }), n.d(e, "resolveInnerNodes", function () {
      return c.Zc;
    }), n.d(e, "isHierarchical", function () {
      return c.Jc;
    }), n.d(e, "deriveHierarchy", function () {
      return c.sc;
    }), n.d(e, "ImpositionBoxPlotColumn", function () {
      return c.wb;
    }), n.d(e, "ImpositionCompositeColumn", function () {
      return c.xb;
    }), n.d(e, "ImpositionCompositesColumn", function () {
      return c.yb;
    }), n.d(e, "MapColumn", function () {
      return c.Cb;
    }), n.d(e, "MultiLevelCompositeColumn", function () {
      return c.Db;
    }), n.d(e, "NestedColumn", function () {
      return c.Eb;
    }), n.d(e, "NumberColumn", function () {
      return c.Fb;
    }), n.d(e, "INumberColumnDesc", function () {
      return c.eb;
    }), n.d(e, "INumberColumn", function () {
      return c.db;
    }), n.d(e, "isNumberColumn", function () {
      return c.Oc;
    }), n.d(e, "NumberMapColumn", function () {
      return c.Gb;
    }), n.d(e, "INumberMapDesc", function () {
      return c.gb;
    }), n.d(e, "INumberMapColumnDesc", function () {
      return c.fb;
    }), n.d(e, "NumbersColumn", function () {
      return c.Hb;
    }), n.d(e, "INumbersDesc", function () {
      return c.ib;
    }), n.d(e, "INumbersColumnDesc", function () {
      return c.hb;
    }), n.d(e, "OrdinalColumn", function () {
      return c.Ib;
    }), n.d(e, "ICategoricalNumberColumnDesc", function () {
      return c.J;
    }), n.d(e, "RankColumn", function () {
      return c.Jb;
    }), n.d(e, "Ranking", function () {
      return c.Kb;
    }), n.d(e, "ISortCriteria", function () {
      return c.rb;
    }), n.d(e, "ReduceColumn", function () {
      return c.Lb;
    }), n.d(e, "createReduceDesc", function () {
      return c.lc;
    }), n.d(e, "IReduceDesc", function () {
      return c.lb;
    }), n.d(e, "IReduceColumnDesc", function () {
      return c.kb;
    }), n.d(e, "ScriptColumn", function () {
      return c.Nb;
    }), n.d(e, "createScriptDesc", function () {
      return c.mc;
    }), n.d(e, "IScriptDesc", function () {
      return c.nb;
    }), n.d(e, "IScriptColumnDesc", function () {
      return c.mb;
    }), n.d(e, "SelectionColumn", function () {
      return c.Pb;
    }), n.d(e, "createSelectionDesc", function () {
      return c.nc;
    }), n.d(e, "ISelectionColumnDesc", function () {
      return c.ob;
    }), n.d(e, "SetColumn", function () {
      return c.Qb;
    }), n.d(e, "ISetColumnDesc", function () {
      return c.pb;
    }), n.d(e, "ISetDesc", function () {
      return c.qb;
    }), n.d(e, "StackColumn", function () {
      return c.Sb;
    }), n.d(e, "createStackDesc", function () {
      return c.oc;
    }), n.d(e, "StringColumn", function () {
      return c.Tb;
    }), n.d(e, "EAlignment", function () {
      return c.v;
    }), n.d(e, "IStringDesc", function () {
      return c.ub;
    }), n.d(e, "IStringColumnDesc", function () {
      return c.tb;
    }), n.d(e, "StringMapColumn", function () {
      return c.Ub;
    }), n.d(e, "StringsColumn", function () {
      return c.Vb;
    }), n.d(e, "ValueColumn", function () {
      return c.Xb;
    }), n.d(e, "IValueColumnDesc", function () {
      return c.vb;
    }), n.d(e, "LinkColumn", function () {
      return c.zb;
    }), n.d(e, "ILinkDesc", function () {
      return c.bb;
    }), n.d(e, "ILinkColumnDesc", function () {
      return c.ab;
    }), n.d(e, "ILink", function () {
      return c.Z;
    }), n.d(e, "LinkMapColumn", function () {
      return c.Ab;
    }), n.d(e, "LinksColumn", function () {
      return c.Bb;
    }), n.d(e, "defineColumn", function () {
      return c.rc;
    }), n.d(e, "models", function () {
      return c.Vc;
    }), n.d(e, "defaultGroup", function () {
      return c.qc;
    }), n.d(e, "isGroup", function () {
      return c.Ic;
    }), n.d(e, "isSetColumn", function () {
      return c.Rc;
    }), n.d(e, "toCategory", function () {
      return c.ed;
    }), n.d(e, "compareCategory", function () {
      return c.bc;
    }), n.d(e, "groupCompareCategory", function () {
      return c.vc;
    }), n.d(e, "toCategories", function () {
      return c.dd;
    }), n.d(e, "isCategoricalColumn", function () {
      return c.yc;
    }), n.d(e, "isEqualCategoricalFilter", function () {
      return c.Fc;
    }), n.d(e, "isCategoryIncluded", function () {
      return c.zc;
    }), n.d(e, "DEFAULT_FORMATTER", function () {
      return c.p;
    }), n.d(e, "compareBoxPlot", function () {
      return c.ac;
    }), n.d(e, "getBoxPlotNumber", function () {
      return c.uc;
    }), n.d(e, "ESortMethod", function () {
      return c.x;
    }), n.d(e, "isBoxPlotColumn", function () {
      return c.xc;
    }), n.d(e, "EAdvancedSortMethod", function () {
      return c.u;
    }), n.d(e, "isNumbersColumn", function () {
      return c.Qc;
    }), n.d(e, "numberCompare", function () {
      return c.Yc;
    }), n.d(e, "noNumberFilter", function () {
      return c.Xc;
    }), n.d(e, "isEqualNumberFilter", function () {
      return c.Hc;
    }), n.d(e, "isNumberIncluded", function () {
      return c.Pc;
    }), n.d(e, "isDummyNumberFilter", function () {
      return c.Ec;
    }), n.d(e, "restoreNumberFilter", function () {
      return c.cd;
    }), n.d(e, "IDateFilter", function () {
      return c.S;
    }), n.d(e, "restoreDateFilter", function () {
      return c.ad;
    }), n.d(e, "noDateFilter", function () {
      return c.Wc;
    }), n.d(e, "isEqualDateFilter", function () {
      return c.Gc;
    }), n.d(e, "isDummyDateFilter", function () {
      return c.Dc;
    }), n.d(e, "isDateColumn", function () {
      return c.Ac;
    }), n.d(e, "isDateIncluded", function () {
      return c.Bc;
    }), n.d(e, "defaultDateGrouper", function () {
      return c.pc;
    }), n.d(e, "isDefaultDateGrouper", function () {
      return c.Cc;
    }), n.d(e, "toDateGroup", function () {
      return c.fd;
    }), n.d(e, "isMapColumn", function () {
      return c.Lc;
    }), n.d(e, "isArrayColumn", function () {
      return c.wc;
    }), n.d(e, "isMapAbleColumn", function () {
      return c.Kc;
    }), n.d(e, "ScaleMappingFunction", function () {
      return c.Mb;
    }), n.d(e, "ScriptMappingFunction", function () {
      return c.Ob;
    }), n.d(e, "createMappingFunction", function () {
      return c.ic;
    }), n.d(e, "restoreMapping", function () {
      return c.bd;
    }), n.d(e, "createActionDesc", function () {
      return c.cc;
    }), n.d(e, "createImpositionBoxPlotDesc", function () {
      return c.fc;
    }), n.d(e, "createImpositionDesc", function () {
      return c.gc;
    }), n.d(e, "createImpositionsDesc", function () {
      return c.hc;
    }), n.d(e, "createNestedDesc", function () {
      return c.jc;
    }), n.d(e, "createRankDesc", function () {
      return c.kc;
    });
    var s = n(99);
    n.d(e, "asTaggle", function () {
      return s.t;
    }), n.d(e, "asLineUp", function () {
      return s.s;
    }), n.d(e, "builder", function () {
      return s.C;
    }), n.d(e, "buildColumn", function () {
      return s.w;
    }), n.d(e, "buildRanking", function () {
      return s.A;
    }), n.d(e, "IBuilderAdapterCategoricalColumnDescProps", function () {
      return s.c;
    }), n.d(e, "IBuilderAdapterColumnDescProps", function () {
      return s.d;
    }), n.d(e, "IBuilderAdapterDateColumnDescProps", function () {
      return s.f;
    }), n.d(e, "IBuilderAdapterHierarchyColumnDescProps", function () {
      return s.g;
    }), n.d(e, "IBuilderAdapterNumberColumnDescProps", function () {
      return s.j;
    }), n.d(e, "IBuilderAdapterStringColumnDescProps", function () {
      return s.o;
    }), n.d(e, "IBuilderAdapterActionsColumnDescProps", function () {
      return s.b;
    }), n.d(e, "IChangeDetecter", function () {
      return s.r;
    }), n.d(e, "IBuilderAdapter", function () {
      return s.a;
    }), n.d(e, "IBuilderAdapterDataProps", function () {
      return s.e;
    }), n.d(e, "IBuilderAdapterProps", function () {
      return s.k;
    }), n.d(e, "IBuilderAdapterImposeColumnProps", function () {
      return s.h;
    }), n.d(e, "IBuilderAdapterNestedColumnProps", function () {
      return s.i;
    }), n.d(e, "IBuilderAdapterRankingProps", function () {
      return s.l;
    }), n.d(e, "IBuilderAdapterReduceColumnProps", function () {
      return s.m;
    }), n.d(e, "IBuilderAdapterScriptColumnProps", function () {
      return s.n;
    }), n.d(e, "IBuilderAdapterSupportColumnProps", function () {
      return s.p;
    }), n.d(e, "IBuilderAdapterWeightedSumColumnProps", function () {
      return s.q;
    }), n.d(e, "builderAdapter", function () {
      return s.D;
    }), n.d(e, "buildCategoricalColumn", function () {
      return s.v;
    }), n.d(e, "buildNumberColumn", function () {
      return s.z;
    }), n.d(e, "buildStringColumn", function () {
      return s.B;
    }), n.d(e, "buildDateColumn", function () {
      return s.x;
    }), n.d(e, "buildHierarchicalColumn", function () {
      return s.y;
    }), n.d(e, "buildActionsColumn", function () {
      return s.u;
    });
    var l = n(84);

    for (var p in l) {
      ["default", "IBoxPlotData", "IAdvancedBoxPlotData", "IStatistics", "ICategoricalBin", "ICategoricalStatistics", "INumberBin", "version", "buildId", "license", "createLocalDataProvider", "createLineUp", "createTaggle", "DataProvider", "IStatsBuilder", "IDataProviderOptions", "IDataProvider", "IExportOptions", "LocalDataProvider", "RemoteDataProvider", "cleanCategories", "deriveColumnDescriptions", "deriveColors", "exportRanking", "IRenderContext", "IImposer", "ERenderMode", "ISummaryRenderer", "IGroupCellRenderer", "ICellRenderer", "ICellRendererFactory", "colorOf", "renderMissingDOM", "renderMissingCanvas", "renderers", "chooseRenderer", "chooseGroupRenderer", "chooseSummaryRenderer", "possibleRenderer", "possibleGroupRenderer", "possibleSummaryRenderer", "isSupportType", "Category", "SupportType", "SortByDefault", "Categories", "toolbar", "dialogAddons", "categoryOfDesc", "categoryOf", "IColumnCategory", "isMissingValue", "isUnknown", "FIRST_IS_NAN", "FIRST_IS_MISSING", "missingGroup", "ActionColumn", "AggregateGroupColumn", "createAggregateDesc", "IAggregateGroupColumnDesc", "AnnotateColumn", "ArrayColumn", "IArrayColumnDesc", "IArrayDesc", "ISplicer", "BooleanColumn", "IBooleanColumnDesc", "IBooleanDesc", "BooleansColumn", "BoxPlotColumn", "IBoxPlotColumnDesc", "IBoxPlotDesc", "CategoricalColumn", "CategoricalMapColumn", "CategoricalsColumn", "Column", "IFlatColumn", "IColumnParent", "IColumnMetaData", "IColumnDesc", "CompositeColumn", "isMultiLevelColumn", "IMultiLevelColumn", "CompositeNumberColumn", "DateColumn", "IDateColumnDesc", "DatesMapColumn", "IDateMapColumnDesc", "DatesColumn", "IDatesDesc", "IDatesColumnDesc", "DummyColumn", "GroupColumn", "createGroupDesc", "EGroupSortMethod", "HierarchyColumn", "ICategoryNode", "IPartialCategoryNode", "IHierarchyColumnDesc", "IHierarchyDesc", "ICategoryInternalNode", "ICutOffNode", "resolveInnerNodes", "isHierarchical", "deriveHierarchy", "ImpositionBoxPlotColumn", "ImpositionCompositeColumn", "ImpositionCompositesColumn", "MapColumn", "MultiLevelCompositeColumn", "NestedColumn", "NumberColumn", "INumberColumnDesc", "INumberColumn", "isNumberColumn", "NumberMapColumn", "INumberMapDesc", "INumberMapColumnDesc", "NumbersColumn", "INumbersDesc", "INumbersColumnDesc", "OrdinalColumn", "ICategoricalNumberColumnDesc", "RankColumn", "Ranking", "ISortCriteria", "ReduceColumn", "createReduceDesc", "IReduceDesc", "IReduceColumnDesc", "ScriptColumn", "createScriptDesc", "IScriptDesc", "IScriptColumnDesc", "SelectionColumn", "createSelectionDesc", "ISelectionColumnDesc", "SetColumn", "ISetColumnDesc", "ISetDesc", "StackColumn", "createStackDesc", "StringColumn", "EAlignment", "IStringDesc", "IStringColumnDesc", "StringMapColumn", "StringsColumn", "ValueColumn", "IValueColumnDesc", "LinkColumn", "ILinkDesc", "ILinkColumnDesc", "ILink", "LinkMapColumn", "LinksColumn", "defineColumn", "models", "defaultGroup", "isGroup", "isSetColumn", "toCategory", "compareCategory", "groupCompareCategory", "toCategories", "isCategoricalColumn", "isEqualCategoricalFilter", "isCategoryIncluded", "DEFAULT_FORMATTER", "compareBoxPlot", "getBoxPlotNumber", "ESortMethod", "isBoxPlotColumn", "EAdvancedSortMethod", "isNumbersColumn", "numberCompare", "noNumberFilter", "isEqualNumberFilter", "isNumberIncluded", "isDummyNumberFilter", "restoreNumberFilter", "IDateFilter", "restoreDateFilter", "noDateFilter", "isEqualDateFilter", "isDummyDateFilter", "isDateColumn", "isDateIncluded", "defaultDateGrouper", "isDefaultDateGrouper", "toDateGroup", "isMapColumn", "isArrayColumn", "isMapAbleColumn", "ScaleMappingFunction", "ScriptMappingFunction", "createMappingFunction", "restoreMapping", "createActionDesc", "createImpositionBoxPlotDesc", "createImpositionDesc", "createImpositionsDesc", "createNestedDesc", "createRankDesc", "asTaggle", "asLineUp", "builder", "buildColumn", "buildRanking", "IBuilderAdapterCategoricalColumnDescProps", "IBuilderAdapterColumnDescProps", "IBuilderAdapterDateColumnDescProps", "IBuilderAdapterHierarchyColumnDescProps", "IBuilderAdapterNumberColumnDescProps", "IBuilderAdapterStringColumnDescProps", "IBuilderAdapterActionsColumnDescProps", "IChangeDetecter", "IBuilderAdapter", "IBuilderAdapterDataProps", "IBuilderAdapterProps", "IBuilderAdapterImposeColumnProps", "IBuilderAdapterNestedColumnProps", "IBuilderAdapterRankingProps", "IBuilderAdapterReduceColumnProps", "IBuilderAdapterScriptColumnProps", "IBuilderAdapterSupportColumnProps", "IBuilderAdapterWeightedSumColumnProps", "builderAdapter", "buildCategoricalColumn", "buildNumberColumn", "buildStringColumn", "buildDateColumn", "buildHierarchicalColumn", "buildActionsColumn", "default"].indexOf(p) < 0 && function (t) {
        n.d(e, t, function () {
          return l[t];
        });
      }(p);
    }

    var f = n(51);
    n.d(e, "DENSE_HISTOGRAM", function () {
      return f.a;
    }), n.d(e, "MIN_LABEL_WIDTH", function () {
      return f.e;
    }), n.d(e, "HOVER_DELAY_SHOW_DETAIL", function () {
      return f.b;
    });
    var d = n(52);
    n.d(e, "defaultOptions", function () {
      return d.a;
    }), n.d(e, "default", function () {
      return i.a;
    });
    var h = n(16);
    n.d(e, "IBoxPlotData", function () {
      return h.IBoxPlotData;
    }), n.d(e, "IAdvancedBoxPlotData", function () {
      return h.IAdvancedBoxPlotData;
    }), n.d(e, "IStatistics", function () {
      return h.IStatistics;
    }), n.d(e, "ICategoricalBin", function () {
      return h.ICategoricalBin;
    }), n.d(e, "ICategoricalStatistics", function () {
      return h.ICategoricalStatistics;
    }), n.d(e, "INumberBin", function () {
      return h.INumberBin;
    });
    var g = "3.2.2",
        b = "20190917-145353",
        m = "BSD-3-Clause";

    function y(t, e, n) {
      return void 0 === n && (n = {}), new r.a(t, e, n);
    }

    function v(t, e, n) {
      return void 0 === n && (n = {}), new i.a(t, e, n);
    }

    function E(t, e, n) {
      return void 0 === n && (n = {}), new o.a(t, e, n);
    }
  },, function (t, e) {
    /*! *****************************************************************************
    Copyright (C) Microsoft. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    var n;
    !function (t) {
      !function (e) {
        var n = "object" == typeof global ? global : "object" == typeof self ? self : "object" == typeof this ? this : Function("return this;")(),
            r = i(t);

        function i(t, e) {
          return function (n, r) {
            "function" != typeof t[n] && Object.defineProperty(t, n, {
              configurable: !0,
              writable: !0,
              value: r
            }), e && e(n, r);
          };
        }

        void 0 === n.Reflect ? n.Reflect = t : r = i(n.Reflect, r), function (t) {
          var e = Object.prototype.hasOwnProperty,
              n = "function" == typeof Symbol,
              r = n && void 0 !== Symbol.toPrimitive ? Symbol.toPrimitive : "@@toPrimitive",
              i = n && void 0 !== Symbol.iterator ? Symbol.iterator : "@@iterator",
              o = "function" == typeof Object.create,
              a = {
            __proto__: []
          } instanceof Array,
              u = !o && !a,
              c = {
            create: o ? function () {
              return j(Object.create(null));
            } : a ? function () {
              return j({
                __proto__: null
              });
            } : function () {
              return j({});
            },
            has: u ? function (t, n) {
              return e.call(t, n);
            } : function (t, e) {
              return e in t;
            },
            get: u ? function (t, n) {
              return e.call(t, n) ? t[n] : void 0;
            } : function (t, e) {
              return t[e];
            }
          },
              s = Object.getPrototypeOf(Function),
              l = "object" == typeof process && process.env && "true" === process.env.REFLECT_METADATA_USE_MAP_POLYFILL,
              p = l || "function" != typeof Map || "function" != typeof Map.prototype.entries ? function () {
            var t = {},
                e = [],
                n = function () {
              function t(t, e, n) {
                this._index = 0, this._keys = t, this._values = e, this._selector = n;
              }

              return t.prototype["@@iterator"] = function () {
                return this;
              }, t.prototype[i] = function () {
                return this;
              }, t.prototype.next = function () {
                var t = this._index;

                if (t >= 0 && t < this._keys.length) {
                  var n = this._selector(this._keys[t], this._values[t]);

                  return t + 1 >= this._keys.length ? (this._index = -1, this._keys = e, this._values = e) : this._index++, {
                    value: n,
                    done: !1
                  };
                }

                return {
                  value: void 0,
                  done: !0
                };
              }, t.prototype.throw = function (t) {
                throw this._index >= 0 && (this._index = -1, this._keys = e, this._values = e), t;
              }, t.prototype.return = function (t) {
                return this._index >= 0 && (this._index = -1, this._keys = e, this._values = e), {
                  value: t,
                  done: !0
                };
              }, t;
            }();

            return function () {
              function e() {
                this._keys = [], this._values = [], this._cacheKey = t, this._cacheIndex = -2;
              }

              return Object.defineProperty(e.prototype, "size", {
                get: function get() {
                  return this._keys.length;
                },
                enumerable: !0,
                configurable: !0
              }), e.prototype.has = function (t) {
                return this._find(t, !1) >= 0;
              }, e.prototype.get = function (t) {
                var e = this._find(t, !1);

                return e >= 0 ? this._values[e] : void 0;
              }, e.prototype.set = function (t, e) {
                var n = this._find(t, !0);

                return this._values[n] = e, this;
              }, e.prototype.delete = function (e) {
                var n = this._find(e, !1);

                if (n >= 0) {
                  for (var r = this._keys.length, i = n + 1; i < r; i++) {
                    this._keys[i - 1] = this._keys[i], this._values[i - 1] = this._values[i];
                  }

                  return this._keys.length--, this._values.length--, e === this._cacheKey && (this._cacheKey = t, this._cacheIndex = -2), !0;
                }

                return !1;
              }, e.prototype.clear = function () {
                this._keys.length = 0, this._values.length = 0, this._cacheKey = t, this._cacheIndex = -2;
              }, e.prototype.keys = function () {
                return new n(this._keys, this._values, r);
              }, e.prototype.values = function () {
                return new n(this._keys, this._values, o);
              }, e.prototype.entries = function () {
                return new n(this._keys, this._values, a);
              }, e.prototype["@@iterator"] = function () {
                return this.entries();
              }, e.prototype[i] = function () {
                return this.entries();
              }, e.prototype._find = function (t, e) {
                return this._cacheKey !== t && (this._cacheIndex = this._keys.indexOf(this._cacheKey = t)), this._cacheIndex < 0 && e && (this._cacheIndex = this._keys.length, this._keys.push(t), this._values.push(void 0)), this._cacheIndex;
              }, e;
            }();

            function r(t, e) {
              return t;
            }

            function o(t, e) {
              return e;
            }

            function a(t, e) {
              return [t, e];
            }
          }() : Map,
              f = l || "function" != typeof Set || "function" != typeof Set.prototype.entries ? function () {
            function t() {
              this._map = new p();
            }

            return Object.defineProperty(t.prototype, "size", {
              get: function get() {
                return this._map.size;
              },
              enumerable: !0,
              configurable: !0
            }), t.prototype.has = function (t) {
              return this._map.has(t);
            }, t.prototype.add = function (t) {
              return this._map.set(t, t), this;
            }, t.prototype.delete = function (t) {
              return this._map.delete(t);
            }, t.prototype.clear = function () {
              this._map.clear();
            }, t.prototype.keys = function () {
              return this._map.keys();
            }, t.prototype.values = function () {
              return this._map.values();
            }, t.prototype.entries = function () {
              return this._map.entries();
            }, t.prototype["@@iterator"] = function () {
              return this.keys();
            }, t.prototype[i] = function () {
              return this.keys();
            }, t;
          }() : Set,
              d = new (l || "function" != typeof WeakMap ? function () {
            var t = 16,
                n = c.create(),
                r = i();
            return function () {
              function t() {
                this._key = i();
              }

              return t.prototype.has = function (t) {
                var e = o(t, !1);
                return void 0 !== e && c.has(e, this._key);
              }, t.prototype.get = function (t) {
                var e = o(t, !1);
                return void 0 !== e ? c.get(e, this._key) : void 0;
              }, t.prototype.set = function (t, e) {
                return o(t, !0)[this._key] = e, this;
              }, t.prototype.delete = function (t) {
                var e = o(t, !1);
                return void 0 !== e && delete e[this._key];
              }, t.prototype.clear = function () {
                this._key = i();
              }, t;
            }();

            function i() {
              var t;

              do {
                t = "@@WeakMap@@" + u();
              } while (c.has(n, t));

              return n[t] = !0, t;
            }

            function o(t, n) {
              if (!e.call(t, r)) {
                if (!n) return;
                Object.defineProperty(t, r, {
                  value: c.create()
                });
              }

              return t[r];
            }

            function a(t, e) {
              for (var n = 0; n < e; ++n) {
                t[n] = 255 * Math.random() | 0;
              }

              return t;
            }

            function u() {
              var e,
                  n = (e = t, "function" == typeof Uint8Array ? "undefined" != typeof crypto ? crypto.getRandomValues(new Uint8Array(e)) : "undefined" != typeof msCrypto ? msCrypto.getRandomValues(new Uint8Array(e)) : a(new Uint8Array(e), e) : a(new Array(e), e));
              n[6] = 79 & n[6] | 64, n[8] = 191 & n[8] | 128;

              for (var r = "", i = 0; i < t; ++i) {
                var o = n[i];
                4 !== i && 6 !== i && 8 !== i || (r += "-"), o < 16 && (r += "0"), r += o.toString(16).toLowerCase();
              }

              return r;
            }
          }() : WeakMap)();

          function h(t, e, n) {
            var r = d.get(t);

            if (E(r)) {
              if (!n) return;
              r = new p(), d.set(t, r);
            }

            var i = r.get(e);

            if (E(i)) {
              if (!n) return;
              i = new p(), r.set(e, i);
            }

            return i;
          }

          function g(t, e, n) {
            var r = h(e, n, !1);
            return !E(r) && !!r.has(t);
          }

          function b(t, e, n) {
            var r = h(e, n, !1);
            if (!E(r)) return r.get(t);
          }

          function m(t, e, n, r) {
            h(n, r, !0).set(t, e);
          }

          function y(t, e) {
            var n = [],
                r = h(t, e, !1);
            if (E(r)) return n;

            for (var o = function (t) {
              var e = w(t, i);
              if (!D(e)) throw new TypeError();
              var n = e.call(t);
              if (!C(n)) throw new TypeError();
              return n;
            }(r.keys()), a = 0;;) {
              var u = A(o);
              if (!u) return n.length = a, n;
              var c = u.value;

              try {
                n[a] = c;
              } catch (t) {
                try {
                  M(o);
                } finally {
                  throw t;
                }
              }

              a++;
            }
          }

          function v(t) {
            if (null === t) return 1;

            switch (typeof t) {
              case "undefined":
                return 0;

              case "boolean":
                return 2;

              case "string":
                return 3;

              case "symbol":
                return 4;

              case "number":
                return 5;

              case "object":
                return null === t ? 1 : 6;

              default:
                return 6;
            }
          }

          function E(t) {
            return void 0 === t;
          }

          function O(t) {
            return null === t;
          }

          function C(t) {
            return "object" == typeof t ? null !== t : "function" == typeof t;
          }

          function _(t, e) {
            switch (v(t)) {
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                return t;
            }

            var n = 3 === e ? "string" : 5 === e ? "number" : "default",
                i = w(t, r);

            if (void 0 !== i) {
              var o = i.call(t, n);
              if (C(o)) throw new TypeError();
              return o;
            }

            return function (t, e) {
              if ("string" === e) {
                var n = t.toString;
                if (D(n)) if (!C(i = n.call(t))) return i;
                if (D(r = t.valueOf)) if (!C(i = r.call(t))) return i;
              } else {
                var r;
                if (D(r = t.valueOf)) if (!C(i = r.call(t))) return i;
                var i,
                    o = t.toString;
                if (D(o)) if (!C(i = o.call(t))) return i;
              }

              throw new TypeError();
            }(t, "default" === n ? "number" : n);
          }

          function T(t) {
            var e = _(t, 3);

            return "symbol" == typeof e ? e : function (t) {
              return "" + t;
            }(e);
          }

          function N(t) {
            return Array.isArray ? Array.isArray(t) : t instanceof Object ? t instanceof Array : "[object Array]" === Object.prototype.toString.call(t);
          }

          function D(t) {
            return "function" == typeof t;
          }

          function R(t) {
            return "function" == typeof t;
          }

          function w(t, e) {
            var n = t[e];

            if (null != n) {
              if (!D(n)) throw new TypeError();
              return n;
            }
          }

          function A(t) {
            var e = t.next();
            return !e.done && e;
          }

          function M(t) {
            var e = t.return;
            e && e.call(t);
          }

          function L(t) {
            var e = Object.getPrototypeOf(t);
            if ("function" != typeof t || t === s) return e;
            if (e !== s) return e;
            var n = t.prototype,
                r = n && Object.getPrototypeOf(n);
            if (null == r || r === Object.prototype) return e;
            var i = r.constructor;
            return "function" != typeof i ? e : i === t ? e : i;
          }

          function j(t) {
            return t.__ = void 0, delete t.__, t;
          }

          t("decorate", function (t, e, n, r) {
            if (E(n)) {
              if (!N(t)) throw new TypeError();
              if (!R(e)) throw new TypeError();
              return function (t, e) {
                for (var n = t.length - 1; n >= 0; --n) {
                  var r = (0, t[n])(e);

                  if (!E(r) && !O(r)) {
                    if (!R(r)) throw new TypeError();
                    e = r;
                  }
                }

                return e;
              }(t, e);
            }

            if (!N(t)) throw new TypeError();
            if (!C(e)) throw new TypeError();
            if (!C(r) && !E(r) && !O(r)) throw new TypeError();
            return O(r) && (r = void 0), function (t, e, n, r) {
              for (var i = t.length - 1; i >= 0; --i) {
                var o = (0, t[i])(e, n, r);

                if (!E(o) && !O(o)) {
                  if (!C(o)) throw new TypeError();
                  r = o;
                }
              }

              return r;
            }(t, e, n = T(n), r);
          }), t("metadata", function (t, e) {
            return function (n, r) {
              if (!C(n)) throw new TypeError();
              if (!E(r) && !function (t) {
                switch (v(t)) {
                  case 3:
                  case 4:
                    return !0;

                  default:
                    return !1;
                }
              }(r)) throw new TypeError();
              m(t, e, n, r);
            };
          }), t("defineMetadata", function (t, e, n, r) {
            if (!C(n)) throw new TypeError();
            return E(r) || (r = T(r)), m(t, e, n, r);
          }), t("hasMetadata", function (t, e, n) {
            if (!C(e)) throw new TypeError();
            return E(n) || (n = T(n)), function t(e, n, r) {
              var i = g(e, n, r);
              if (i) return !0;
              var o = L(n);
              if (!O(o)) return t(e, o, r);
              return !1;
            }(t, e, n);
          }), t("hasOwnMetadata", function (t, e, n) {
            if (!C(e)) throw new TypeError();
            return E(n) || (n = T(n)), g(t, e, n);
          }), t("getMetadata", function (t, e, n) {
            if (!C(e)) throw new TypeError();
            return E(n) || (n = T(n)), function t(e, n, r) {
              var i = g(e, n, r);
              if (i) return b(e, n, r);
              var o = L(n);
              if (!O(o)) return t(e, o, r);
              return;
            }(t, e, n);
          }), t("getOwnMetadata", function (t, e, n) {
            if (!C(e)) throw new TypeError();
            return E(n) || (n = T(n)), b(t, e, n);
          }), t("getMetadataKeys", function (t, e) {
            if (!C(t)) throw new TypeError();
            return E(e) || (e = T(e)), function t(e, n) {
              var r = y(e, n);
              var i = L(e);
              if (null === i) return r;
              var o = t(i, n);
              if (o.length <= 0) return r;
              if (r.length <= 0) return o;
              var a = new f();
              var u = [];

              for (var c = 0, s = r; c < s.length; c++) {
                var l = s[c];
                a.has(l) || (a.add(l), u.push(l));
              }

              for (var p = 0, d = o; p < d.length; p++) {
                l = d[p];
                a.has(l) || (a.add(l), u.push(l));
              }

              return u;
            }(t, e);
          }), t("getOwnMetadataKeys", function (t, e) {
            if (!C(t)) throw new TypeError();
            return E(e) || (e = T(e)), y(t, e);
          }), t("deleteMetadata", function (t, e, n) {
            if (!C(e)) throw new TypeError();
            E(n) || (n = T(n));
            var r = h(e, n, !1);
            if (E(r)) return !1;
            if (!r.delete(t)) return !1;
            if (r.size > 0) return !0;
            var i = d.get(e);
            return i.delete(n), i.size > 0 || (d.delete(e), !0);
          });
        }(r);
      }();
    }(n || (n = {}));
  },,,,,, function (t, e) {},,,,,,,,,,,, function (t, e, n) {
    "use strict";

    n.r(e), e.default = "// removed by extract-text-webpack-plugin";
  }]);
});